/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.6.0 (NJsonSchema v10.0.23.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>_observableThrow(response_);
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonateOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(<any>response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchToLinkedAccountOutput>(<any>null);
    }
}

@Injectable()
export class ActivitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param finishedFilter (optional) 
     * @param thematicAreaFilter (optional) 
     * @param activityTypeFilter (optional) 
     * @param onThecalendar (optional) 
     * @param finished (optional) 
     * @param published (optional) 
     * @param eventScheduleId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, finishedFilter: number | undefined, thematicAreaFilter: number | undefined, activityTypeFilter: number | undefined, onThecalendar: boolean | undefined, finished: boolean | undefined, published: boolean | undefined, eventScheduleId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (finishedFilter === null)
            throw new Error("The parameter 'finishedFilter' cannot be null.");
        else if (finishedFilter !== undefined)
            url_ += "FinishedFilter=" + encodeURIComponent("" + finishedFilter) + "&"; 
        if (thematicAreaFilter === null)
            throw new Error("The parameter 'thematicAreaFilter' cannot be null.");
        else if (thematicAreaFilter !== undefined)
            url_ += "ThematicAreaFilter=" + encodeURIComponent("" + thematicAreaFilter) + "&"; 
        if (activityTypeFilter === null)
            throw new Error("The parameter 'activityTypeFilter' cannot be null.");
        else if (activityTypeFilter !== undefined)
            url_ += "ActivityTypeFilter=" + encodeURIComponent("" + activityTypeFilter) + "&"; 
        if (onThecalendar === null)
            throw new Error("The parameter 'onThecalendar' cannot be null.");
        else if (onThecalendar !== undefined)
            url_ += "OnThecalendar=" + encodeURIComponent("" + onThecalendar) + "&"; 
        if (finished === null)
            throw new Error("The parameter 'finished' cannot be null.");
        else if (finished !== undefined)
            url_ += "Finished=" + encodeURIComponent("" + finished) + "&"; 
        if (published === null)
            throw new Error("The parameter 'published' cannot be null.");
        else if (published !== undefined)
            url_ += "Published=" + encodeURIComponent("" + published) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActivityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActivityForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param finishedFilter (optional) 
     * @param thematicAreaFilter (optional) 
     * @param activityTypeFilter (optional) 
     * @param onThecalendar (optional) 
     * @param finished (optional) 
     * @param published (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getActivitiesToExcel(filter: string | undefined, finishedFilter: number | undefined, thematicAreaFilter: number | undefined, activityTypeFilter: number | undefined, onThecalendar: boolean | undefined, finished: boolean | undefined, published: boolean | undefined, eventScheduleId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivitiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (finishedFilter === null)
            throw new Error("The parameter 'finishedFilter' cannot be null.");
        else if (finishedFilter !== undefined)
            url_ += "FinishedFilter=" + encodeURIComponent("" + finishedFilter) + "&"; 
        if (thematicAreaFilter === null)
            throw new Error("The parameter 'thematicAreaFilter' cannot be null.");
        else if (thematicAreaFilter !== undefined)
            url_ += "ThematicAreaFilter=" + encodeURIComponent("" + thematicAreaFilter) + "&"; 
        if (activityTypeFilter === null)
            throw new Error("The parameter 'activityTypeFilter' cannot be null.");
        else if (activityTypeFilter !== undefined)
            url_ += "ActivityTypeFilter=" + encodeURIComponent("" + activityTypeFilter) + "&"; 
        if (onThecalendar === null)
            throw new Error("The parameter 'onThecalendar' cannot be null.");
        else if (onThecalendar !== undefined)
            url_ += "OnThecalendar=" + encodeURIComponent("" + onThecalendar) + "&"; 
        if (finished === null)
            throw new Error("The parameter 'finished' cannot be null.");
        else if (finished !== undefined)
            url_ += "Finished=" + encodeURIComponent("" + finished) + "&"; 
        if (published === null)
            throw new Error("The parameter 'published' cannot be null.");
        else if (published !== undefined)
            url_ += "Published=" + encodeURIComponent("" + published) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleId (optional) 
     * @param onTheCalendar (optional) 
     * @return Success
     */
    getActivitiesForSelect(term: string | undefined, eventScheduleId: number | undefined, onTheCalendar: boolean | undefined): Observable<ListResultDtoOfActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivitiesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (onTheCalendar === null)
            throw new Error("The parameter 'onTheCalendar' cannot be null.");
        else if (onTheCalendar !== undefined)
            url_ += "OnTheCalendar=" + encodeURIComponent("" + onTheCalendar) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivitiesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfActivityDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllThematicAreaForTableDropdown(): Observable<ActivityThematicAreaLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetAllThematicAreaForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllThematicAreaForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllThematicAreaForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ActivityThematicAreaLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityThematicAreaLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllThematicAreaForTableDropdown(response: HttpResponseBase): Observable<ActivityThematicAreaLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityThematicAreaLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityThematicAreaLookupTableDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getAllActivityTypeForTableDropdown(): Observable<ActivityActivityTypeLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetAllActivityTypeForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActivityTypeForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActivityTypeForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ActivityActivityTypeLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivityActivityTypeLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllActivityTypeForTableDropdown(response: HttpResponseBase): Observable<ActivityActivityTypeLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityActivityTypeLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityActivityTypeLookupTableDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityForView(id: number | undefined): Observable<GetActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityForView(response: HttpResponseBase): Observable<GetActivityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityForEdit(id: number | undefined): Observable<GetActivityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Activities/GetActivityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityForEdit(response: HttpResponseBase): Observable<GetActivityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditActivityDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Activities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publish(body: PublishActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activities/Publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finish(body: PublishActivityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activities/Finish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processFinish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ActivityTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetActivityTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivityTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivityTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActivityTemplateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetActivityTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActivityTemplateForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getActivityTemplatesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTemplatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTemplatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTemplatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityTemplateForView(id: number | undefined): Observable<GetActivityTemplateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTemplateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTemplateForView(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityTemplateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityTemplateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTemplateForView(response: HttpResponseBase): Observable<GetActivityTemplateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityTemplateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityTemplateForViewDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getActivityTemplatesForSelect(term: string | undefined): Observable<ListResultDtoOfActivityTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplatesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTemplatesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTemplatesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityTemplateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityTemplateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTemplatesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfActivityTemplateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfActivityTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfActivityTemplateDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityTemplateForEdit(id: number | undefined): Observable<GetActivityTemplateForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/GetActivityTemplateForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTemplateForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTemplateForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityTemplateForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityTemplateForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTemplateForEdit(response: HttpResponseBase): Observable<GetActivityTemplateForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityTemplateForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityTemplateForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditActivityTemplateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ActivityTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetActivityTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetActivityTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetActivityTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetActivityTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetActivityTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetActivityTypeForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getActivityTypesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTypesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityTypeForView(id: number | undefined): Observable<GetActivityTypeForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypeForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypeForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypeForView(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityTypeForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityTypeForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTypeForView(response: HttpResponseBase): Observable<GetActivityTypeForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityTypeForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityTypeForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivityTypeForEdit(id: number | undefined): Observable<GetActivityTypeForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypeForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypeForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypeForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityTypeForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityTypeForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTypeForEdit(response: HttpResponseBase): Observable<GetActivityTypeForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityTypeForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityTypeForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getActivityTypesForSelect(term: string | undefined): Observable<ListResultDtoOfActivityTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/GetActivityTypesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityTypesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetActivityTypesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfActivityTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfActivityTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfActivityTypeDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditActivityTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityTypes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AnnuitiesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param situationFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param memberIdFilter (optional) 
     * @param yearFilter (optional) 
     * @param itsReadmissionFilter (optional) 
     * @param userIdFilter (optional) 
     * @param categoryIdFilter (optional) 
     * @param categoryLevelIdFilter (optional) 
     * @param realizedRepasse (optional) 
     * @param statusFilter (optional) 
     * @param beginPaymentDate (optional) 
     * @param endPaymentDate (optional) 
     * @param userSituationId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, situationFilter: number | undefined, paymentTypeFilter: number | undefined, memberIdFilter: number | undefined, yearFilter: number | undefined, itsReadmissionFilter: boolean | undefined, userIdFilter: number | undefined, categoryIdFilter: number | undefined, categoryLevelIdFilter: number | undefined, realizedRepasse: boolean | undefined, statusFilter: PaymentStatus | undefined, beginPaymentDate: moment.Moment | undefined, endPaymentDate: moment.Moment | undefined, userSituationId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAnnuityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (situationFilter === null)
            throw new Error("The parameter 'situationFilter' cannot be null.");
        else if (situationFilter !== undefined)
            url_ += "SituationFilter=" + encodeURIComponent("" + situationFilter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (memberIdFilter === null)
            throw new Error("The parameter 'memberIdFilter' cannot be null.");
        else if (memberIdFilter !== undefined)
            url_ += "MemberIdFilter=" + encodeURIComponent("" + memberIdFilter) + "&"; 
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&"; 
        if (itsReadmissionFilter === null)
            throw new Error("The parameter 'itsReadmissionFilter' cannot be null.");
        else if (itsReadmissionFilter !== undefined)
            url_ += "ItsReadmissionFilter=" + encodeURIComponent("" + itsReadmissionFilter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (categoryIdFilter === null)
            throw new Error("The parameter 'categoryIdFilter' cannot be null.");
        else if (categoryIdFilter !== undefined)
            url_ += "CategoryIdFilter=" + encodeURIComponent("" + categoryIdFilter) + "&"; 
        if (categoryLevelIdFilter === null)
            throw new Error("The parameter 'categoryLevelIdFilter' cannot be null.");
        else if (categoryLevelIdFilter !== undefined)
            url_ += "CategoryLevelIdFilter=" + encodeURIComponent("" + categoryLevelIdFilter) + "&"; 
        if (realizedRepasse === null)
            throw new Error("The parameter 'realizedRepasse' cannot be null.");
        else if (realizedRepasse !== undefined)
            url_ += "RealizedRepasse=" + encodeURIComponent("" + realizedRepasse) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (beginPaymentDate === null)
            throw new Error("The parameter 'beginPaymentDate' cannot be null.");
        else if (beginPaymentDate !== undefined)
            url_ += "BeginPaymentDate=" + encodeURIComponent(beginPaymentDate ? "" + beginPaymentDate.toJSON() : "") + "&"; 
        if (endPaymentDate === null)
            throw new Error("The parameter 'endPaymentDate' cannot be null.");
        else if (endPaymentDate !== undefined)
            url_ += "EndPaymentDate=" + encodeURIComponent(endPaymentDate ? "" + endPaymentDate.toJSON() : "") + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAnnuityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAnnuityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAnnuityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAnnuityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAnnuityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnnuityForView(id: number | undefined): Observable<GetAnnuityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuityForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityForView(response: HttpResponseBase): Observable<GetAnnuityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnnuityForEdit(id: number | undefined): Observable<GetAnnuityForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityForEdit(response: HttpResponseBase): Observable<GetAnnuityForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuityForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAnnuityDto | undefined): Observable<ResultEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<ResultEmailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultEmailDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<ResultEmailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultEmailDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param situationFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param memberIdFilter (optional) 
     * @param yearFilter (optional) 
     * @param itsReadmissionFilter (optional) 
     * @param userIdFilter (optional) 
     * @param categoryIdFilter (optional) 
     * @param categoryLevelIdFilter (optional) 
     * @param realizedRepasse (optional) 
     * @param statusFilter (optional) 
     * @param beginPaymentDate (optional) 
     * @param endPaymentDate (optional) 
     * @param userSituationId (optional) 
     * @return Success
     */
    getAnnuitiesToExcel(filter: string | undefined, situationFilter: number | undefined, paymentTypeFilter: number | undefined, memberIdFilter: number | undefined, yearFilter: number | undefined, itsReadmissionFilter: boolean | undefined, userIdFilter: number | undefined, categoryIdFilter: number | undefined, categoryLevelIdFilter: number | undefined, realizedRepasse: boolean | undefined, statusFilter: PaymentStatus | undefined, beginPaymentDate: moment.Moment | undefined, endPaymentDate: moment.Moment | undefined, userSituationId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuitiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (situationFilter === null)
            throw new Error("The parameter 'situationFilter' cannot be null.");
        else if (situationFilter !== undefined)
            url_ += "SituationFilter=" + encodeURIComponent("" + situationFilter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (memberIdFilter === null)
            throw new Error("The parameter 'memberIdFilter' cannot be null.");
        else if (memberIdFilter !== undefined)
            url_ += "MemberIdFilter=" + encodeURIComponent("" + memberIdFilter) + "&"; 
        if (yearFilter === null)
            throw new Error("The parameter 'yearFilter' cannot be null.");
        else if (yearFilter !== undefined)
            url_ += "YearFilter=" + encodeURIComponent("" + yearFilter) + "&"; 
        if (itsReadmissionFilter === null)
            throw new Error("The parameter 'itsReadmissionFilter' cannot be null.");
        else if (itsReadmissionFilter !== undefined)
            url_ += "ItsReadmissionFilter=" + encodeURIComponent("" + itsReadmissionFilter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (categoryIdFilter === null)
            throw new Error("The parameter 'categoryIdFilter' cannot be null.");
        else if (categoryIdFilter !== undefined)
            url_ += "CategoryIdFilter=" + encodeURIComponent("" + categoryIdFilter) + "&"; 
        if (categoryLevelIdFilter === null)
            throw new Error("The parameter 'categoryLevelIdFilter' cannot be null.");
        else if (categoryLevelIdFilter !== undefined)
            url_ += "CategoryLevelIdFilter=" + encodeURIComponent("" + categoryLevelIdFilter) + "&"; 
        if (realizedRepasse === null)
            throw new Error("The parameter 'realizedRepasse' cannot be null.");
        else if (realizedRepasse !== undefined)
            url_ += "RealizedRepasse=" + encodeURIComponent("" + realizedRepasse) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (beginPaymentDate === null)
            throw new Error("The parameter 'beginPaymentDate' cannot be null.");
        else if (beginPaymentDate !== undefined)
            url_ += "BeginPaymentDate=" + encodeURIComponent(beginPaymentDate ? "" + beginPaymentDate.toJSON() : "") + "&"; 
        if (endPaymentDate === null)
            throw new Error("The parameter 'endPaymentDate' cannot be null.");
        else if (endPaymentDate !== undefined)
            url_ += "EndPaymentDate=" + encodeURIComponent(endPaymentDate ? "" + endPaymentDate.toJSON() : "") + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param year (optional) 
     * @return Success
     */
    getCurrentAnnuityForPayment(year: number | undefined): Observable<OutputCurrentPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetCurrentAnnuityForPayment?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentAnnuityForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentAnnuityForPayment(<any>response_);
                } catch (e) {
                    return <Observable<OutputCurrentPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutputCurrentPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentAnnuityForPayment(response: HttpResponseBase): Observable<OutputCurrentPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutputCurrentPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutputCurrentPaymentDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAnnuitiesForPaymentOrder(userId: number | undefined): Observable<GetAnnuityForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Annuities/GetAnnuitiesForPaymentOrder?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitiesForPaymentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitiesForPaymentOrder(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitiesForPaymentOrder(response: HttpResponseBase): Observable<GetAnnuityForViewDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetAnnuityForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityForViewDto[]>(<any>null);
    }
}

@Injectable()
export class AnnuitySettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetAnnuitySettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAnnuitySettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAnnuitySettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetAnnuitySettingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetAnnuitySettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAnnuitySettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnnuitySettingForView(id: number | undefined): Observable<GetAnnuitySettingForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAnnuitySettingForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitySettingForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitySettingForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuitySettingForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuitySettingForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitySettingForView(response: HttpResponseBase): Observable<GetAnnuitySettingForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuitySettingForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuitySettingForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAnnuitySettingForEdit(id: number | undefined): Observable<GetAnnuitySettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAnnuitySettingForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitySettingForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitySettingForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuitySettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuitySettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitySettingForEdit(response: HttpResponseBase): Observable<GetAnnuitySettingForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuitySettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuitySettingForEditOutput>(<any>null);
    }

    /**
     * @param year (optional) 
     * @return Success
     */
    getAnnuitySettingForPayment(year: number | undefined): Observable<GetAnnuitySettingForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAnnuitySettingForPayment?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitySettingForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitySettingForPayment(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuitySettingForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuitySettingForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitySettingForPayment(response: HttpResponseBase): Observable<GetAnnuitySettingForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuitySettingForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuitySettingForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAnnuitySettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAnnuitySettingsToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAnnuitySettingsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitySettingsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitySettingsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitySettingsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAnnuitySettingsForSelect(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ListResultDtoOfAnnuitySettingDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAnnuitySettingsForSelect?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitySettingsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitySettingsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAnnuitySettingDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfAnnuitySettingDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitySettingsForSelect(response: HttpResponseBase): Observable<ListResultDtoOfAnnuitySettingDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfAnnuitySettingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfAnnuitySettingDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateAnnuities(body: EntityDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GenerateAnnuities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAnnuities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAnnuities(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAnnuities(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkGenerateAnnuities(body: EntityDto | undefined): Observable<GetGenerateAnnuityDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/CheckGenerateAnnuities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckGenerateAnnuities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckGenerateAnnuities(<any>response_);
                } catch (e) {
                    return <Observable<GetGenerateAnnuityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGenerateAnnuityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckGenerateAnnuities(response: HttpResponseBase): Observable<GetGenerateAnnuityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGenerateAnnuityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGenerateAnnuityDto>(<any>null);
    }

    /**
     * @param backgroundJobId (optional) 
     * @return Success
     */
    getAnnuityGenerationForView(backgroundJobId: number | undefined): Observable<GetAnnuityGenerationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAnnuityGenerationForView?";
        if (backgroundJobId === null)
            throw new Error("The parameter 'backgroundJobId' cannot be null.");
        else if (backgroundJobId !== undefined)
            url_ += "backgroundJobId=" + encodeURIComponent("" + backgroundJobId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityGenerationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityGenerationForView(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityGenerationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityGenerationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityGenerationForView(response: HttpResponseBase): Observable<GetAnnuityGenerationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuityGenerationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityGenerationForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllGlobalRules(): Observable<GlobalRulesDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/GetAllGlobalRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGlobalRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGlobalRules(<any>response_);
                } catch (e) {
                    return <Observable<GlobalRulesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GlobalRulesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllGlobalRules(response: HttpResponseBase): Observable<GlobalRulesDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GlobalRulesDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllGlobalRules(body: GlobalRulesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnuitySettings/UpdateAllGlobalRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllGlobalRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllGlobalRules(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllGlobalRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(<any>response_);
                } catch (e) {
                    return <Observable<NameValueDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueDto[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&"; 
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityChangeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityChangeListDto>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto[]>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CategoriesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param shortNameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param requiresDocumentFilter (optional) 
     * @param requiresAdditionalDocumentFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, nameFilter: string | undefined, shortNameFilter: string | undefined, isActiveFilter: number | undefined, requiresDocumentFilter: number | undefined, requiresAdditionalDocumentFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Categories/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (shortNameFilter === null)
            throw new Error("The parameter 'shortNameFilter' cannot be null.");
        else if (shortNameFilter !== undefined)
            url_ += "ShortNameFilter=" + encodeURIComponent("" + shortNameFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (requiresDocumentFilter === null)
            throw new Error("The parameter 'requiresDocumentFilter' cannot be null.");
        else if (requiresDocumentFilter !== undefined)
            url_ += "RequiresDocumentFilter=" + encodeURIComponent("" + requiresDocumentFilter) + "&"; 
        if (requiresAdditionalDocumentFilter === null)
            throw new Error("The parameter 'requiresAdditionalDocumentFilter' cannot be null.");
        else if (requiresAdditionalDocumentFilter !== undefined)
            url_ += "RequiresAdditionalDocumentFilter=" + encodeURIComponent("" + requiresAdditionalDocumentFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCategoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCategoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCategoryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCategoryForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param nameFilter (optional) 
     * @param shortNameFilter (optional) 
     * @param isActiveFilter (optional) 
     * @param requiresDocumentFilter (optional) 
     * @param requiresAdditionalDocumentFilter (optional) 
     * @return Success
     */
    getCategoriesToExcel(filter: string | undefined, nameFilter: string | undefined, shortNameFilter: string | undefined, isActiveFilter: number | undefined, requiresDocumentFilter: number | undefined, requiresAdditionalDocumentFilter: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Categories/GetCategoriesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "NameFilter=" + encodeURIComponent("" + nameFilter) + "&"; 
        if (shortNameFilter === null)
            throw new Error("The parameter 'shortNameFilter' cannot be null.");
        else if (shortNameFilter !== undefined)
            url_ += "ShortNameFilter=" + encodeURIComponent("" + shortNameFilter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (requiresDocumentFilter === null)
            throw new Error("The parameter 'requiresDocumentFilter' cannot be null.");
        else if (requiresDocumentFilter !== undefined)
            url_ += "RequiresDocumentFilter=" + encodeURIComponent("" + requiresDocumentFilter) + "&"; 
        if (requiresAdditionalDocumentFilter === null)
            throw new Error("The parameter 'requiresAdditionalDocumentFilter' cannot be null.");
        else if (requiresAdditionalDocumentFilter !== undefined)
            url_ += "RequiresAdditionalDocumentFilter=" + encodeURIComponent("" + requiresAdditionalDocumentFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoriesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoriesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCategoryForView(id: number | undefined): Observable<GetCategoryForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Categories/GetCategoryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCategoryForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCategoryForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryForView(response: HttpResponseBase): Observable<GetCategoryForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoryForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoryForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCategoryForEdit(id: number | undefined): Observable<GetCategoryForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Categories/GetCategoryForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCategoryForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCategoryForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryForEdit(response: HttpResponseBase): Observable<GetCategoryForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCategoryForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoryForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param isActive (optional) 
     * @param isExempt (optional) 
     * @return Success
     */
    getForSelect(term: string | undefined, isActive: boolean | undefined, isExempt: boolean | undefined): Observable<ListResultDtoOfCategoryListDto> {
        let url_ = this.baseUrl + "/api/services/app/Categories/GetForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (isExempt === null)
            throw new Error("The parameter 'isExempt' cannot be null.");
        else if (isExempt !== undefined)
            url_ += "IsExempt=" + encodeURIComponent("" + isExempt) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCategoryListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCategoryListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetForSelect(response: HttpResponseBase): Observable<ListResultDtoOfCategoryListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCategoryListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCategoryListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Categories/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Categories/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Categories/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCategoryEvolutions(): Observable<GetCategoryEvolutionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Categories/GetCategoryEvolutions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryEvolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryEvolutions(<any>response_);
                } catch (e) {
                    return <Observable<GetCategoryEvolutionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCategoryEvolutionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCategoryEvolutions(response: HttpResponseBase): Observable<GetCategoryEvolutionDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetCategoryEvolutionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCategoryEvolutionDto[]>(<any>null);
    }
}

@Injectable()
export class CertificatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param eventId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllConfigs(filter: string | undefined, eventId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCertificateConfigForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetAllConfigs?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllConfigs(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCertificateConfigForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCertificateConfigForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllConfigs(response: HttpResponseBase): Observable<PagedResultDtoOfGetCertificateConfigForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCertificateConfigForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCertificateConfigForViewDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventId (optional) 
     * @param cpf (optional) 
     * @param registrationId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCertificateConfigsForSelect(term: string | undefined, eventId: number | undefined, cpf: string | undefined, registrationId: number | undefined, tenantId: number | undefined): Observable<ListResultDtoOfCertificateConfigDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetCertificateConfigsForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (cpf === null)
            throw new Error("The parameter 'cpf' cannot be null.");
        else if (cpf !== undefined)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&"; 
        if (registrationId === null)
            throw new Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "RegistrationId=" + encodeURIComponent("" + registrationId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateConfigsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateConfigsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCertificateConfigDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCertificateConfigDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateConfigsForSelect(response: HttpResponseBase): Observable<ListResultDtoOfCertificateConfigDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCertificateConfigDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCertificateConfigDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    certificatePreview(body: CreateOrEditCertificateConfigDto | undefined): Observable<PreviewFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/CertificatePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCertificatePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCertificatePreview(<any>response_);
                } catch (e) {
                    return <Observable<PreviewFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreviewFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processCertificatePreview(response: HttpResponseBase): Observable<PreviewFileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviewFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreviewFileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param configId (optional) 
     * @param eventId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, configId: number | undefined, eventId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCertificateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "ConfigId=" + encodeURIComponent("" + configId) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCertificateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCertificateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCertificateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCertificateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCertificateForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCertificateForView(id: number | undefined): Observable<GetCertificateForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetCertificateForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCertificateForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCertificateForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateForView(response: HttpResponseBase): Observable<GetCertificateForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCertificateForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCertificateForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param configId (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getCertificatesToExcel(filter: string | undefined, configId: number | undefined, eventId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetCertificatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "ConfigId=" + encodeURIComponent("" + configId) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param cpf (optional) 
     * @param registrationId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCertificate(cpf: string | undefined, registrationId: number | undefined, configId: number, tenantId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetCertificate?";
        if (cpf === null)
            throw new Error("The parameter 'cpf' cannot be null.");
        else if (cpf !== undefined)
            url_ += "Cpf=" + encodeURIComponent("" + cpf) + "&"; 
        if (registrationId === null)
            throw new Error("The parameter 'registrationId' cannot be null.");
        else if (registrationId !== undefined)
            url_ += "RegistrationId=" + encodeURIComponent("" + registrationId) + "&"; 
        if (configId === undefined || configId === null)
            throw new Error("The parameter 'configId' must be defined and cannot be null.");
        else
            url_ += "ConfigId=" + encodeURIComponent("" + configId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificate(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param userIdFilter (optional) 
     * @param eventIds (optional) 
     * @param typeIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMemberCertificates(filter: string | undefined, userIdFilter: number | undefined, eventIds: string | undefined, typeIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRegistrationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetMemberCertificates?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (eventIds === null)
            throw new Error("The parameter 'eventIds' cannot be null.");
        else if (eventIds !== undefined)
            url_ += "EventIds=" + encodeURIComponent("" + eventIds) + "&"; 
        if (typeIdFilter === null)
            throw new Error("The parameter 'typeIdFilter' cannot be null.");
        else if (typeIdFilter !== undefined)
            url_ += "TypeIdFilter=" + encodeURIComponent("" + typeIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberCertificates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberCertificates(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegistrationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegistrationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberCertificates(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegistrationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRegistrationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegistrationForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param userIdFilter (optional) 
     * @param eventIds (optional) 
     * @param typeIdFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMemberCertificatesToExcel(filter: string | undefined, userIdFilter: number | undefined, eventIds: string | undefined, typeIdFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificates/GetMemberCertificatesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (eventIds === null)
            throw new Error("The parameter 'eventIds' cannot be null.");
        else if (eventIds !== undefined)
            url_ += "EventIds=" + encodeURIComponent("" + eventIds) + "&"; 
        if (typeIdFilter === null)
            throw new Error("The parameter 'typeIdFilter' cannot be null.");
        else if (typeIdFilter !== undefined)
            url_ += "TypeIdFilter=" + encodeURIComponent("" + typeIdFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberCertificatesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberCertificatesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberCertificatesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (minMessageId === null)
            throw new Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param onlyAdminMembers (optional) 
     * @param tenantId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenantUsers(filter: string | undefined, onlyAdminMembers: boolean | undefined, tenantId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetTenantUsers?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (onlyAdminMembers === null)
            throw new Error("The parameter 'onlyAdminMembers' cannot be null.");
        else if (onlyAdminMembers !== undefined)
            url_ += "OnlyAdminMembers=" + encodeURIComponent("" + onlyAdminMembers) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(<any>response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class CompaniesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isActiveFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCompanyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Companies/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCompanyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCompanyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCompanyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCompanyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCompanyForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getCompaniesToExcel(filter: string | undefined, isActiveFilter: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Companies/GetCompaniesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompaniesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompaniesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompaniesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyForView(id: number | undefined): Observable<GetCompanyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Companies/GetCompanyForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCompanyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCompanyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyForView(response: HttpResponseBase): Observable<GetCompanyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompanyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCompanyForEdit(id: number | undefined): Observable<GetCompanyForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Companies/GetCompanyForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCompanyForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCompanyForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyForEdit(response: HttpResponseBase): Observable<GetCompanyForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCompanyForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCompanyForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    getForSelect(term: string | undefined, isActive: boolean | undefined): Observable<ListResultDtoOfCompanyListDto> {
        let url_ = this.baseUrl + "/api/services/app/Companies/GetForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCompanyListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCompanyListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetForSelect(response: HttpResponseBase): Observable<ListResultDtoOfCompanyListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCompanyListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCompanyListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCompanyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Companies/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Companies/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getCompanyTypesForSelect(term: string | undefined): Observable<ListResultDtoOfCompanyTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Companies/GetCompanyTypesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyTypesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCompanyTypeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCompanyTypeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyTypesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfCompanyTypeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCompanyTypeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCompanyTypeListDto>(<any>null);
    }
}

@Injectable()
export class CouponsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param batchId (optional) 
     * @param couponUserId (optional) 
     * @param updatedManually (optional) 
     * @param used (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, batchId: number | undefined, couponUserId: number | undefined, updatedManually: boolean | undefined, used: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCouponForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&"; 
        if (couponUserId === null)
            throw new Error("The parameter 'couponUserId' cannot be null.");
        else if (couponUserId !== undefined)
            url_ += "CouponUserId=" + encodeURIComponent("" + couponUserId) + "&"; 
        if (updatedManually === null)
            throw new Error("The parameter 'updatedManually' cannot be null.");
        else if (updatedManually !== undefined)
            url_ += "UpdatedManually=" + encodeURIComponent("" + updatedManually) + "&"; 
        if (used === null)
            throw new Error("The parameter 'used' cannot be null.");
        else if (used !== undefined)
            url_ += "Used=" + encodeURIComponent("" + used) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCouponForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCouponForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCouponForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCouponForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCouponForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param couponBatchId (optional) 
     * @param couponUserId (optional) 
     * @param updatedManually (optional) 
     * @param used (optional) 
     * @return Success
     */
    getCouponsToExcel(filter: string | undefined, couponBatchId: number | undefined, couponUserId: number | undefined, updatedManually: boolean | undefined, used: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (couponBatchId === null)
            throw new Error("The parameter 'couponBatchId' cannot be null.");
        else if (couponBatchId !== undefined)
            url_ += "CouponBatchId=" + encodeURIComponent("" + couponBatchId) + "&"; 
        if (couponUserId === null)
            throw new Error("The parameter 'couponUserId' cannot be null.");
        else if (couponUserId !== undefined)
            url_ += "CouponUserId=" + encodeURIComponent("" + couponUserId) + "&"; 
        if (updatedManually === null)
            throw new Error("The parameter 'updatedManually' cannot be null.");
        else if (updatedManually !== undefined)
            url_ += "UpdatedManually=" + encodeURIComponent("" + updatedManually) + "&"; 
        if (used === null)
            throw new Error("The parameter 'used' cannot be null.");
        else if (used !== undefined)
            url_ += "Used=" + encodeURIComponent("" + used) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCouponsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCouponsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCouponsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCouponForEdit(id: number | undefined): Observable<GetCouponForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCouponForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCouponForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCouponForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCouponForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCouponForEdit(response: HttpResponseBase): Observable<GetCouponForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCouponForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCouponDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param couponCode (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    validateCouponByCode(couponCode: string | undefined, tenantId: number | undefined): Observable<ValidateCouponOutput> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/ValidateCouponByCode?";
        if (couponCode === null)
            throw new Error("The parameter 'couponCode' cannot be null.");
        else if (couponCode !== undefined)
            url_ += "couponCode=" + encodeURIComponent("" + couponCode) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCouponByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCouponByCode(<any>response_);
                } catch (e) {
                    return <Observable<ValidateCouponOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateCouponOutput>><any>_observableThrow(response_);
        }));
    }

    protected processValidateCouponByCode(response: HttpResponseBase): Observable<ValidateCouponOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateCouponOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateCouponOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param discountTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllBatches(filter: string | undefined, discountTypeFilter: DiscountType | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCouponBatchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetAllBatches?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (discountTypeFilter === null)
            throw new Error("The parameter 'discountTypeFilter' cannot be null.");
        else if (discountTypeFilter !== undefined)
            url_ += "DiscountTypeFilter=" + encodeURIComponent("" + discountTypeFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBatches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBatches(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCouponBatchForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCouponBatchForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBatches(response: HttpResponseBase): Observable<PagedResultDtoOfGetCouponBatchForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCouponBatchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCouponBatchForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param discountTypeFilter (optional) 
     * @return Success
     */
    getCouponBatchesToExcel(filter: string | undefined, discountTypeFilter: DiscountType | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponBatchesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (discountTypeFilter === null)
            throw new Error("The parameter 'discountTypeFilter' cannot be null.");
        else if (discountTypeFilter !== undefined)
            url_ += "DiscountTypeFilter=" + encodeURIComponent("" + discountTypeFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCouponBatchesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCouponBatchesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCouponBatchesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCouponBatchForView(id: number | undefined): Observable<GetCouponBatchForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponBatchForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCouponBatchForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCouponBatchForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCouponBatchForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCouponBatchForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCouponBatchForView(response: HttpResponseBase): Observable<GetCouponBatchForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCouponBatchForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponBatchForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCouponBatchForEdit(id: number | undefined): Observable<GetCouponBatchForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/GetCouponBatchForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCouponBatchForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCouponBatchForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCouponBatchForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCouponBatchForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCouponBatchForEdit(response: HttpResponseBase): Observable<GetCouponBatchForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCouponBatchForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponBatchForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditBatch(body: CreateOrEditCouponBatchDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/CreateOrEditBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditBatch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteBatch(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Coupons/DeleteBatch?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBatch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CoverageAreasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetCoverageAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetCoverageAreaForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetCoverageAreaForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetCoverageAreaForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetCoverageAreaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetCoverageAreaForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getCoverageAreasToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/GetCoverageAreasToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverageAreasToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverageAreasToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoverageAreasToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoverageAreaForView(id: number | undefined): Observable<GetCoverageAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/GetCoverageAreaForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverageAreaForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverageAreaForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCoverageAreaForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCoverageAreaForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoverageAreaForView(response: HttpResponseBase): Observable<GetCoverageAreaForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoverageAreaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoverageAreaForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCoverageAreaForEdit(id: number | undefined): Observable<GetCoverageAreaForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/GetCoverageAreaForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverageAreaForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverageAreaForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCoverageAreaForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCoverageAreaForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoverageAreaForEdit(response: HttpResponseBase): Observable<GetCoverageAreaForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCoverageAreaForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCoverageAreaForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    getCoverageAreasForSelect(term: string | undefined, isActive: boolean | undefined): Observable<ListResultDtoOfCoverageAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/GetCoverageAreasForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverageAreasForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverageAreasForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCoverageAreaDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfCoverageAreaDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCoverageAreasForSelect(response: HttpResponseBase): Observable<ListResultDtoOfCoverageAreaDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCoverageAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfCoverageAreaDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditCoverageAreaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CoverageAreas/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getUserDashboard(dashboardName: string | undefined, application: string | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(<any>response_);
                } catch (e) {
                    return <Observable<Dashboard>><any>_observableThrow(e);
                }
            } else
                return <Observable<Dashboard>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Dashboard>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePage(body: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renamePage(body: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(<any>response_);
                } catch (e) {
                    return <Observable<AddNewPageOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddNewPageOutput>><any>_observableThrow(response_);
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddNewPageOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @param backToDefaultPage (optional) 
     * @return Success
     */
    deletePage(id: string | undefined, dashboardName: string | undefined, application: string | undefined, backToDefaultPage: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        if (backToDefaultPage === null)
            throw new Error("The parameter 'backToDefaultPage' cannot be null.");
        else if (backToDefaultPage !== undefined)
            url_ += "BackToDefaultPage=" + encodeURIComponent("" + backToDefaultPage) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(<any>response_);
                } catch (e) {
                    return <Observable<Widget>><any>_observableThrow(e);
                }
            } else
                return <Observable<Widget>><any>_observableThrow(response_);
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Widget>(<any>null);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getDashboardDefinition(dashboardName: string | undefined, application: string | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(<any>response_);
                } catch (e) {
                    return <Observable<DashboardOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DashboardOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardOutput>(<any>null);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getAllWidgetDefinitions(dashboardName: string | undefined, application: string | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&"; 
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(<any>response_);
                } catch (e) {
                    return <Observable<WidgetOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<WidgetOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WidgetOutput[]>(<any>null);
    }

    /**
     * @param application (optional) 
     * @return Success
     */
    getSettingName(application: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetSettingName?";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "application=" + encodeURIComponent("" + application) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingName(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSettingName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(<any>response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DateToStringOutput>(<any>null);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(<any>response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameValueOfString[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(<any>response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StringOutput>><any>_observableThrow(response_);
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StringOutput>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&"; 
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&"; 
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEditionComboboxItemDto[]>(<any>null);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

@Injectable()
export class EventsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param type (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, type: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param maxStartDateFilter (optional) 
     * @param minStartDateFilter (optional) 
     * @param maxEndDateFilter (optional) 
     * @param minEndDateFilter (optional) 
     * @param type (optional) 
     * @return Success
     */
    getEventsToExcel(filter: string | undefined, maxStartDateFilter: moment.Moment | undefined, minStartDateFilter: moment.Moment | undefined, maxEndDateFilter: moment.Moment | undefined, minEndDateFilter: moment.Moment | undefined, type: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (maxStartDateFilter === null)
            throw new Error("The parameter 'maxStartDateFilter' cannot be null.");
        else if (maxStartDateFilter !== undefined)
            url_ += "MaxStartDateFilter=" + encodeURIComponent(maxStartDateFilter ? "" + maxStartDateFilter.toJSON() : "") + "&"; 
        if (minStartDateFilter === null)
            throw new Error("The parameter 'minStartDateFilter' cannot be null.");
        else if (minStartDateFilter !== undefined)
            url_ += "MinStartDateFilter=" + encodeURIComponent(minStartDateFilter ? "" + minStartDateFilter.toJSON() : "") + "&"; 
        if (maxEndDateFilter === null)
            throw new Error("The parameter 'maxEndDateFilter' cannot be null.");
        else if (maxEndDateFilter !== undefined)
            url_ += "MaxEndDateFilter=" + encodeURIComponent(maxEndDateFilter ? "" + maxEndDateFilter.toJSON() : "") + "&"; 
        if (minEndDateFilter === null)
            throw new Error("The parameter 'minEndDateFilter' cannot be null.");
        else if (minEndDateFilter !== undefined)
            url_ += "MinEndDateFilter=" + encodeURIComponent(minEndDateFilter ? "" + minEndDateFilter.toJSON() : "") + "&"; 
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventForView(id: number | undefined): Observable<GetEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventForView(<any>response_);
                } catch (e) {
                    return <Observable<GetEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventForView(response: HttpResponseBase): Observable<GetEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventForRegistration(id: number | undefined): Observable<GetEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventForRegistration?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventForRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventForRegistration(<any>response_);
                } catch (e) {
                    return <Observable<GetEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventForRegistration(response: HttpResponseBase): Observable<GetEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventForSignUp(id: number | undefined): Observable<GetEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventForSignUp?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventForSignUp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventForSignUp(<any>response_);
                } catch (e) {
                    return <Observable<GetEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventForSignUp(response: HttpResponseBase): Observable<GetEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param type (optional) 
     * @param registrationPaymentType (optional) 
     * @param placeType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getEventsForRegistration(filter: string | undefined, type: number | undefined, registrationPaymentType: RegistrationPaymentType | undefined, placeType: EventPlaceType | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEventForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsForRegistration?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        if (registrationPaymentType === null)
            throw new Error("The parameter 'registrationPaymentType' cannot be null.");
        else if (registrationPaymentType !== undefined)
            url_ += "RegistrationPaymentType=" + encodeURIComponent("" + registrationPaymentType) + "&"; 
        if (placeType === null)
            throw new Error("The parameter 'placeType' cannot be null.");
        else if (placeType !== undefined)
            url_ += "PlaceType=" + encodeURIComponent("" + placeType) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventsForRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventsForRegistration(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventsForRegistration(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEventForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventForViewDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getEventsForRegistrationOrder(userId: number | undefined): Observable<GetEventForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsForRegistrationOrder?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventsForRegistrationOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventsForRegistrationOrder(<any>response_);
                } catch (e) {
                    return <Observable<GetEventForViewDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventForViewDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventsForRegistrationOrder(response: HttpResponseBase): Observable<GetEventForViewDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEventForViewDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventForViewDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventForEdit(id: number | undefined): Observable<GetEventForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventForEdit(response: HttpResponseBase): Observable<GetEventForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventTypeId (optional) 
     * @param onlyWithoutHotsite (optional) 
     * @param onlyWithoutEventSchedule (optional) 
     * @param onlyCertificates (optional) 
     * @return Success
     */
    getEventsForSelect(term: string | undefined, eventTypeId: number | undefined, onlyWithoutHotsite: boolean | undefined, onlyWithoutEventSchedule: boolean | undefined, onlyCertificates: boolean | undefined): Observable<ListResultDtoOfEventListDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventsForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventTypeId === null)
            throw new Error("The parameter 'eventTypeId' cannot be null.");
        else if (eventTypeId !== undefined)
            url_ += "EventTypeId=" + encodeURIComponent("" + eventTypeId) + "&"; 
        if (onlyWithoutHotsite === null)
            throw new Error("The parameter 'onlyWithoutHotsite' cannot be null.");
        else if (onlyWithoutHotsite !== undefined)
            url_ += "OnlyWithoutHotsite=" + encodeURIComponent("" + onlyWithoutHotsite) + "&"; 
        if (onlyWithoutEventSchedule === null)
            throw new Error("The parameter 'onlyWithoutEventSchedule' cannot be null.");
        else if (onlyWithoutEventSchedule !== undefined)
            url_ += "OnlyWithoutEventSchedule=" + encodeURIComponent("" + onlyWithoutEventSchedule) + "&"; 
        if (onlyCertificates === null)
            throw new Error("The parameter 'onlyCertificates' cannot be null.");
        else if (onlyCertificates !== undefined)
            url_ += "OnlyCertificates=" + encodeURIComponent("" + onlyCertificates) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventsForSelect(response: HttpResponseBase): Observable<ListResultDtoOfEventListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEventListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEventDto | undefined): Observable<UpdateEventDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UpdateEventDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateEventDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UpdateEventDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateEventDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEventDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEventLogo(body: UpdateEventLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/UpdateEventLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEventLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEventLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateEventLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publish(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/Publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPublish(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CancelPublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPublish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getEventTypesForSelect(term: string | undefined): Observable<ListResultDtoOfEventTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventTypesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventTypesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventTypeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventTypeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventTypesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfEventTypeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEventTypeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventTypeListDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getEventPlacesForSelect(term: string | undefined): Observable<ListResultDtoOfEventPlaceListDto> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetEventPlacesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventPlacesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventPlacesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventPlaceListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventPlaceListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventPlacesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfEventPlaceListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEventPlaceListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventPlaceListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDeadlines(id: number | undefined): Observable<EventDeadlineDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetDeadlines?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeadlines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeadlines(<any>response_);
                } catch (e) {
                    return <Observable<EventDeadlineDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventDeadlineDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDeadlines(response: HttpResponseBase): Observable<EventDeadlineDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDeadlineDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDeadlineDto[]>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAllEventDeadlineForSelect(term: string | undefined, eventId: number | undefined): Observable<EventDeadlineListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetAllEventDeadlineForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventDeadlineForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventDeadlineForSelect(<any>response_);
                } catch (e) {
                    return <Observable<EventDeadlineListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventDeadlineListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEventDeadlineForSelect(response: HttpResponseBase): Observable<EventDeadlineListDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventDeadlineListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventDeadlineListDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDeadlines(body: CreateOrEditEventDeadlinesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CreateDeadlines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeadlines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeadlines(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateDeadlines(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDeadlines(body: CreateOrEditEventDeadlinesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/UpdateDeadlines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeadlines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeadlines(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDeadlines(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExtraFees(id: number | undefined): Observable<EventExtraFeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetExtraFees?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExtraFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExtraFees(<any>response_);
                } catch (e) {
                    return <Observable<EventExtraFeeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventExtraFeeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExtraFees(response: HttpResponseBase): Observable<EventExtraFeeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventExtraFeeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventExtraFeeDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createExtraFees(body: CreateOrEditEeventExtraFeesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CreateExtraFees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExtraFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExtraFees(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateExtraFees(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExtraFees(body: CreateOrEditEeventExtraFeesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/UpdateExtraFees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExtraFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExtraFees(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExtraFees(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCnaScores(id: number | undefined): Observable<EventCnaScoreDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetCnaScores?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCnaScores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCnaScores(<any>response_);
                } catch (e) {
                    return <Observable<EventCnaScoreDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventCnaScoreDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCnaScores(response: HttpResponseBase): Observable<EventCnaScoreDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventCnaScoreDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventCnaScoreDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCnaScores(body: CreateOrEditEventCnaScoresDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CreateCnaScores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCnaScores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCnaScores(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCnaScores(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCnaScores(body: CreateOrEditEventCnaScoresDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/UpdateCnaScores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCnaScores(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCnaScores(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCnaScores(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCertificateConfigs(id: number | undefined): Observable<CertificateConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Events/GetCertificateConfigs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateConfigs(<any>response_);
                } catch (e) {
                    return <Observable<CertificateConfigDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateConfigDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateConfigs(response: HttpResponseBase): Observable<CertificateConfigDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificateConfigDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateConfigDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCertificateConfigs(body: CreateOrEditCertificateConfigsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/CreateCertificateConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCertificateConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCertificateConfigs(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCertificateConfigs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCertificateConfigs(body: CreateOrEditCertificateConfigsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Events/UpdateCertificateConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCertificateConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCertificateConfigs(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCertificateConfigs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EventSchedulesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param eventId (optional) 
     * @param eventScheduleId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, eventId: number | undefined, eventScheduleId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetEventScheduleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetEventScheduleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetEventScheduleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetEventScheduleForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetEventScheduleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetEventScheduleForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventId (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getEventSchedulesToExcel(filter: string | undefined, eventId: number | undefined, eventScheduleId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetEventSchedulesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventSchedulesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventSchedulesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventSchedulesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllEventForTableDropdown(): Observable<EventScheduleEventLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetAllEventForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<EventScheduleEventLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventScheduleEventLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEventForTableDropdown(response: HttpResponseBase): Observable<EventScheduleEventLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventScheduleEventLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventScheduleEventLookupTableDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    eventSchedulesForSelect(body: GetEventSchedulesInput | undefined): Observable<EventScheduleListDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/EventSchedulesForSelect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEventSchedulesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEventSchedulesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<EventScheduleListDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EventScheduleListDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processEventSchedulesForSelect(response: HttpResponseBase): Observable<EventScheduleListDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventScheduleListDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EventScheduleListDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventScheduleForView(id: number | undefined): Observable<GetEventScheduleForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetEventScheduleForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventScheduleForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventScheduleForView(<any>response_);
                } catch (e) {
                    return <Observable<GetEventScheduleForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventScheduleForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventScheduleForView(response: HttpResponseBase): Observable<GetEventScheduleForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventScheduleForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventScheduleForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEventScheduleForEdit(id: number | undefined): Observable<GetEventScheduleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetEventScheduleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventScheduleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventScheduleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetEventScheduleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEventScheduleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventScheduleForEdit(response: HttpResponseBase): Observable<GetEventScheduleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventScheduleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEventScheduleForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEventScheduleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEventScheduleDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCalendarForView(id: number | undefined): Observable<GetCalendarForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetCalendarForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarForView(<any>response_);
                } catch (e) {
                    return <Observable<GetCalendarForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCalendarForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarForView(response: HttpResponseBase): Observable<GetCalendarForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalendarForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCalendarForViewDto>(<any>null);
    }

    /**
     * @param calendarId (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getCalendarForEdit(calendarId: number | undefined, eventScheduleId: number | undefined): Observable<GetCalendarForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetCalendarForEdit?";
        if (calendarId === null)
            throw new Error("The parameter 'calendarId' cannot be null.");
        else if (calendarId !== undefined)
            url_ += "CalendarId=" + encodeURIComponent("" + calendarId) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetCalendarForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCalendarForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarForEdit(response: HttpResponseBase): Observable<GetCalendarForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalendarForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCalendarForEditOutput>(<any>null);
    }

    /**
     * @param eventScheduleId (optional) 
     * @return Success
     */
    createCalendar(eventScheduleId: number | undefined): Observable<CalendarDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/CreateCalendar?";
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "eventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCalendar(<any>response_);
                } catch (e) {
                    return <Observable<CalendarDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CalendarDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCalendar(response: HttpResponseBase): Observable<CalendarDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalendarDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalendarDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCalendar(body: CreateOrEditCalendarDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/UpdateCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCalendar(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCalendarToExcel(id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetCalendarToExcel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param calendarId (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getCalendarToWord(calendarId: number | undefined, eventScheduleId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetCalendarToWord?";
        if (calendarId === null)
            throw new Error("The parameter 'calendarId' cannot be null.");
        else if (calendarId !== undefined)
            url_ += "CalendarId=" + encodeURIComponent("" + calendarId) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarToWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarToWord(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarToWord(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param activityId (optional) 
     * @return Success
     */
    getCalendarActivityForView(activityId: number | undefined): Observable<GetActivityForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetCalendarActivityForView?";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalendarActivityForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarActivityForView(<any>response_);
                } catch (e) {
                    return <Observable<GetActivityForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetActivityForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCalendarActivityForView(response: HttpResponseBase): Observable<GetActivityForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActivityForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityForViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrEditActivityToTheCalendar(body: CreateOrEditActivityDto | undefined): Observable<CreateOrEditCalendarActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/AddOrEditActivityToTheCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrEditActivityToTheCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrEditActivityToTheCalendar(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditCalendarActivityOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditCalendarActivityOutput>><any>_observableThrow(response_);
        }));
    }

    protected processAddOrEditActivityToTheCalendar(response: HttpResponseBase): Observable<CreateOrEditCalendarActivityOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditCalendarActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCalendarActivityOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateActivityToTheCalendar(body: CreateOrEditActivityDto | undefined): Observable<CreateOrEditCalendarActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/UpdateActivityToTheCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityToTheCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityToTheCalendar(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditCalendarActivityOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditCalendarActivityOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateActivityToTheCalendar(response: HttpResponseBase): Observable<CreateOrEditCalendarActivityOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditCalendarActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCalendarActivityOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeActivity(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/RemoveActivity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveActivity(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveActivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param day (optional) 
     * @param eventScheduleDayId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEventScheduleDaysForSelect(day: moment.Moment | undefined, eventScheduleDayId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ListResultDtoOfEventScheduleDayListDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetEventScheduleDaysForSelect?";
        if (day === null)
            throw new Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "Day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&"; 
        if (eventScheduleDayId === null)
            throw new Error("The parameter 'eventScheduleDayId' cannot be null.");
        else if (eventScheduleDayId !== undefined)
            url_ += "EventScheduleDayId=" + encodeURIComponent("" + eventScheduleDayId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventScheduleDaysForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventScheduleDaysForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventScheduleDayListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventScheduleDayListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventScheduleDaysForSelect(response: HttpResponseBase): Observable<ListResultDtoOfEventScheduleDayListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEventScheduleDayListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventScheduleDayListDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleDayId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEventScheduleRoomsForSelect(term: string | undefined, eventScheduleDayId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ListResultDtoOfEventScheduleRoomListDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetEventScheduleRoomsForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleDayId === null)
            throw new Error("The parameter 'eventScheduleDayId' cannot be null.");
        else if (eventScheduleDayId !== undefined)
            url_ += "EventScheduleDayId=" + encodeURIComponent("" + eventScheduleDayId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventScheduleRoomsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventScheduleRoomsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventScheduleRoomListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventScheduleRoomListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventScheduleRoomsForSelect(response: HttpResponseBase): Observable<ListResultDtoOfEventScheduleRoomListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEventScheduleRoomListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventScheduleRoomListDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param day (optional) 
     * @param calendarId (optional) 
     * @param eventScheduleDayId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEventScheduleRoomDaysForSelect(term: string | undefined, day: moment.Moment | undefined, calendarId: number | undefined, eventScheduleDayId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ListResultDtoOfEventScheduleRoomDayListDto> {
        let url_ = this.baseUrl + "/api/services/app/EventSchedules/GetEventScheduleRoomDaysForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (day === null)
            throw new Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "Day=" + encodeURIComponent(day ? "" + day.toJSON() : "") + "&"; 
        if (calendarId === null)
            throw new Error("The parameter 'calendarId' cannot be null.");
        else if (calendarId !== undefined)
            url_ += "CalendarId=" + encodeURIComponent("" + calendarId) + "&"; 
        if (eventScheduleDayId === null)
            throw new Error("The parameter 'eventScheduleDayId' cannot be null.");
        else if (eventScheduleDayId !== undefined)
            url_ += "EventScheduleDayId=" + encodeURIComponent("" + eventScheduleDayId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventScheduleRoomDaysForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventScheduleRoomDaysForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEventScheduleRoomDayListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfEventScheduleRoomDayListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEventScheduleRoomDaysForSelect(response: HttpResponseBase): Observable<ListResultDtoOfEventScheduleRoomDayListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEventScheduleRoomDayListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfEventScheduleRoomDayListDto>(<any>null);
    }
}

@Injectable()
export class ExhibitorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param eventScheduleId (optional) 
     * @param exhibitorTypeId (optional) 
     * @param onlyIsActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, eventScheduleId: number | undefined, exhibitorTypeId: number | undefined, onlyIsActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetExhibitorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (exhibitorTypeId === null)
            throw new Error("The parameter 'exhibitorTypeId' cannot be null.");
        else if (exhibitorTypeId !== undefined)
            url_ += "ExhibitorTypeId=" + encodeURIComponent("" + exhibitorTypeId) + "&"; 
        if (onlyIsActive === null)
            throw new Error("The parameter 'onlyIsActive' cannot be null.");
        else if (onlyIsActive !== undefined)
            url_ += "OnlyIsActive=" + encodeURIComponent("" + onlyIsActive) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetExhibitorForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetExhibitorForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetExhibitorForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetExhibitorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetExhibitorForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventScheduleId (optional) 
     * @param exhibitorTypeId (optional) 
     * @param onlyIsActive (optional) 
     * @return Success
     */
    getExhibitorsToExcel(filter: string | undefined, eventScheduleId: number | undefined, exhibitorTypeId: number | undefined, onlyIsActive: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetExhibitorsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (exhibitorTypeId === null)
            throw new Error("The parameter 'exhibitorTypeId' cannot be null.");
        else if (exhibitorTypeId !== undefined)
            url_ += "ExhibitorTypeId=" + encodeURIComponent("" + exhibitorTypeId) + "&"; 
        if (onlyIsActive === null)
            throw new Error("The parameter 'onlyIsActive' cannot be null.");
        else if (onlyIsActive !== undefined)
            url_ += "OnlyIsActive=" + encodeURIComponent("" + onlyIsActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExhibitorsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExhibitorsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExhibitorsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllEventScheduleForTableDropdown(): Observable<ExhibitorEventScheduleLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetAllEventScheduleForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventScheduleForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventScheduleForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<ExhibitorEventScheduleLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExhibitorEventScheduleLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllEventScheduleForTableDropdown(response: HttpResponseBase): Observable<ExhibitorEventScheduleLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExhibitorEventScheduleLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExhibitorEventScheduleLookupTableDto[]>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getExhibitorForSelect(term: string | undefined, eventScheduleId: number | undefined): Observable<ListResultDtoOfExhibitorDto> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetExhibitorForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExhibitorForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExhibitorForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfExhibitorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfExhibitorDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExhibitorForSelect(response: HttpResponseBase): Observable<ListResultDtoOfExhibitorDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfExhibitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfExhibitorDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExhibitorForView(id: number | undefined): Observable<GetExhibitorForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetExhibitorForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExhibitorForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExhibitorForView(<any>response_);
                } catch (e) {
                    return <Observable<GetExhibitorForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExhibitorForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExhibitorForView(response: HttpResponseBase): Observable<GetExhibitorForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExhibitorForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExhibitorForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getExhibitorForEdit(id: number | undefined): Observable<GetExhibitorForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetExhibitorForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExhibitorForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExhibitorForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetExhibitorForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExhibitorForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetExhibitorForEdit(response: HttpResponseBase): Observable<GetExhibitorForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExhibitorForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExhibitorForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditExhibitorDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExhibitorLogo(body: UpdateExhibitorLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/UpdateExhibitorLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExhibitorLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExhibitorLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExhibitorLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExhibitorEmblem(body: UpdateExhibitorLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/UpdateExhibitorEmblem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExhibitorEmblem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExhibitorEmblem(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExhibitorEmblem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExhibitorLogoList(body: UpdateExhibitorLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/UpdateExhibitorLogoList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExhibitorLogoList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExhibitorLogoList(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExhibitorLogoList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSurveyImage(body: UpdateExhibitorLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/UpdateSurveyImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSurveyImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSurveyImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSurveyImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDrawImage(body: UpdateExhibitorLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/UpdateDrawImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDrawImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDrawImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDrawImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExhibitorsOrder(body: UpdateExhibitorOrderInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/UpdateExhibitorsOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExhibitorsOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExhibitorsOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateExhibitorsOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getExhibitorTypesForSelect(term: string | undefined): Observable<ListResultDtoOfExhibitorTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Exhibitors/GetExhibitorTypesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExhibitorTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExhibitorTypesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfExhibitorTypeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfExhibitorTypeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetExhibitorTypesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfExhibitorTypeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfExhibitorTypeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfExhibitorTypeListDto>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(<any>response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FriendDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(<any>response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FriendDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FriendDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class GuestsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param userNameFilter (optional) 
     * @param eventScheduleId (optional) 
     * @param scheduleSubmitted (optional) 
     * @param countryName (optional) 
     * @param stateName (optional) 
     * @param city (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, userNameFilter: string | undefined, eventScheduleId: number | undefined, scheduleSubmitted: boolean | undefined, countryName: string | undefined, stateName: string | undefined, city: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetGuestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (userNameFilter === null)
            throw new Error("The parameter 'userNameFilter' cannot be null.");
        else if (userNameFilter !== undefined)
            url_ += "UserNameFilter=" + encodeURIComponent("" + userNameFilter) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (scheduleSubmitted === null)
            throw new Error("The parameter 'scheduleSubmitted' cannot be null.");
        else if (scheduleSubmitted !== undefined)
            url_ += "ScheduleSubmitted=" + encodeURIComponent("" + scheduleSubmitted) + "&"; 
        if (countryName === null)
            throw new Error("The parameter 'countryName' cannot be null.");
        else if (countryName !== undefined)
            url_ += "CountryName=" + encodeURIComponent("" + countryName) + "&"; 
        if (stateName === null)
            throw new Error("The parameter 'stateName' cannot be null.");
        else if (stateName !== undefined)
            url_ += "StateName=" + encodeURIComponent("" + stateName) + "&"; 
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetGuestForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetGuestForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetGuestForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetGuestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetGuestForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventScheduleId (optional) 
     * @param scheduleSubmitted (optional) 
     * @param countryName (optional) 
     * @param stateName (optional) 
     * @param city (optional) 
     * @return Success
     */
    getGuestsToExcel(filter: string | undefined, eventScheduleId: number | undefined, scheduleSubmitted: boolean | undefined, countryName: string | undefined, stateName: string | undefined, city: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (scheduleSubmitted === null)
            throw new Error("The parameter 'scheduleSubmitted' cannot be null.");
        else if (scheduleSubmitted !== undefined)
            url_ += "ScheduleSubmitted=" + encodeURIComponent("" + scheduleSubmitted) + "&"; 
        if (countryName === null)
            throw new Error("The parameter 'countryName' cannot be null.");
        else if (countryName !== undefined)
            url_ += "CountryName=" + encodeURIComponent("" + countryName) + "&"; 
        if (stateName === null)
            throw new Error("The parameter 'stateName' cannot be null.");
        else if (stateName !== undefined)
            url_ += "StateName=" + encodeURIComponent("" + stateName) + "&"; 
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuestsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuestsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGuestsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGuestForView(id: number | undefined): Observable<GetGuestForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuestForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuestForView(<any>response_);
                } catch (e) {
                    return <Observable<GetGuestForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGuestForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGuestForView(response: HttpResponseBase): Observable<GetGuestForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGuestForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGuestForViewDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllUserForTableDropdown(): Observable<GuestUserLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetAllUserForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<GuestUserLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GuestUserLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserForTableDropdown(response: HttpResponseBase): Observable<GuestUserLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuestUserLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuestUserLookupTableDto[]>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getThematicAreasForSelect(term: string | undefined, eventScheduleId: number | undefined): Observable<ListResultDtoOfGuestDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetThematicAreasForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThematicAreasForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThematicAreasForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetThematicAreasForSelect(response: HttpResponseBase): Observable<ListResultDtoOfGuestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGuestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGuestDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getGuestsForSelect(term: string | undefined, eventScheduleId: number | undefined): Observable<ListResultDtoOfGuestListDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestsForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuestsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuestsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGuestsForSelect(response: HttpResponseBase): Observable<ListResultDtoOfGuestListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGuestListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGuestListDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getSpeakersForSelect(term: string | undefined, eventScheduleId: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ListResultDtoOfGuestListDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetSpeakersForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeakersForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeakersForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpeakersForSelect(response: HttpResponseBase): Observable<ListResultDtoOfGuestListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGuestListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGuestListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGuestForEdit(id: number | undefined): Observable<GetGuestForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuestForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuestForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetGuestForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGuestForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGuestForEdit(response: HttpResponseBase): Observable<GetGuestForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGuestForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGuestForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditGuestDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGuestSchedule(id: number | undefined): Observable<GuestScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestSchedule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuestSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuestSchedule(<any>response_);
                } catch (e) {
                    return <Observable<GuestScheduleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GuestScheduleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGuestSchedule(response: HttpResponseBase): Observable<GuestScheduleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuestScheduleDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendScheduleByEmail(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/SendScheduleByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendScheduleByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScheduleByEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendScheduleByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSchedulesListByEmail(body: SendSchedulesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/SendSchedulesListByEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSchedulesListByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSchedulesListByEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendSchedulesListByEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateGuestProfilePicture(body: UpdateProfilePictureDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Guests/UpdateGuestProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGuestProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGuestProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGuestProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getGuestRolesForSelect(term: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ListResultDtoOfGuestRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Guests/GetGuestRolesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuestRolesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuestRolesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGuestRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfGuestRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetGuestRolesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfGuestRoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfGuestRoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfGuestRoleDto>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTopStatsData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(<any>response_);
                } catch (e) {
                    return <Observable<TopStatsData>><any>_observableThrow(e);
                }
            } else
                return <Observable<TopStatsData>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopStatsData>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(<any>response_);
                } catch (e) {
                    return <Observable<GetRecentTenantsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRecentTenantsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentTenantsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(<any>response_);
                } catch (e) {
                    return <Observable<GetExpiringTenantsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExpiringTenantsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExpiringTenantsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === undefined || incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' must be defined and cannot be null.");
        else
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(<any>response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditionTenantStatisticsOutput>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HostSettingsEditDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class HotsitesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param eventId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, eventId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetHotsiteForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetHotsiteForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetHotsiteForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetHotsiteForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetHotsiteForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetHotsiteForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getHotsitesToExcel(filter: string | undefined, eventId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHotsitesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsitesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsitesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsitesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param friendlyUrl (optional) 
     * @return Success
     */
    getHotsiteByFriendlyUrl(friendlyUrl: string | undefined): Observable<GetHotsiteInput> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHotsiteByFriendlyUrl?";
        if (friendlyUrl === null)
            throw new Error("The parameter 'friendlyUrl' cannot be null.");
        else if (friendlyUrl !== undefined)
            url_ += "friendlyUrl=" + encodeURIComponent("" + friendlyUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsiteByFriendlyUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsiteByFriendlyUrl(<any>response_);
                } catch (e) {
                    return <Observable<GetHotsiteInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetHotsiteInput>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsiteByFriendlyUrl(response: HttpResponseBase): Observable<GetHotsiteInput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotsiteInput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotsiteInput>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param eventId (optional) 
     * @param color1 (optional) 
     * @param color2 (optional) 
     * @param friendlyUrl (optional) 
     * @param isPublished (optional) 
     * @param id (optional) 
     * @return Success
     */
    getHotsiteForView(tenantId: number | undefined, eventId: number | undefined, color1: string | undefined, color2: string | undefined, friendlyUrl: string | undefined, isPublished: boolean | undefined, id: number | undefined): Observable<GetHotsiteForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHotsiteForView?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (color1 === null)
            throw new Error("The parameter 'color1' cannot be null.");
        else if (color1 !== undefined)
            url_ += "Color1=" + encodeURIComponent("" + color1) + "&"; 
        if (color2 === null)
            throw new Error("The parameter 'color2' cannot be null.");
        else if (color2 !== undefined)
            url_ += "Color2=" + encodeURIComponent("" + color2) + "&"; 
        if (friendlyUrl === null)
            throw new Error("The parameter 'friendlyUrl' cannot be null.");
        else if (friendlyUrl !== undefined)
            url_ += "FriendlyUrl=" + encodeURIComponent("" + friendlyUrl) + "&"; 
        if (isPublished === null)
            throw new Error("The parameter 'isPublished' cannot be null.");
        else if (isPublished !== undefined)
            url_ += "IsPublished=" + encodeURIComponent("" + isPublished) + "&"; 
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsiteForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsiteForView(<any>response_);
                } catch (e) {
                    return <Observable<GetHotsiteForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetHotsiteForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsiteForView(response: HttpResponseBase): Observable<GetHotsiteForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotsiteForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotsiteForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getHotsiteForEdit(id: number | undefined): Observable<GetHotsiteForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHotsiteForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsiteForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsiteForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetHotsiteForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetHotsiteForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsiteForEdit(response: HttpResponseBase): Observable<GetHotsiteForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotsiteForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotsiteForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getHotsitesForSelect(term: string | undefined, eventId: number | undefined): Observable<ListResultDtoOfHotsiteListDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHotsitesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsitesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsitesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfHotsiteListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfHotsiteListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsitesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfHotsiteListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfHotsiteListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfHotsiteListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHotsiteDto | undefined): Observable<UpdateHotsiteDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UpdateHotsiteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateHotsiteDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UpdateHotsiteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateHotsiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateHotsiteDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHotsiteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSectionSettings(body: HotsiteSectionSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/UpdateSectionSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSectionSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSectionSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateSectionSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    publish(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/Publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPublish(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CancelPublish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPublish(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHotsiteSettings(hotsiteId: number | undefined, tenantId: number | undefined): Observable<HotsiteSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHotsiteSettings?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsiteSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsiteSettings(<any>response_);
                } catch (e) {
                    return <Observable<HotsiteSettingsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HotsiteSettingsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsiteSettings(response: HttpResponseBase): Observable<HotsiteSettingsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HotsiteSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HotsiteSettingsDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSponsorTypesForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<SponsorTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetSponsorTypesForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorTypesForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorTypesForView(<any>response_);
                } catch (e) {
                    return <Observable<SponsorTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SponsorTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSponsorTypesForView(response: HttpResponseBase): Observable<SponsorTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SponsorTypeDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSponsorTypesForEdit(id: number | undefined): Observable<SponsorTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetSponsorTypesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorTypesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorTypesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<SponsorTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SponsorTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSponsorTypesForEdit(response: HttpResponseBase): Observable<SponsorTypeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SponsorTypeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SponsorTypeDto[]>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getAllSponsorTypes(term: string | undefined): Observable<ListResultDtoOfSponsorTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetAllSponsorTypes?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSponsorTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSponsorTypes(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSponsorTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSponsorTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSponsorTypes(response: HttpResponseBase): Observable<ListResultDtoOfSponsorTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSponsorTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSponsorTypeDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    getSponsorTypesForSelect(term: string | undefined): Observable<ListResultDtoOfSponsorTypeListDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetSponsorTypesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSponsorTypesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSponsorTypesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSponsorTypeListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfSponsorTypeListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSponsorTypesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfSponsorTypeListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSponsorTypeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfSponsorTypeListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditSponsorType(body: CreateOrEditSponsorTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditSponsorType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditSponsorType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditSponsorType(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditSponsorType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteSponsorType(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/DeleteSponsorType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSponsorType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSponsorType(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteSponsorType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateHotsiteSettings(body: UpdateHotsiteSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/UpdateHotsiteSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHotsiteSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHotsiteSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateHotsiteSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLogo(body: UpdateImageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/UpdateLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBackgroundImage(body: UpdateImageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/UpdateBackgroundImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBackgroundImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBackgroundImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateBackgroundImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteBackgroundImage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/DeleteBackgroundImage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBackgroundImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBackgroundImage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteBackgroundImage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHomeSectionForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<HomeSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHomeSectionForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<HomeSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<HomeSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeSectionForView(response: HttpResponseBase): Observable<HomeSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HomeSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HomeSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHomeSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditHomeSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetHomeSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHomeSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHomeSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditHomeSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditHomeSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHomeSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditHomeSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditHomeSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditHomeSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditHomeSection(body: CreateOrEditHomeSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditHomeSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditHomeSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditHomeSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditHomeSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAboutEventSectionForViewCache(isActive: boolean | undefined, hotsiteId: number | undefined, tenantId: number | undefined): Observable<AboutEventSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetAboutEventSectionForViewCache?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAboutEventSectionForViewCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAboutEventSectionForViewCache(<any>response_);
                } catch (e) {
                    return <Observable<AboutEventSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AboutEventSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAboutEventSectionForViewCache(response: HttpResponseBase): Observable<AboutEventSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AboutEventSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AboutEventSectionDto>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAboutEventSectionForView(isActive: boolean | undefined, hotsiteId: number | undefined, tenantId: number | undefined): Observable<AboutEventSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetAboutEventSectionForView?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAboutEventSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAboutEventSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<AboutEventSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AboutEventSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAboutEventSectionForView(response: HttpResponseBase): Observable<AboutEventSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AboutEventSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AboutEventSectionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getImageGalleryForView(id: number | undefined): Observable<ImageGalleryDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetImageGalleryForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImageGalleryForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImageGalleryForView(<any>response_);
                } catch (e) {
                    return <Observable<ImageGalleryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImageGalleryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetImageGalleryForView(response: HttpResponseBase): Observable<ImageGalleryDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageGalleryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImageGalleryDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAboutEventSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditAboutEventSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetAboutEventSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAboutEventSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAboutEventSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditAboutEventSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditAboutEventSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAboutEventSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditAboutEventSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditAboutEventSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditAboutEventSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditAboutEventSection(body: CreateOrEditAboutEventSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditAboutEventSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditAboutEventSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditAboutEventSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditAboutEventSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getScientificProgramSectionForViewCache(isActive: boolean | undefined, hotsiteId: number | undefined, tenantId: number | undefined): Observable<ScientificProgramSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetScientificProgramSectionForViewCache?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScientificProgramSectionForViewCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScientificProgramSectionForViewCache(<any>response_);
                } catch (e) {
                    return <Observable<ScientificProgramSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScientificProgramSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetScientificProgramSectionForViewCache(response: HttpResponseBase): Observable<ScientificProgramSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScientificProgramSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScientificProgramSectionDto>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getScientificProgramSectionForView(isActive: boolean | undefined, hotsiteId: number | undefined, tenantId: number | undefined): Observable<ScientificProgramSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetScientificProgramSectionForView?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScientificProgramSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScientificProgramSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<ScientificProgramSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ScientificProgramSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetScientificProgramSectionForView(response: HttpResponseBase): Observable<ScientificProgramSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScientificProgramSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScientificProgramSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getScientificProgramSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditScientificProgramSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetScientificProgramSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScientificProgramSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScientificProgramSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditScientificProgramSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditScientificProgramSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetScientificProgramSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditScientificProgramSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditScientificProgramSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditScientificProgramSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditScientificProgramSection(body: CreateOrEditScientificProgramSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditScientificProgramSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditScientificProgramSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditScientificProgramSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditScientificProgramSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getRegistrationSectionForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<RegistrationSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetRegistrationSectionForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<RegistrationSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegistrationSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationSectionForView(response: HttpResponseBase): Observable<RegistrationSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getRegistrationSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditRegistrationSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetRegistrationSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditRegistrationSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditRegistrationSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditRegistrationSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditRegistrationSection(body: CreateOrEditRegistrationSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditRegistrationSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditRegistrationSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditRegistrationSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditRegistrationSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getContactSectionForViewCache(hotsiteId: number | undefined, tenantId: number | undefined): Observable<ContactSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetContactSectionForViewCache?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactSectionForViewCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactSectionForViewCache(<any>response_);
                } catch (e) {
                    return <Observable<ContactSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactSectionForViewCache(response: HttpResponseBase): Observable<ContactSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getContactSectionForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<ContactSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetContactSectionForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<ContactSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactSectionForView(response: HttpResponseBase): Observable<ContactSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getContactSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditContactSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetContactSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditContactSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditContactSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetContactSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditContactSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditContactSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditContactSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditContactSection(body: CreateOrEditContactSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditContactSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditContactSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditContactSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditContactSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendContactMessage(body: SendContactMessageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/SendContactMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendContactMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendContactMessage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendContactMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLocalizationSectionForViewCache(hotsiteId: number | undefined, tenantId: number | undefined): Observable<LocalizationSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetLocalizationSectionForViewCache?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalizationSectionForViewCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalizationSectionForViewCache(<any>response_);
                } catch (e) {
                    return <Observable<LocalizationSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocalizationSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalizationSectionForViewCache(response: HttpResponseBase): Observable<LocalizationSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocalizationSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocalizationSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLocalizationSectionForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<LocalizationSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetLocalizationSectionForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalizationSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalizationSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<LocalizationSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LocalizationSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalizationSectionForView(response: HttpResponseBase): Observable<LocalizationSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocalizationSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocalizationSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLocalizationSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditLocalizationSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetLocalizationSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalizationSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalizationSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditLocalizationSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditLocalizationSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLocalizationSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditLocalizationSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditLocalizationSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditLocalizationSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditLocalizationSection(body: CreateOrEditLocalizationSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditLocalizationSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditLocalizationSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditLocalizationSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditLocalizationSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCertificateSectionForView(isActive: boolean | undefined, hotsiteId: number | undefined, tenantId: number | undefined): Observable<CertificateSectionDtoForView> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetCertificateSectionForView?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<CertificateSectionDtoForView>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateSectionDtoForView>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateSectionForView(response: HttpResponseBase): Observable<CertificateSectionDtoForView> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateSectionDtoForView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateSectionDtoForView>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCertificateSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditCertificateSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetCertificateSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificateSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificateSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditCertificateSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditCertificateSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCertificateSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditCertificateSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditCertificateSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditCertificateSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditCertificateSection(body: CreateOrEditCertificateSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditCertificateSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditCertificateSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditCertificateSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditCertificateSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param isActive (optional) 
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTravelAgencySectionForView(isActive: boolean | undefined, hotsiteId: number | undefined, tenantId: number | undefined): Observable<TravelAgencySectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetTravelAgencySectionForView?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelAgencySectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelAgencySectionForView(<any>response_);
                } catch (e) {
                    return <Observable<TravelAgencySectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TravelAgencySectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelAgencySectionForView(response: HttpResponseBase): Observable<TravelAgencySectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TravelAgencySectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TravelAgencySectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTravelAgencySectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditTravelAgencySectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetTravelAgencySectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTravelAgencySectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTravelAgencySectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditTravelAgencySectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditTravelAgencySectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTravelAgencySectionForEdit(response: HttpResponseBase): Observable<CreateOrEditTravelAgencySectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditTravelAgencySectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditTravelAgencySectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditTravelAgencySection(body: CreateOrEditTravelAgencySectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditTravelAgencySection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditTravelAgencySection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditTravelAgencySection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditTravelAgencySection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param documentId (optional) 
     * @param fileExtension (optional) 
     * @param id (optional) 
     * @return Success
     */
    getFile(documentId: string | undefined, fileExtension: string | undefined, id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetFile?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&"; 
        if (fileExtension === null)
            throw new Error("The parameter 'fileExtension' cannot be null.");
        else if (fileExtension !== undefined)
            url_ += "FileExtension=" + encodeURIComponent("" + fileExtension) + "&"; 
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param eventCode (optional) 
     * @param page (optional) 
     * @return Success
     */
    getPage(eventCode: string | undefined, page: string | undefined): Observable<GetHotsitePageDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetPage?";
        if (eventCode === null)
            throw new Error("The parameter 'eventCode' cannot be null.");
        else if (eventCode !== undefined)
            url_ += "EventCode=" + encodeURIComponent("" + eventCode) + "&"; 
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPage(<any>response_);
                } catch (e) {
                    return <Observable<GetHotsitePageDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetHotsitePageDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPage(response: HttpResponseBase): Observable<GetHotsitePageDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHotsitePageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetHotsitePageDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getVideoSectionForViewCache(hotsiteId: number | undefined, tenantId: number | undefined): Observable<VideoSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetVideoSectionForViewCache?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideoSectionForViewCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoSectionForViewCache(<any>response_);
                } catch (e) {
                    return <Observable<VideoSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VideoSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVideoSectionForViewCache(response: HttpResponseBase): Observable<VideoSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VideoSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getVideoSectionForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<VideoSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetVideoSectionForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideoSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<VideoSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<VideoSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVideoSectionForView(response: HttpResponseBase): Observable<VideoSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VideoSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getVideoSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditVideoSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetVideoSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideoSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditVideoSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditVideoSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetVideoSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditVideoSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditVideoSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditVideoSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditVideoSection(body: CreateOrEditVideoSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditVideoSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditVideoSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditVideoSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditVideoSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSpeakerSectionForViewCache(hotsiteId: number | undefined, tenantId: number | undefined): Observable<SpeakerSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetSpeakerSectionForViewCache?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeakerSectionForViewCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeakerSectionForViewCache(<any>response_);
                } catch (e) {
                    return <Observable<SpeakerSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SpeakerSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpeakerSectionForViewCache(response: HttpResponseBase): Observable<SpeakerSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpeakerSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpeakerSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSpeakerSectionForView(hotsiteId: number | undefined, tenantId: number | undefined): Observable<SpeakerSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetSpeakerSectionForView?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeakerSectionForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeakerSectionForView(<any>response_);
                } catch (e) {
                    return <Observable<SpeakerSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SpeakerSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpeakerSectionForView(response: HttpResponseBase): Observable<SpeakerSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpeakerSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpeakerSectionDto>(<any>null);
    }

    /**
     * @param hotsiteId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSpeakerSectionForEdit(hotsiteId: number | undefined, tenantId: number | undefined): Observable<CreateOrEditSpeakerSectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/GetSpeakerSectionForEdit?";
        if (hotsiteId === null)
            throw new Error("The parameter 'hotsiteId' cannot be null.");
        else if (hotsiteId !== undefined)
            url_ += "HotsiteId=" + encodeURIComponent("" + hotsiteId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpeakerSectionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpeakerSectionForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditSpeakerSectionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditSpeakerSectionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpeakerSectionForEdit(response: HttpResponseBase): Observable<CreateOrEditSpeakerSectionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditSpeakerSectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditSpeakerSectionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditSpeakerSection(body: CreateOrEditSpeakerSectionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hotsites/CreateOrEditSpeakerSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditSpeakerSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditSpeakerSection(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditSpeakerSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(<any>response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(<any>response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(<any>response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<InvoiceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguagesOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter === null)
            throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MembersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param categoryNameFilter (optional) 
     * @param categoryLevelIdFilter (optional) 
     * @param annuitySituation (optional) 
     * @param documentationStatus (optional) 
     * @param pendingDocumentation (optional) 
     * @param userSituationId (optional) 
     * @param statusCrm (optional) 
     * @param situationCrm (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, categoryNameFilter: string | undefined, categoryLevelIdFilter: number | undefined, annuitySituation: MemberAnnuitySituation | undefined, documentationStatus: DocumentationStatus | undefined, pendingDocumentation: boolean | undefined, userSituationId: number | undefined, statusCrm: StatusCrm | undefined, situationCrm: SituationCrm | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMemberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (categoryNameFilter === null)
            throw new Error("The parameter 'categoryNameFilter' cannot be null.");
        else if (categoryNameFilter !== undefined)
            url_ += "CategoryNameFilter=" + encodeURIComponent("" + categoryNameFilter) + "&"; 
        if (categoryLevelIdFilter === null)
            throw new Error("The parameter 'categoryLevelIdFilter' cannot be null.");
        else if (categoryLevelIdFilter !== undefined)
            url_ += "CategoryLevelIdFilter=" + encodeURIComponent("" + categoryLevelIdFilter) + "&"; 
        if (annuitySituation === null)
            throw new Error("The parameter 'annuitySituation' cannot be null.");
        else if (annuitySituation !== undefined)
            url_ += "AnnuitySituation=" + encodeURIComponent("" + annuitySituation) + "&"; 
        if (documentationStatus === null)
            throw new Error("The parameter 'documentationStatus' cannot be null.");
        else if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (pendingDocumentation === null)
            throw new Error("The parameter 'pendingDocumentation' cannot be null.");
        else if (pendingDocumentation !== undefined)
            url_ += "PendingDocumentation=" + encodeURIComponent("" + pendingDocumentation) + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        if (statusCrm === null)
            throw new Error("The parameter 'statusCrm' cannot be null.");
        else if (statusCrm !== undefined)
            url_ += "StatusCrm=" + encodeURIComponent("" + statusCrm) + "&"; 
        if (situationCrm === null)
            throw new Error("The parameter 'situationCrm' cannot be null.");
        else if (situationCrm !== undefined)
            url_ += "SituationCrm=" + encodeURIComponent("" + situationCrm) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMemberForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMemberForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetMemberForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMemberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMemberForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param categoryNameFilter (optional) 
     * @param categoryLevelIdFilter (optional) 
     * @param annuitySituation (optional) 
     * @param documentationStatus (optional) 
     * @param pendingDocumentation (optional) 
     * @param userSituationId (optional) 
     * @param statusCrm (optional) 
     * @param situationCrm (optional) 
     * @return Success
     */
    getMembersToExcel(filter: string | undefined, categoryNameFilter: string | undefined, categoryLevelIdFilter: number | undefined, annuitySituation: MemberAnnuitySituation | undefined, documentationStatus: DocumentationStatus | undefined, pendingDocumentation: boolean | undefined, userSituationId: number | undefined, statusCrm: StatusCrm | undefined, situationCrm: SituationCrm | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMembersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (categoryNameFilter === null)
            throw new Error("The parameter 'categoryNameFilter' cannot be null.");
        else if (categoryNameFilter !== undefined)
            url_ += "CategoryNameFilter=" + encodeURIComponent("" + categoryNameFilter) + "&"; 
        if (categoryLevelIdFilter === null)
            throw new Error("The parameter 'categoryLevelIdFilter' cannot be null.");
        else if (categoryLevelIdFilter !== undefined)
            url_ += "CategoryLevelIdFilter=" + encodeURIComponent("" + categoryLevelIdFilter) + "&"; 
        if (annuitySituation === null)
            throw new Error("The parameter 'annuitySituation' cannot be null.");
        else if (annuitySituation !== undefined)
            url_ += "AnnuitySituation=" + encodeURIComponent("" + annuitySituation) + "&"; 
        if (documentationStatus === null)
            throw new Error("The parameter 'documentationStatus' cannot be null.");
        else if (documentationStatus !== undefined)
            url_ += "DocumentationStatus=" + encodeURIComponent("" + documentationStatus) + "&"; 
        if (pendingDocumentation === null)
            throw new Error("The parameter 'pendingDocumentation' cannot be null.");
        else if (pendingDocumentation !== undefined)
            url_ += "PendingDocumentation=" + encodeURIComponent("" + pendingDocumentation) + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        if (statusCrm === null)
            throw new Error("The parameter 'statusCrm' cannot be null.");
        else if (statusCrm !== undefined)
            url_ += "StatusCrm=" + encodeURIComponent("" + statusCrm) + "&"; 
        if (situationCrm === null)
            throw new Error("The parameter 'situationCrm' cannot be null.");
        else if (situationCrm !== undefined)
            url_ += "SituationCrm=" + encodeURIComponent("" + situationCrm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMembersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMembersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMembersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMemberForView(id: number | undefined): Observable<GetMemberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMemberForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberForView(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberForView(response: HttpResponseBase): Observable<GetMemberForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberForViewDto>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getMemberByUserIdForView(userId: number | undefined, eventScheduleId: number | undefined): Observable<GetMemberForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMemberByUserIdForView?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberByUserIdForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberByUserIdForView(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberByUserIdForView(response: HttpResponseBase): Observable<GetMemberForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMemberForEdit(id: number | undefined): Observable<GetMemberForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMemberForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberForEdit(response: HttpResponseBase): Observable<GetMemberForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditMemberDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateCrm(body: ValidateCrmDto | undefined): Observable<ResultValidateCrmDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/ValidateCrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCrm(<any>response_);
                } catch (e) {
                    return <Observable<ResultValidateCrmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultValidateCrmDto>><any>_observableThrow(response_);
        }));
    }

    protected processValidateCrm(response: HttpResponseBase): Observable<ResultValidateCrmDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultValidateCrmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultValidateCrmDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllCategoryForTableDropdown(): Observable<MemberCategoryLookupTableDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetAllCategoryForTableDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCategoryForTableDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCategoryForTableDropdown(<any>response_);
                } catch (e) {
                    return <Observable<MemberCategoryLookupTableDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberCategoryLookupTableDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCategoryForTableDropdown(response: HttpResponseBase): Observable<MemberCategoryLookupTableDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberCategoryLookupTableDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberCategoryLookupTableDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMemberCategories(id: number | undefined): Observable<PagedResultDtoOfCreateOrEditMemberCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMemberCategories?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberCategories(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCreateOrEditMemberCategoryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCreateOrEditMemberCategoryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberCategories(response: HttpResponseBase): Observable<PagedResultDtoOfCreateOrEditMemberCategoryDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCreateOrEditMemberCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCreateOrEditMemberCategoryDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateMemberCategory(body: CreateOrEditMemberCategoryDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/CreateOrUpdateMemberCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateMemberCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateMemberCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateMemberCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param memberId (optional) 
     * @param memberCategoryId (optional) 
     * @return Success
     */
    deleteMemberCategory(memberId: number | undefined, memberCategoryId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/DeleteMemberCategory?";
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "MemberId=" + encodeURIComponent("" + memberId) + "&"; 
        if (memberCategoryId === null)
            throw new Error("The parameter 'memberCategoryId' cannot be null.");
        else if (memberCategoryId !== undefined)
            url_ += "MemberCategoryId=" + encodeURIComponent("" + memberCategoryId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMemberCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMemberCategory(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMemberCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param documentationId (optional) 
     * @param memberId (optional) 
     * @return Success
     */
    getDocumentationForEdit(documentationId: number | undefined, memberId: number | undefined): Observable<CreateOrEditDocumentationDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetDocumentationForEdit?";
        if (documentationId === null)
            throw new Error("The parameter 'documentationId' cannot be null.");
        else if (documentationId !== undefined)
            url_ += "DocumentationId=" + encodeURIComponent("" + documentationId) + "&"; 
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "MemberId=" + encodeURIComponent("" + memberId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditDocumentationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditDocumentationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentationForEdit(response: HttpResponseBase): Observable<CreateOrEditDocumentationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditDocumentationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditDocumentationDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditDocumentation(body: CreateOrEditDocumentationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/CreateOrEditDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditDocumentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditDocumentation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditDocumentation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveDocumentation(body: EntityDtoOfInt64 | undefined): Observable<ResultEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/ApproveDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveDocumentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveDocumentation(<any>response_);
                } catch (e) {
                    return <Observable<ResultEmailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultEmailDto>><any>_observableThrow(response_);
        }));
    }

    protected processApproveDocumentation(response: HttpResponseBase): Observable<ResultEmailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultEmailDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    disapproveDocumentation(body: DisapproveDocDto | undefined): Observable<ResultEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/DisapproveDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisapproveDocumentation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisapproveDocumentation(<any>response_);
                } catch (e) {
                    return <Observable<ResultEmailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultEmailDto>><any>_observableThrow(response_);
        }));
    }

    protected processDisapproveDocumentation(response: HttpResponseBase): Observable<ResultEmailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultEmailDto>(<any>null);
    }

    /**
     * @param documentId (optional) 
     * @param fileExtension (optional) 
     * @param id (optional) 
     * @return Success
     */
    getDocumentFile(documentId: string | undefined, fileExtension: string | undefined, id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetDocumentFile?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "DocumentId=" + encodeURIComponent("" + documentId) + "&"; 
        if (fileExtension === null)
            throw new Error("The parameter 'fileExtension' cannot be null.");
        else if (fileExtension !== undefined)
            url_ += "FileExtension=" + encodeURIComponent("" + fileExtension) + "&"; 
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFile(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param isActive (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSpecialtiesForSelectCache(term: string | undefined, isActive: boolean | undefined, tenantId: number | undefined): Observable<ListResultDtoOfMemberSpecialtyDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetSpecialtiesForSelectCache?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialtiesForSelectCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialtiesForSelectCache(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMemberSpecialtyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfMemberSpecialtyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialtiesForSelectCache(response: HttpResponseBase): Observable<ListResultDtoOfMemberSpecialtyDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfMemberSpecialtyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfMemberSpecialtyDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param isActive (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getSpecialtiesForSelect(term: string | undefined, isActive: boolean | undefined, tenantId: number | undefined): Observable<ListResultDtoOfMemberSpecialtyDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetSpecialtiesForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialtiesForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialtiesForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMemberSpecialtyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfMemberSpecialtyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSpecialtiesForSelect(response: HttpResponseBase): Observable<ListResultDtoOfMemberSpecialtyDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfMemberSpecialtyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfMemberSpecialtyDto>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllMemberSpecialties(term: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetMemberSpecialtyForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetAllMemberSpecialties?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMemberSpecialties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMemberSpecialties(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetMemberSpecialtyForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetMemberSpecialtyForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllMemberSpecialties(response: HttpResponseBase): Observable<PagedResultDtoOfGetMemberSpecialtyForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetMemberSpecialtyForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetMemberSpecialtyForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMemberSpecialityForEdit(id: number | undefined): Observable<MemberSpecialtyDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMemberSpecialityForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberSpecialityForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberSpecialityForEdit(<any>response_);
                } catch (e) {
                    return <Observable<MemberSpecialtyDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberSpecialtyDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberSpecialityForEdit(response: HttpResponseBase): Observable<MemberSpecialtyDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MemberSpecialtyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberSpecialtyDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditMemberSpeciality(body: CreateOrEditMemberSpecialtyDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/CreateOrEditMemberSpeciality";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditMemberSpeciality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditMemberSpeciality(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditMemberSpeciality(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteMemberSpecialty(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Members/DeleteMemberSpecialty?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMemberSpecialty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMemberSpecialty(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteMemberSpecialty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getMemberMemberSpecialtiesToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Members/GetMemberMemberSpecialtiesToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberMemberSpecialtiesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberMemberSpecialtiesToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberMemberSpecialtiesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrderItemProductsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isActiveFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrderItemProductForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOrderItemProductForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOrderItemProductForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrderItemProductForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrderItemProductForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOrderItemProductForViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOrderItemProductDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getForSelect(filter: string | undefined, isActiveFilter: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ListResultDtoOfOrderItemProductDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/GetForSelect?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrderItemProductDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrderItemProductDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetForSelect(response: HttpResponseBase): Observable<ListResultDtoOfOrderItemProductDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrderItemProductDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrderItemProductDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditOrderItemProductLogo(body: OrderItemProductLogoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/CreateOrEditOrderItemProductLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditOrderItemProductLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditOrderItemProductLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditOrderItemProductLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderItemProductForEdit(id: number | undefined): Observable<GetOrderItemProductForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/GetOrderItemProductForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderItemProductForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItemProductForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOrderItemProductForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOrderItemProductForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderItemProductForEdit(response: HttpResponseBase): Observable<GetOrderItemProductForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderItemProductForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrderItemProductForEditOutput>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getOrderItemProductsToExcel(filter: string | undefined, isActiveFilter: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/OrderItemProducts/GetOrderItemProductsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderItemProductsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItemProductsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderItemProductsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

@Injectable()
export class OrdersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param eventIdsFilter (optional) 
     * @param annuitySettingIdsFilter (optional) 
     * @param userIdFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param beginPaymentDate (optional) 
     * @param endPaymentDate (optional) 
     * @param myOrders (optional) 
     * @param orderItemTypeFilter (optional) 
     * @param orderSituationFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, eventIdsFilter: string | undefined, annuitySettingIdsFilter: string | undefined, userIdFilter: number | undefined, paymentTypeFilter: PaymentType | undefined, statusFilter: PaymentStatus | undefined, beginPaymentDate: moment.Moment | undefined, endPaymentDate: moment.Moment | undefined, myOrders: boolean | undefined, orderItemTypeFilter: OrderItemType | undefined, orderSituationFilter: OrderSituation | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetOrderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventIdsFilter === null)
            throw new Error("The parameter 'eventIdsFilter' cannot be null.");
        else if (eventIdsFilter !== undefined)
            url_ += "EventIdsFilter=" + encodeURIComponent("" + eventIdsFilter) + "&"; 
        if (annuitySettingIdsFilter === null)
            throw new Error("The parameter 'annuitySettingIdsFilter' cannot be null.");
        else if (annuitySettingIdsFilter !== undefined)
            url_ += "AnnuitySettingIdsFilter=" + encodeURIComponent("" + annuitySettingIdsFilter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (beginPaymentDate === null)
            throw new Error("The parameter 'beginPaymentDate' cannot be null.");
        else if (beginPaymentDate !== undefined)
            url_ += "BeginPaymentDate=" + encodeURIComponent(beginPaymentDate ? "" + beginPaymentDate.toJSON() : "") + "&"; 
        if (endPaymentDate === null)
            throw new Error("The parameter 'endPaymentDate' cannot be null.");
        else if (endPaymentDate !== undefined)
            url_ += "EndPaymentDate=" + encodeURIComponent(endPaymentDate ? "" + endPaymentDate.toJSON() : "") + "&"; 
        if (myOrders === null)
            throw new Error("The parameter 'myOrders' cannot be null.");
        else if (myOrders !== undefined)
            url_ += "MyOrders=" + encodeURIComponent("" + myOrders) + "&"; 
        if (orderItemTypeFilter === null)
            throw new Error("The parameter 'orderItemTypeFilter' cannot be null.");
        else if (orderItemTypeFilter !== undefined)
            url_ += "OrderItemTypeFilter=" + encodeURIComponent("" + orderItemTypeFilter) + "&"; 
        if (orderSituationFilter === null)
            throw new Error("The parameter 'orderSituationFilter' cannot be null.");
        else if (orderSituationFilter !== undefined)
            url_ += "OrderSituationFilter=" + encodeURIComponent("" + orderSituationFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetOrderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetOrderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetOrderForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetOrderForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetOrderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderForView(id: number | undefined): Observable<GetOrderForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderForView(<any>response_);
                } catch (e) {
                    return <Observable<GetOrderForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOrderForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderForView(response: HttpResponseBase): Observable<GetOrderForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrderForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderForEdit(id: number | undefined): Observable<GetOrderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetOrderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOrderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderForEdit(response: HttpResponseBase): Observable<GetOrderForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrderForEditOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getOrderForPayment(id: number | undefined): Observable<GetOrderForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderForPayment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderForPayment(<any>response_);
                } catch (e) {
                    return <Observable<GetOrderForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetOrderForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrderForPayment(response: HttpResponseBase): Observable<GetOrderForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOrderForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditOrderDto | undefined): Observable<CreateOrEditOrderOutput> {
        let url_ = this.baseUrl + "/api/services/app/Orders/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditOrderOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditOrderOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<CreateOrEditOrderOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditOrderOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditOrderOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    giveMoneyBackOrder(body: GiveMoneyBackInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GiveMoneyBackOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGiveMoneyBackOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGiveMoneyBackOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGiveMoneyBackOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventIdsFilter (optional) 
     * @param annuitySettingIdsFilter (optional) 
     * @param userIdFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param beginPaymentDate (optional) 
     * @param endPaymentDate (optional) 
     * @param orderItemTypeFilter (optional) 
     * @param orderSituationFilter (optional) 
     * @return Success
     */
    getOrdersToExcel(filter: string | undefined, eventIdsFilter: number[] | undefined, annuitySettingIdsFilter: number[] | undefined, userIdFilter: number | undefined, paymentTypeFilter: PaymentType | undefined, statusFilter: PaymentStatus | undefined, beginPaymentDate: moment.Moment | undefined, endPaymentDate: moment.Moment | undefined, orderItemTypeFilter: OrderItemType | undefined, orderSituationFilter: OrderSituation | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrdersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventIdsFilter === null)
            throw new Error("The parameter 'eventIdsFilter' cannot be null.");
        else if (eventIdsFilter !== undefined)
            eventIdsFilter && eventIdsFilter.forEach(item => { url_ += "EventIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (annuitySettingIdsFilter === null)
            throw new Error("The parameter 'annuitySettingIdsFilter' cannot be null.");
        else if (annuitySettingIdsFilter !== undefined)
            annuitySettingIdsFilter && annuitySettingIdsFilter.forEach(item => { url_ += "AnnuitySettingIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (beginPaymentDate === null)
            throw new Error("The parameter 'beginPaymentDate' cannot be null.");
        else if (beginPaymentDate !== undefined)
            url_ += "BeginPaymentDate=" + encodeURIComponent(beginPaymentDate ? "" + beginPaymentDate.toJSON() : "") + "&"; 
        if (endPaymentDate === null)
            throw new Error("The parameter 'endPaymentDate' cannot be null.");
        else if (endPaymentDate !== undefined)
            url_ += "EndPaymentDate=" + encodeURIComponent(endPaymentDate ? "" + endPaymentDate.toJSON() : "") + "&"; 
        if (orderItemTypeFilter === null)
            throw new Error("The parameter 'orderItemTypeFilter' cannot be null.");
        else if (orderItemTypeFilter !== undefined)
            url_ += "OrderItemTypeFilter=" + encodeURIComponent("" + orderItemTypeFilter) + "&"; 
        if (orderSituationFilter === null)
            throw new Error("The parameter 'orderSituationFilter' cannot be null.");
        else if (orderSituationFilter !== undefined)
            url_ += "OrderSituationFilter=" + encodeURIComponent("" + orderSituationFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrdersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrdersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    orderItsPaid(body: EntityDtoOfInt64 | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Orders/OrderItsPaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOrderItsPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrderItsPaid(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processOrderItsPaid(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getReceiptSettings(): Observable<ReceiptSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetReceiptSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptSettings(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptSettingsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptSettingsDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetReceiptSettings(response: HttpResponseBase): Observable<ReceiptSettingsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptSettingsDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReceiptSettings(body: ReceiptSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/UpdateReceiptSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceiptSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceiptSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateReceiptSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    receiptPreview(body: ReceiptSettingsDto | undefined): Observable<PreviewFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/ReceiptPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceiptPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceiptPreview(<any>response_);
                } catch (e) {
                    return <Observable<PreviewFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreviewFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processReceiptPreview(response: HttpResponseBase): Observable<PreviewFileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviewFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreviewFileDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateReceipt(body: GetReceiptDto | undefined): Observable<PreviewFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GenerateReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateReceipt(<any>response_);
                } catch (e) {
                    return <Observable<PreviewFileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PreviewFileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateReceipt(response: HttpResponseBase): Observable<PreviewFileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviewFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreviewFileDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pagSeguroNotification(body: Blob | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/PagSeguroNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPagSeguroNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPagSeguroNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPagSeguroNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfOrganizationUnitRoleListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>_observableThrow(response_);
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&"; 
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class PagSeguroPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param pagSeguroConfigId (optional) 
     * @return Success
     */
    getSession(pagSeguroConfigId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/GetSession?";
        if (pagSeguroConfigId === null)
            throw new Error("The parameter 'pagSeguroConfigId' cannot be null.");
        else if (pagSeguroConfigId !== undefined)
            url_ += "pagSeguroConfigId=" + encodeURIComponent("" + pagSeguroConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSession(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param urlSessions (optional) 
     * @param email (optional) 
     * @param token (optional) 
     * @return Success
     */
    getSessionPagSeguro(urlSessions: string | undefined, email: string | undefined, token: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/GetSessionPagSeguro?";
        if (urlSessions === null)
            throw new Error("The parameter 'urlSessions' cannot be null.");
        else if (urlSessions !== undefined)
            url_ += "UrlSessions=" + encodeURIComponent("" + urlSessions) + "&"; 
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&"; 
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSessionPagSeguro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSessionPagSeguro(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetSessionPagSeguro(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param pagSeguroConfigId (optional) 
     * @return Success
     */
    updateUrlWebhook(pagSeguroConfigId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/UpdateUrlWebhook?";
        if (pagSeguroConfigId === null)
            throw new Error("The parameter 'pagSeguroConfigId' cannot be null.");
        else if (pagSeguroConfigId !== undefined)
            url_ += "pagSeguroConfigId=" + encodeURIComponent("" + pagSeguroConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUrlWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUrlWebhook(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUrlWebhook(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmPaymentPix(body: PagSeguroWebhookDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/ConfirmPaymentPix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPaymentPix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPaymentPix(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPaymentPix(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param reference (optional) 
     * @param status (optional) 
     * @return Success
     */
    confirmPaymentOrder(reference: string | undefined, status: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/ConfirmPaymentOrder?";
        if (reference === null)
            throw new Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&"; 
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPaymentOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPaymentOrder(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPaymentOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param value (optional) 
     * @param maxInstallments (optional) 
     * @param maxInstallmentsNoInterest (optional) 
     * @param creditCardBin (optional) 
     * @param showSellerFees (optional) 
     * @param pagSeguroConfigId (optional) 
     * @return Success
     */
    getInstallments(value: string | undefined, maxInstallments: number | undefined, maxInstallmentsNoInterest: number | undefined, creditCardBin: string | undefined, showSellerFees: boolean | undefined, pagSeguroConfigId: number | undefined): Observable<PagSeguroInstallmentsResponse> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/GetInstallments?";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "Value=" + encodeURIComponent("" + value) + "&"; 
        if (maxInstallments === null)
            throw new Error("The parameter 'maxInstallments' cannot be null.");
        else if (maxInstallments !== undefined)
            url_ += "MaxInstallments=" + encodeURIComponent("" + maxInstallments) + "&"; 
        if (maxInstallmentsNoInterest === null)
            throw new Error("The parameter 'maxInstallmentsNoInterest' cannot be null.");
        else if (maxInstallmentsNoInterest !== undefined)
            url_ += "MaxInstallmentsNoInterest=" + encodeURIComponent("" + maxInstallmentsNoInterest) + "&"; 
        if (creditCardBin === null)
            throw new Error("The parameter 'creditCardBin' cannot be null.");
        else if (creditCardBin !== undefined)
            url_ += "CreditCardBin=" + encodeURIComponent("" + creditCardBin) + "&"; 
        if (showSellerFees === null)
            throw new Error("The parameter 'showSellerFees' cannot be null.");
        else if (showSellerFees !== undefined)
            url_ += "ShowSellerFees=" + encodeURIComponent("" + showSellerFees) + "&"; 
        if (pagSeguroConfigId === null)
            throw new Error("The parameter 'pagSeguroConfigId' cannot be null.");
        else if (pagSeguroConfigId !== undefined)
            url_ += "PagSeguroConfigId=" + encodeURIComponent("" + pagSeguroConfigId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInstallments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInstallments(<any>response_);
                } catch (e) {
                    return <Observable<PagSeguroInstallmentsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagSeguroInstallmentsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetInstallments(response: HttpResponseBase): Observable<PagSeguroInstallmentsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagSeguroInstallmentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagSeguroInstallmentsResponse>(<any>null);
    }

    /**
     * @param url (optional) 
     * @param token (optional) 
     * @return Success
     */
    getPublicKeys(url: string | undefined, token: string | undefined): Observable<PagSeguroPublicKeysResponse> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/GetPublicKeys?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "Url=" + encodeURIComponent("" + url) + "&"; 
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicKeys(<any>response_);
                } catch (e) {
                    return <Observable<PagSeguroPublicKeysResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagSeguroPublicKeysResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPublicKeys(response: HttpResponseBase): Observable<PagSeguroPublicKeysResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagSeguroPublicKeysResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagSeguroPublicKeysResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePublicKeys(body: EntityDto | undefined): Observable<PagSeguroPublicKeysResponse> {
        let url_ = this.baseUrl + "/api/services/app/PagSeguroPayment/UpdatePublicKeys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePublicKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePublicKeys(<any>response_);
                } catch (e) {
                    return <Observable<PagSeguroPublicKeysResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagSeguroPublicKeysResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePublicKeys(response: HttpResponseBase): Observable<PagSeguroPublicKeysResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagSeguroPublicKeysResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagSeguroPublicKeysResponse>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(<any>response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfoDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }

    /**
     * @param recurringPaymentsEnabled (optional) 
     * @return Success
     */
    getActiveGateways(recurringPaymentsEnabled: boolean | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled === null)
            throw new Error("The parameter 'recurringPaymentsEnabled' cannot be null.");
        else if (recurringPaymentsEnabled !== undefined)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(<any>response_);
                } catch (e) {
                    return <Observable<PaymentGatewayModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentGatewayModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentGatewayModel[]>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @return Success
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    buyNowSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    upgradeSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    extendSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    paymentFailed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class PaymentMethodsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<PagedResultDtoOfPaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPaymentMethodDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPaymentMethodDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPaymentMethodDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPaymentMethodDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPagSeuroConfig(id: number | undefined): Observable<CreateOrEditPagSeguroConfig> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPagSeuroConfig?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagSeuroConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagSeuroConfig(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditPagSeguroConfig>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditPagSeguroConfig>><any>_observableThrow(response_);
        }));
    }

    protected processGetPagSeuroConfig(response: HttpResponseBase): Observable<CreateOrEditPagSeguroConfig> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditPagSeguroConfig.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditPagSeguroConfig>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditPagSeguroConfig(body: CreateOrEditPagSeguroConfig | undefined): Observable<CreateOrEditPagSeguroConfig> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/CreateOrEditPagSeguroConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditPagSeguroConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditPagSeguroConfig(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditPagSeguroConfig>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditPagSeguroConfig>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditPagSeguroConfig(response: HttpResponseBase): Observable<CreateOrEditPagSeguroConfig> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditPagSeguroConfig.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditPagSeguroConfig>(<any>null);
    }

    /**
     * @param paymentType (optional) 
     * @return Success
     */
    getPaymentMethodsToPayment(paymentType: PaymentType | undefined): Observable<PaymentMethodDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetPaymentMethodsToPayment?";
        if (paymentType === null)
            throw new Error("The parameter 'paymentType' cannot be null.");
        else if (paymentType !== undefined)
            url_ += "paymentType=" + encodeURIComponent("" + paymentType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentMethodsToPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentMethodsToPayment(<any>response_);
                } catch (e) {
                    return <Observable<PaymentMethodDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentMethodDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentMethodsToPayment(response: HttpResponseBase): Observable<PaymentMethodDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentMethodDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto[]>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isActiveFilter (optional) 
     * @return Success
     */
    getAllBrands(filter: string | undefined, isActiveFilter: boolean | undefined): Observable<ListResultDtoOfBrandDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethods/GetAllBrands?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActiveFilter === null)
            throw new Error("The parameter 'isActiveFilter' cannot be null.");
        else if (isActiveFilter !== undefined)
            url_ += "IsActiveFilter=" + encodeURIComponent("" + isActiveFilter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBrands(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfBrandDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfBrandDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllBrands(response: HttpResponseBase): Observable<ListResultDtoOfBrandDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfBrandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfBrandDto>(<any>null);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param paymentId (optional) 
     * @param paypalOrderId (optional) 
     * @return Success
     */
    confirmPayment(paymentId: number | undefined, paypalOrderId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        if (paypalOrderId === null)
            throw new Error("The parameter 'paypalOrderId' cannot be null.");
        else if (paypalOrderId !== undefined)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<PayPalConfigurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PayPalConfigurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayPalConfigurationDto>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(<any>response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(<any>response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional) 
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string | undefined, userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId === null)
            throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureById(<any>response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentProfileForEdit(): Observable<CurrentProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentProfileForEdit(<any>response_);
                } catch (e) {
                    return <Observable<CurrentProfileEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CurrentProfileEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentProfileForEdit(response: HttpResponseBase): Observable<CurrentProfileEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrentProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentCategoryProfileForView(): Observable<OutputAnnuityProfileForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentCategoryProfileForView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentCategoryProfileForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentCategoryProfileForView(<any>response_);
                } catch (e) {
                    return <Observable<OutputAnnuityProfileForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutputAnnuityProfileForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentCategoryProfileForView(response: HttpResponseBase): Observable<OutputAnnuityProfileForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutputAnnuityProfileForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutputAnnuityProfileForViewDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentProfile(body: CurrentUserProfileDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentProfile(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCurrentProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RegistrationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param presenceFilter (optional) 
     * @param couponFilter (optional) 
     * @param eventIdsFilter (optional) 
     * @param deadlineIdsFilter (optional) 
     * @param extraFeeIdsFilter (optional) 
     * @param categoryIdFilter (optional) 
     * @param typeIdFilter (optional) 
     * @param userIdFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param situationFilter (optional) 
     * @param beginPaymentDate (optional) 
     * @param endPaymentDate (optional) 
     * @param userSituationId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, presenceFilter: number | undefined, couponFilter: boolean | undefined, eventIdsFilter: string | undefined, deadlineIdsFilter: string | undefined, extraFeeIdsFilter: string | undefined, categoryIdFilter: number | undefined, typeIdFilter: number | undefined, userIdFilter: number | undefined, paymentTypeFilter: PaymentType | undefined, statusFilter: PaymentStatus | undefined, situationFilter: RegistrationSituation | undefined, beginPaymentDate: moment.Moment | undefined, endPaymentDate: moment.Moment | undefined, userSituationId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRegistrationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (presenceFilter === null)
            throw new Error("The parameter 'presenceFilter' cannot be null.");
        else if (presenceFilter !== undefined)
            url_ += "PresenceFilter=" + encodeURIComponent("" + presenceFilter) + "&"; 
        if (couponFilter === null)
            throw new Error("The parameter 'couponFilter' cannot be null.");
        else if (couponFilter !== undefined)
            url_ += "CouponFilter=" + encodeURIComponent("" + couponFilter) + "&"; 
        if (eventIdsFilter === null)
            throw new Error("The parameter 'eventIdsFilter' cannot be null.");
        else if (eventIdsFilter !== undefined)
            url_ += "EventIdsFilter=" + encodeURIComponent("" + eventIdsFilter) + "&"; 
        if (deadlineIdsFilter === null)
            throw new Error("The parameter 'deadlineIdsFilter' cannot be null.");
        else if (deadlineIdsFilter !== undefined)
            url_ += "DeadlineIdsFilter=" + encodeURIComponent("" + deadlineIdsFilter) + "&"; 
        if (extraFeeIdsFilter === null)
            throw new Error("The parameter 'extraFeeIdsFilter' cannot be null.");
        else if (extraFeeIdsFilter !== undefined)
            url_ += "ExtraFeeIdsFilter=" + encodeURIComponent("" + extraFeeIdsFilter) + "&"; 
        if (categoryIdFilter === null)
            throw new Error("The parameter 'categoryIdFilter' cannot be null.");
        else if (categoryIdFilter !== undefined)
            url_ += "CategoryIdFilter=" + encodeURIComponent("" + categoryIdFilter) + "&"; 
        if (typeIdFilter === null)
            throw new Error("The parameter 'typeIdFilter' cannot be null.");
        else if (typeIdFilter !== undefined)
            url_ += "TypeIdFilter=" + encodeURIComponent("" + typeIdFilter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (situationFilter === null)
            throw new Error("The parameter 'situationFilter' cannot be null.");
        else if (situationFilter !== undefined)
            url_ += "SituationFilter=" + encodeURIComponent("" + situationFilter) + "&"; 
        if (beginPaymentDate === null)
            throw new Error("The parameter 'beginPaymentDate' cannot be null.");
        else if (beginPaymentDate !== undefined)
            url_ += "BeginPaymentDate=" + encodeURIComponent(beginPaymentDate ? "" + beginPaymentDate.toJSON() : "") + "&"; 
        if (endPaymentDate === null)
            throw new Error("The parameter 'endPaymentDate' cannot be null.");
        else if (endPaymentDate !== undefined)
            url_ += "EndPaymentDate=" + encodeURIComponent(endPaymentDate ? "" + endPaymentDate.toJSON() : "") + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegistrationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegistrationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegistrationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRegistrationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegistrationForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventIdFilter (optional) 
     * @param statusFilter (optional) 
     * @param situationFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyRegistrations(filter: string | undefined, eventIdFilter: number | undefined, statusFilter: PaymentStatus | undefined, situationFilter: RegistrationSituation | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetRegistrationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetMyRegistrations?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventIdFilter === null)
            throw new Error("The parameter 'eventIdFilter' cannot be null.");
        else if (eventIdFilter !== undefined)
            url_ += "EventIdFilter=" + encodeURIComponent("" + eventIdFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (situationFilter === null)
            throw new Error("The parameter 'situationFilter' cannot be null.");
        else if (situationFilter !== undefined)
            url_ += "SituationFilter=" + encodeURIComponent("" + situationFilter) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRegistrations(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetRegistrationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetRegistrationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyRegistrations(response: HttpResponseBase): Observable<PagedResultDtoOfGetRegistrationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetRegistrationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetRegistrationForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param presenceFilter (optional) 
     * @param couponFilter (optional) 
     * @param eventIdsFilter (optional) 
     * @param deadlineIdsFilter (optional) 
     * @param extraFeeIdsFilter (optional) 
     * @param categoryIdFilter (optional) 
     * @param typeIdFilter (optional) 
     * @param userIdFilter (optional) 
     * @param paymentTypeFilter (optional) 
     * @param statusFilter (optional) 
     * @param situationFilter (optional) 
     * @param beginPaymentDate (optional) 
     * @param endPaymentDate (optional) 
     * @param userSituationId (optional) 
     * @return Success
     */
    getRegistrationsToExcel(filter: string | undefined, presenceFilter: number | undefined, couponFilter: boolean | undefined, eventIdsFilter: number[] | undefined, deadlineIdsFilter: number[] | undefined, extraFeeIdsFilter: number[] | undefined, categoryIdFilter: number | undefined, typeIdFilter: number | undefined, userIdFilter: number | undefined, paymentTypeFilter: PaymentType | undefined, statusFilter: PaymentStatus | undefined, situationFilter: RegistrationSituation | undefined, beginPaymentDate: moment.Moment | undefined, endPaymentDate: moment.Moment | undefined, userSituationId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetRegistrationsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (presenceFilter === null)
            throw new Error("The parameter 'presenceFilter' cannot be null.");
        else if (presenceFilter !== undefined)
            url_ += "PresenceFilter=" + encodeURIComponent("" + presenceFilter) + "&"; 
        if (couponFilter === null)
            throw new Error("The parameter 'couponFilter' cannot be null.");
        else if (couponFilter !== undefined)
            url_ += "CouponFilter=" + encodeURIComponent("" + couponFilter) + "&"; 
        if (eventIdsFilter === null)
            throw new Error("The parameter 'eventIdsFilter' cannot be null.");
        else if (eventIdsFilter !== undefined)
            eventIdsFilter && eventIdsFilter.forEach(item => { url_ += "EventIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (deadlineIdsFilter === null)
            throw new Error("The parameter 'deadlineIdsFilter' cannot be null.");
        else if (deadlineIdsFilter !== undefined)
            deadlineIdsFilter && deadlineIdsFilter.forEach(item => { url_ += "DeadlineIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (extraFeeIdsFilter === null)
            throw new Error("The parameter 'extraFeeIdsFilter' cannot be null.");
        else if (extraFeeIdsFilter !== undefined)
            extraFeeIdsFilter && extraFeeIdsFilter.forEach(item => { url_ += "ExtraFeeIdsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (categoryIdFilter === null)
            throw new Error("The parameter 'categoryIdFilter' cannot be null.");
        else if (categoryIdFilter !== undefined)
            url_ += "CategoryIdFilter=" + encodeURIComponent("" + categoryIdFilter) + "&"; 
        if (typeIdFilter === null)
            throw new Error("The parameter 'typeIdFilter' cannot be null.");
        else if (typeIdFilter !== undefined)
            url_ += "TypeIdFilter=" + encodeURIComponent("" + typeIdFilter) + "&"; 
        if (userIdFilter === null)
            throw new Error("The parameter 'userIdFilter' cannot be null.");
        else if (userIdFilter !== undefined)
            url_ += "UserIdFilter=" + encodeURIComponent("" + userIdFilter) + "&"; 
        if (paymentTypeFilter === null)
            throw new Error("The parameter 'paymentTypeFilter' cannot be null.");
        else if (paymentTypeFilter !== undefined)
            url_ += "PaymentTypeFilter=" + encodeURIComponent("" + paymentTypeFilter) + "&"; 
        if (statusFilter === null)
            throw new Error("The parameter 'statusFilter' cannot be null.");
        else if (statusFilter !== undefined)
            url_ += "StatusFilter=" + encodeURIComponent("" + statusFilter) + "&"; 
        if (situationFilter === null)
            throw new Error("The parameter 'situationFilter' cannot be null.");
        else if (situationFilter !== undefined)
            url_ += "SituationFilter=" + encodeURIComponent("" + situationFilter) + "&"; 
        if (beginPaymentDate === null)
            throw new Error("The parameter 'beginPaymentDate' cannot be null.");
        else if (beginPaymentDate !== undefined)
            url_ += "BeginPaymentDate=" + encodeURIComponent(beginPaymentDate ? "" + beginPaymentDate.toJSON() : "") + "&"; 
        if (endPaymentDate === null)
            throw new Error("The parameter 'endPaymentDate' cannot be null.");
        else if (endPaymentDate !== undefined)
            url_ += "EndPaymentDate=" + encodeURIComponent(endPaymentDate ? "" + endPaymentDate.toJSON() : "") + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRegistrationForView(id: number | undefined): Observable<GetRegistrationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetRegistrationForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationForView(<any>response_);
                } catch (e) {
                    return <Observable<GetRegistrationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegistrationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationForView(response: HttpResponseBase): Observable<GetRegistrationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegistrationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegistrationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getRegistrationForEdit(id: number | undefined, tenantId: number | undefined): Observable<RegistrationForEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetRegistrationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<RegistrationForEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegistrationForEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationForEdit(response: HttpResponseBase): Observable<RegistrationForEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationForEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationForEditDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditRegistrationDto | undefined): Observable<CreateOrEditRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<CreateOrEditRegistrationOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditRegistrationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditRegistrationOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditForOrder(body: CreateOrEditRegistrationDto | undefined): Observable<CreateOrEditRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateOrEditForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditForOrder(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditForOrder(response: HttpResponseBase): Observable<CreateOrEditRegistrationOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditRegistrationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditRegistrationOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditListForOrder(body: CreateOrEditListRegistrationDto | undefined): Observable<CreateOrEditListRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateOrEditListForOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditListForOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditListForOrder(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditListRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditListRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditListForOrder(response: HttpResponseBase): Observable<CreateOrEditListRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditListRegistrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditListRegistrationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setPresence(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/SetPresence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPresence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPresence(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSetPresence(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: EntityDtoOfInt64 | undefined): Observable<ResultEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(<any>response_);
                } catch (e) {
                    return <Observable<ResultEmailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultEmailDto>><any>_observableThrow(response_);
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<ResultEmailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultEmailDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: EntityDtoOfInt64 | undefined): Observable<ResultEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<ResultEmailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultEmailDto>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<ResultEmailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultEmailDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRegistrationForPayment(id: number | undefined): Observable<OutputCurrentPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetRegistrationForPayment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationForPayment(<any>response_);
                } catch (e) {
                    return <Observable<OutputCurrentPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutputCurrentPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationForPayment(response: HttpResponseBase): Observable<OutputCurrentPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutputCurrentPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutputCurrentPaymentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForRegistration(id: number | undefined): Observable<CreateOrEditRegistrationUser> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetUserForRegistration?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForRegistration(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationUser>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationUser>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserForRegistration(response: HttpResponseBase): Observable<CreateOrEditRegistrationUser> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditRegistrationUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditRegistrationUser>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @param eventId (optional) 
     * @param cPF (optional) 
     * @param onlyMembers (optional) 
     * @return Success
     */
    getUserForRegistrationByTenantAndLogin(tenantId: number | undefined, eventId: number | undefined, cPF: string | undefined, onlyMembers: boolean | undefined): Observable<CreateOrEditRegistrationUser> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/GetUserForRegistrationByTenantAndLogin?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        if (cPF === null)
            throw new Error("The parameter 'cPF' cannot be null.");
        else if (cPF !== undefined)
            url_ += "CPF=" + encodeURIComponent("" + cPF) + "&"; 
        if (onlyMembers === null)
            throw new Error("The parameter 'onlyMembers' cannot be null.");
        else if (onlyMembers !== undefined)
            url_ += "OnlyMembers=" + encodeURIComponent("" + onlyMembers) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForRegistrationByTenantAndLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForRegistrationByTenantAndLogin(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditRegistrationUser>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditRegistrationUser>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserForRegistrationByTenantAndLogin(response: HttpResponseBase): Observable<CreateOrEditRegistrationUser> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditRegistrationUser.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditRegistrationUser>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditUserForRegistration(body: CreateOrEditRegistrationUser | undefined): Observable<CreateOrEditUserDto> {
        let url_ = this.baseUrl + "/api/services/app/Registrations/CreateOrEditUserForRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEditUserForRegistration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEditUserForRegistration(<any>response_);
                } catch (e) {
                    return <Observable<CreateOrEditUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CreateOrEditUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEditUserForRegistration(response: HttpResponseBase): Observable<CreateOrEditUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrEditUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrEditUserDto>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param permissions (optional) 
     * @return Success
     */
    getRoles(permissions: string[] | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(<any>response_);
                } catch (e) {
                    return <Observable<StripeConfigurationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StripeConfigurationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripeConfigurationDto>(<any>null);
    }

    /**
     * @param stripeSessionId (optional) 
     * @return Success
     */
    getPayment(stripeSessionId: string | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
        if (stripeSessionId === null)
            throw new Error("The parameter 'stripeSessionId' cannot be null.");
        else if (stripeSessionId !== undefined)
            url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(<any>response_);
                } catch (e) {
                    return <Observable<SubscriptionPaymentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubscriptionPaymentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionPaymentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentSession(body: StripeCreatePaymentSessionInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentSession(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPaymentResult(paymentId: number | undefined): Observable<StripePaymentResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentResult(<any>response_);
                } catch (e) {
                    return <Observable<StripePaymentResultOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<StripePaymentResultOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripePaymentResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StripePaymentResultOutput>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: moment.Moment | undefined, subscriptionEndDateEnd: moment.Moment | undefined, creationDateStart: moment.Moment | undefined, creationDateEnd: moment.Moment | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (subscriptionEndDateStart === null)
            throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&"; 
        if (subscriptionEndDateEnd === null)
            throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&"; 
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&"; 
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&"; 
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&"; 
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(<any>response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantEditDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getHotsiteTenants(tenantId: number | undefined): Observable<HotsiteTenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetHotsiteTenants?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsiteTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsiteTenants(<any>response_);
                } catch (e) {
                    return <Observable<HotsiteTenantDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<HotsiteTenantDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsiteTenants(response: HttpResponseBase): Observable<HotsiteTenantDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HotsiteTenantDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HotsiteTenantDto[]>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(<any>response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getMemberActivity(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(<any>response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getTopStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(<any>response_);
                } catch (e) {
                    return <Observable<GetTopStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTopStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTopStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getRegistrationTotalProfit(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegistrationTotalProfit?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationTotalProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationTotalProfit(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationTotalProfit(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getRegistrationTotalReceivables(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegistrationTotalReceivables?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationTotalReceivables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationTotalReceivables(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationTotalReceivables(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getRegistrationNewRegistrations(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegistrationNewRegistrations?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationNewRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationNewRegistrations(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationNewRegistrations(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getRegistrationApproval(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegistrationApproval?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistrationApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistrationApproval(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistrationApproval(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getProfitShare(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(<any>response_);
                } catch (e) {
                    return <Observable<GetProfitShareOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfitShareOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfitShareOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getDailySales(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(<any>response_);
                } catch (e) {
                    return <Observable<GetDailySalesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDailySalesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDailySalesOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetPaymentStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentStats(response: HttpResponseBase): Observable<GetPaymentStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralTotalProfit(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralTotalProfit?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralTotalProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralTotalProfit(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralTotalProfit(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralTotalReceivables(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralTotalReceivables?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralTotalReceivables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralTotalReceivables(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralTotalReceivables(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralNewMembers(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralNewMembers?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralNewMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralNewMembers(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralNewMembers(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralDocumentsApprove(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetGeneralDocumentsApproveOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralDocumentsApprove?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralDocumentsApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDocumentsApprove(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralDocumentsApproveOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralDocumentsApproveOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralDocumentsApprove(response: HttpResponseBase): Observable<GetGeneralDocumentsApproveOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralDocumentsApproveOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralDocumentsApproveOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralDocumentsApproveCounter(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralDocumentsApproveCounter?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralDocumentsApproveCounter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDocumentsApproveCounter(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralDocumentsApproveCounter(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyDocumentationStatus(userId: number | undefined): Observable<GetMyDocumentationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyDocumentationStatus?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDocumentationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDocumentationStatus(<any>response_);
                } catch (e) {
                    return <Observable<GetMyDocumentationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyDocumentationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyDocumentationStatus(response: HttpResponseBase): Observable<GetMyDocumentationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyDocumentationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyDocumentationsOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyAnnuities(userId: number | undefined): Observable<GetMyAnnuitiesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyAnnuities?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAnnuities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAnnuities(<any>response_);
                } catch (e) {
                    return <Observable<GetMyAnnuitiesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyAnnuitiesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyAnnuities(response: HttpResponseBase): Observable<GetMyAnnuitiesOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyAnnuitiesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyAnnuitiesOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getNextEvents(userId: number | undefined): Observable<GetMyNextEventsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetNextEvents?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextEvents(<any>response_);
                } catch (e) {
                    return <Observable<GetMyNextEventsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyNextEventsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetNextEvents(response: HttpResponseBase): Observable<GetMyNextEventsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyNextEventsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyNextEventsOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyRegistrations(userId: number | undefined): Observable<GetMyRegistrationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyRegistrations?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRegistrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRegistrations(<any>response_);
                } catch (e) {
                    return <Observable<GetMyRegistrationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyRegistrationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyRegistrations(response: HttpResponseBase): Observable<GetMyRegistrationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyRegistrationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyRegistrationsOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyOrders(userId: number | undefined): Observable<GetMyOrdersOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyOrders?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrders(<any>response_);
                } catch (e) {
                    return <Observable<GetMyOrdersOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyOrdersOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyOrders(response: HttpResponseBase): Observable<GetMyOrdersOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyOrdersOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyOrdersOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getFinancialNewOrders(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialNewOrders?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialNewOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialNewOrders(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialNewOrders(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getFinancialOverdueOrders(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialOverdueOrders?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialOverdueOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialOverdueOrders(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialOverdueOrders(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getFinancialSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetFinancialSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetFinancialSalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFinancialSalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialSalesSummary(response: HttpResponseBase): Observable<GetFinancialSalesSummaryOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialSalesSummaryOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getFinancialPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetPaymentStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialPaymentStats(response: HttpResponseBase): Observable<GetPaymentStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getFinancialProfitShare(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetFinancialProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialProfitShare?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialProfitShare(<any>response_);
                } catch (e) {
                    return <Observable<GetFinancialProfitShareOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFinancialProfitShareOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialProfitShare(response: HttpResponseBase): Observable<GetFinancialProfitShareOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialProfitShareOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getFinancialGeneralStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetFinancialGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialGeneralStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGeneralStats(<any>response_);
                } catch (e) {
                    return <Observable<GetFinancialGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFinancialGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialGeneralStats(response: HttpResponseBase): Observable<GetFinancialGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialGeneralStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuityTotalProfit(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuityTotalProfit?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityTotalProfit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityTotalProfit(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityTotalProfit(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuityTotalReceivables(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuityTotalReceivables?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityTotalReceivables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityTotalReceivables(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityTotalReceivables(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuityNewAnnuities(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuityNewAnnuities?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityNewAnnuities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityNewAnnuities(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityNewAnnuities(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuityNewReadmissions(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuityNewReadmissions?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityNewReadmissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityNewReadmissions(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityNewReadmissions(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuitiesSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetAnnuitySalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuitiesSalesSummary?";
        if (salesSummaryDatePeriod === undefined || salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' must be defined and cannot be null.");
        else
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitiesSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitiesSalesSummary(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuitySalesSummaryOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuitySalesSummaryOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitiesSalesSummary(response: HttpResponseBase): Observable<GetAnnuitySalesSummaryOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuitySalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuitySalesSummaryOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuitiesPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetPaymentStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuitiesPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitiesPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitiesPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitiesPaymentStats(response: HttpResponseBase): Observable<GetPaymentStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuitiesProfitShare(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetAnnuityProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuitiesProfitShare?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitiesProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitiesProfitShare(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityProfitShareOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityProfitShareOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitiesProfitShare(response: HttpResponseBase): Observable<GetAnnuityProfitShareOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuityProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityProfitShareOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getAnnuitiesGeneralStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetAnnuityGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuitiesGeneralStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "EventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuitiesGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuitiesGeneralStats(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuitiesGeneralStats(response: HttpResponseBase): Observable<GetAnnuityGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuityGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityGeneralStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    generateFinancialSalesSummaryData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<SalesSummaryData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GenerateFinancialSalesSummaryData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFinancialSalesSummaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFinancialSalesSummaryData(<any>response_);
                } catch (e) {
                    return <Observable<SalesSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SalesSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateFinancialSalesSummaryData(response: HttpResponseBase): Observable<SalesSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesSummaryData[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getFinancialGeneralPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<GetFinancialGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetFinancialGeneralPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialGeneralPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialGeneralPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<GetFinancialGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetFinancialGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetFinancialGeneralPaymentStats(response: HttpResponseBase): Observable<GetFinancialGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialGeneralStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @param body (optional) 
     * @return Success
     */
    generateSalesSummaryData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined, body: number[] | undefined): Observable<SalesSummaryData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GenerateSalesSummaryData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateSalesSummaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateSalesSummaryData(<any>response_);
                } catch (e) {
                    return <Observable<SalesSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SalesSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateSalesSummaryData(response: HttpResponseBase): Observable<SalesSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesSummaryData[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    generatePaymentStat(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<PaymentStatusData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GeneratePaymentStat?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePaymentStat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePaymentStat(<any>response_);
                } catch (e) {
                    return <Observable<PaymentStatusData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentStatusData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGeneratePaymentStat(response: HttpResponseBase): Observable<PaymentStatusData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentStatusData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentStatusData[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    getGeneralPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralPaymentStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param eventId (optional) 
     * @return Success
     */
    generateMemberActivities(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, eventId: number | undefined): Observable<MemberActivity[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GenerateMemberActivities?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateMemberActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateMemberActivities(<any>response_);
                } catch (e) {
                    return <Observable<MemberActivity[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<MemberActivity[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateMemberActivities(response: HttpResponseBase): Observable<MemberActivity[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MemberActivity.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MemberActivity[]>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneralDocumentsApproveList(): Observable<GetGeneralDocumentsApproveOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralDocumentsApproveList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralDocumentsApproveList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDocumentsApproveList(<any>response_);
                } catch (e) {
                    return <Observable<GetGeneralDocumentsApproveOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetGeneralDocumentsApproveOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralDocumentsApproveList(response: HttpResponseBase): Observable<GetGeneralDocumentsApproveOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralDocumentsApproveOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGeneralDocumentsApproveOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getGeneralDocumentsApproveTotal(): Observable<GetTotalOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralDocumentsApproveTotal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralDocumentsApproveTotal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDocumentsApproveTotal(<any>response_);
                } catch (e) {
                    return <Observable<GetTotalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTotalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetGeneralDocumentsApproveTotal(response: HttpResponseBase): Observable<GetTotalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTotalOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTotalOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyDocumentationsList(userId: number | undefined): Observable<GetMyDocumentationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyDocumentationsList?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyDocumentationsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyDocumentationsList(<any>response_);
                } catch (e) {
                    return <Observable<GetMyDocumentationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyDocumentationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyDocumentationsList(response: HttpResponseBase): Observable<GetMyDocumentationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyDocumentationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyDocumentationsOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyAnnuitiesList(userId: number | undefined): Observable<GetMyAnnuitiesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyAnnuitiesList?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyAnnuitiesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyAnnuitiesList(<any>response_);
                } catch (e) {
                    return <Observable<GetMyAnnuitiesOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyAnnuitiesOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyAnnuitiesList(response: HttpResponseBase): Observable<GetMyAnnuitiesOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyAnnuitiesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyAnnuitiesOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyRegistrationsList(userId: number | undefined): Observable<GetMyRegistrationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyRegistrationsList?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyRegistrationsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyRegistrationsList(<any>response_);
                } catch (e) {
                    return <Observable<GetMyRegistrationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyRegistrationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyRegistrationsList(response: HttpResponseBase): Observable<GetMyRegistrationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyRegistrationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyRegistrationsOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyOrdersList(userId: number | undefined): Observable<GetMyOrdersOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyOrdersList?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyOrdersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyOrdersList(<any>response_);
                } catch (e) {
                    return <Observable<GetMyOrdersOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyOrdersOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyOrdersList(response: HttpResponseBase): Observable<GetMyOrdersOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyOrdersOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyOrdersOutput>(<any>null);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getMyNextEventsList(userId: number | undefined): Observable<GetMyNextEventsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMyNextEventsList?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNextEventsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNextEventsList(<any>response_);
                } catch (e) {
                    return <Observable<GetMyNextEventsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetMyNextEventsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetMyNextEventsList(response: HttpResponseBase): Observable<GetMyNextEventsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMyNextEventsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMyNextEventsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param annuitySettingId (optional) 
     * @param body (optional) 
     * @return Success
     */
    generateAnnuitySalesSummaryData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, annuitySettingId: number | undefined, body: number[] | undefined): Observable<SalesSummaryData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GenerateAnnuitySalesSummaryData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (annuitySettingId === null)
            throw new Error("The parameter 'annuitySettingId' cannot be null.");
        else if (annuitySettingId !== undefined)
            url_ += "annuitySettingId=" + encodeURIComponent("" + annuitySettingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAnnuitySalesSummaryData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAnnuitySalesSummaryData(<any>response_);
                } catch (e) {
                    return <Observable<SalesSummaryData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SalesSummaryData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAnnuitySalesSummaryData(response: HttpResponseBase): Observable<SalesSummaryData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesSummaryData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SalesSummaryData[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param annuitySettingId (optional) 
     * @return Success
     */
    getAnnuityGeneralPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, annuitySettingId: number | undefined): Observable<GetAnnuityGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetAnnuityGeneralPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (annuitySettingId === null)
            throw new Error("The parameter 'annuitySettingId' cannot be null.");
        else if (annuitySettingId !== undefined)
            url_ += "annuitySettingId=" + encodeURIComponent("" + annuitySettingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnnuityGeneralPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnnuityGeneralPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<GetAnnuityGeneralStatsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAnnuityGeneralStatsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAnnuityGeneralPaymentStats(response: HttpResponseBase): Observable<GetAnnuityGeneralStatsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAnnuityGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAnnuityGeneralStatsOutput>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    generateFinancialPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<PaymentStatusData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GenerateFinancialPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFinancialPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFinancialPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<PaymentStatusData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentStatusData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateFinancialPaymentStats(response: HttpResponseBase): Observable<PaymentStatusData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentStatusData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentStatusData[]>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param annuitySettingId (optional) 
     * @return Success
     */
    generateAnnuityPaymentStats(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, annuitySettingId: number | undefined): Observable<PaymentStatusData[]> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GenerateAnnuityPaymentStats?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (annuitySettingId === null)
            throw new Error("The parameter 'annuitySettingId' cannot be null.");
        else if (annuitySettingId !== undefined)
            url_ += "annuitySettingId=" + encodeURIComponent("" + annuitySettingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAnnuityPaymentStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAnnuityPaymentStats(<any>response_);
                } catch (e) {
                    return <Observable<PaymentStatusData[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentStatusData[]>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateAnnuityPaymentStats(response: HttpResponseBase): Observable<PaymentStatusData[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentStatusData.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentStatusData[]>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(<any>response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(<any>response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsSelectOutput>(<any>null);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(<any>response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTermsOfResponsibilityCache(): Observable<TenantTermOfResponsibilityDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetTermsOfResponsibilityCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsOfResponsibilityCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsOfResponsibilityCache(<any>response_);
                } catch (e) {
                    return <Observable<TenantTermOfResponsibilityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantTermOfResponsibilityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermsOfResponsibilityCache(response: HttpResponseBase): Observable<TenantTermOfResponsibilityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantTermOfResponsibilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantTermOfResponsibilityDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTermsOfResponsibility(): Observable<TenantTermOfResponsibilityDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetTermsOfResponsibility";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTermsOfResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTermsOfResponsibility(<any>response_);
                } catch (e) {
                    return <Observable<TenantTermOfResponsibilityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantTermOfResponsibilityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTermsOfResponsibility(response: HttpResponseBase): Observable<TenantTermOfResponsibilityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantTermOfResponsibilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantTermOfResponsibilityDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSerpro(): Observable<TenantSerproDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetSerpro";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSerpro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSerpro(<any>response_);
                } catch (e) {
                    return <Observable<TenantSerproDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantSerproDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSerpro(response: HttpResponseBase): Observable<TenantSerproDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSerproDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantSerproDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCfm(): Observable<TenantCfmDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetCfm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCfm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCfm(<any>response_);
                } catch (e) {
                    return <Observable<TenantCfmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantCfmDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCfm(response: HttpResponseBase): Observable<TenantCfmDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantCfmDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantCfmDto>(<any>null);
    }

    /**
     * @return Success
     */
    getHotsite(): Observable<TenantHotsiteDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetHotsite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHotsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHotsite(<any>response_);
                } catch (e) {
                    return <Observable<TenantHotsiteDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantHotsiteDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetHotsite(response: HttpResponseBase): Observable<TenantHotsiteDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantHotsiteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantHotsiteDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class ThematicAreasServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param eventScheduleId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, eventScheduleId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetThematicAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetThematicAreaForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetThematicAreaForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetThematicAreaForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetThematicAreaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetThematicAreaForViewDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param eventScheduleId (optional) 
     * @return Success
     */
    getThematicAreasToExcel(filter: string | undefined, eventScheduleId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreasToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThematicAreasToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThematicAreasToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetThematicAreasToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getThematicAreaForView(id: number | undefined): Observable<GetThematicAreaForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreaForView?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThematicAreaForView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThematicAreaForView(<any>response_);
                } catch (e) {
                    return <Observable<GetThematicAreaForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetThematicAreaForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetThematicAreaForView(response: HttpResponseBase): Observable<GetThematicAreaForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThematicAreaForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetThematicAreaForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getThematicAreaForEdit(id: number | undefined): Observable<GetThematicAreaForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreaForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThematicAreaForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThematicAreaForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetThematicAreaForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetThematicAreaForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetThematicAreaForEdit(response: HttpResponseBase): Observable<GetThematicAreaForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetThematicAreaForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetThematicAreaForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param eventScheduleId (optional) 
     * @param coverageAreaId (optional) 
     * @return Success
     */
    getThematicAreasForSelect(term: string | undefined, eventScheduleId: number | undefined, coverageAreaId: number | undefined): Observable<ListResultDtoOfThematicAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/GetThematicAreasForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (eventScheduleId === null)
            throw new Error("The parameter 'eventScheduleId' cannot be null.");
        else if (eventScheduleId !== undefined)
            url_ += "EventScheduleId=" + encodeURIComponent("" + eventScheduleId) + "&"; 
        if (coverageAreaId === null)
            throw new Error("The parameter 'coverageAreaId' cannot be null.");
        else if (coverageAreaId !== undefined)
            url_ += "CoverageAreaId=" + encodeURIComponent("" + coverageAreaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThematicAreasForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThematicAreasForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfThematicAreaDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfThematicAreaDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetThematicAreasForSelect(response: HttpResponseBase): Observable<ListResultDtoOfThematicAreaDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfThematicAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfThematicAreaDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditThematicAreaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ThematicAreas/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === undefined || defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' must be defined and cannot be null.");
        else
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(<any>response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(<any>response_);
                } catch (e) {
                    return <Observable<RefreshTokenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<RefreshTokenResult>><any>_observableThrow(response_);
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RefreshTokenResult>(<any>null);
    }

    /**
     * @return Success
     */
    logOut(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (severity === null)
            throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<ThemeSettingsDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ThemeSettingsDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ThemeSettingsDto[]>(<any>null);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param onlyMembers (optional) 
     * @param isActive (optional) 
     * @param isEmailConfirmed (optional) 
     * @param userSituationId (optional) 
     * @param statusCpf (optional) 
     * @param situationCpf (optional) 
     * @param confirmedName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, onlyMembers: boolean | undefined, isActive: boolean | undefined, isEmailConfirmed: boolean | undefined, userSituationId: number | undefined, statusCpf: StatusCpf | undefined, situationCpf: SituationCpf | undefined, confirmedName: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&"; 
        if (onlyMembers === null)
            throw new Error("The parameter 'onlyMembers' cannot be null.");
        else if (onlyMembers !== undefined)
            url_ += "OnlyMembers=" + encodeURIComponent("" + onlyMembers) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (isEmailConfirmed === null)
            throw new Error("The parameter 'isEmailConfirmed' cannot be null.");
        else if (isEmailConfirmed !== undefined)
            url_ += "IsEmailConfirmed=" + encodeURIComponent("" + isEmailConfirmed) + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        if (statusCpf === null)
            throw new Error("The parameter 'statusCpf' cannot be null.");
        else if (statusCpf !== undefined)
            url_ += "StatusCpf=" + encodeURIComponent("" + statusCpf) + "&"; 
        if (situationCpf === null)
            throw new Error("The parameter 'situationCpf' cannot be null.");
        else if (situationCpf !== undefined)
            url_ += "SituationCpf=" + encodeURIComponent("" + situationCpf) + "&"; 
        if (confirmedName === null)
            throw new Error("The parameter 'confirmedName' cannot be null.");
        else if (confirmedName !== undefined)
            url_ += "ConfirmedName=" + encodeURIComponent("" + confirmedName) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param isActive (optional) 
     * @param isEmailConfirmed (optional) 
     * @param sorting (optional) 
     * @param onlyMembers (optional) 
     * @param userSituationId (optional) 
     * @param statusCpf (optional) 
     * @param situationCpf (optional) 
     * @param confirmedName (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, isActive: boolean | undefined, isEmailConfirmed: boolean | undefined, sorting: string | undefined, onlyMembers: boolean | undefined, userSituationId: number | undefined, statusCpf: StatusCpf | undefined, situationCpf: SituationCpf | undefined, confirmedName: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (isEmailConfirmed === null)
            throw new Error("The parameter 'isEmailConfirmed' cannot be null.");
        else if (isEmailConfirmed !== undefined)
            url_ += "IsEmailConfirmed=" + encodeURIComponent("" + isEmailConfirmed) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (onlyMembers === null)
            throw new Error("The parameter 'onlyMembers' cannot be null.");
        else if (onlyMembers !== undefined)
            url_ += "OnlyMembers=" + encodeURIComponent("" + onlyMembers) + "&"; 
        if (userSituationId === null)
            throw new Error("The parameter 'userSituationId' cannot be null.");
        else if (userSituationId !== undefined)
            url_ += "UserSituationId=" + encodeURIComponent("" + userSituationId) + "&"; 
        if (statusCpf === null)
            throw new Error("The parameter 'statusCpf' cannot be null.");
        else if (statusCpf !== undefined)
            url_ += "StatusCpf=" + encodeURIComponent("" + statusCpf) + "&"; 
        if (situationCpf === null)
            throw new Error("The parameter 'situationCpf' cannot be null.");
        else if (situationCpf !== undefined)
            url_ += "SituationCpf=" + encodeURIComponent("" + situationCpf) + "&"; 
        if (confirmedName === null)
            throw new Error("The parameter 'confirmedName' cannot be null.");
        else if (confirmedName !== undefined)
            url_ += "ConfirmedName=" + encodeURIComponent("" + confirmedName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserForEditOutput>(<any>null);
    }

    /**
     * @param term (optional) 
     * @param onlyMembers (optional) 
     * @param onlyNotMembers (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsersForSelect(term: string | undefined, onlyMembers: boolean | undefined, onlyNotMembers: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<ListResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersForSelect?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "Term=" + encodeURIComponent("" + term) + "&"; 
        if (onlyMembers === null)
            throw new Error("The parameter 'onlyMembers' cannot be null.");
        else if (onlyMembers !== undefined)
            url_ += "OnlyMembers=" + encodeURIComponent("" + onlyMembers) + "&"; 
        if (onlyNotMembers === null)
            throw new Error("The parameter 'onlyNotMembers' cannot be null.");
        else if (onlyNotMembers !== undefined)
            url_ += "OnlyNotMembers=" + encodeURIComponent("" + onlyNotMembers) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersForSelect(response: HttpResponseBase): Observable<ListResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkUserForCreateOrUpdate(body: CheckUserInput | undefined): Observable<ListResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CheckUserForCreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserForCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserForCreateOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserListDto>><any>_observableThrow(response_);
        }));
    }

    protected processCheckUserForCreateOrUpdate(response: HttpResponseBase): Observable<ListResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<ResultEmailDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<ResultEmailDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ResultEmailDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<ResultEmailDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResultEmailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultEmailDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserMainData(id: number | undefined): Observable<UpdateUserMainDataDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserMainData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserMainData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserMainData(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserMainDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserMainDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserMainData(response: HttpResponseBase): Observable<UpdateUserMainDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserMainDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserMainDataDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserMainData(body: UpdateUserMainDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserMainData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserMainData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserMainData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUserMainData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateCpfUser(body: ValidateCpfUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ValidateCpfUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateCpfUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateCpfUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processValidateCpfUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class UserSituationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetUserSituationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSituations/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetUserSituationForViewDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetUserSituationForViewDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetUserSituationForViewDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetUserSituationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetUserSituationForViewDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserSituationForEdit(id: number | undefined): Observable<GetUserSituationForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/UserSituations/GetUserSituationForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSituationForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSituationForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetUserSituationForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserSituationForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSituationForEdit(response: HttpResponseBase): Observable<GetUserSituationForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserSituationForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserSituationForEditOutput>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditUserSituationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSituations/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrEdit(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserSituations/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getUserSituationsToExcel(filter: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSituations/GetUserSituationsToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSituationsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSituationsToExcel(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserSituationsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param filter (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getForSelect(filter: string | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ListResultDtoOfUserSituationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSituations/GetForSelect?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForSelect(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserSituationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfUserSituationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetForSelect(response: HttpResponseBase): Observable<ListResultDtoOfUserSituationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserSituationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfUserSituationDto>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(<any>response_);
                } catch (e) {
                    return <Observable<FileDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileDto>><any>_observableThrow(response_);
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string | undefined;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string | undefined;
}

export enum TenantAvailabilityState {
    Available = 1,
    InActive = 2,
    NotFound = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data; 
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export enum PhoneType {
    Mobile = 0,
    Home = 1,
    Business = 2,
    Emergency = 3,
    Fax = 4,
    WhatsApp = 5,
}

export class UserPhoneDto implements IUserPhoneDto {
    ddi!: string | undefined;
    ddd!: string | undefined;
    number!: string | undefined;
    type!: PhoneType;
    id!: number | undefined;

    constructor(data?: IUserPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserPhoneDto {
    ddi: string | undefined;
    ddd: string | undefined;
    number: string | undefined;
    type: PhoneType;
    id: number | undefined;
}

export enum AddressType {
    Home = 0,
    Business = 1,
}

export class UserAddressDto implements IUserAddressDto {
    logradour!: string | undefined;
    number!: string | undefined;
    complement!: string | undefined;
    district!: string | undefined;
    zipCode!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    stateName!: string | undefined;
    countryName!: string | undefined;
    isMailing!: boolean;
    type!: AddressType;
    id!: number | undefined;

    constructor(data?: IUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserAddressDto {
    logradour: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    district: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    stateName: string | undefined;
    countryName: string | undefined;
    isMailing: boolean;
    type: AddressType;
    id: number | undefined;
}

export enum StatusCrm {
    Invalido = 0,
    Valido = 1,
    AguardandoValidacao = 2,
}

export enum SituationCrm {
    Regular = 0,
    SuspensaoParcialPermanente = 1,
    Cassado = 2,
    Inoperante = 3,
    Falecido = 4,
    SemExercicioProfissaoUF = 5,
    InterdicaoCautelarTotal = 6,
    SuspensoOrdemJudicialParcial = 7,
    Cancelado = 8,
    SuspensaoTotalTemporaria = 9,
    InterdicaoCautelarParcial = 10,
    SuspensoOrdemJudicialTotal = 11,
    Aposentado = 12,
    SuspensaoTemporaria = 13,
    SuspensoTotal = 14,
    Transferido = 15,
    SuspensoParcial = 16,
}

export enum MemberAnnuitySituation {
    Pending = 0,
    Paid = 1,
    Overdue = 2,
    OverdueTwoYears = 3,
}

export class CategoryLevelDto implements ICategoryLevelDto {
    name!: string | undefined;
    order!: number;
    categoryId!: number;
    requiresDocumentationApproval!: boolean;
    id!: number;

    constructor(data?: ICategoryLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.order = data["order"];
            this.categoryId = data["categoryId"];
            this.requiresDocumentationApproval = data["requiresDocumentationApproval"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["categoryId"] = this.categoryId;
        data["requiresDocumentationApproval"] = this.requiresDocumentationApproval;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryLevelDto {
    name: string | undefined;
    order: number;
    categoryId: number;
    requiresDocumentationApproval: boolean;
    id: number;
}

export class CategoryListDto implements ICategoryListDto {
    name!: string | undefined;
    shortName!: string | undefined;
    isActive!: boolean;
    requiresDocument!: boolean;
    requiresAdditionalDocument!: boolean;
    isExempt!: boolean;
    isResident!: boolean;
    requiresCRM!: boolean;
    allowNewUserRegister!: boolean;
    nextCategoryId!: number | undefined;
    levels!: CategoryLevelDto[] | undefined;
    id!: number;

    constructor(data?: ICategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
            this.requiresDocument = data["requiresDocument"];
            this.requiresAdditionalDocument = data["requiresAdditionalDocument"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.requiresCRM = data["requiresCRM"];
            this.allowNewUserRegister = data["allowNewUserRegister"];
            this.nextCategoryId = data["nextCategoryId"];
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item of data["levels"])
                    this.levels!.push(CategoryLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        data["requiresDocument"] = this.requiresDocument;
        data["requiresAdditionalDocument"] = this.requiresAdditionalDocument;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["requiresCRM"] = this.requiresCRM;
        data["allowNewUserRegister"] = this.allowNewUserRegister;
        data["nextCategoryId"] = this.nextCategoryId;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryListDto {
    name: string | undefined;
    shortName: string | undefined;
    isActive: boolean;
    requiresDocument: boolean;
    requiresAdditionalDocument: boolean;
    isExempt: boolean;
    isResident: boolean;
    requiresCRM: boolean;
    allowNewUserRegister: boolean;
    nextCategoryId: number | undefined;
    levels: CategoryLevelDto[] | undefined;
    id: number;
}

export class CategoryDto implements ICategoryDto {
    name!: string | undefined;
    shortName!: string | undefined;
    isActive!: boolean;
    requiresDocument!: boolean;
    requiresAdditionalDocument!: boolean;
    isExempt!: boolean;
    isResident!: boolean;
    requiresCRM!: boolean;
    validateCRM!: boolean;
    validateCPF!: boolean;
    allowNewUserRegister!: boolean;
    nextCategoryId!: number | undefined;
    nextCategory!: CategoryListDto;
    levels!: CategoryLevelDto[] | undefined;
    id!: number;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
            this.requiresDocument = data["requiresDocument"];
            this.requiresAdditionalDocument = data["requiresAdditionalDocument"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.requiresCRM = data["requiresCRM"];
            this.validateCRM = data["validateCRM"];
            this.validateCPF = data["validateCPF"];
            this.allowNewUserRegister = data["allowNewUserRegister"];
            this.nextCategoryId = data["nextCategoryId"];
            this.nextCategory = data["nextCategory"] ? CategoryListDto.fromJS(data["nextCategory"]) : <any>undefined;
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item of data["levels"])
                    this.levels!.push(CategoryLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        data["requiresDocument"] = this.requiresDocument;
        data["requiresAdditionalDocument"] = this.requiresAdditionalDocument;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["requiresCRM"] = this.requiresCRM;
        data["validateCRM"] = this.validateCRM;
        data["validateCPF"] = this.validateCPF;
        data["allowNewUserRegister"] = this.allowNewUserRegister;
        data["nextCategoryId"] = this.nextCategoryId;
        data["nextCategory"] = this.nextCategory ? this.nextCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICategoryDto {
    name: string | undefined;
    shortName: string | undefined;
    isActive: boolean;
    requiresDocument: boolean;
    requiresAdditionalDocument: boolean;
    isExempt: boolean;
    isResident: boolean;
    requiresCRM: boolean;
    validateCRM: boolean;
    validateCPF: boolean;
    allowNewUserRegister: boolean;
    nextCategoryId: number | undefined;
    nextCategory: CategoryListDto;
    levels: CategoryLevelDto[] | undefined;
    id: number;
}

export class CreateOrEditMemberCategoryDto implements ICreateOrEditMemberCategoryDto {
    beginDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    note!: string | undefined;
    categoryId!: number;
    category!: CategoryDto;
    levelId!: number | undefined;
    level!: CategoryLevelDto;
    memberId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMemberCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.note = data["note"];
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryDto.fromJS(data["category"]) : <any>undefined;
            this.levelId = data["levelId"];
            this.level = data["level"] ? CategoryLevelDto.fromJS(data["level"]) : <any>undefined;
            this.memberId = data["memberId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMemberCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMemberCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["levelId"] = this.levelId;
        data["level"] = this.level ? this.level.toJSON() : <any>undefined;
        data["memberId"] = this.memberId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditMemberCategoryDto {
    beginDate: moment.Moment;
    endDate: moment.Moment | undefined;
    note: string | undefined;
    categoryId: number;
    category: CategoryDto;
    levelId: number | undefined;
    level: CategoryLevelDto;
    memberId: number;
    id: number | undefined;
}

export class CreateOrEditMemberDto implements ICreateOrEditMemberDto {
    cpf!: string | undefined;
    badgeName!: string | undefined;
    rg!: string | undefined;
    crm!: string | undefined;
    statusCrm!: StatusCrm;
    situationCrm!: SituationCrm;
    rgEmitter!: string | undefined;
    rgEmitterUf!: string | undefined;
    bornDate!: moment.Moment | undefined;
    deathYear!: number | undefined;
    graduationYear!: number | undefined;
    annuitySituation!: MemberAnnuitySituation;
    userId!: number;
    specialtyId!: number | undefined;
    categories!: CreateOrEditMemberCategoryDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.badgeName = data["badgeName"];
            this.rg = data["rg"];
            this.crm = data["crm"];
            this.statusCrm = data["statusCrm"];
            this.situationCrm = data["situationCrm"];
            this.rgEmitter = data["rgEmitter"];
            this.rgEmitterUf = data["rgEmitterUf"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.deathYear = data["deathYear"];
            this.graduationYear = data["graduationYear"];
            this.annuitySituation = data["annuitySituation"];
            this.userId = data["userId"];
            this.specialtyId = data["specialtyId"];
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(CreateOrEditMemberCategoryDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["badgeName"] = this.badgeName;
        data["rg"] = this.rg;
        data["crm"] = this.crm;
        data["statusCrm"] = this.statusCrm;
        data["situationCrm"] = this.situationCrm;
        data["rgEmitter"] = this.rgEmitter;
        data["rgEmitterUf"] = this.rgEmitterUf;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["deathYear"] = this.deathYear;
        data["graduationYear"] = this.graduationYear;
        data["annuitySituation"] = this.annuitySituation;
        data["userId"] = this.userId;
        data["specialtyId"] = this.specialtyId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditMemberDto {
    cpf: string | undefined;
    badgeName: string | undefined;
    rg: string | undefined;
    crm: string | undefined;
    statusCrm: StatusCrm;
    situationCrm: SituationCrm;
    rgEmitter: string | undefined;
    rgEmitterUf: string | undefined;
    bornDate: moment.Moment | undefined;
    deathYear: number | undefined;
    graduationYear: number | undefined;
    annuitySituation: MemberAnnuitySituation;
    userId: number;
    specialtyId: number | undefined;
    categories: CreateOrEditMemberCategoryDto[] | undefined;
    id: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    password!: string | undefined;
    captchaResponse!: string | undefined;
    phone!: UserPhoneDto;
    address!: UserAddressDto;
    member!: CreateOrEditMemberDto;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
            this.phone = data["phone"] ? UserPhoneDto.fromJS(data["phone"]) : <any>undefined;
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
            this.member = data["member"] ? CreateOrEditMemberDto.fromJS(data["member"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IRegisterInput {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    password: string | undefined;
    captchaResponse: string | undefined;
    phone: UserPhoneDto;
    address: UserAddressDto;
    member: CreateOrEditMemberDto;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string | undefined;
    isHotsite!: boolean | undefined;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.isHotsite = data["isHotsite"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["isHotsite"] = this.isHotsite;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string | undefined;
    isHotsite: boolean | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data; 
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string | undefined;
    isHotsite!: boolean | undefined;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.isHotsite = data["isHotsite"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["isHotsite"] = this.isHotsite;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string | undefined;
    isHotsite: boolean | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
            this.c = data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export enum StatusCpf {
    Invalido = 0,
    Valido = 1,
    AguardandoValidacao = 2,
}

export enum SituationCpf {
    Regular = 0,
    Suspensa = 2,
    Falecido = 3,
    PendenteRegularizacao = 4,
    CanceladaMultiplicidade = 5,
    Nula = 8,
    CanceladaOficio = 9,
}

export class UserEmailDto implements IUserEmailDto {
    emailAddress!: string | undefined;
    id!: number | undefined;

    constructor(data?: IUserEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserEmailDto {
    emailAddress: string | undefined;
    id: number | undefined;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserSituationDto implements IUserSituationDto {
    description!: string | undefined;
    isActive!: boolean;
    generateAnnuity!: boolean;
    id!: number;

    constructor(data?: IUserSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.generateAnnuity = data["generateAnnuity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["generateAnnuity"] = this.generateAnnuity;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserSituationDto {
    description: string | undefined;
    isActive: boolean;
    generateAnnuity: boolean;
    id: number;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    statusCpf!: StatusCpf;
    situationCpf!: SituationCpf;
    confirmedName!: boolean | undefined;
    emails!: UserEmailDto[] | undefined;
    roles!: UserListRoleDto[] | undefined;
    phones!: UserPhoneDto[] | undefined;
    addresses!: UserAddressDto[] | undefined;
    userSituation!: UserSituationDto;
    isActive!: boolean;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.statusCpf = data["statusCpf"];
            this.situationCpf = data["situationCpf"];
            this.confirmedName = data["confirmedName"];
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(UserEmailDto.fromJS(item));
            }
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(UserPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(UserAddressDto.fromJS(item));
            }
            this.userSituation = data["userSituation"] ? UserSituationDto.fromJS(data["userSituation"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["statusCpf"] = this.statusCpf;
        data["situationCpf"] = this.situationCpf;
        data["confirmedName"] = this.confirmedName;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["userSituation"] = this.userSituation ? this.userSituation.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    statusCpf: StatusCpf;
    situationCpf: SituationCpf;
    confirmedName: boolean | undefined;
    emails: UserEmailDto[] | undefined;
    roles: UserListRoleDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    userSituation: UserSituationDto;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class ThematicAreaListDto implements IThematicAreaListDto {
    isActive!: boolean;
    description!: string | undefined;
    id!: number;

    constructor(data?: IThematicAreaListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThematicAreaListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThematicAreaListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IThematicAreaListDto {
    isActive: boolean;
    description: string | undefined;
    id: number;
}

export class CoverageAreaDto implements ICoverageAreaDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    color!: string | undefined;
    isActive!: boolean;
    thematicAreas!: ThematicAreaListDto[] | undefined;
    id!: number;

    constructor(data?: ICoverageAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            this.isActive = data["isActive"];
            if (Array.isArray(data["thematicAreas"])) {
                this.thematicAreas = [] as any;
                for (let item of data["thematicAreas"])
                    this.thematicAreas!.push(ThematicAreaListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CoverageAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoverageAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.thematicAreas)) {
            data["thematicAreas"] = [];
            for (let item of this.thematicAreas)
                data["thematicAreas"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICoverageAreaDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    isActive: boolean;
    thematicAreas: ThematicAreaListDto[] | undefined;
    id: number;
}

export class ThematicAreaDto implements IThematicAreaDto {
    isActive!: boolean;
    description!: string | undefined;
    eventScheduleId!: number;
    responsibleId!: number;
    responsible!: UserListDto;
    coverageAreaId!: number;
    coverageArea!: CoverageAreaDto;
    activitiesDto!: ActivityDto[] | undefined;
    id!: number;

    constructor(data?: IThematicAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.eventScheduleId = data["eventScheduleId"];
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? UserListDto.fromJS(data["responsible"]) : <any>undefined;
            this.coverageAreaId = data["coverageAreaId"];
            this.coverageArea = data["coverageArea"] ? CoverageAreaDto.fromJS(data["coverageArea"]) : <any>undefined;
            if (Array.isArray(data["activitiesDto"])) {
                this.activitiesDto = [] as any;
                for (let item of data["activitiesDto"])
                    this.activitiesDto!.push(ActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ThematicAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThematicAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["eventScheduleId"] = this.eventScheduleId;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["coverageAreaId"] = this.coverageAreaId;
        data["coverageArea"] = this.coverageArea ? this.coverageArea.toJSON() : <any>undefined;
        if (Array.isArray(this.activitiesDto)) {
            data["activitiesDto"] = [];
            for (let item of this.activitiesDto)
                data["activitiesDto"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IThematicAreaDto {
    isActive: boolean;
    description: string | undefined;
    eventScheduleId: number;
    responsibleId: number;
    responsible: UserListDto;
    coverageAreaId: number;
    coverageArea: CoverageAreaDto;
    activitiesDto: ActivityDto[] | undefined;
    id: number;
}

export class ActivityTypeListDto implements IActivityTypeListDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    color!: string | undefined;
    id!: number;

    constructor(data?: IActivityTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTypeListDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    id: number;
}

export class EventScheduleRoomListDto implements IEventScheduleRoomListDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    numberOfVacancies!: number | undefined;
    id!: number;

    constructor(data?: IEventScheduleRoomListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.numberOfVacancies = data["numberOfVacancies"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleRoomListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleRoomListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["numberOfVacancies"] = this.numberOfVacancies;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleRoomListDto {
    description: string | undefined;
    shortDescription: string | undefined;
    numberOfVacancies: number | undefined;
    id: number;
}

export class EventScheduleDayListDto implements IEventScheduleDayListDto {
    day!: moment.Moment;
    color!: string | undefined;
    beginHour!: string;
    endHour!: string;
    verifyAtivityConflicts!: boolean;
    eventScheduleDayId!: number;
    id!: number;

    constructor(data?: IEventScheduleDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? moment(data["day"].toString()) : <any>undefined;
            this.color = data["color"];
            this.beginHour = data["beginHour"];
            this.endHour = data["endHour"];
            this.verifyAtivityConflicts = data["verifyAtivityConflicts"];
            this.eventScheduleDayId = data["eventScheduleDayId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleDayListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["beginHour"] = this.beginHour;
        data["endHour"] = this.endHour;
        data["verifyAtivityConflicts"] = this.verifyAtivityConflicts;
        data["eventScheduleDayId"] = this.eventScheduleDayId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleDayListDto {
    day: moment.Moment;
    color: string | undefined;
    beginHour: string;
    endHour: string;
    verifyAtivityConflicts: boolean;
    eventScheduleDayId: number;
    id: number;
}

export class EventScheduleRoomDayListDto implements IEventScheduleRoomDayListDto {
    isDeleted!: boolean;
    eventScheduleRoomId!: number;
    eventScheduleRoom!: EventScheduleRoomListDto;
    eventScheduleDayId!: number | undefined;
    eventScheduleDay!: EventScheduleDayListDto;
    calendarId!: number | undefined;
    id!: number;

    constructor(data?: IEventScheduleRoomDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.eventScheduleRoomId = data["eventScheduleRoomId"];
            this.eventScheduleRoom = data["eventScheduleRoom"] ? EventScheduleRoomListDto.fromJS(data["eventScheduleRoom"]) : <any>undefined;
            this.eventScheduleDayId = data["eventScheduleDayId"];
            this.eventScheduleDay = data["eventScheduleDay"] ? EventScheduleDayListDto.fromJS(data["eventScheduleDay"]) : <any>undefined;
            this.calendarId = data["calendarId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleRoomDayListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleRoomDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["eventScheduleRoomId"] = this.eventScheduleRoomId;
        data["eventScheduleRoom"] = this.eventScheduleRoom ? this.eventScheduleRoom.toJSON() : <any>undefined;
        data["eventScheduleDayId"] = this.eventScheduleDayId;
        data["eventScheduleDay"] = this.eventScheduleDay ? this.eventScheduleDay.toJSON() : <any>undefined;
        data["calendarId"] = this.calendarId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleRoomDayListDto {
    isDeleted: boolean;
    eventScheduleRoomId: number;
    eventScheduleRoom: EventScheduleRoomListDto;
    eventScheduleDayId: number | undefined;
    eventScheduleDay: EventScheduleDayListDto;
    calendarId: number | undefined;
    id: number;
}

export enum TopicType {
    MainTopic = 0,
    SubTopic = 1,
    Lunch = 2,
    CoffeeBreak = 3,
    Interval = 4,
}

export class AdDto implements IAdDto {
    displayTime!: string | undefined;
    gotoLink!: string | undefined;
    videoUrl!: string | undefined;
    skipTimer!: number;
    videoId!: number;

    constructor(data?: IAdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayTime = data["displayTime"];
            this.gotoLink = data["gotoLink"];
            this.videoUrl = data["videoUrl"];
            this.skipTimer = data["skipTimer"];
            this.videoId = data["videoId"];
        }
    }

    static fromJS(data: any): AdDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayTime"] = this.displayTime;
        data["gotoLink"] = this.gotoLink;
        data["videoUrl"] = this.videoUrl;
        data["skipTimer"] = this.skipTimer;
        data["videoId"] = this.videoId;
        return data; 
    }
}

export interface IAdDto {
    displayTime: string | undefined;
    gotoLink: string | undefined;
    videoUrl: string | undefined;
    skipTimer: number;
    videoId: number;
}

export class VideoDto implements IVideoDto {
    url!: string | undefined;
    description!: string | undefined;
    gotoLink!: string | undefined;
    topicId!: number;
    ads!: AdDto[] | undefined;

    constructor(data?: IVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.url = data["url"];
            this.description = data["description"];
            this.gotoLink = data["gotoLink"];
            this.topicId = data["topicId"];
            if (Array.isArray(data["ads"])) {
                this.ads = [] as any;
                for (let item of data["ads"])
                    this.ads!.push(AdDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["description"] = this.description;
        data["gotoLink"] = this.gotoLink;
        data["topicId"] = this.topicId;
        if (Array.isArray(this.ads)) {
            data["ads"] = [];
            for (let item of this.ads)
                data["ads"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVideoDto {
    url: string | undefined;
    description: string | undefined;
    gotoLink: string | undefined;
    topicId: number;
    ads: AdDto[] | undefined;
}

export class UpdateProfilePictureDto implements IUpdateProfilePictureDto {
    guestId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateProfilePictureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureDto {
    guestId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GuestAddressDto implements IGuestAddressDto {
    guestId!: number;
    logradour!: string | undefined;
    number!: string | undefined;
    complement!: string | undefined;
    district!: string | undefined;
    zipCode!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    stateName!: string | undefined;
    countryName!: string | undefined;
    isMailing!: boolean;
    type!: AddressType;
    id!: number | undefined;

    constructor(data?: IGuestAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestAddressDto {
    guestId: number;
    logradour: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    district: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    stateName: string | undefined;
    countryName: string | undefined;
    isMailing: boolean;
    type: AddressType;
    id: number | undefined;
}

export class GuestPhoneDto implements IGuestPhoneDto {
    guestId!: number;
    ddi!: string | undefined;
    ddd!: string | undefined;
    number!: string | undefined;
    type!: PhoneType;
    id!: number | undefined;

    constructor(data?: IGuestPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestPhoneDto {
    guestId: number;
    ddi: string | undefined;
    ddd: string | undefined;
    number: string | undefined;
    type: PhoneType;
    id: number | undefined;
}

export class GuestEmailDto implements IGuestEmailDto {
    guestId!: number;
    emailAddress!: string | undefined;
    id!: number | undefined;

    constructor(data?: IGuestEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestEmailDto {
    guestId: number;
    emailAddress: string | undefined;
    id: number | undefined;
}

export class CreateOrEditGuestDto implements ICreateOrEditGuestDto {
    name!: string | undefined;
    nameForCredential!: string | undefined;
    profilePictureInput!: UpdateProfilePictureDto;
    profilePicturePath!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    crm!: string | undefined;
    rg!: string | undefined;
    rgEmitter!: string | undefined;
    rgEmitterUf!: string | undefined;
    lattes!: string | undefined;
    eventScheduleId!: number;
    userId!: number | undefined;
    user!: UserListDto;
    addresses!: GuestAddressDto[] | undefined;
    phones!: GuestPhoneDto[] | undefined;
    emails!: GuestEmailDto[] | undefined;
    numberOfParticipations!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.profilePictureInput = data["profilePictureInput"] ? UpdateProfilePictureDto.fromJS(data["profilePictureInput"]) : <any>undefined;
            this.profilePicturePath = data["profilePicturePath"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.crm = data["crm"];
            this.rg = data["rg"];
            this.rgEmitter = data["rgEmitter"];
            this.rgEmitterUf = data["rgEmitterUf"];
            this.lattes = data["lattes"];
            this.eventScheduleId = data["eventScheduleId"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(GuestAddressDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(GuestPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(GuestEmailDto.fromJS(item));
            }
            this.numberOfParticipations = data["numberOfParticipations"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["profilePictureInput"] = this.profilePictureInput ? this.profilePictureInput.toJSON() : <any>undefined;
        data["profilePicturePath"] = this.profilePicturePath;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["crm"] = this.crm;
        data["rg"] = this.rg;
        data["rgEmitter"] = this.rgEmitter;
        data["rgEmitterUf"] = this.rgEmitterUf;
        data["lattes"] = this.lattes;
        data["eventScheduleId"] = this.eventScheduleId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["numberOfParticipations"] = this.numberOfParticipations;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditGuestDto {
    name: string | undefined;
    nameForCredential: string | undefined;
    profilePictureInput: UpdateProfilePictureDto;
    profilePicturePath: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    rg: string | undefined;
    rgEmitter: string | undefined;
    rgEmitterUf: string | undefined;
    lattes: string | undefined;
    eventScheduleId: number;
    userId: number | undefined;
    user: UserListDto;
    addresses: GuestAddressDto[] | undefined;
    phones: GuestPhoneDto[] | undefined;
    emails: GuestEmailDto[] | undefined;
    numberOfParticipations: number;
    id: number | undefined;
}

export class CreateOrEditGuestRoleDto implements ICreateOrEditGuestRoleDto {
    description!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateOrEditGuestRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateOrEditGuestRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditGuestRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateOrEditGuestRoleDto {
    description: string | undefined;
    isActive: boolean;
}

export class CreateOrEditParticipationDto implements ICreateOrEditParticipationDto {
    guestId!: number;
    guest!: CreateOrEditGuestDto;
    roleId!: number;
    role!: CreateOrEditGuestRoleDto;
    topicId!: number;
    hasConflict!: boolean;
    conflictActivityId!: number;

    constructor(data?: ICreateOrEditParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? CreateOrEditGuestDto.fromJS(data["guest"]) : <any>undefined;
            this.roleId = data["roleId"];
            this.role = data["role"] ? CreateOrEditGuestRoleDto.fromJS(data["role"]) : <any>undefined;
            this.topicId = data["topicId"];
            this.hasConflict = data["hasConflict"];
            this.conflictActivityId = data["conflictActivityId"];
        }
    }

    static fromJS(data: any): CreateOrEditParticipationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["topicId"] = this.topicId;
        data["hasConflict"] = this.hasConflict;
        data["conflictActivityId"] = this.conflictActivityId;
        return data; 
    }
}

export interface ICreateOrEditParticipationDto {
    guestId: number;
    guest: CreateOrEditGuestDto;
    roleId: number;
    role: CreateOrEditGuestRoleDto;
    topicId: number;
    hasConflict: boolean;
    conflictActivityId: number;
}

export class TopicDto implements ITopicDto {
    tenantId!: number | undefined;
    duration!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    description!: string | undefined;
    number!: number;
    order!: number;
    note!: string | undefined;
    activityId!: number;
    type!: TopicType;
    video!: VideoDto;
    participations!: CreateOrEditParticipationDto[] | undefined;
    id!: number;

    constructor(data?: ITopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.duration = data["duration"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.description = data["description"];
            this.number = data["number"];
            this.order = data["order"];
            this.note = data["note"];
            this.activityId = data["activityId"];
            this.type = data["type"];
            this.video = data["video"] ? VideoDto.fromJS(data["video"]) : <any>undefined;
            if (Array.isArray(data["participations"])) {
                this.participations = [] as any;
                for (let item of data["participations"])
                    this.participations!.push(CreateOrEditParticipationDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["duration"] = this.duration;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["description"] = this.description;
        data["number"] = this.number;
        data["order"] = this.order;
        data["note"] = this.note;
        data["activityId"] = this.activityId;
        data["type"] = this.type;
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        if (Array.isArray(this.participations)) {
            data["participations"] = [];
            for (let item of this.participations)
                data["participations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITopicDto {
    tenantId: number | undefined;
    duration: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    description: string | undefined;
    number: number;
    order: number;
    note: string | undefined;
    activityId: number;
    type: TopicType;
    video: VideoDto;
    participations: CreateOrEditParticipationDto[] | undefined;
    id: number;
}

export class ActivityDto implements IActivityDto {
    description!: string | undefined;
    duration!: string | undefined;
    order!: number | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    finished!: boolean;
    published!: boolean;
    onTheCalendar!: boolean;
    notes!: string | undefined;
    thematicAreaId!: number | undefined;
    thematicArea!: ThematicAreaDto;
    activityTypeId!: number | undefined;
    activityType!: ActivityTypeListDto;
    roomDayId!: number | undefined;
    roomDay!: EventScheduleRoomDayListDto;
    topics!: TopicDto[] | undefined;
    id!: number;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.duration = data["duration"];
            this.order = data["order"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.finished = data["finished"];
            this.published = data["published"];
            this.onTheCalendar = data["onTheCalendar"];
            this.notes = data["notes"];
            this.thematicAreaId = data["thematicAreaId"];
            this.thematicArea = data["thematicArea"] ? ThematicAreaDto.fromJS(data["thematicArea"]) : <any>undefined;
            this.activityTypeId = data["activityTypeId"];
            this.activityType = data["activityType"] ? ActivityTypeListDto.fromJS(data["activityType"]) : <any>undefined;
            this.roomDayId = data["roomDayId"];
            this.roomDay = data["roomDay"] ? EventScheduleRoomDayListDto.fromJS(data["roomDay"]) : <any>undefined;
            if (Array.isArray(data["topics"])) {
                this.topics = [] as any;
                for (let item of data["topics"])
                    this.topics!.push(TopicDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["order"] = this.order;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["finished"] = this.finished;
        data["published"] = this.published;
        data["onTheCalendar"] = this.onTheCalendar;
        data["notes"] = this.notes;
        data["thematicAreaId"] = this.thematicAreaId;
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        data["activityTypeId"] = this.activityTypeId;
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        data["roomDayId"] = this.roomDayId;
        data["roomDay"] = this.roomDay ? this.roomDay.toJSON() : <any>undefined;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityDto {
    description: string | undefined;
    duration: string | undefined;
    order: number | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    finished: boolean;
    published: boolean;
    onTheCalendar: boolean;
    notes: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaDto;
    activityTypeId: number | undefined;
    activityType: ActivityTypeListDto;
    roomDayId: number | undefined;
    roomDay: EventScheduleRoomDayListDto;
    topics: TopicDto[] | undefined;
    id: number;
}

export class GuestDto implements IGuestDto {
    name!: string | undefined;
    nameForCredential!: string | undefined;
    profilePicturePath!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    crm!: string | undefined;
    rg!: string | undefined;
    rgEmitter!: string | undefined;
    rgEmitterUf!: string | undefined;
    lattes!: string | undefined;
    eventScheduleId!: number;
    userId!: number | undefined;
    userIsDeleted!: boolean;
    scheduleSubmitted!: boolean;
    hasSchedule!: boolean;
    participationsNumber!: number;
    addresses!: GuestAddressDto[] | undefined;
    phones!: GuestPhoneDto[] | undefined;
    emails!: GuestEmailDto[] | undefined;
    id!: number;

    constructor(data?: IGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.nameForCredential = data["nameForCredential"];
            this.profilePicturePath = data["profilePicturePath"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.crm = data["crm"];
            this.rg = data["rg"];
            this.rgEmitter = data["rgEmitter"];
            this.rgEmitterUf = data["rgEmitterUf"];
            this.lattes = data["lattes"];
            this.eventScheduleId = data["eventScheduleId"];
            this.userId = data["userId"];
            this.userIsDeleted = data["userIsDeleted"];
            this.scheduleSubmitted = data["scheduleSubmitted"];
            this.hasSchedule = data["hasSchedule"];
            this.participationsNumber = data["participationsNumber"];
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(GuestAddressDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(GuestPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(GuestEmailDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameForCredential"] = this.nameForCredential;
        data["profilePicturePath"] = this.profilePicturePath;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["crm"] = this.crm;
        data["rg"] = this.rg;
        data["rgEmitter"] = this.rgEmitter;
        data["rgEmitterUf"] = this.rgEmitterUf;
        data["lattes"] = this.lattes;
        data["eventScheduleId"] = this.eventScheduleId;
        data["userId"] = this.userId;
        data["userIsDeleted"] = this.userIsDeleted;
        data["scheduleSubmitted"] = this.scheduleSubmitted;
        data["hasSchedule"] = this.hasSchedule;
        data["participationsNumber"] = this.participationsNumber;
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestDto {
    name: string | undefined;
    nameForCredential: string | undefined;
    profilePicturePath: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    crm: string | undefined;
    rg: string | undefined;
    rgEmitter: string | undefined;
    rgEmitterUf: string | undefined;
    lattes: string | undefined;
    eventScheduleId: number;
    userId: number | undefined;
    userIsDeleted: boolean;
    scheduleSubmitted: boolean;
    hasSchedule: boolean;
    participationsNumber: number;
    addresses: GuestAddressDto[] | undefined;
    phones: GuestPhoneDto[] | undefined;
    emails: GuestEmailDto[] | undefined;
    id: number;
}

export class GuestRoleDto implements IGuestRoleDto {
    description!: string | undefined;
    isActive!: boolean;

    constructor(data?: IGuestRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): GuestRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IGuestRoleDto {
    description: string | undefined;
    isActive: boolean;
}

export class ParticipationDto implements IParticipationDto {
    guestId!: number;
    guest!: GuestDto;
    roleId!: number;
    role!: GuestRoleDto;
    topicId!: number;
    topic!: TopicDto;
    id!: number;

    constructor(data?: IParticipationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guestId = data["guestId"];
            this.guest = data["guest"] ? GuestDto.fromJS(data["guest"]) : <any>undefined;
            this.roleId = data["roleId"];
            this.role = data["role"] ? GuestRoleDto.fromJS(data["role"]) : <any>undefined;
            this.topicId = data["topicId"];
            this.topic = data["topic"] ? TopicDto.fromJS(data["topic"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ParticipationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["topicId"] = this.topicId;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IParticipationDto {
    guestId: number;
    guest: GuestDto;
    roleId: number;
    role: GuestRoleDto;
    topicId: number;
    topic: TopicDto;
    id: number;
}

export class BlockConfictDto implements IBlockConfictDto {
    calendarActivity!: ActivityDto;
    room!: EventScheduleRoomListDto;
    participation!: ParticipationDto;

    constructor(data?: IBlockConfictDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendarActivity = data["calendarActivity"] ? ActivityDto.fromJS(data["calendarActivity"]) : <any>undefined;
            this.room = data["room"] ? EventScheduleRoomListDto.fromJS(data["room"]) : <any>undefined;
            this.participation = data["participation"] ? ParticipationDto.fromJS(data["participation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BlockConfictDto {
        data = typeof data === 'object' ? data : {};
        let result = new BlockConfictDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarActivity"] = this.calendarActivity ? this.calendarActivity.toJSON() : <any>undefined;
        data["room"] = this.room ? this.room.toJSON() : <any>undefined;
        data["participation"] = this.participation ? this.participation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBlockConfictDto {
    calendarActivity: ActivityDto;
    room: EventScheduleRoomListDto;
    participation: ParticipationDto;
}

export class GetActivityForViewDto implements IGetActivityForViewDto {
    activity!: ActivityDto;
    thematicAreaDescription!: string | undefined;
    activityTypeDescription!: string | undefined;
    hasConflicts!: boolean;
    conflicts!: BlockConfictDto[] | undefined;
    topics!: TopicDto[] | undefined;

    constructor(data?: IGetActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activity = data["activity"] ? ActivityDto.fromJS(data["activity"]) : <any>undefined;
            this.thematicAreaDescription = data["thematicAreaDescription"];
            this.activityTypeDescription = data["activityTypeDescription"];
            this.hasConflicts = data["hasConflicts"];
            if (Array.isArray(data["conflicts"])) {
                this.conflicts = [] as any;
                for (let item of data["conflicts"])
                    this.conflicts!.push(BlockConfictDto.fromJS(item));
            }
            if (Array.isArray(data["topics"])) {
                this.topics = [] as any;
                for (let item of data["topics"])
                    this.topics!.push(TopicDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["thematicAreaDescription"] = this.thematicAreaDescription;
        data["activityTypeDescription"] = this.activityTypeDescription;
        data["hasConflicts"] = this.hasConflicts;
        if (Array.isArray(this.conflicts)) {
            data["conflicts"] = [];
            for (let item of this.conflicts)
                data["conflicts"].push(item.toJSON());
        }
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetActivityForViewDto {
    activity: ActivityDto;
    thematicAreaDescription: string | undefined;
    activityTypeDescription: string | undefined;
    hasConflicts: boolean;
    conflicts: BlockConfictDto[] | undefined;
    topics: TopicDto[] | undefined;
}

export class PagedResultDtoOfGetActivityForViewDto implements IPagedResultDtoOfGetActivityForViewDto {
    totalCount!: number;
    items!: GetActivityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActivityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetActivityForViewDto {
    totalCount: number;
    items: GetActivityForViewDto[] | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string | undefined;
    fileType!: string | undefined;
    fileToken!: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileDto {
    fileName: string | undefined;
    fileType: string | undefined;
    fileToken: string | undefined;
}

export class ListResultDtoOfActivityDto implements IListResultDtoOfActivityDto {
    items!: ActivityDto[] | undefined;

    constructor(data?: IListResultDtoOfActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityDto {
    items: ActivityDto[] | undefined;
}

export class ActivityThematicAreaLookupTableDto implements IActivityThematicAreaLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IActivityThematicAreaLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ActivityThematicAreaLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityThematicAreaLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IActivityThematicAreaLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ActivityActivityTypeLookupTableDto implements IActivityActivityTypeLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IActivityActivityTypeLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ActivityActivityTypeLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityActivityTypeLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IActivityActivityTypeLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ActivityTypeDto implements IActivityTypeDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    color!: string | undefined;
    activities!: ActivityDto[] | undefined;
    id!: number;

    constructor(data?: IActivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item of data["activities"])
                    this.activities!.push(ActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    activities: ActivityDto[] | undefined;
    id: number;
}

export class CreateOrEditActivityDto implements ICreateOrEditActivityDto {
    description!: string | undefined;
    duration!: string | undefined;
    order!: number | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;
    finished!: boolean;
    published!: boolean;
    onTheCalendar!: boolean;
    notes!: string | undefined;
    thematicAreaId!: number | undefined;
    thematicArea!: ThematicAreaDto;
    activityTypeId!: number | undefined;
    activityType!: ActivityTypeDto;
    roomDayId!: number | undefined;
    topics!: TopicDto[] | undefined;
    roomDay!: EventScheduleRoomDayListDto;
    hasConflict!: boolean;
    eventScheduleId!: number;
    isActivity!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.duration = data["duration"];
            this.order = data["order"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.finished = data["finished"];
            this.published = data["published"];
            this.onTheCalendar = data["onTheCalendar"];
            this.notes = data["notes"];
            this.thematicAreaId = data["thematicAreaId"];
            this.thematicArea = data["thematicArea"] ? ThematicAreaDto.fromJS(data["thematicArea"]) : <any>undefined;
            this.activityTypeId = data["activityTypeId"];
            this.activityType = data["activityType"] ? ActivityTypeDto.fromJS(data["activityType"]) : <any>undefined;
            this.roomDayId = data["roomDayId"];
            if (Array.isArray(data["topics"])) {
                this.topics = [] as any;
                for (let item of data["topics"])
                    this.topics!.push(TopicDto.fromJS(item));
            }
            this.roomDay = data["roomDay"] ? EventScheduleRoomDayListDto.fromJS(data["roomDay"]) : <any>undefined;
            this.hasConflict = data["hasConflict"];
            this.eventScheduleId = data["eventScheduleId"];
            this.isActivity = data["isActivity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["order"] = this.order;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["finished"] = this.finished;
        data["published"] = this.published;
        data["onTheCalendar"] = this.onTheCalendar;
        data["notes"] = this.notes;
        data["thematicAreaId"] = this.thematicAreaId;
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        data["activityTypeId"] = this.activityTypeId;
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        data["roomDayId"] = this.roomDayId;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item.toJSON());
        }
        data["roomDay"] = this.roomDay ? this.roomDay.toJSON() : <any>undefined;
        data["hasConflict"] = this.hasConflict;
        data["eventScheduleId"] = this.eventScheduleId;
        data["isActivity"] = this.isActivity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditActivityDto {
    description: string | undefined;
    duration: string | undefined;
    order: number | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
    finished: boolean;
    published: boolean;
    onTheCalendar: boolean;
    notes: string | undefined;
    thematicAreaId: number | undefined;
    thematicArea: ThematicAreaDto;
    activityTypeId: number | undefined;
    activityType: ActivityTypeDto;
    roomDayId: number | undefined;
    topics: TopicDto[] | undefined;
    roomDay: EventScheduleRoomDayListDto;
    hasConflict: boolean;
    eventScheduleId: number;
    isActivity: boolean;
    id: number | undefined;
}

export class GetActivityForEditOutput implements IGetActivityForEditOutput {
    activity!: CreateOrEditActivityDto;
    thematicAreaDescription!: string | undefined;
    activityTypeDescription!: string | undefined;

    constructor(data?: IGetActivityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activity = data["activity"] ? CreateOrEditActivityDto.fromJS(data["activity"]) : <any>undefined;
            this.thematicAreaDescription = data["thematicAreaDescription"];
            this.activityTypeDescription = data["activityTypeDescription"];
        }
    }

    static fromJS(data: any): GetActivityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["thematicAreaDescription"] = this.thematicAreaDescription;
        data["activityTypeDescription"] = this.activityTypeDescription;
        return data; 
    }
}

export interface IGetActivityForEditOutput {
    activity: CreateOrEditActivityDto;
    thematicAreaDescription: string | undefined;
    activityTypeDescription: string | undefined;
}

export class PublishActivityDto implements IPublishActivityDto {
    activityId!: number;
    publish!: boolean;

    constructor(data?: IPublishActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityId = data["activityId"];
            this.publish = data["publish"];
        }
    }

    static fromJS(data: any): PublishActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublishActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["publish"] = this.publish;
        return data; 
    }
}

export interface IPublishActivityDto {
    activityId: number;
    publish: boolean;
}

export class ActivityTemplateDto implements IActivityTemplateDto {
    description!: string | undefined;
    templateJson!: string | undefined;
    activityTypes!: ActivityTypeListDto[] | undefined;
    id!: number;

    constructor(data?: IActivityTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.templateJson = data["templateJson"];
            if (Array.isArray(data["activityTypes"])) {
                this.activityTypes = [] as any;
                for (let item of data["activityTypes"])
                    this.activityTypes!.push(ActivityTypeListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["templateJson"] = this.templateJson;
        if (Array.isArray(this.activityTypes)) {
            data["activityTypes"] = [];
            for (let item of this.activityTypes)
                data["activityTypes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTemplateDto {
    description: string | undefined;
    templateJson: string | undefined;
    activityTypes: ActivityTypeListDto[] | undefined;
    id: number;
}

export class GetActivityTemplateForViewDto implements IGetActivityTemplateForViewDto {
    activityTemplate!: ActivityTemplateDto;

    constructor(data?: IGetActivityTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityTemplate = data["activityTemplate"] ? ActivityTemplateDto.fromJS(data["activityTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTemplate"] = this.activityTemplate ? this.activityTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTemplateForViewDto {
    activityTemplate: ActivityTemplateDto;
}

export class PagedResultDtoOfGetActivityTemplateForViewDto implements IPagedResultDtoOfGetActivityTemplateForViewDto {
    totalCount!: number;
    items!: GetActivityTemplateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivityTemplateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetActivityTemplateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivityTemplateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActivityTemplateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetActivityTemplateForViewDto {
    totalCount: number;
    items: GetActivityTemplateForViewDto[] | undefined;
}

export class ListResultDtoOfActivityTemplateDto implements IListResultDtoOfActivityTemplateDto {
    items!: ActivityTemplateDto[] | undefined;

    constructor(data?: IListResultDtoOfActivityTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ActivityTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfActivityTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityTemplateDto {
    items: ActivityTemplateDto[] | undefined;
}

export class CreateOrEditActivityTemplateDto implements ICreateOrEditActivityTemplateDto {
    description!: string | undefined;
    templateJson!: string | undefined;
    activityTypes!: ActivityTypeListDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActivityTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.templateJson = data["templateJson"];
            if (Array.isArray(data["activityTypes"])) {
                this.activityTypes = [] as any;
                for (let item of data["activityTypes"])
                    this.activityTypes!.push(ActivityTypeListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivityTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActivityTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["templateJson"] = this.templateJson;
        if (Array.isArray(this.activityTypes)) {
            data["activityTypes"] = [];
            for (let item of this.activityTypes)
                data["activityTypes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditActivityTemplateDto {
    description: string | undefined;
    templateJson: string | undefined;
    activityTypes: ActivityTypeListDto[] | undefined;
    id: number | undefined;
}

export class GetActivityTemplateForEditOutput implements IGetActivityTemplateForEditOutput {
    activityTemplate!: CreateOrEditActivityTemplateDto;

    constructor(data?: IGetActivityTemplateForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityTemplate = data["activityTemplate"] ? CreateOrEditActivityTemplateDto.fromJS(data["activityTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTemplateForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityTemplateForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityTemplate"] = this.activityTemplate ? this.activityTemplate.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTemplateForEditOutput {
    activityTemplate: CreateOrEditActivityTemplateDto;
}

export class GetActivityTypeForViewDto implements IGetActivityTypeForViewDto {
    activityType!: ActivityTypeDto;

    constructor(data?: IGetActivityTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityType = data["activityType"] ? ActivityTypeDto.fromJS(data["activityType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTypeForViewDto {
    activityType: ActivityTypeDto;
}

export class PagedResultDtoOfGetActivityTypeForViewDto implements IPagedResultDtoOfGetActivityTypeForViewDto {
    totalCount!: number;
    items!: GetActivityTypeForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetActivityTypeForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetActivityTypeForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetActivityTypeForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetActivityTypeForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetActivityTypeForViewDto {
    totalCount: number;
    items: GetActivityTypeForViewDto[] | undefined;
}

export class CreateOrEditActivityTypeDto implements ICreateOrEditActivityTypeDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    color!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditActivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditActivityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditActivityTypeDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    id: number | undefined;
}

export class GetActivityTypeForEditOutput implements IGetActivityTypeForEditOutput {
    activityType!: CreateOrEditActivityTypeDto;

    constructor(data?: IGetActivityTypeForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityType = data["activityType"] ? CreateOrEditActivityTypeDto.fromJS(data["activityType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetActivityTypeForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetActivityTypeForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityType"] = this.activityType ? this.activityType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetActivityTypeForEditOutput {
    activityType: CreateOrEditActivityTypeDto;
}

export class ListResultDtoOfActivityTypeDto implements IListResultDtoOfActivityTypeDto {
    items!: ActivityTypeDto[] | undefined;

    constructor(data?: IListResultDtoOfActivityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ActivityTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfActivityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityTypeDto {
    items: ActivityTypeDto[] | undefined;
}

export enum PaymentStatus {
    WaitingPayment = 1,
    UnderAnalysis = 2,
    Paid = 3,
    Available = 4,
    Indispute = 5,
    Returned = 6,
    Canceled = 7,
    Undefined = 8,
}

export enum AnnuitySituation {
    WaitingPayment = 0,
    Paid = 1,
    Canceled = 2,
}

export class AnnuitySettingDto implements IAnnuitySettingDto {
    year!: number;
    validate!: moment.Moment;
    yearsReadmission!: number | undefined;
    receivableByCoupon!: boolean;
    id!: number;

    constructor(data?: IAnnuitySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.validate = data["validate"] ? moment(data["validate"].toString()) : <any>undefined;
            this.yearsReadmission = data["yearsReadmission"];
            this.receivableByCoupon = data["receivableByCoupon"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuitySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnuitySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["validate"] = this.validate ? this.validate.toISOString() : <any>undefined;
        data["yearsReadmission"] = this.yearsReadmission;
        data["receivableByCoupon"] = this.receivableByCoupon;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuitySettingDto {
    year: number;
    validate: moment.Moment;
    yearsReadmission: number | undefined;
    receivableByCoupon: boolean;
    id: number;
}

export class AnnuityRepasseDto implements IAnnuityRepasseDto {
    date!: moment.Moment;
    value!: number;
    id!: number;

    constructor(data?: IAnnuityRepasseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityRepasseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnuityRepasseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityRepasseDto {
    date: moment.Moment;
    value: number;
    id: number;
}

export enum PaymentType {
    PagSeguroPayment = 0,
    CashPayment = 1,
    CreditCardPayment = 2,
    TicketPayment = 3,
    OnlineDebitPayment = 4,
    CouponPayment = 5,
    PixPayment = 6,
}

export class PaymentAddressDto implements IPaymentAddressDto {
    logradour!: string | undefined;
    number!: string | undefined;
    complement!: string | undefined;
    district!: string | undefined;
    zipCode!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    stateName!: string | undefined;
    countryName!: string | undefined;
    isMailing!: boolean;
    type!: AddressType;
    id!: number | undefined;

    constructor(data?: IPaymentAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentAddressDto {
    logradour: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    district: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    stateName: string | undefined;
    countryName: string | undefined;
    isMailing: boolean;
    type: AddressType;
    id: number | undefined;
}

export class CouponUserDto implements ICouponUserDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    id!: number;

    constructor(data?: ICouponUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponUserDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    id: number;
}

export class CouponBatchListDto implements ICouponBatchListDto {
    code!: string | undefined;
    name!: string | undefined;
    id!: number;

    constructor(data?: ICouponBatchListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponBatchListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponBatchListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponBatchListDto {
    code: string | undefined;
    name: string | undefined;
    id: number;
}

export class CouponDto implements ICouponDto {
    code!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    discountAmount!: number | undefined;
    discountPercentage!: number | undefined;
    updatedManually!: boolean;
    couponUserId!: number | undefined;
    couponUser!: CouponUserDto;
    orderId!: number | undefined;
    couponBatchId!: number;
    batch!: CouponBatchListDto;
    id!: number;

    constructor(data?: ICouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.updatedManually = data["updatedManually"];
            this.couponUserId = data["couponUserId"];
            this.couponUser = data["couponUser"] ? CouponUserDto.fromJS(data["couponUser"]) : <any>undefined;
            this.orderId = data["orderId"];
            this.couponBatchId = data["couponBatchId"];
            this.batch = data["batch"] ? CouponBatchListDto.fromJS(data["batch"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["updatedManually"] = this.updatedManually;
        data["couponUserId"] = this.couponUserId;
        data["couponUser"] = this.couponUser ? this.couponUser.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["couponBatchId"] = this.couponBatchId;
        data["batch"] = this.batch ? this.batch.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponDto {
    code: string | undefined;
    expirationDate: moment.Moment | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    updatedManually: boolean;
    couponUserId: number | undefined;
    couponUser: CouponUserDto;
    orderId: number | undefined;
    couponBatchId: number;
    batch: CouponBatchListDto;
    id: number;
}

export class PaymentDto implements IPaymentDto {
    isActive!: boolean;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    status!: PaymentStatus;
    type!: PaymentType;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    coupon!: CouponDto;
    id!: number;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.status = data["status"];
            this.type = data["type"];
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["status"] = this.status;
        data["type"] = this.type;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentDto {
    isActive: boolean;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    status: PaymentStatus;
    type: PaymentType;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    coupon: CouponDto;
    id: number;
}

export class AnnuityDto implements IAnnuityDto {
    situation!: AnnuitySituation;
    memberId!: number;
    annuitySettingId!: number;
    annuitySetting!: AnnuitySettingDto;
    categoryId!: number | undefined;
    category!: CategoryDto;
    itsReadmission!: boolean;
    repasse!: AnnuityRepasseDto;
    payments!: PaymentDto[] | undefined;
    id!: number;

    constructor(data?: IAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.situation = data["situation"];
            this.memberId = data["memberId"];
            this.annuitySettingId = data["annuitySettingId"];
            this.annuitySetting = data["annuitySetting"] ? AnnuitySettingDto.fromJS(data["annuitySetting"]) : <any>undefined;
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryDto.fromJS(data["category"]) : <any>undefined;
            this.itsReadmission = data["itsReadmission"];
            this.repasse = data["repasse"] ? AnnuityRepasseDto.fromJS(data["repasse"]) : <any>undefined;
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["situation"] = this.situation;
        data["memberId"] = this.memberId;
        data["annuitySettingId"] = this.annuitySettingId;
        data["annuitySetting"] = this.annuitySetting ? this.annuitySetting.toJSON() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["itsReadmission"] = this.itsReadmission;
        data["repasse"] = this.repasse ? this.repasse.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityDto {
    situation: AnnuitySituation;
    memberId: number;
    annuitySettingId: number;
    annuitySetting: AnnuitySettingDto;
    categoryId: number | undefined;
    category: CategoryDto;
    itsReadmission: boolean;
    repasse: AnnuityRepasseDto;
    payments: PaymentDto[] | undefined;
    id: number;
}

export class InstallmentDto implements IInstallmentDto {
    quantity!: number;
    value!: number;
    interest!: number;
    total!: number;
    noInterestInstallmentQuantity!: number;
    id!: number | undefined;

    constructor(data?: IInstallmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quantity = data["quantity"];
            this.value = data["value"];
            this.interest = data["interest"];
            this.total = data["total"];
            this.noInterestInstallmentQuantity = data["noInterestInstallmentQuantity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): InstallmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["value"] = this.value;
        data["interest"] = this.interest;
        data["total"] = this.total;
        data["noInterestInstallmentQuantity"] = this.noInterestInstallmentQuantity;
        data["id"] = this.id;
        return data; 
    }
}

export interface IInstallmentDto {
    quantity: number;
    value: number;
    interest: number;
    total: number;
    noInterestInstallmentQuantity: number;
    id: number | undefined;
}

export class PaymentCompleteDto implements IPaymentCompleteDto {
    holderCpfCnpj!: string | undefined;
    holderPhone!: string | undefined;
    holderBornDate!: moment.Moment | undefined;
    cardBrand!: string | undefined;
    holderName!: string | undefined;
    cardNumber!: string | undefined;
    cardExpirationDate!: moment.Moment | undefined;
    installment!: InstallmentDto;
    bankName!: string | undefined;
    barcode!: string | undefined;
    dueDate!: moment.Moment | undefined;
    key!: string | undefined;
    pixCopiaECola!: string | undefined;
    coupon!: CouponDto;
    couponId!: number | undefined;
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: IPaymentCompleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.holderCpfCnpj = data["holderCpfCnpj"];
            this.holderPhone = data["holderPhone"];
            this.holderBornDate = data["holderBornDate"] ? moment(data["holderBornDate"].toString()) : <any>undefined;
            this.cardBrand = data["cardBrand"];
            this.holderName = data["holderName"];
            this.cardNumber = data["cardNumber"];
            this.cardExpirationDate = data["cardExpirationDate"] ? moment(data["cardExpirationDate"].toString()) : <any>undefined;
            this.installment = data["installment"] ? InstallmentDto.fromJS(data["installment"]) : <any>undefined;
            this.bankName = data["bankName"];
            this.barcode = data["barcode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.key = data["key"];
            this.pixCopiaECola = data["pixCopiaECola"];
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
            this.couponId = data["couponId"];
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentCompleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentCompleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["holderCpfCnpj"] = this.holderCpfCnpj;
        data["holderPhone"] = this.holderPhone;
        data["holderBornDate"] = this.holderBornDate ? this.holderBornDate.toISOString() : <any>undefined;
        data["cardBrand"] = this.cardBrand;
        data["holderName"] = this.holderName;
        data["cardNumber"] = this.cardNumber;
        data["cardExpirationDate"] = this.cardExpirationDate ? this.cardExpirationDate.toISOString() : <any>undefined;
        data["installment"] = this.installment ? this.installment.toJSON() : <any>undefined;
        data["bankName"] = this.bankName;
        data["barcode"] = this.barcode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["key"] = this.key;
        data["pixCopiaECola"] = this.pixCopiaECola;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["couponId"] = this.couponId;
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentCompleteDto {
    holderCpfCnpj: string | undefined;
    holderPhone: string | undefined;
    holderBornDate: moment.Moment | undefined;
    cardBrand: string | undefined;
    holderName: string | undefined;
    cardNumber: string | undefined;
    cardExpirationDate: moment.Moment | undefined;
    installment: InstallmentDto;
    bankName: string | undefined;
    barcode: string | undefined;
    dueDate: moment.Moment | undefined;
    key: string | undefined;
    pixCopiaECola: string | undefined;
    coupon: CouponDto;
    couponId: number | undefined;
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class AnnuitySettingCategoryDeadlineDto implements IAnnuitySettingCategoryDeadlineDto {
    value!: number;
    deadline!: moment.Moment;
    readmissionValue!: number | undefined;
    maxInstallments!: number;
    maxInstallmentsWithoutCardFee!: number;
    annuitySettingCategoryId!: number;
    id!: number;

    constructor(data?: IAnnuitySettingCategoryDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : <any>undefined;
            this.readmissionValue = data["readmissionValue"];
            this.maxInstallments = data["maxInstallments"];
            this.maxInstallmentsWithoutCardFee = data["maxInstallmentsWithoutCardFee"];
            this.annuitySettingCategoryId = data["annuitySettingCategoryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuitySettingCategoryDeadlineDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnuitySettingCategoryDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["readmissionValue"] = this.readmissionValue;
        data["maxInstallments"] = this.maxInstallments;
        data["maxInstallmentsWithoutCardFee"] = this.maxInstallmentsWithoutCardFee;
        data["annuitySettingCategoryId"] = this.annuitySettingCategoryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuitySettingCategoryDeadlineDto {
    value: number;
    deadline: moment.Moment;
    readmissionValue: number | undefined;
    maxInstallments: number;
    maxInstallmentsWithoutCardFee: number;
    annuitySettingCategoryId: number;
    id: number;
}

export class AnnuitySettingCategoryDto implements IAnnuitySettingCategoryDto {
    categoryId!: number;
    category!: CategoryListDto;
    annuitySettingDtoId!: number;
    deadlines!: AnnuitySettingCategoryDeadlineDto[] | undefined;
    id!: number;

    constructor(data?: IAnnuitySettingCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryListDto.fromJS(data["category"]) : <any>undefined;
            this.annuitySettingDtoId = data["annuitySettingDtoId"];
            if (Array.isArray(data["deadlines"])) {
                this.deadlines = [] as any;
                for (let item of data["deadlines"])
                    this.deadlines!.push(AnnuitySettingCategoryDeadlineDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuitySettingCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnuitySettingCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["annuitySettingDtoId"] = this.annuitySettingDtoId;
        if (Array.isArray(this.deadlines)) {
            data["deadlines"] = [];
            for (let item of this.deadlines)
                data["deadlines"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuitySettingCategoryDto {
    categoryId: number;
    category: CategoryListDto;
    annuitySettingDtoId: number;
    deadlines: AnnuitySettingCategoryDeadlineDto[] | undefined;
    id: number;
}

export class CertificateFilePagSeguroInput implements ICertificateFilePagSeguroInput {
    pagSeguroConfigId!: number;
    isKey!: boolean;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: ICertificateFilePagSeguroInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.isKey = data["isKey"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): CertificateFilePagSeguroInput {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateFilePagSeguroInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["isKey"] = this.isKey;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface ICertificateFilePagSeguroInput {
    pagSeguroConfigId: number;
    isKey: boolean;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class PaymentMethodBankDto implements IPaymentMethodBankDto {
    name!: string | undefined;
    displayName!: string | undefined;
    id!: number;

    constructor(data?: IPaymentMethodBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodBankDto {
    name: string | undefined;
    displayName: string | undefined;
    id: number;
}

export class PaymentMethodCardBrandDto implements IPaymentMethodCardBrandDto {
    name!: string | undefined;
    displayName!: string | undefined;
    id!: number;

    constructor(data?: IPaymentMethodCardBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodCardBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodCardBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodCardBrandDto {
    name: string | undefined;
    displayName: string | undefined;
    id: number;
}

export class PaymentTypePermissionDto implements IPaymentTypePermissionDto {
    paymentType!: PaymentType;
    pagSeguroConfigId!: number | undefined;

    constructor(data?: IPaymentTypePermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
        }
    }

    static fromJS(data: any): PaymentTypePermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypePermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        return data; 
    }
}

export interface IPaymentTypePermissionDto {
    paymentType: PaymentType;
    pagSeguroConfigId: number | undefined;
}

export class CreateOrEditPagSeguroConfig implements ICreateOrEditPagSeguroConfig {
    tenantId!: number | undefined;
    description!: string | undefined;
    email!: string | undefined;
    token!: string | undefined;
    appId!: string | undefined;
    appKey!: string | undefined;
    urlSessions!: string | undefined;
    urlNotifications!: string | undefined;
    urlTransactions!: string | undefined;
    urlTickets!: string | undefined;
    urlJavaScriptLibrary!: string | undefined;
    pixKey!: string | undefined;
    publicKey!: string | undefined;
    pixTime!: number;
    clientID!: string | undefined;
    clientSecret!: string | undefined;
    urlToken!: string | undefined;
    urlCharges!: string | undefined;
    certificatePathPem!: string | undefined;
    certificatePemInput!: CertificateFilePagSeguroInput;
    certificatePathKey!: string | undefined;
    certificateKeyInput!: CertificateFilePagSeguroInput;
    certificatePathP12!: string | undefined;
    certificateP12Input!: CertificateFilePagSeguroInput;
    certificateP12Password!: string | undefined;
    urlRegisterKeyWebhook!: string | undefined;
    urlWebhookNotifications!: string | undefined;
    isActive!: boolean;
    banks!: PaymentMethodBankDto[] | undefined;
    cardBrands!: PaymentMethodCardBrandDto[] | undefined;
    paymentTypes!: PaymentTypePermissionDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPagSeguroConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.description = data["description"];
            this.email = data["email"];
            this.token = data["token"];
            this.appId = data["appId"];
            this.appKey = data["appKey"];
            this.urlSessions = data["urlSessions"];
            this.urlNotifications = data["urlNotifications"];
            this.urlTransactions = data["urlTransactions"];
            this.urlTickets = data["urlTickets"];
            this.urlJavaScriptLibrary = data["urlJavaScriptLibrary"];
            this.pixKey = data["pixKey"];
            this.publicKey = data["publicKey"];
            this.pixTime = data["pixTime"];
            this.clientID = data["clientID"];
            this.clientSecret = data["clientSecret"];
            this.urlToken = data["urlToken"];
            this.urlCharges = data["urlCharges"];
            this.certificatePathPem = data["certificatePathPem"];
            this.certificatePemInput = data["certificatePemInput"] ? CertificateFilePagSeguroInput.fromJS(data["certificatePemInput"]) : <any>undefined;
            this.certificatePathKey = data["certificatePathKey"];
            this.certificateKeyInput = data["certificateKeyInput"] ? CertificateFilePagSeguroInput.fromJS(data["certificateKeyInput"]) : <any>undefined;
            this.certificatePathP12 = data["certificatePathP12"];
            this.certificateP12Input = data["certificateP12Input"] ? CertificateFilePagSeguroInput.fromJS(data["certificateP12Input"]) : <any>undefined;
            this.certificateP12Password = data["certificateP12Password"];
            this.urlRegisterKeyWebhook = data["urlRegisterKeyWebhook"];
            this.urlWebhookNotifications = data["urlWebhookNotifications"];
            this.isActive = data["isActive"];
            if (Array.isArray(data["banks"])) {
                this.banks = [] as any;
                for (let item of data["banks"])
                    this.banks!.push(PaymentMethodBankDto.fromJS(item));
            }
            if (Array.isArray(data["cardBrands"])) {
                this.cardBrands = [] as any;
                for (let item of data["cardBrands"])
                    this.cardBrands!.push(PaymentMethodCardBrandDto.fromJS(item));
            }
            if (Array.isArray(data["paymentTypes"])) {
                this.paymentTypes = [] as any;
                for (let item of data["paymentTypes"])
                    this.paymentTypes!.push(PaymentTypePermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPagSeguroConfig {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPagSeguroConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["email"] = this.email;
        data["token"] = this.token;
        data["appId"] = this.appId;
        data["appKey"] = this.appKey;
        data["urlSessions"] = this.urlSessions;
        data["urlNotifications"] = this.urlNotifications;
        data["urlTransactions"] = this.urlTransactions;
        data["urlTickets"] = this.urlTickets;
        data["urlJavaScriptLibrary"] = this.urlJavaScriptLibrary;
        data["pixKey"] = this.pixKey;
        data["publicKey"] = this.publicKey;
        data["pixTime"] = this.pixTime;
        data["clientID"] = this.clientID;
        data["clientSecret"] = this.clientSecret;
        data["urlToken"] = this.urlToken;
        data["urlCharges"] = this.urlCharges;
        data["certificatePathPem"] = this.certificatePathPem;
        data["certificatePemInput"] = this.certificatePemInput ? this.certificatePemInput.toJSON() : <any>undefined;
        data["certificatePathKey"] = this.certificatePathKey;
        data["certificateKeyInput"] = this.certificateKeyInput ? this.certificateKeyInput.toJSON() : <any>undefined;
        data["certificatePathP12"] = this.certificatePathP12;
        data["certificateP12Input"] = this.certificateP12Input ? this.certificateP12Input.toJSON() : <any>undefined;
        data["certificateP12Password"] = this.certificateP12Password;
        data["urlRegisterKeyWebhook"] = this.urlRegisterKeyWebhook;
        data["urlWebhookNotifications"] = this.urlWebhookNotifications;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item.toJSON());
        }
        if (Array.isArray(this.cardBrands)) {
            data["cardBrands"] = [];
            for (let item of this.cardBrands)
                data["cardBrands"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentTypes)) {
            data["paymentTypes"] = [];
            for (let item of this.paymentTypes)
                data["paymentTypes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPagSeguroConfig {
    tenantId: number | undefined;
    description: string | undefined;
    email: string | undefined;
    token: string | undefined;
    appId: string | undefined;
    appKey: string | undefined;
    urlSessions: string | undefined;
    urlNotifications: string | undefined;
    urlTransactions: string | undefined;
    urlTickets: string | undefined;
    urlJavaScriptLibrary: string | undefined;
    pixKey: string | undefined;
    publicKey: string | undefined;
    pixTime: number;
    clientID: string | undefined;
    clientSecret: string | undefined;
    urlToken: string | undefined;
    urlCharges: string | undefined;
    certificatePathPem: string | undefined;
    certificatePemInput: CertificateFilePagSeguroInput;
    certificatePathKey: string | undefined;
    certificateKeyInput: CertificateFilePagSeguroInput;
    certificatePathP12: string | undefined;
    certificateP12Input: CertificateFilePagSeguroInput;
    certificateP12Password: string | undefined;
    urlRegisterKeyWebhook: string | undefined;
    urlWebhookNotifications: string | undefined;
    isActive: boolean;
    banks: PaymentMethodBankDto[] | undefined;
    cardBrands: PaymentMethodCardBrandDto[] | undefined;
    paymentTypes: PaymentTypePermissionDto[] | undefined;
    id: number | undefined;
}

export class PaymentMethodPermissionDto implements IPaymentMethodPermissionDto {
    isActive!: boolean;
    discountPercentage!: number;
    maxInstallments!: number | undefined;
    maxInstallmentsWithoutCardFee!: number | undefined;
    paymentType!: PaymentType;
    description!: string | undefined;
    pagSeguroConfigId!: number | undefined;
    pagSeguroConfig!: CreateOrEditPagSeguroConfig;
    id!: number;

    constructor(data?: IPaymentMethodPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.discountPercentage = data["discountPercentage"];
            this.maxInstallments = data["maxInstallments"];
            this.maxInstallmentsWithoutCardFee = data["maxInstallmentsWithoutCardFee"];
            this.paymentType = data["paymentType"];
            this.description = data["description"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.pagSeguroConfig = data["pagSeguroConfig"] ? CreateOrEditPagSeguroConfig.fromJS(data["pagSeguroConfig"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaymentMethodPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["discountPercentage"] = this.discountPercentage;
        data["maxInstallments"] = this.maxInstallments;
        data["maxInstallmentsWithoutCardFee"] = this.maxInstallmentsWithoutCardFee;
        data["paymentType"] = this.paymentType;
        data["description"] = this.description;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["pagSeguroConfig"] = this.pagSeguroConfig ? this.pagSeguroConfig.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPaymentMethodPermissionDto {
    isActive: boolean;
    discountPercentage: number;
    maxInstallments: number | undefined;
    maxInstallmentsWithoutCardFee: number | undefined;
    paymentType: PaymentType;
    description: string | undefined;
    pagSeguroConfigId: number | undefined;
    pagSeguroConfig: CreateOrEditPagSeguroConfig;
    id: number;
}

export class CreateOrEditAnnuitySettingDto implements ICreateOrEditAnnuitySettingDto {
    year!: number;
    validate!: moment.Moment;
    yearsReadmission!: number | undefined;
    receivableByCoupon!: boolean;
    categories!: AnnuitySettingCategoryDto[] | undefined;
    paymentMethods!: PaymentMethodPermissionDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAnnuitySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.validate = data["validate"] ? moment(data["validate"].toString()) : <any>undefined;
            this.yearsReadmission = data["yearsReadmission"];
            this.receivableByCoupon = data["receivableByCoupon"];
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(AnnuitySettingCategoryDto.fromJS(item));
            }
            if (Array.isArray(data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodPermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAnnuitySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAnnuitySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["validate"] = this.validate ? this.validate.toISOString() : <any>undefined;
        data["yearsReadmission"] = this.yearsReadmission;
        data["receivableByCoupon"] = this.receivableByCoupon;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAnnuitySettingDto {
    year: number;
    validate: moment.Moment;
    yearsReadmission: number | undefined;
    receivableByCoupon: boolean;
    categories: AnnuitySettingCategoryDto[] | undefined;
    paymentMethods: PaymentMethodPermissionDto[] | undefined;
    id: number | undefined;
}

export class GetAnnuityForViewDto implements IGetAnnuityForViewDto {
    annuity!: AnnuityDto;
    payment!: PaymentCompleteDto;
    annuitySetting!: CreateOrEditAnnuitySettingDto;
    memberUserName!: string | undefined;
    memberName!: string | undefined;
    memberBadgeName!: string | undefined;
    memberEmailAddress!: string | undefined;
    memberPhone!: string | undefined;
    annuitySettingYear!: string | undefined;
    creationTime!: moment.Moment;
    categoryName!: string | undefined;
    categoryLevelName!: string | undefined;
    phone!: UserPhoneDto;
    address!: UserAddressDto;
    userSituationDescription!: string | undefined;
    orderId!: string | undefined;
    orderHasOtherItems!: boolean;

    constructor(data?: IGetAnnuityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuity = data["annuity"] ? AnnuityDto.fromJS(data["annuity"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.annuitySetting = data["annuitySetting"] ? CreateOrEditAnnuitySettingDto.fromJS(data["annuitySetting"]) : <any>undefined;
            this.memberUserName = data["memberUserName"];
            this.memberName = data["memberName"];
            this.memberBadgeName = data["memberBadgeName"];
            this.memberEmailAddress = data["memberEmailAddress"];
            this.memberPhone = data["memberPhone"];
            this.annuitySettingYear = data["annuitySettingYear"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.categoryName = data["categoryName"];
            this.categoryLevelName = data["categoryLevelName"];
            this.phone = data["phone"] ? UserPhoneDto.fromJS(data["phone"]) : <any>undefined;
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : <any>undefined;
            this.userSituationDescription = data["userSituationDescription"];
            this.orderId = data["orderId"];
            this.orderHasOtherItems = data["orderHasOtherItems"];
        }
    }

    static fromJS(data: any): GetAnnuityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["annuitySetting"] = this.annuitySetting ? this.annuitySetting.toJSON() : <any>undefined;
        data["memberUserName"] = this.memberUserName;
        data["memberName"] = this.memberName;
        data["memberBadgeName"] = this.memberBadgeName;
        data["memberEmailAddress"] = this.memberEmailAddress;
        data["memberPhone"] = this.memberPhone;
        data["annuitySettingYear"] = this.annuitySettingYear;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["categoryName"] = this.categoryName;
        data["categoryLevelName"] = this.categoryLevelName;
        data["phone"] = this.phone ? this.phone.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["userSituationDescription"] = this.userSituationDescription;
        data["orderId"] = this.orderId;
        data["orderHasOtherItems"] = this.orderHasOtherItems;
        return data; 
    }
}

export interface IGetAnnuityForViewDto {
    annuity: AnnuityDto;
    payment: PaymentCompleteDto;
    annuitySetting: CreateOrEditAnnuitySettingDto;
    memberUserName: string | undefined;
    memberName: string | undefined;
    memberBadgeName: string | undefined;
    memberEmailAddress: string | undefined;
    memberPhone: string | undefined;
    annuitySettingYear: string | undefined;
    creationTime: moment.Moment;
    categoryName: string | undefined;
    categoryLevelName: string | undefined;
    phone: UserPhoneDto;
    address: UserAddressDto;
    userSituationDescription: string | undefined;
    orderId: string | undefined;
    orderHasOtherItems: boolean;
}

export class PagedResultDtoOfGetAnnuityForViewDto implements IPagedResultDtoOfGetAnnuityForViewDto {
    totalCount!: number;
    items!: GetAnnuityForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAnnuityForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAnnuityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAnnuityForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAnnuityForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAnnuityForViewDto {
    totalCount: number;
    items: GetAnnuityForViewDto[] | undefined;
}

export class CreateOrEditAnnuityDto implements ICreateOrEditAnnuityDto {
    memberId!: number;
    annuitySettingId!: number;
    categoryId!: number | undefined;
    levelId!: number | undefined;
    situation!: AnnuitySituation;
    itsReadmission!: boolean;
    repasse!: AnnuityRepasseDto;
    payment!: PaymentCompleteDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberId = data["memberId"];
            this.annuitySettingId = data["annuitySettingId"];
            this.categoryId = data["categoryId"];
            this.levelId = data["levelId"];
            this.situation = data["situation"];
            this.itsReadmission = data["itsReadmission"];
            this.repasse = data["repasse"] ? AnnuityRepasseDto.fromJS(data["repasse"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAnnuityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["annuitySettingId"] = this.annuitySettingId;
        data["categoryId"] = this.categoryId;
        data["levelId"] = this.levelId;
        data["situation"] = this.situation;
        data["itsReadmission"] = this.itsReadmission;
        data["repasse"] = this.repasse ? this.repasse.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAnnuityDto {
    memberId: number;
    annuitySettingId: number;
    categoryId: number | undefined;
    levelId: number | undefined;
    situation: AnnuitySituation;
    itsReadmission: boolean;
    repasse: AnnuityRepasseDto;
    payment: PaymentCompleteDto;
    id: number | undefined;
}

export class GetAnnuityForEditOutput implements IGetAnnuityForEditOutput {
    annuity!: CreateOrEditAnnuityDto;
    memberName!: string | undefined;
    annuitySettingYear!: string | undefined;
    payment!: PaymentCompleteDto;
    orderId!: number | undefined;
    dueDate!: moment.Moment | undefined;
    orderHasOtherItems!: boolean;
    userId!: number | undefined;
    categoryName!: string | undefined;

    constructor(data?: IGetAnnuityForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuity = data["annuity"] ? CreateOrEditAnnuityDto.fromJS(data["annuity"]) : <any>undefined;
            this.memberName = data["memberName"];
            this.annuitySettingYear = data["annuitySettingYear"];
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.orderId = data["orderId"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.orderHasOtherItems = data["orderHasOtherItems"];
            this.userId = data["userId"];
            this.categoryName = data["categoryName"];
        }
    }

    static fromJS(data: any): GetAnnuityForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuityForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["annuitySettingYear"] = this.annuitySettingYear;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["orderHasOtherItems"] = this.orderHasOtherItems;
        data["userId"] = this.userId;
        data["categoryName"] = this.categoryName;
        return data; 
    }
}

export interface IGetAnnuityForEditOutput {
    annuity: CreateOrEditAnnuityDto;
    memberName: string | undefined;
    annuitySettingYear: string | undefined;
    payment: PaymentCompleteDto;
    orderId: number | undefined;
    dueDate: moment.Moment | undefined;
    orderHasOtherItems: boolean;
    userId: number | undefined;
    categoryName: string | undefined;
}

export class ResultEmailDto implements IResultEmailDto {
    errorOnSendEmail!: boolean;

    constructor(data?: IResultEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.errorOnSendEmail = data["errorOnSendEmail"];
        }
    }

    static fromJS(data: any): ResultEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorOnSendEmail"] = this.errorOnSendEmail;
        return data; 
    }
}

export interface IResultEmailDto {
    errorOnSendEmail: boolean;
}

export enum DocumentationStatus {
    WaitingForApproval = 0,
    Approved = 1,
    Disapproved = 2,
    NotSent = 3,
}

export class UpdateDocumentInput implements IUpdateDocumentInput {
    documentId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentId = data["documentId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateDocumentInput {
    documentId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditDocumentDto implements ICreateOrEditDocumentDto {
    documentId!: string | undefined;
    document!: string | undefined;
    fileExtension!: string | undefined;
    input!: UpdateDocumentInput;
    fileName!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.documentId = data["documentId"];
            this.document = data["document"];
            this.fileExtension = data["fileExtension"];
            this.input = data["input"] ? UpdateDocumentInput.fromJS(data["input"]) : <any>undefined;
            this.fileName = data["fileName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["document"] = this.document;
        data["fileExtension"] = this.fileExtension;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditDocumentDto {
    documentId: string | undefined;
    document: string | undefined;
    fileExtension: string | undefined;
    input: UpdateDocumentInput;
    fileName: string | undefined;
    id: number | undefined;
}

export class CreateOrEditDocumentationDto implements ICreateOrEditDocumentationDto {
    memberId!: number;
    note!: string | undefined;
    tenantId!: number | undefined;
    status!: DocumentationStatus;
    documents!: CreateOrEditDocumentDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditDocumentationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberId = data["memberId"];
            this.note = data["note"];
            this.tenantId = data["tenantId"];
            this.status = data["status"];
            if (Array.isArray(data["documents"])) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents!.push(CreateOrEditDocumentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditDocumentationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditDocumentationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["note"] = this.note;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditDocumentationDto {
    memberId: number;
    note: string | undefined;
    tenantId: number | undefined;
    status: DocumentationStatus;
    documents: CreateOrEditDocumentDto[] | undefined;
    id: number | undefined;
}

export class MemberCategoryDto implements IMemberCategoryDto {
    beginDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    note!: string | undefined;
    categoryId!: number;
    category!: CategoryDto;
    levelId!: number | undefined;
    memberId!: number;
    documentation!: CreateOrEditDocumentationDto;
    id!: number;

    constructor(data?: IMemberCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.note = data["note"];
            this.categoryId = data["categoryId"];
            this.category = data["category"] ? CategoryDto.fromJS(data["category"]) : <any>undefined;
            this.levelId = data["levelId"];
            this.memberId = data["memberId"];
            this.documentation = data["documentation"] ? CreateOrEditDocumentationDto.fromJS(data["documentation"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["levelId"] = this.levelId;
        data["memberId"] = this.memberId;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberCategoryDto {
    beginDate: moment.Moment;
    endDate: moment.Moment | undefined;
    note: string | undefined;
    categoryId: number;
    category: CategoryDto;
    levelId: number | undefined;
    memberId: number;
    documentation: CreateOrEditDocumentationDto;
    id: number;
}

export class EventListDto implements IEventListDto {
    id!: number;
    name!: string | undefined;
    shortName!: string | undefined;
    logoId!: string | undefined;
    logo!: string | undefined;
    receivableByCoupon!: boolean;

    constructor(data?: IEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.logoId = data["logoId"];
            this.logo = data["logo"];
            this.receivableByCoupon = data["receivableByCoupon"];
        }
    }

    static fromJS(data: any): EventListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo;
        data["receivableByCoupon"] = this.receivableByCoupon;
        return data; 
    }
}

export interface IEventListDto {
    id: number;
    name: string | undefined;
    shortName: string | undefined;
    logoId: string | undefined;
    logo: string | undefined;
    receivableByCoupon: boolean;
}

export class EventDeadlineListDto implements IEventDeadlineListDto {
    description!: string | undefined;
    deadline!: moment.Moment;
    amount!: number;
    event!: EventListDto;
    id!: number;

    constructor(data?: IEventDeadlineListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDeadlineListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDeadlineListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDeadlineListDto {
    description: string | undefined;
    deadline: moment.Moment;
    amount: number;
    event: EventListDto;
    id: number;
}

export class EventCategoryExtraFeeDto implements IEventCategoryExtraFeeDto {
    categoryId!: number;
    eventExtraFeeId!: number;
    id!: number;

    constructor(data?: IEventCategoryExtraFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.eventExtraFeeId = data["eventExtraFeeId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventCategoryExtraFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventCategoryExtraFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["eventExtraFeeId"] = this.eventExtraFeeId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventCategoryExtraFeeDto {
    categoryId: number;
    eventExtraFeeId: number;
    id: number;
}

export class EventExtraFeeDto implements IEventExtraFeeDto {
    description!: string | undefined;
    value!: number;
    isRequired!: boolean;
    eventId!: number;
    hasRegistrations!: boolean;
    categories!: EventCategoryExtraFeeDto[] | undefined;
    id!: number;

    constructor(data?: IEventExtraFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.value = data["value"];
            this.isRequired = data["isRequired"];
            this.eventId = data["eventId"];
            this.hasRegistrations = data["hasRegistrations"];
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(EventCategoryExtraFeeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventExtraFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventExtraFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["value"] = this.value;
        data["isRequired"] = this.isRequired;
        data["eventId"] = this.eventId;
        data["hasRegistrations"] = this.hasRegistrations;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventExtraFeeDto {
    description: string | undefined;
    value: number;
    isRequired: boolean;
    eventId: number;
    hasRegistrations: boolean;
    categories: EventCategoryExtraFeeDto[] | undefined;
    id: number;
}

export class RegistrationExtraFeeDto implements IRegistrationExtraFeeDto {
    extraFeeId!: number;
    extraFee!: EventExtraFeeDto;
    registrationId!: number;
    id!: number;

    constructor(data?: IRegistrationExtraFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extraFeeId = data["extraFeeId"];
            this.extraFee = data["extraFee"] ? EventExtraFeeDto.fromJS(data["extraFee"]) : <any>undefined;
            this.registrationId = data["registrationId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationExtraFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationExtraFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraFeeId"] = this.extraFeeId;
        data["extraFee"] = this.extraFee ? this.extraFee.toJSON() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationExtraFeeDto {
    extraFeeId: number;
    extraFee: EventExtraFeeDto;
    registrationId: number;
    id: number;
}

export class RegistrationForEditDto implements IRegistrationForEditDto {
    isFree!: boolean;
    presence!: boolean;
    category!: CategoryListDto;
    eventDeadline!: EventDeadlineListDto;
    user!: UserListDto;
    userId!: number;
    payment!: PaymentCompleteDto;
    fees!: RegistrationExtraFeeDto[] | undefined;
    orderId!: number | undefined;
    dueDate!: moment.Moment | undefined;
    orderHasOtherItems!: boolean;
    annuitySituation!: MemberAnnuitySituation;
    id!: number | undefined;

    constructor(data?: IRegistrationForEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.presence = data["presence"];
            this.category = data["category"] ? CategoryListDto.fromJS(data["category"]) : <any>undefined;
            this.eventDeadline = data["eventDeadline"] ? EventDeadlineListDto.fromJS(data["eventDeadline"]) : <any>undefined;
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.userId = data["userId"];
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            if (Array.isArray(data["fees"])) {
                this.fees = [] as any;
                for (let item of data["fees"])
                    this.fees!.push(RegistrationExtraFeeDto.fromJS(item));
            }
            this.orderId = data["orderId"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.orderHasOtherItems = data["orderHasOtherItems"];
            this.annuitySituation = data["annuitySituation"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationForEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationForEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["presence"] = this.presence;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["eventDeadline"] = this.eventDeadline ? this.eventDeadline.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["orderHasOtherItems"] = this.orderHasOtherItems;
        data["annuitySituation"] = this.annuitySituation;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationForEditDto {
    isFree: boolean;
    presence: boolean;
    category: CategoryListDto;
    eventDeadline: EventDeadlineListDto;
    user: UserListDto;
    userId: number;
    payment: PaymentCompleteDto;
    fees: RegistrationExtraFeeDto[] | undefined;
    orderId: number | undefined;
    dueDate: moment.Moment | undefined;
    orderHasOtherItems: boolean;
    annuitySituation: MemberAnnuitySituation;
    id: number | undefined;
}

export enum OrderSituation {
    WaitingPayment = 0,
    Paid = 1,
    Canceled = 2,
}

export class CouponListDto implements ICouponListDto {
    code!: string | undefined;
    expirationDate!: moment.Moment;
    id!: number;

    constructor(data?: ICouponListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponListDto {
    code: string | undefined;
    expirationDate: moment.Moment;
    id: number;
}

export class RegistrationDto implements IRegistrationDto {
    presence!: boolean;
    creationTime!: moment.Moment;
    user!: UserListDto;
    category!: CategoryListDto;
    coupon!: CouponListDto;
    eventDeadline!: EventDeadlineListDto;
    payments!: PaymentDto[] | undefined;
    fees!: RegistrationExtraFeeDto[] | undefined;
    id!: number;

    constructor(data?: IRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.presence = data["presence"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.category = data["category"] ? CategoryListDto.fromJS(data["category"]) : <any>undefined;
            this.coupon = data["coupon"] ? CouponListDto.fromJS(data["coupon"]) : <any>undefined;
            this.eventDeadline = data["eventDeadline"] ? EventDeadlineListDto.fromJS(data["eventDeadline"]) : <any>undefined;
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentDto.fromJS(item));
            }
            if (Array.isArray(data["fees"])) {
                this.fees = [] as any;
                for (let item of data["fees"])
                    this.fees!.push(RegistrationExtraFeeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presence"] = this.presence;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        data["eventDeadline"] = this.eventDeadline ? this.eventDeadline.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationDto {
    presence: boolean;
    creationTime: moment.Moment;
    user: UserListDto;
    category: CategoryListDto;
    coupon: CouponListDto;
    eventDeadline: EventDeadlineListDto;
    payments: PaymentDto[] | undefined;
    fees: RegistrationExtraFeeDto[] | undefined;
    id: number;
}

export class OrderItemProductDto implements IOrderItemProductDto {
    isActive!: boolean;
    description!: string | undefined;
    amount!: number;
    logoPath!: string | undefined;
    creationTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrderItemProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.amount = data["amount"];
            this.logoPath = data["logoPath"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderItemProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["logoPath"] = this.logoPath;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrderItemProductDto {
    isActive: boolean;
    description: string | undefined;
    amount: number;
    logoPath: string | undefined;
    creationTime: moment.Moment;
    id: number;
}

export class OrderItemFreeDto implements IOrderItemFreeDto {
    description!: string | undefined;
    orderItemProductId!: number | undefined;
    orderItemProduct!: OrderItemProductDto;
    payments!: PaymentDto[] | undefined;
    id!: number;

    constructor(data?: IOrderItemFreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.orderItemProductId = data["orderItemProductId"];
            this.orderItemProduct = data["orderItemProduct"] ? OrderItemProductDto.fromJS(data["orderItemProduct"]) : <any>undefined;
            if (Array.isArray(data["payments"])) {
                this.payments = [] as any;
                for (let item of data["payments"])
                    this.payments!.push(PaymentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderItemFreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemFreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["orderItemProductId"] = this.orderItemProductId;
        data["orderItemProduct"] = this.orderItemProduct ? this.orderItemProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrderItemFreeDto {
    description: string | undefined;
    orderItemProductId: number | undefined;
    orderItemProduct: OrderItemProductDto;
    payments: PaymentDto[] | undefined;
    id: number;
}

export class OrderItemDto implements IOrderItemDto {
    description!: string | undefined;
    category!: string | undefined;
    quantity!: number;
    annuityId!: number | undefined;
    annuity!: AnnuityDto;
    registrationId!: number | undefined;
    registration!: RegistrationDto;
    orderItemFreeId!: number | undefined;
    orderItemFree!: OrderItemFreeDto;
    orderId!: number;
    payment!: PaymentCompleteDto;
    id!: number;

    constructor(data?: IOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.category = data["category"];
            this.quantity = data["quantity"];
            this.annuityId = data["annuityId"];
            this.annuity = data["annuity"] ? AnnuityDto.fromJS(data["annuity"]) : <any>undefined;
            this.registrationId = data["registrationId"];
            this.registration = data["registration"] ? RegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.orderItemFreeId = data["orderItemFreeId"];
            this.orderItemFree = data["orderItemFree"] ? OrderItemFreeDto.fromJS(data["orderItemFree"]) : <any>undefined;
            this.orderId = data["orderId"];
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["category"] = this.category;
        data["quantity"] = this.quantity;
        data["annuityId"] = this.annuityId;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["registrationId"] = this.registrationId;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["orderItemFreeId"] = this.orderItemFreeId;
        data["orderItemFree"] = this.orderItemFree ? this.orderItemFree.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrderItemDto {
    description: string | undefined;
    category: string | undefined;
    quantity: number;
    annuityId: number | undefined;
    annuity: AnnuityDto;
    registrationId: number | undefined;
    registration: RegistrationDto;
    orderItemFreeId: number | undefined;
    orderItemFree: OrderItemFreeDto;
    orderId: number;
    payment: PaymentCompleteDto;
    id: number;
}

export class OrderDto implements IOrderDto {
    description!: string | undefined;
    dueDate!: moment.Moment | undefined;
    userId!: number | undefined;
    user!: UserListDto;
    situation!: OrderSituation;
    creationTime!: moment.Moment;
    items!: OrderItemDto[] | undefined;
    paymentMethods!: PaymentMethodPermissionDto[] | undefined;
    id!: number;

    constructor(data?: IOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.situation = data["situation"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrderItemDto.fromJS(item));
            }
            if (Array.isArray(data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodPermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["situation"] = this.situation;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrderDto {
    description: string | undefined;
    dueDate: moment.Moment | undefined;
    userId: number | undefined;
    user: UserListDto;
    situation: OrderSituation;
    creationTime: moment.Moment;
    items: OrderItemDto[] | undefined;
    paymentMethods: PaymentMethodPermissionDto[] | undefined;
    id: number;
}

export class OutputCurrentPaymentDto implements IOutputCurrentPaymentDto {
    annuitySituation!: MemberAnnuitySituation;
    memberCategory!: MemberCategoryDto;
    annuity!: AnnuityDto;
    registration!: RegistrationForEditDto;
    order!: OrderDto;
    payment!: PaymentCompleteDto;
    itsPaid!: boolean;

    constructor(data?: IOutputCurrentPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuitySituation = data["annuitySituation"];
            this.memberCategory = data["memberCategory"] ? MemberCategoryDto.fromJS(data["memberCategory"]) : <any>undefined;
            this.annuity = data["annuity"] ? AnnuityDto.fromJS(data["annuity"]) : <any>undefined;
            this.registration = data["registration"] ? RegistrationForEditDto.fromJS(data["registration"]) : <any>undefined;
            this.order = data["order"] ? OrderDto.fromJS(data["order"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.itsPaid = data["itsPaid"];
        }
    }

    static fromJS(data: any): OutputCurrentPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputCurrentPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuitySituation"] = this.annuitySituation;
        data["memberCategory"] = this.memberCategory ? this.memberCategory.toJSON() : <any>undefined;
        data["annuity"] = this.annuity ? this.annuity.toJSON() : <any>undefined;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["itsPaid"] = this.itsPaid;
        return data; 
    }
}

export interface IOutputCurrentPaymentDto {
    annuitySituation: MemberAnnuitySituation;
    memberCategory: MemberCategoryDto;
    annuity: AnnuityDto;
    registration: RegistrationForEditDto;
    order: OrderDto;
    payment: PaymentCompleteDto;
    itsPaid: boolean;
}

export class GetAnnuitySettingForViewDto implements IGetAnnuitySettingForViewDto {
    annuitySetting!: AnnuitySettingDto;
    totalAnnuities!: number;
    totalPaidAnnuities!: number;

    constructor(data?: IGetAnnuitySettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuitySetting = data["annuitySetting"] ? AnnuitySettingDto.fromJS(data["annuitySetting"]) : <any>undefined;
            this.totalAnnuities = data["totalAnnuities"];
            this.totalPaidAnnuities = data["totalPaidAnnuities"];
        }
    }

    static fromJS(data: any): GetAnnuitySettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuitySettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuitySetting"] = this.annuitySetting ? this.annuitySetting.toJSON() : <any>undefined;
        data["totalAnnuities"] = this.totalAnnuities;
        data["totalPaidAnnuities"] = this.totalPaidAnnuities;
        return data; 
    }
}

export interface IGetAnnuitySettingForViewDto {
    annuitySetting: AnnuitySettingDto;
    totalAnnuities: number;
    totalPaidAnnuities: number;
}

export class PagedResultDtoOfGetAnnuitySettingForViewDto implements IPagedResultDtoOfGetAnnuitySettingForViewDto {
    totalCount!: number;
    items!: GetAnnuitySettingForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAnnuitySettingForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetAnnuitySettingForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAnnuitySettingForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAnnuitySettingForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetAnnuitySettingForViewDto {
    totalCount: number;
    items: GetAnnuitySettingForViewDto[] | undefined;
}

export class GetAnnuitySettingForEditOutput implements IGetAnnuitySettingForEditOutput {
    annuitySetting!: CreateOrEditAnnuitySettingDto;

    constructor(data?: IGetAnnuitySettingForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuitySetting = data["annuitySetting"] ? CreateOrEditAnnuitySettingDto.fromJS(data["annuitySetting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAnnuitySettingForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuitySettingForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuitySetting"] = this.annuitySetting ? this.annuitySetting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetAnnuitySettingForEditOutput {
    annuitySetting: CreateOrEditAnnuitySettingDto;
}

export class ListResultDtoOfAnnuitySettingDto implements IListResultDtoOfAnnuitySettingDto {
    items!: AnnuitySettingDto[] | undefined;

    constructor(data?: IListResultDtoOfAnnuitySettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AnnuitySettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAnnuitySettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfAnnuitySettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAnnuitySettingDto {
    items: AnnuitySettingDto[] | undefined;
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id: number;
}

export class GetGenerateAnnuityDto implements IGetGenerateAnnuityDto {
    year!: number;
    jobId!: number | undefined;
    totalAnnuities!: number;
    totalCategories!: number;
    estimatedTime!: string;

    constructor(data?: IGetGenerateAnnuityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.jobId = data["jobId"];
            this.totalAnnuities = data["totalAnnuities"];
            this.totalCategories = data["totalCategories"];
            this.estimatedTime = data["estimatedTime"];
        }
    }

    static fromJS(data: any): GetGenerateAnnuityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGenerateAnnuityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["jobId"] = this.jobId;
        data["totalAnnuities"] = this.totalAnnuities;
        data["totalCategories"] = this.totalCategories;
        data["estimatedTime"] = this.estimatedTime;
        return data; 
    }
}

export interface IGetGenerateAnnuityDto {
    year: number;
    jobId: number | undefined;
    totalAnnuities: number;
    totalCategories: number;
    estimatedTime: string;
}

export enum AnnuityGenerationStatus {
    Calculating = 0,
    ChangingCategories = 1,
    GeneratingAnnuities = 2,
    Finished = 3,
    Interrupted = 4,
}

export class AnnuityGenerationDto implements IAnnuityGenerationDto {
    backgroundJobId!: number;
    categoriesTotal!: number;
    categoriesCreated!: number;
    annuitiesTotal!: number;
    annuitiesCreated!: number;
    creationTime!: moment.Moment;
    finishedDate!: moment.Moment;
    status!: AnnuityGenerationStatus;
    annuitySettingId!: number;
    id!: number;

    constructor(data?: IAnnuityGenerationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.backgroundJobId = data["backgroundJobId"];
            this.categoriesTotal = data["categoriesTotal"];
            this.categoriesCreated = data["categoriesCreated"];
            this.annuitiesTotal = data["annuitiesTotal"];
            this.annuitiesCreated = data["annuitiesCreated"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.finishedDate = data["finishedDate"] ? moment(data["finishedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.annuitySettingId = data["annuitySettingId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnuityGenerationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnuityGenerationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backgroundJobId"] = this.backgroundJobId;
        data["categoriesTotal"] = this.categoriesTotal;
        data["categoriesCreated"] = this.categoriesCreated;
        data["annuitiesTotal"] = this.annuitiesTotal;
        data["annuitiesCreated"] = this.annuitiesCreated;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["finishedDate"] = this.finishedDate ? this.finishedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["annuitySettingId"] = this.annuitySettingId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnuityGenerationDto {
    backgroundJobId: number;
    categoriesTotal: number;
    categoriesCreated: number;
    annuitiesTotal: number;
    annuitiesCreated: number;
    creationTime: moment.Moment;
    finishedDate: moment.Moment;
    status: AnnuityGenerationStatus;
    annuitySettingId: number;
    id: number;
}

export class GetAnnuityGenerationForViewDto implements IGetAnnuityGenerationForViewDto {
    annuityGeneration!: AnnuityGenerationDto;
    annuitySettingYear!: string | undefined;

    constructor(data?: IGetAnnuityGenerationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuityGeneration = data["annuityGeneration"] ? AnnuityGenerationDto.fromJS(data["annuityGeneration"]) : <any>undefined;
            this.annuitySettingYear = data["annuitySettingYear"];
        }
    }

    static fromJS(data: any): GetAnnuityGenerationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuityGenerationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuityGeneration"] = this.annuityGeneration ? this.annuityGeneration.toJSON() : <any>undefined;
        data["annuitySettingYear"] = this.annuitySettingYear;
        return data; 
    }
}

export interface IGetAnnuityGenerationForViewDto {
    annuityGeneration: AnnuityGenerationDto;
    annuitySettingYear: string | undefined;
}

export enum AnnuitySituationAdimplente {
    PaidCurrentYear = 0,
    PaidAllAnnuites = 1,
    Custom = 2,
}

export class GlobalRulesAnnuitySituationDto implements IGlobalRulesAnnuitySituationDto {
    adimplente!: AnnuitySituationAdimplente;
    annuitySettings!: string | undefined;

    constructor(data?: IGlobalRulesAnnuitySituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adimplente = data["adimplente"];
            this.annuitySettings = data["annuitySettings"];
        }
    }

    static fromJS(data: any): GlobalRulesAnnuitySituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalRulesAnnuitySituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adimplente"] = this.adimplente;
        data["annuitySettings"] = this.annuitySettings;
        return data; 
    }
}

export interface IGlobalRulesAnnuitySituationDto {
    adimplente: AnnuitySituationAdimplente;
    annuitySettings: string | undefined;
}

export class GlobalRulesDto implements IGlobalRulesDto {
    annuitySituation!: GlobalRulesAnnuitySituationDto;

    constructor(data?: IGlobalRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuitySituation = data["annuitySituation"] ? GlobalRulesAnnuitySituationDto.fromJS(data["annuitySituation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GlobalRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuitySituation"] = this.annuitySituation ? this.annuitySituation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGlobalRulesDto {
    annuitySituation: GlobalRulesAnnuitySituationDto;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: moment.Moment;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    id: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export enum EntityChangeType {
    Created = 0,
    Updated = 1,
    Deleted = 2,
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: moment.Moment;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.changeTime = data["changeTime"] ? moment(data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = data["entityTypeFullName"];
            this.changeType = data["changeType"];
            (<any>this).changeTypeName = data["changeTypeName"];
            this.entityChangeSetId = data["entityChangeSetId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: moment.Moment;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityChangeId = data["entityChangeId"];
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class GetCategoryForViewDto implements IGetCategoryForViewDto {
    category!: CategoryDto;
    totalMembers!: number;

    constructor(data?: IGetCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"] ? CategoryDto.fromJS(data["category"]) : <any>undefined;
            this.totalMembers = data["totalMembers"];
        }
    }

    static fromJS(data: any): GetCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["totalMembers"] = this.totalMembers;
        return data; 
    }
}

export interface IGetCategoryForViewDto {
    category: CategoryDto;
    totalMembers: number;
}

export class PagedResultDtoOfGetCategoryForViewDto implements IPagedResultDtoOfGetCategoryForViewDto {
    totalCount!: number;
    items!: GetCategoryForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCategoryForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCategoryForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCategoryForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCategoryForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCategoryForViewDto {
    totalCount: number;
    items: GetCategoryForViewDto[] | undefined;
}

export class UpdateCategoryDto implements IUpdateCategoryDto {
    name!: string | undefined;
    shortName!: string | undefined;
    isActive!: boolean;
    requiresDocument!: boolean;
    requiresAdditionalDocument!: boolean;
    isExempt!: boolean;
    isResident!: boolean;
    requiresCRM!: boolean;
    validateCRM!: boolean;
    validateCPF!: boolean;
    allowNewUserRegister!: boolean;
    nextCategoryId!: number | undefined;
    nextCategory!: CategoryListDto;
    levels!: CategoryLevelDto[] | undefined;
    id!: number;

    constructor(data?: IUpdateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
            this.requiresDocument = data["requiresDocument"];
            this.requiresAdditionalDocument = data["requiresAdditionalDocument"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.requiresCRM = data["requiresCRM"];
            this.validateCRM = data["validateCRM"];
            this.validateCPF = data["validateCPF"];
            this.allowNewUserRegister = data["allowNewUserRegister"];
            this.nextCategoryId = data["nextCategoryId"];
            this.nextCategory = data["nextCategory"] ? CategoryListDto.fromJS(data["nextCategory"]) : <any>undefined;
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item of data["levels"])
                    this.levels!.push(CategoryLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        data["requiresDocument"] = this.requiresDocument;
        data["requiresAdditionalDocument"] = this.requiresAdditionalDocument;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["requiresCRM"] = this.requiresCRM;
        data["validateCRM"] = this.validateCRM;
        data["validateCPF"] = this.validateCPF;
        data["allowNewUserRegister"] = this.allowNewUserRegister;
        data["nextCategoryId"] = this.nextCategoryId;
        data["nextCategory"] = this.nextCategory ? this.nextCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateCategoryDto {
    name: string | undefined;
    shortName: string | undefined;
    isActive: boolean;
    requiresDocument: boolean;
    requiresAdditionalDocument: boolean;
    isExempt: boolean;
    isResident: boolean;
    requiresCRM: boolean;
    validateCRM: boolean;
    validateCPF: boolean;
    allowNewUserRegister: boolean;
    nextCategoryId: number | undefined;
    nextCategory: CategoryListDto;
    levels: CategoryLevelDto[] | undefined;
    id: number;
}

export class GetCategoryForEditOutput implements IGetCategoryForEditOutput {
    category!: UpdateCategoryDto;

    constructor(data?: IGetCategoryForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"] ? UpdateCategoryDto.fromJS(data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCategoryForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCategoryForEditOutput {
    category: UpdateCategoryDto;
}

export class ListResultDtoOfCategoryListDto implements IListResultDtoOfCategoryListDto {
    items!: CategoryListDto[] | undefined;

    constructor(data?: IListResultDtoOfCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CategoryListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCategoryListDto {
    items: CategoryListDto[] | undefined;
}

export class CreateCategoryDto implements ICreateCategoryDto {
    name!: string | undefined;
    shortName!: string | undefined;
    isActive!: boolean;
    requiresDocument!: boolean;
    requiresAdditionalDocument!: boolean;
    isExempt!: boolean;
    isResident!: boolean;
    requiresCRM!: boolean;
    validateCRM!: boolean;
    validateCPF!: boolean;
    allowNewUserRegister!: boolean;
    nextCategoryId!: number | undefined;
    nextCategory!: CategoryListDto;
    levels!: CategoryLevelDto[] | undefined;

    constructor(data?: ICreateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.isActive = data["isActive"];
            this.requiresDocument = data["requiresDocument"];
            this.requiresAdditionalDocument = data["requiresAdditionalDocument"];
            this.isExempt = data["isExempt"];
            this.isResident = data["isResident"];
            this.requiresCRM = data["requiresCRM"];
            this.validateCRM = data["validateCRM"];
            this.validateCPF = data["validateCPF"];
            this.allowNewUserRegister = data["allowNewUserRegister"];
            this.nextCategoryId = data["nextCategoryId"];
            this.nextCategory = data["nextCategory"] ? CategoryListDto.fromJS(data["nextCategory"]) : <any>undefined;
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item of data["levels"])
                    this.levels!.push(CategoryLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["isActive"] = this.isActive;
        data["requiresDocument"] = this.requiresDocument;
        data["requiresAdditionalDocument"] = this.requiresAdditionalDocument;
        data["isExempt"] = this.isExempt;
        data["isResident"] = this.isResident;
        data["requiresCRM"] = this.requiresCRM;
        data["validateCRM"] = this.validateCRM;
        data["validateCPF"] = this.validateCPF;
        data["allowNewUserRegister"] = this.allowNewUserRegister;
        data["nextCategoryId"] = this.nextCategoryId;
        data["nextCategory"] = this.nextCategory ? this.nextCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateCategoryDto {
    name: string | undefined;
    shortName: string | undefined;
    isActive: boolean;
    requiresDocument: boolean;
    requiresAdditionalDocument: boolean;
    isExempt: boolean;
    isResident: boolean;
    requiresCRM: boolean;
    validateCRM: boolean;
    validateCPF: boolean;
    allowNewUserRegister: boolean;
    nextCategoryId: number | undefined;
    nextCategory: CategoryListDto;
    levels: CategoryLevelDto[] | undefined;
}

export class GetCategoryEvolutionDto implements IGetCategoryEvolutionDto {
    name!: string | undefined;
    evolution!: string | undefined;
    totalMembers!: number;

    constructor(data?: IGetCategoryEvolutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.evolution = data["evolution"];
            this.totalMembers = data["totalMembers"];
        }
    }

    static fromJS(data: any): GetCategoryEvolutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCategoryEvolutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["evolution"] = this.evolution;
        data["totalMembers"] = this.totalMembers;
        return data; 
    }
}

export interface IGetCategoryEvolutionDto {
    name: string | undefined;
    evolution: string | undefined;
    totalMembers: number;
}

export enum EventPlaceType {
    Physical = 0,
    Online = 1,
    Hibrid = 2,
}

export class EventAddressDto implements IEventAddressDto {
    logradour!: string | undefined;
    number!: string | undefined;
    complement!: string | undefined;
    district!: string | undefined;
    zipCode!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    stateName!: string | undefined;
    countryName!: string | undefined;
    isMailing!: boolean;
    type!: AddressType;
    id!: number | undefined;

    constructor(data?: IEventAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventAddressDto {
    logradour: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    district: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    stateName: string | undefined;
    countryName: string | undefined;
    isMailing: boolean;
    type: AddressType;
    id: number | undefined;
}

export class EventPlaceDto implements IEventPlaceDto {
    name!: string | undefined;
    placeType!: EventPlaceType;
    urlEvent!: string | undefined;
    address!: EventAddressDto;
    id!: number;

    constructor(data?: IEventPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.placeType = data["placeType"];
            this.urlEvent = data["urlEvent"];
            this.address = data["address"] ? EventAddressDto.fromJS(data["address"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["placeType"] = this.placeType;
        data["urlEvent"] = this.urlEvent;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventPlaceDto {
    name: string | undefined;
    placeType: EventPlaceType;
    urlEvent: string | undefined;
    address: EventAddressDto;
    id: number;
}

export class EventDayDto implements IEventDayDto {
    day!: moment.Moment;
    startHour!: string | undefined;
    endHour!: string | undefined;
    eventId!: number;
    id!: number;

    constructor(data?: IEventDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? moment(data["day"].toString()) : <any>undefined;
            this.startHour = data["startHour"];
            this.endHour = data["endHour"];
            this.eventId = data["eventId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        data["startHour"] = this.startHour;
        data["endHour"] = this.endHour;
        data["eventId"] = this.eventId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDayDto {
    day: moment.Moment;
    startHour: string | undefined;
    endHour: string | undefined;
    eventId: number;
    id: number;
}

export class EventCategoryDeadlineDto implements IEventCategoryDeadlineDto {
    categoryId!: number;
    eventDeadlineId!: number;
    id!: number;

    constructor(data?: IEventCategoryDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.eventDeadlineId = data["eventDeadlineId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventCategoryDeadlineDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventCategoryDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["eventDeadlineId"] = this.eventDeadlineId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventCategoryDeadlineDto {
    categoryId: number;
    eventDeadlineId: number;
    id: number;
}

export class EventAnnuitySituationCategoryDto implements IEventAnnuitySituationCategoryDto {
    annuitySituation!: MemberAnnuitySituation;
    eventDeadlineId!: number;
    id!: number;

    constructor(data?: IEventAnnuitySituationCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annuitySituation = data["annuitySituation"];
            this.eventDeadlineId = data["eventDeadlineId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventAnnuitySituationCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventAnnuitySituationCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annuitySituation"] = this.annuitySituation;
        data["eventDeadlineId"] = this.eventDeadlineId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventAnnuitySituationCategoryDto {
    annuitySituation: MemberAnnuitySituation;
    eventDeadlineId: number;
    id: number;
}

export class EventDeadlineDto implements IEventDeadlineDto {
    order!: number;
    description!: string | undefined;
    roleCertificate!: string | undefined;
    deadline!: moment.Moment;
    amount!: number;
    inLocal!: boolean;
    extended!: boolean;
    maxInstallments!: number;
    maxInstallmentsWithoutCardFee!: number;
    approvalAutomatic!: boolean;
    isActive!: boolean;
    hasRegistrations!: boolean;
    allowNewUserRegister!: boolean;
    eventId!: number;
    categories!: EventCategoryDeadlineDto[] | undefined;
    annuitySituations!: EventAnnuitySituationCategoryDto[] | undefined;
    id!: number;

    constructor(data?: IEventDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"];
            this.description = data["description"];
            this.roleCertificate = data["roleCertificate"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.inLocal = data["inLocal"];
            this.extended = data["extended"];
            this.maxInstallments = data["maxInstallments"];
            this.maxInstallmentsWithoutCardFee = data["maxInstallmentsWithoutCardFee"];
            this.approvalAutomatic = data["approvalAutomatic"];
            this.isActive = data["isActive"];
            this.hasRegistrations = data["hasRegistrations"];
            this.allowNewUserRegister = data["allowNewUserRegister"];
            this.eventId = data["eventId"];
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(EventCategoryDeadlineDto.fromJS(item));
            }
            if (Array.isArray(data["annuitySituations"])) {
                this.annuitySituations = [] as any;
                for (let item of data["annuitySituations"])
                    this.annuitySituations!.push(EventAnnuitySituationCategoryDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDeadlineDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["description"] = this.description;
        data["roleCertificate"] = this.roleCertificate;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["inLocal"] = this.inLocal;
        data["extended"] = this.extended;
        data["maxInstallments"] = this.maxInstallments;
        data["maxInstallmentsWithoutCardFee"] = this.maxInstallmentsWithoutCardFee;
        data["approvalAutomatic"] = this.approvalAutomatic;
        data["isActive"] = this.isActive;
        data["hasRegistrations"] = this.hasRegistrations;
        data["allowNewUserRegister"] = this.allowNewUserRegister;
        data["eventId"] = this.eventId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.annuitySituations)) {
            data["annuitySituations"] = [];
            for (let item of this.annuitySituations)
                data["annuitySituations"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDeadlineDto {
    order: number;
    description: string | undefined;
    roleCertificate: string | undefined;
    deadline: moment.Moment;
    amount: number;
    inLocal: boolean;
    extended: boolean;
    maxInstallments: number;
    maxInstallmentsWithoutCardFee: number;
    approvalAutomatic: boolean;
    isActive: boolean;
    hasRegistrations: boolean;
    allowNewUserRegister: boolean;
    eventId: number;
    categories: EventCategoryDeadlineDto[] | undefined;
    annuitySituations: EventAnnuitySituationCategoryDto[] | undefined;
    id: number;
}

export class CertificateEventDto implements ICertificateEventDto {
    name!: string | undefined;
    shortName!: string | undefined;
    place!: EventPlaceDto;
    days!: EventDayDto[] | undefined;
    deadlines!: EventDeadlineDto[] | undefined;
    id!: number;

    constructor(data?: ICertificateEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            if (Array.isArray(data["days"])) {
                this.days = [] as any;
                for (let item of data["days"])
                    this.days!.push(EventDayDto.fromJS(item));
            }
            if (Array.isArray(data["deadlines"])) {
                this.deadlines = [] as any;
                for (let item of data["deadlines"])
                    this.deadlines!.push(EventDeadlineDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.deadlines)) {
            data["deadlines"] = [];
            for (let item of this.deadlines)
                data["deadlines"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificateEventDto {
    name: string | undefined;
    shortName: string | undefined;
    place: EventPlaceDto;
    days: EventDayDto[] | undefined;
    deadlines: EventDeadlineDto[] | undefined;
    id: number;
}

export class CertificateConfigDto implements ICertificateConfigDto {
    description!: string | undefined;
    imageId!: string | undefined;
    image!: string | undefined;
    text!: string | undefined;
    eventId!: number;
    event!: CertificateEventDto;
    id!: number;

    constructor(data?: ICertificateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.imageId = data["imageId"];
            this.image = data["image"];
            this.text = data["text"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? CertificateEventDto.fromJS(data["event"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["imageId"] = this.imageId;
        data["image"] = this.image;
        data["text"] = this.text;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificateConfigDto {
    description: string | undefined;
    imageId: string | undefined;
    image: string | undefined;
    text: string | undefined;
    eventId: number;
    event: CertificateEventDto;
    id: number;
}

export class GetCertificateConfigForViewDto implements IGetCertificateConfigForViewDto {
    config!: CertificateConfigDto;

    constructor(data?: IGetCertificateConfigForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.config = data["config"] ? CertificateConfigDto.fromJS(data["config"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCertificateConfigForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCertificateConfigForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCertificateConfigForViewDto {
    config: CertificateConfigDto;
}

export class PagedResultDtoOfGetCertificateConfigForViewDto implements IPagedResultDtoOfGetCertificateConfigForViewDto {
    totalCount!: number;
    items!: GetCertificateConfigForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCertificateConfigForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCertificateConfigForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCertificateConfigForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCertificateConfigForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCertificateConfigForViewDto {
    totalCount: number;
    items: GetCertificateConfigForViewDto[] | undefined;
}

export class ListResultDtoOfCertificateConfigDto implements IListResultDtoOfCertificateConfigDto {
    items!: CertificateConfigDto[] | undefined;

    constructor(data?: IListResultDtoOfCertificateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CertificateConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCertificateConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCertificateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCertificateConfigDto {
    items: CertificateConfigDto[] | undefined;
}

export class UpdateCertificateImageInput implements IUpdateCertificateImageInput {
    certificateId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateCertificateImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.certificateId = data["certificateId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateCertificateImageInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCertificateImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateId"] = this.certificateId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateCertificateImageInput {
    certificateId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditCertificateConfigDto implements ICreateOrEditCertificateConfigDto {
    description!: string | undefined;
    imageId!: string | undefined;
    image!: string | undefined;
    imageInput!: UpdateCertificateImageInput;
    text!: string | undefined;
    eventId!: number;
    event!: CertificateEventDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCertificateConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.imageId = data["imageId"];
            this.image = data["image"];
            this.imageInput = data["imageInput"] ? UpdateCertificateImageInput.fromJS(data["imageInput"]) : <any>undefined;
            this.text = data["text"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? CertificateEventDto.fromJS(data["event"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCertificateConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCertificateConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["imageId"] = this.imageId;
        data["image"] = this.image;
        data["imageInput"] = this.imageInput ? this.imageInput.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCertificateConfigDto {
    description: string | undefined;
    imageId: string | undefined;
    image: string | undefined;
    imageInput: UpdateCertificateImageInput;
    text: string | undefined;
    eventId: number;
    event: CertificateEventDto;
    id: number | undefined;
}

export class PreviewFileDto implements IPreviewFileDto {
    imageId!: string;
    image!: string | undefined;
    file!: FileDto;

    constructor(data?: IPreviewFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.imageId = data["imageId"];
            this.image = data["image"];
            this.file = data["file"] ? FileDto.fromJS(data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PreviewFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageId"] = this.imageId;
        data["image"] = this.image;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPreviewFileDto {
    imageId: string;
    image: string | undefined;
    file: FileDto;
}

export class CertificateDto implements ICertificateDto {
    cpf!: string | undefined;
    name!: string | undefined;
    creationTime!: moment.Moment;
    roleCertificate!: string | undefined;
    registrationId!: number;
    registration!: RegistrationDto;
    configId!: number;
    config!: CertificateConfigDto;
    id!: number;

    constructor(data?: ICertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.roleCertificate = data["roleCertificate"];
            this.registrationId = data["registrationId"];
            this.registration = data["registration"] ? RegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.configId = data["configId"];
            this.config = data["config"] ? CertificateConfigDto.fromJS(data["config"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["roleCertificate"] = this.roleCertificate;
        data["registrationId"] = this.registrationId;
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["configId"] = this.configId;
        data["config"] = this.config ? this.config.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificateDto {
    cpf: string | undefined;
    name: string | undefined;
    creationTime: moment.Moment;
    roleCertificate: string | undefined;
    registrationId: number;
    registration: RegistrationDto;
    configId: number;
    config: CertificateConfigDto;
    id: number;
}

export class GetCertificateForViewDto implements IGetCertificateForViewDto {
    certificate!: CertificateDto;
    eventName!: string | undefined;
    eventType!: string | undefined;

    constructor(data?: IGetCertificateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.certificate = data["certificate"] ? CertificateDto.fromJS(data["certificate"]) : <any>undefined;
            this.eventName = data["eventName"];
            this.eventType = data["eventType"];
        }
    }

    static fromJS(data: any): GetCertificateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCertificateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificate"] = this.certificate ? this.certificate.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        data["eventType"] = this.eventType;
        return data; 
    }
}

export interface IGetCertificateForViewDto {
    certificate: CertificateDto;
    eventName: string | undefined;
    eventType: string | undefined;
}

export class PagedResultDtoOfGetCertificateForViewDto implements IPagedResultDtoOfGetCertificateForViewDto {
    totalCount!: number;
    items!: GetCertificateForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCertificateForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCertificateForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCertificateForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCertificateForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCertificateForViewDto {
    totalCount: number;
    items: GetCertificateForViewDto[] | undefined;
}

export class EventTypeDto implements IEventTypeDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IEventTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventTypeDto {
    description: string | undefined;
    id: number | undefined;
}

export class UpdatePolicyFile implements IUpdatePolicyFile {
    eventPoliceId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdatePolicyFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventPoliceId = data["eventPoliceId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdatePolicyFile {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePolicyFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventPoliceId"] = this.eventPoliceId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdatePolicyFile {
    eventPoliceId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class EventPolicyDto implements IEventPolicyDto {
    title!: string | undefined;
    description!: string | undefined;
    fileIsActive!: boolean;
    policyFileId!: string | undefined;
    policyFile!: string | undefined;
    policyFileFileExtension!: string | undefined;
    policyFileFileName!: string | undefined;
    policyFileInput!: UpdatePolicyFile;
    eventId!: number;
    id!: number;

    constructor(data?: IEventPolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.description = data["description"];
            this.fileIsActive = data["fileIsActive"];
            this.policyFileId = data["policyFileId"];
            this.policyFile = data["policyFile"];
            this.policyFileFileExtension = data["policyFileFileExtension"];
            this.policyFileFileName = data["policyFileFileName"];
            this.policyFileInput = data["policyFileInput"] ? UpdatePolicyFile.fromJS(data["policyFileInput"]) : <any>undefined;
            this.eventId = data["eventId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventPolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventPolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["fileIsActive"] = this.fileIsActive;
        data["policyFileId"] = this.policyFileId;
        data["policyFile"] = this.policyFile;
        data["policyFileFileExtension"] = this.policyFileFileExtension;
        data["policyFileFileName"] = this.policyFileFileName;
        data["policyFileInput"] = this.policyFileInput ? this.policyFileInput.toJSON() : <any>undefined;
        data["eventId"] = this.eventId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventPolicyDto {
    title: string | undefined;
    description: string | undefined;
    fileIsActive: boolean;
    policyFileId: string | undefined;
    policyFile: string | undefined;
    policyFileFileExtension: string | undefined;
    policyFileFileName: string | undefined;
    policyFileInput: UpdatePolicyFile;
    eventId: number;
    id: number;
}

export class EventDto implements IEventDto {
    name!: string | undefined;
    shortName!: string | undefined;
    description!: string | undefined;
    terms!: string | undefined;
    receivableByCoupon!: boolean;
    numberOfPlaces!: number | undefined;
    isPublished!: boolean;
    creationTime!: moment.Moment;
    logoId!: string | undefined;
    type!: EventTypeDto;
    place!: EventPlaceDto;
    policies!: EventPolicyDto[] | undefined;
    days!: EventDayDto[] | undefined;
    extraFees!: EventExtraFeeDto[] | undefined;
    deadlines!: EventDeadlineDto[] | undefined;
    certificateConfigs!: CertificateConfigDto[] | undefined;
    paymentMethods!: PaymentMethodPermissionDto[] | undefined;
    id!: number;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            this.terms = data["terms"];
            this.receivableByCoupon = data["receivableByCoupon"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.isPublished = data["isPublished"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.logoId = data["logoId"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            if (Array.isArray(data["policies"])) {
                this.policies = [] as any;
                for (let item of data["policies"])
                    this.policies!.push(EventPolicyDto.fromJS(item));
            }
            if (Array.isArray(data["days"])) {
                this.days = [] as any;
                for (let item of data["days"])
                    this.days!.push(EventDayDto.fromJS(item));
            }
            if (Array.isArray(data["extraFees"])) {
                this.extraFees = [] as any;
                for (let item of data["extraFees"])
                    this.extraFees!.push(EventExtraFeeDto.fromJS(item));
            }
            if (Array.isArray(data["deadlines"])) {
                this.deadlines = [] as any;
                for (let item of data["deadlines"])
                    this.deadlines!.push(EventDeadlineDto.fromJS(item));
            }
            if (Array.isArray(data["certificateConfigs"])) {
                this.certificateConfigs = [] as any;
                for (let item of data["certificateConfigs"])
                    this.certificateConfigs!.push(CertificateConfigDto.fromJS(item));
            }
            if (Array.isArray(data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodPermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["terms"] = this.terms;
        data["receivableByCoupon"] = this.receivableByCoupon;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["isPublished"] = this.isPublished;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["logoId"] = this.logoId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.extraFees)) {
            data["extraFees"] = [];
            for (let item of this.extraFees)
                data["extraFees"].push(item.toJSON());
        }
        if (Array.isArray(this.deadlines)) {
            data["deadlines"] = [];
            for (let item of this.deadlines)
                data["deadlines"].push(item.toJSON());
        }
        if (Array.isArray(this.certificateConfigs)) {
            data["certificateConfigs"] = [];
            for (let item of this.certificateConfigs)
                data["certificateConfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventDto {
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    terms: string | undefined;
    receivableByCoupon: boolean;
    numberOfPlaces: number | undefined;
    isPublished: boolean;
    creationTime: moment.Moment;
    logoId: string | undefined;
    type: EventTypeDto;
    place: EventPlaceDto;
    policies: EventPolicyDto[] | undefined;
    days: EventDayDto[] | undefined;
    extraFees: EventExtraFeeDto[] | undefined;
    deadlines: EventDeadlineDto[] | undefined;
    certificateConfigs: CertificateConfigDto[] | undefined;
    paymentMethods: PaymentMethodPermissionDto[] | undefined;
    id: number;
}

export enum RegistrationSituation {
    WaitingForApproval = 0,
    Approved = 1,
    Canceled = 2,
}

export class PhoneDto implements IPhoneDto {
    ddi!: string | undefined;
    ddd!: string | undefined;
    number!: string | undefined;
    type!: PhoneType;
    id!: number | undefined;

    constructor(data?: IPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPhoneDto {
    ddi: string | undefined;
    ddd: string | undefined;
    number: string | undefined;
    type: PhoneType;
    id: number | undefined;
}

export class GetRegistrationForViewDto implements IGetRegistrationForViewDto {
    registration!: RegistrationDto;
    event!: EventDto;
    logo!: string | undefined;
    badgeName!: string | undefined;
    eventName!: string | undefined;
    eventType!: string | undefined;
    isFree!: boolean;
    situation!: RegistrationSituation;
    payment!: PaymentCompleteDto;
    hasCertificate!: boolean;
    memberId!: number | undefined;
    eventId!: number;
    userSituationDescription!: string | undefined;
    beginEventDate!: moment.Moment | undefined;
    endEventDate!: moment.Moment | undefined;
    email!: string | undefined;
    whatsApp!: PhoneDto;
    orderId!: string | undefined;
    orderHasOtherItems!: boolean;

    constructor(data?: IGetRegistrationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registration = data["registration"] ? RegistrationDto.fromJS(data["registration"]) : <any>undefined;
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.logo = data["logo"];
            this.badgeName = data["badgeName"];
            this.eventName = data["eventName"];
            this.eventType = data["eventType"];
            this.isFree = data["isFree"];
            this.situation = data["situation"];
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.hasCertificate = data["hasCertificate"];
            this.memberId = data["memberId"];
            this.eventId = data["eventId"];
            this.userSituationDescription = data["userSituationDescription"];
            this.beginEventDate = data["beginEventDate"] ? moment(data["beginEventDate"].toString()) : <any>undefined;
            this.endEventDate = data["endEventDate"] ? moment(data["endEventDate"].toString()) : <any>undefined;
            this.email = data["email"];
            this.whatsApp = data["whatsApp"] ? PhoneDto.fromJS(data["whatsApp"]) : <any>undefined;
            this.orderId = data["orderId"];
            this.orderHasOtherItems = data["orderHasOtherItems"];
        }
    }

    static fromJS(data: any): GetRegistrationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistrationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["logo"] = this.logo;
        data["badgeName"] = this.badgeName;
        data["eventName"] = this.eventName;
        data["eventType"] = this.eventType;
        data["isFree"] = this.isFree;
        data["situation"] = this.situation;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["hasCertificate"] = this.hasCertificate;
        data["memberId"] = this.memberId;
        data["eventId"] = this.eventId;
        data["userSituationDescription"] = this.userSituationDescription;
        data["beginEventDate"] = this.beginEventDate ? this.beginEventDate.toISOString() : <any>undefined;
        data["endEventDate"] = this.endEventDate ? this.endEventDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["whatsApp"] = this.whatsApp ? this.whatsApp.toJSON() : <any>undefined;
        data["orderId"] = this.orderId;
        data["orderHasOtherItems"] = this.orderHasOtherItems;
        return data; 
    }
}

export interface IGetRegistrationForViewDto {
    registration: RegistrationDto;
    event: EventDto;
    logo: string | undefined;
    badgeName: string | undefined;
    eventName: string | undefined;
    eventType: string | undefined;
    isFree: boolean;
    situation: RegistrationSituation;
    payment: PaymentCompleteDto;
    hasCertificate: boolean;
    memberId: number | undefined;
    eventId: number;
    userSituationDescription: string | undefined;
    beginEventDate: moment.Moment | undefined;
    endEventDate: moment.Moment | undefined;
    email: string | undefined;
    whatsApp: PhoneDto;
    orderId: string | undefined;
    orderHasOtherItems: boolean;
}

export class PagedResultDtoOfGetRegistrationForViewDto implements IPagedResultDtoOfGetRegistrationForViewDto {
    totalCount!: number;
    items!: GetRegistrationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetRegistrationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetRegistrationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetRegistrationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetRegistrationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetRegistrationForViewDto {
    totalCount: number;
    items: GetRegistrationForViewDto[] | undefined;
}

export enum FriendshipState {
    Accepted = 1,
    Blocked = 2,
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data; 
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: moment.Moment;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(data["friends"])) {
                this.friends = [] as any;
                for (let item of data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;
}

export enum ChatSide {
    Sender = 1,
    Receiver = 2,
}

export enum ChatMessageReadState {
    Unread = 1,
    Read = 2,
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: moment.Moment;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;
    id: number;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class CompanyTypeDto implements ICompanyTypeDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICompanyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICompanyTypeDto {
    description: string | undefined;
    id: number | undefined;
}

export class CompanyDto implements ICompanyDto {
    name!: string | undefined;
    link!: string | undefined;
    logo!: string | undefined;
    logoId!: string | undefined;
    isActive!: boolean;
    type!: CompanyTypeDto;
    id!: number;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.link = data["link"];
            this.logo = data["logo"];
            this.logoId = data["logoId"];
            this.isActive = data["isActive"];
            this.type = data["type"] ? CompanyTypeDto.fromJS(data["type"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["link"] = this.link;
        data["logo"] = this.logo;
        data["logoId"] = this.logoId;
        data["isActive"] = this.isActive;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICompanyDto {
    name: string | undefined;
    link: string | undefined;
    logo: string | undefined;
    logoId: string | undefined;
    isActive: boolean;
    type: CompanyTypeDto;
    id: number;
}

export class GetCompanyForViewDto implements IGetCompanyForViewDto {
    company!: CompanyDto;
    logo!: string | undefined;

    constructor(data?: IGetCompanyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.company = data["company"] ? CompanyDto.fromJS(data["company"]) : <any>undefined;
            this.logo = data["logo"];
        }
    }

    static fromJS(data: any): GetCompanyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["logo"] = this.logo;
        return data; 
    }
}

export interface IGetCompanyForViewDto {
    company: CompanyDto;
    logo: string | undefined;
}

export class PagedResultDtoOfGetCompanyForViewDto implements IPagedResultDtoOfGetCompanyForViewDto {
    totalCount!: number;
    items!: GetCompanyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCompanyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCompanyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCompanyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCompanyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCompanyForViewDto {
    totalCount: number;
    items: GetCompanyForViewDto[] | undefined;
}

export class UpdateCompanyLogoInput implements IUpdateCompanyLogoInput {
    sponsotId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateCompanyLogoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sponsotId = data["sponsotId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateCompanyLogoInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyLogoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sponsotId"] = this.sponsotId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateCompanyLogoInput {
    sponsotId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditCompanyDto implements ICreateOrEditCompanyDto {
    name!: string | undefined;
    link!: string | undefined;
    logo!: string | undefined;
    logoId!: string | undefined;
    logoInput!: UpdateCompanyLogoInput;
    isActive!: boolean;
    type!: CompanyTypeDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.link = data["link"];
            this.logo = data["logo"];
            this.logoId = data["logoId"];
            this.logoInput = data["logoInput"] ? UpdateCompanyLogoInput.fromJS(data["logoInput"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.type = data["type"] ? CompanyTypeDto.fromJS(data["type"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["link"] = this.link;
        data["logo"] = this.logo;
        data["logoId"] = this.logoId;
        data["logoInput"] = this.logoInput ? this.logoInput.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCompanyDto {
    name: string | undefined;
    link: string | undefined;
    logo: string | undefined;
    logoId: string | undefined;
    logoInput: UpdateCompanyLogoInput;
    isActive: boolean;
    type: CompanyTypeDto;
    id: number | undefined;
}

export class GetCompanyForEditOutput implements IGetCompanyForEditOutput {
    company!: CreateOrEditCompanyDto;

    constructor(data?: IGetCompanyForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.company = data["company"] ? CreateOrEditCompanyDto.fromJS(data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCompanyForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCompanyForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCompanyForEditOutput {
    company: CreateOrEditCompanyDto;
}

export class CompanyListDto implements ICompanyListDto {
    name!: string | undefined;
    link!: string | undefined;
    logoId!: string | undefined;
    logo!: string | undefined;
    id!: number;

    constructor(data?: ICompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.link = data["link"];
            this.logoId = data["logoId"];
            this.logo = data["logo"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["link"] = this.link;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICompanyListDto {
    name: string | undefined;
    link: string | undefined;
    logoId: string | undefined;
    logo: string | undefined;
    id: number;
}

export class ListResultDtoOfCompanyListDto implements IListResultDtoOfCompanyListDto {
    items!: CompanyListDto[] | undefined;

    constructor(data?: IListResultDtoOfCompanyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CompanyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCompanyListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCompanyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCompanyListDto {
    items: CompanyListDto[] | undefined;
}

export class CompanyTypeListDto implements ICompanyTypeListDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: ICompanyTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICompanyTypeListDto {
    description: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfCompanyTypeListDto implements IListResultDtoOfCompanyTypeListDto {
    items!: CompanyTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfCompanyTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CompanyTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCompanyTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCompanyTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCompanyTypeListDto {
    items: CompanyTypeListDto[] | undefined;
}

export class GetCouponForViewDto implements IGetCouponForViewDto {
    coupon!: CouponDto;

    constructor(data?: IGetCouponForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coupon = data["coupon"] ? CouponDto.fromJS(data["coupon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCouponForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponForViewDto {
    coupon: CouponDto;
}

export class PagedResultDtoOfGetCouponForViewDto implements IPagedResultDtoOfGetCouponForViewDto {
    totalCount!: number;
    items!: GetCouponForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCouponForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCouponForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCouponForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCouponForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCouponForViewDto {
    totalCount: number;
    items: GetCouponForViewDto[] | undefined;
}

export class CreateOrEditCouponDto implements ICreateOrEditCouponDto {
    code!: string | undefined;
    discountAmount!: number | undefined;
    discountPercentage!: number | undefined;
    updatedManually!: boolean;
    userId!: number | undefined;
    user!: CouponUserDto;
    expirationDate!: moment.Moment;
    orderId!: number | undefined;
    couponBatchId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.updatedManually = data["updatedManually"];
            this.userId = data["userId"];
            this.user = data["user"] ? CouponUserDto.fromJS(data["user"]) : <any>undefined;
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.orderId = data["orderId"];
            this.couponBatchId = data["couponBatchId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["updatedManually"] = this.updatedManually;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["couponBatchId"] = this.couponBatchId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCouponDto {
    code: string | undefined;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    updatedManually: boolean;
    userId: number | undefined;
    user: CouponUserDto;
    expirationDate: moment.Moment;
    orderId: number | undefined;
    couponBatchId: number;
    id: number | undefined;
}

export class GetCouponForEditOutput implements IGetCouponForEditOutput {
    coupon!: CreateOrEditCouponDto;

    constructor(data?: IGetCouponForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coupon = data["coupon"] ? CreateOrEditCouponDto.fromJS(data["coupon"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCouponForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coupon"] = this.coupon ? this.coupon.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponForEditOutput {
    coupon: CreateOrEditCouponDto;
}

export class ValidateCouponOutput implements IValidateCouponOutput {
    id!: number;
    couponBatchId!: number;
    code!: string | undefined;
    discountAmount!: number;
    discountPercentage!: number;
    expirationDate!: moment.Moment;

    constructor(data?: IValidateCouponOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.couponBatchId = data["couponBatchId"];
            this.code = data["code"];
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateCouponOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCouponOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["couponBatchId"] = this.couponBatchId;
        data["code"] = this.code;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IValidateCouponOutput {
    id: number;
    couponBatchId: number;
    code: string | undefined;
    discountAmount: number;
    discountPercentage: number;
    expirationDate: moment.Moment;
}

export enum DiscountType {
    Cash = 0,
    Percentage = 1,
}

export class ResponsibleDto implements IResponsibleDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    id!: number;

    constructor(data?: IResponsibleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ResponsibleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponsibleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IResponsibleDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    id: number;
}

export class CouponBatchDto implements ICouponBatchDto {
    code!: string | undefined;
    name!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    responsibleId!: number;
    responsible!: ResponsibleDto;
    discountAmount!: number | undefined;
    discountPercentage!: number | undefined;
    discountType!: DiscountType;
    coupons!: CouponDto[] | undefined;
    id!: number;

    constructor(data?: ICouponBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? ResponsibleDto.fromJS(data["responsible"]) : <any>undefined;
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.discountType = data["discountType"];
            if (Array.isArray(data["coupons"])) {
                this.coupons = [] as any;
                for (let item of data["coupons"])
                    this.coupons!.push(CouponDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CouponBatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CouponBatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["discountType"] = this.discountType;
        if (Array.isArray(this.coupons)) {
            data["coupons"] = [];
            for (let item of this.coupons)
                data["coupons"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICouponBatchDto {
    code: string | undefined;
    name: string | undefined;
    expirationDate: moment.Moment | undefined;
    responsibleId: number;
    responsible: ResponsibleDto;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    discountType: DiscountType;
    coupons: CouponDto[] | undefined;
    id: number;
}

export class GetCouponBatchForViewDto implements IGetCouponBatchForViewDto {
    couponBatch!: CouponBatchDto;

    constructor(data?: IGetCouponBatchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.couponBatch = data["couponBatch"] ? CouponBatchDto.fromJS(data["couponBatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponBatchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCouponBatchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["couponBatch"] = this.couponBatch ? this.couponBatch.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponBatchForViewDto {
    couponBatch: CouponBatchDto;
}

export class PagedResultDtoOfGetCouponBatchForViewDto implements IPagedResultDtoOfGetCouponBatchForViewDto {
    totalCount!: number;
    items!: GetCouponBatchForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCouponBatchForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCouponBatchForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCouponBatchForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCouponBatchForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCouponBatchForViewDto {
    totalCount: number;
    items: GetCouponBatchForViewDto[] | undefined;
}

export class CreateOrEditCouponBatchDto implements ICreateOrEditCouponBatchDto {
    quantity!: number | undefined;
    applyChangesToAll!: boolean;
    code!: string | undefined;
    name!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    responsibleId!: number;
    responsible!: ResponsibleDto;
    discountAmount!: number | undefined;
    discountPercentage!: number | undefined;
    discountType!: DiscountType;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCouponBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.quantity = data["quantity"];
            this.applyChangesToAll = data["applyChangesToAll"];
            this.code = data["code"];
            this.name = data["name"];
            this.expirationDate = data["expirationDate"] ? moment(data["expirationDate"].toString()) : <any>undefined;
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? ResponsibleDto.fromJS(data["responsible"]) : <any>undefined;
            this.discountAmount = data["discountAmount"];
            this.discountPercentage = data["discountPercentage"];
            this.discountType = data["discountType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCouponBatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCouponBatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["applyChangesToAll"] = this.applyChangesToAll;
        data["code"] = this.code;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["discountAmount"] = this.discountAmount;
        data["discountPercentage"] = this.discountPercentage;
        data["discountType"] = this.discountType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCouponBatchDto {
    quantity: number | undefined;
    applyChangesToAll: boolean;
    code: string | undefined;
    name: string | undefined;
    expirationDate: moment.Moment | undefined;
    responsibleId: number;
    responsible: ResponsibleDto;
    discountAmount: number | undefined;
    discountPercentage: number | undefined;
    discountType: DiscountType;
    id: number | undefined;
}

export class GetCouponBatchForEditOutput implements IGetCouponBatchForEditOutput {
    couponBatch!: CreateOrEditCouponBatchDto;

    constructor(data?: IGetCouponBatchForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.couponBatch = data["couponBatch"] ? CreateOrEditCouponBatchDto.fromJS(data["couponBatch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCouponBatchForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCouponBatchForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["couponBatch"] = this.couponBatch ? this.couponBatch.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCouponBatchForEditOutput {
    couponBatch: CreateOrEditCouponBatchDto;
}

export class GetCoverageAreaForViewDto implements IGetCoverageAreaForViewDto {
    coverageArea!: CoverageAreaDto;
    thematicAreasCount!: number;

    constructor(data?: IGetCoverageAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coverageArea = data["coverageArea"] ? CoverageAreaDto.fromJS(data["coverageArea"]) : <any>undefined;
            this.thematicAreasCount = data["thematicAreasCount"];
        }
    }

    static fromJS(data: any): GetCoverageAreaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoverageAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coverageArea"] = this.coverageArea ? this.coverageArea.toJSON() : <any>undefined;
        data["thematicAreasCount"] = this.thematicAreasCount;
        return data; 
    }
}

export interface IGetCoverageAreaForViewDto {
    coverageArea: CoverageAreaDto;
    thematicAreasCount: number;
}

export class PagedResultDtoOfGetCoverageAreaForViewDto implements IPagedResultDtoOfGetCoverageAreaForViewDto {
    totalCount!: number;
    items!: GetCoverageAreaForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetCoverageAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetCoverageAreaForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetCoverageAreaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetCoverageAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetCoverageAreaForViewDto {
    totalCount: number;
    items: GetCoverageAreaForViewDto[] | undefined;
}

export class CreateOrEditCoverageAreaDto implements ICreateOrEditCoverageAreaDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    color!: string | undefined;
    isActive!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCoverageAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.color = data["color"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCoverageAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCoverageAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["color"] = this.color;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCoverageAreaDto {
    description: string | undefined;
    shortDescription: string | undefined;
    color: string | undefined;
    isActive: boolean;
    id: number | undefined;
}

export class GetCoverageAreaForEditOutput implements IGetCoverageAreaForEditOutput {
    coverageArea!: CreateOrEditCoverageAreaDto;

    constructor(data?: IGetCoverageAreaForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.coverageArea = data["coverageArea"] ? CreateOrEditCoverageAreaDto.fromJS(data["coverageArea"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCoverageAreaForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCoverageAreaForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coverageArea"] = this.coverageArea ? this.coverageArea.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCoverageAreaForEditOutput {
    coverageArea: CreateOrEditCoverageAreaDto;
}

export class ListResultDtoOfCoverageAreaDto implements IListResultDtoOfCoverageAreaDto {
    items!: CoverageAreaDto[] | undefined;

    constructor(data?: IListResultDtoOfCoverageAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CoverageAreaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCoverageAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCoverageAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCoverageAreaDto {
    items: CoverageAreaDto[] | undefined;
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.widgetId = data["widgetId"];
            this.height = data["height"];
            this.width = data["width"];
            this.positionX = data["positionX"];
            this.positionY = data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data; 
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            if (Array.isArray(data["widgets"])) {
                this.widgets = [] as any;
                for (let item of data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            if (Array.isArray(data["pages"])) {
                this.pages = [] as any;
                for (let item of data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.application = data["application"];
            if (Array.isArray(data["pages"])) {
                this.pages = [] as any;
                for (let item of data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.id = data["id"];
            this.name = data["name"];
            this.application = data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data; 
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dashboardName = data["dashboardName"];
            this.name = data["name"];
            this.application = data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data; 
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pageId = data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data; 
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.widgetId = data["widgetId"];
            this.pageId = data["pageId"];
            this.dashboardName = data["dashboardName"];
            this.width = data["width"];
            this.height = data["height"];
            this.application = data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data; 
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    readonly id!: string | undefined;
    readonly name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).id = data["id"];
            (<any>this).name = data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    readonly id!: string | undefined;
    readonly name!: string | undefined;
    readonly description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).id = data["id"];
            (<any>this).name = data["name"];
            (<any>this).description = data["description"];
            if (Array.isArray(data["filters"])) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (Array.isArray(data["widgets"])) {
                this.widgets = [] as any;
                for (let item of data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data; 
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data; 
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.trialDayCount = data["trialDayCount"];
            this.expiringEditionDisplayName = data["expiringEditionDisplayName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).name = data["name"];
            if (data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;
    itemSource!: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes![key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(data["features"])) {
                this.features = [] as any;
                for (let item of data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionCreateDto.fromJS(data["edition"]) : new EditionCreateDto();
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[] | undefined;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sourceEditionId = data["sourceEditionId"];
            this.targetEditionId = data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data; 
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class GetEventForViewDto implements IGetEventForViewDto {
    event!: EventDto;
    logo!: string | undefined;
    beginEventDate!: moment.Moment | undefined;
    endEventDate!: moment.Moment | undefined;
    beginRegistrationDate!: moment.Moment | undefined;
    endRegistrationDate!: moment.Moment | undefined;
    totalRegistrations!: number;
    totalRegistrationsApproved!: number;
    percentRegistrations!: number | undefined;
    hasRegistrationPaid!: boolean;
    memberCategoryId!: number;
    canSignUp!: boolean;
    email!: string | undefined;
    whatsApp!: PhoneDto;
    deadlineAmount!: number | undefined;
    deadline!: EventDeadlineDto;
    myDeadlines!: EventDeadlineDto[] | undefined;
    othersDeadlines!: EventDeadlineDto[] | undefined;

    constructor(data?: IGetEventForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.logo = data["logo"];
            this.beginEventDate = data["beginEventDate"] ? moment(data["beginEventDate"].toString()) : <any>undefined;
            this.endEventDate = data["endEventDate"] ? moment(data["endEventDate"].toString()) : <any>undefined;
            this.beginRegistrationDate = data["beginRegistrationDate"] ? moment(data["beginRegistrationDate"].toString()) : <any>undefined;
            this.endRegistrationDate = data["endRegistrationDate"] ? moment(data["endRegistrationDate"].toString()) : <any>undefined;
            this.totalRegistrations = data["totalRegistrations"];
            this.totalRegistrationsApproved = data["totalRegistrationsApproved"];
            this.percentRegistrations = data["percentRegistrations"];
            this.hasRegistrationPaid = data["hasRegistrationPaid"];
            this.memberCategoryId = data["memberCategoryId"];
            this.canSignUp = data["canSignUp"];
            this.email = data["email"];
            this.whatsApp = data["whatsApp"] ? PhoneDto.fromJS(data["whatsApp"]) : <any>undefined;
            this.deadlineAmount = data["deadlineAmount"];
            this.deadline = data["deadline"] ? EventDeadlineDto.fromJS(data["deadline"]) : <any>undefined;
            if (Array.isArray(data["myDeadlines"])) {
                this.myDeadlines = [] as any;
                for (let item of data["myDeadlines"])
                    this.myDeadlines!.push(EventDeadlineDto.fromJS(item));
            }
            if (Array.isArray(data["othersDeadlines"])) {
                this.othersDeadlines = [] as any;
                for (let item of data["othersDeadlines"])
                    this.othersDeadlines!.push(EventDeadlineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEventForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["logo"] = this.logo;
        data["beginEventDate"] = this.beginEventDate ? this.beginEventDate.toISOString() : <any>undefined;
        data["endEventDate"] = this.endEventDate ? this.endEventDate.toISOString() : <any>undefined;
        data["beginRegistrationDate"] = this.beginRegistrationDate ? this.beginRegistrationDate.toISOString() : <any>undefined;
        data["endRegistrationDate"] = this.endRegistrationDate ? this.endRegistrationDate.toISOString() : <any>undefined;
        data["totalRegistrations"] = this.totalRegistrations;
        data["totalRegistrationsApproved"] = this.totalRegistrationsApproved;
        data["percentRegistrations"] = this.percentRegistrations;
        data["hasRegistrationPaid"] = this.hasRegistrationPaid;
        data["memberCategoryId"] = this.memberCategoryId;
        data["canSignUp"] = this.canSignUp;
        data["email"] = this.email;
        data["whatsApp"] = this.whatsApp ? this.whatsApp.toJSON() : <any>undefined;
        data["deadlineAmount"] = this.deadlineAmount;
        data["deadline"] = this.deadline ? this.deadline.toJSON() : <any>undefined;
        if (Array.isArray(this.myDeadlines)) {
            data["myDeadlines"] = [];
            for (let item of this.myDeadlines)
                data["myDeadlines"].push(item.toJSON());
        }
        if (Array.isArray(this.othersDeadlines)) {
            data["othersDeadlines"] = [];
            for (let item of this.othersDeadlines)
                data["othersDeadlines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEventForViewDto {
    event: EventDto;
    logo: string | undefined;
    beginEventDate: moment.Moment | undefined;
    endEventDate: moment.Moment | undefined;
    beginRegistrationDate: moment.Moment | undefined;
    endRegistrationDate: moment.Moment | undefined;
    totalRegistrations: number;
    totalRegistrationsApproved: number;
    percentRegistrations: number | undefined;
    hasRegistrationPaid: boolean;
    memberCategoryId: number;
    canSignUp: boolean;
    email: string | undefined;
    whatsApp: PhoneDto;
    deadlineAmount: number | undefined;
    deadline: EventDeadlineDto;
    myDeadlines: EventDeadlineDto[] | undefined;
    othersDeadlines: EventDeadlineDto[] | undefined;
}

export class PagedResultDtoOfGetEventForViewDto implements IPagedResultDtoOfGetEventForViewDto {
    totalCount!: number;
    items!: GetEventForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEventForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEventForViewDto {
    totalCount: number;
    items: GetEventForViewDto[] | undefined;
}

export enum RegistrationPaymentType {
    Free = 0,
    Paid = 1,
}

export class EventCnaScoreDto implements IEventCnaScoreDto {
    specialty!: string | undefined;
    score!: number;
    eventId!: number;
    event!: EventListDto;
    id!: number;

    constructor(data?: IEventCnaScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specialty = data["specialty"];
            this.score = data["score"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventCnaScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventCnaScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialty"] = this.specialty;
        data["score"] = this.score;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventCnaScoreDto {
    specialty: string | undefined;
    score: number;
    eventId: number;
    event: EventListDto;
    id: number;
}

export class UpdateEventDto implements IUpdateEventDto {
    name!: string | undefined;
    shortName!: string | undefined;
    description!: string | undefined;
    cancellationAndTransferPolicy!: string | undefined;
    terms!: string | undefined;
    isPublished!: boolean;
    receivableByCoupon!: boolean;
    numberOfPlaces!: number | undefined;
    logoId!: string | undefined;
    type!: EventTypeDto;
    creationTime!: moment.Moment;
    place!: EventPlaceDto;
    policies!: EventPolicyDto[] | undefined;
    days!: EventDayDto[] | undefined;
    deadlines!: EventDeadlineDto[] | undefined;
    extraFees!: EventExtraFeeDto[] | undefined;
    cnaScores!: EventCnaScoreDto[] | undefined;
    certificateConfigs!: CreateOrEditCertificateConfigDto[] | undefined;
    paymentMethods!: PaymentMethodPermissionDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IUpdateEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            this.cancellationAndTransferPolicy = data["cancellationAndTransferPolicy"];
            this.terms = data["terms"];
            this.isPublished = data["isPublished"];
            this.receivableByCoupon = data["receivableByCoupon"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.logoId = data["logoId"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            if (Array.isArray(data["policies"])) {
                this.policies = [] as any;
                for (let item of data["policies"])
                    this.policies!.push(EventPolicyDto.fromJS(item));
            }
            if (Array.isArray(data["days"])) {
                this.days = [] as any;
                for (let item of data["days"])
                    this.days!.push(EventDayDto.fromJS(item));
            }
            if (Array.isArray(data["deadlines"])) {
                this.deadlines = [] as any;
                for (let item of data["deadlines"])
                    this.deadlines!.push(EventDeadlineDto.fromJS(item));
            }
            if (Array.isArray(data["extraFees"])) {
                this.extraFees = [] as any;
                for (let item of data["extraFees"])
                    this.extraFees!.push(EventExtraFeeDto.fromJS(item));
            }
            if (Array.isArray(data["cnaScores"])) {
                this.cnaScores = [] as any;
                for (let item of data["cnaScores"])
                    this.cnaScores!.push(EventCnaScoreDto.fromJS(item));
            }
            if (Array.isArray(data["certificateConfigs"])) {
                this.certificateConfigs = [] as any;
                for (let item of data["certificateConfigs"])
                    this.certificateConfigs!.push(CreateOrEditCertificateConfigDto.fromJS(item));
            }
            if (Array.isArray(data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodPermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["cancellationAndTransferPolicy"] = this.cancellationAndTransferPolicy;
        data["terms"] = this.terms;
        data["isPublished"] = this.isPublished;
        data["receivableByCoupon"] = this.receivableByCoupon;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["logoId"] = this.logoId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.deadlines)) {
            data["deadlines"] = [];
            for (let item of this.deadlines)
                data["deadlines"].push(item.toJSON());
        }
        if (Array.isArray(this.extraFees)) {
            data["extraFees"] = [];
            for (let item of this.extraFees)
                data["extraFees"].push(item.toJSON());
        }
        if (Array.isArray(this.cnaScores)) {
            data["cnaScores"] = [];
            for (let item of this.cnaScores)
                data["cnaScores"].push(item.toJSON());
        }
        if (Array.isArray(this.certificateConfigs)) {
            data["certificateConfigs"] = [];
            for (let item of this.certificateConfigs)
                data["certificateConfigs"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateEventDto {
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    cancellationAndTransferPolicy: string | undefined;
    terms: string | undefined;
    isPublished: boolean;
    receivableByCoupon: boolean;
    numberOfPlaces: number | undefined;
    logoId: string | undefined;
    type: EventTypeDto;
    creationTime: moment.Moment;
    place: EventPlaceDto;
    policies: EventPolicyDto[] | undefined;
    days: EventDayDto[] | undefined;
    deadlines: EventDeadlineDto[] | undefined;
    extraFees: EventExtraFeeDto[] | undefined;
    cnaScores: EventCnaScoreDto[] | undefined;
    certificateConfigs: CreateOrEditCertificateConfigDto[] | undefined;
    paymentMethods: PaymentMethodPermissionDto[] | undefined;
    id: number | undefined;
}

export class GetEventForEditOutput implements IGetEventForEditOutput {
    event!: UpdateEventDto;
    logo!: string | undefined;

    constructor(data?: IGetEventForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.event = data["event"] ? UpdateEventDto.fromJS(data["event"]) : <any>undefined;
            this.logo = data["logo"];
        }
    }

    static fromJS(data: any): GetEventForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["logo"] = this.logo;
        return data; 
    }
}

export interface IGetEventForEditOutput {
    event: UpdateEventDto;
    logo: string | undefined;
}

export class ListResultDtoOfEventListDto implements IListResultDtoOfEventListDto {
    items!: EventListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventListDto {
    items: EventListDto[] | undefined;
}

export class CreateEventDto implements ICreateEventDto {
    name!: string | undefined;
    shortName!: string | undefined;
    description!: string | undefined;
    numberOfPlaces!: number | undefined;
    type!: EventTypeDto;

    constructor(data?: ICreateEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateEventDto {
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    numberOfPlaces: number | undefined;
    type: EventTypeDto;
}

export class UpdateEventLogoInput implements IUpdateEventLogoInput {
    eventId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateEventLogoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateEventLogoInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventLogoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateEventLogoInput {
    eventId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class EventTypeListDto implements IEventTypeListDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IEventTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventTypeListDto {
    description: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfEventTypeListDto implements IListResultDtoOfEventTypeListDto {
    items!: EventTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventTypeListDto {
    items: EventTypeListDto[] | undefined;
}

export class EventPlaceListDto implements IEventPlaceListDto {
    name!: string | undefined;
    address!: EventAddressDto;
    id!: number | undefined;

    constructor(data?: IEventPlaceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.address = data["address"] ? EventAddressDto.fromJS(data["address"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventPlaceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventPlaceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventPlaceListDto {
    name: string | undefined;
    address: EventAddressDto;
    id: number | undefined;
}

export class ListResultDtoOfEventPlaceListDto implements IListResultDtoOfEventPlaceListDto {
    items!: EventPlaceListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventPlaceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventPlaceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventPlaceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventPlaceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventPlaceListDto {
    items: EventPlaceListDto[] | undefined;
}

export class CreateOrEditEventDeadlineDto implements ICreateOrEditEventDeadlineDto {
    description!: string | undefined;
    deadline!: moment.Moment;
    amount!: number;
    inLocal!: boolean;
    extended!: boolean;
    discount!: number;
    isActive!: boolean;
    eventId!: number;
    categories!: EventCategoryDeadlineDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventDeadlineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : <any>undefined;
            this.amount = data["amount"];
            this.inLocal = data["inLocal"];
            this.extended = data["extended"];
            this.discount = data["discount"];
            this.isActive = data["isActive"];
            this.eventId = data["eventId"];
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(EventCategoryDeadlineDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventDeadlineDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventDeadlineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["inLocal"] = this.inLocal;
        data["extended"] = this.extended;
        data["discount"] = this.discount;
        data["isActive"] = this.isActive;
        data["eventId"] = this.eventId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventDeadlineDto {
    description: string | undefined;
    deadline: moment.Moment;
    amount: number;
    inLocal: boolean;
    extended: boolean;
    discount: number;
    isActive: boolean;
    eventId: number;
    categories: EventCategoryDeadlineDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditEventDeadlinesDto implements ICreateOrEditEventDeadlinesDto {
    eventId!: number;
    deadlines!: CreateOrEditEventDeadlineDto[] | undefined;

    constructor(data?: ICreateOrEditEventDeadlinesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            if (Array.isArray(data["deadlines"])) {
                this.deadlines = [] as any;
                for (let item of data["deadlines"])
                    this.deadlines!.push(CreateOrEditEventDeadlineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditEventDeadlinesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventDeadlinesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        if (Array.isArray(this.deadlines)) {
            data["deadlines"] = [];
            for (let item of this.deadlines)
                data["deadlines"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditEventDeadlinesDto {
    eventId: number;
    deadlines: CreateOrEditEventDeadlineDto[] | undefined;
}

export class CreateOrEditEventExtraFeeDto implements ICreateOrEditEventExtraFeeDto {
    description!: string | undefined;
    value!: number;
    isRequired!: boolean;
    categoryId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventExtraFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.value = data["value"];
            this.isRequired = data["isRequired"];
            this.categoryId = data["categoryId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventExtraFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventExtraFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["value"] = this.value;
        data["isRequired"] = this.isRequired;
        data["categoryId"] = this.categoryId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventExtraFeeDto {
    description: string | undefined;
    value: number;
    isRequired: boolean;
    categoryId: number;
    id: number | undefined;
}

export class CreateOrEditEeventExtraFeesDto implements ICreateOrEditEeventExtraFeesDto {
    eventId!: number;
    extraFees!: CreateOrEditEventExtraFeeDto[] | undefined;

    constructor(data?: ICreateOrEditEeventExtraFeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            if (Array.isArray(data["extraFees"])) {
                this.extraFees = [] as any;
                for (let item of data["extraFees"])
                    this.extraFees!.push(CreateOrEditEventExtraFeeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditEeventExtraFeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEeventExtraFeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        if (Array.isArray(this.extraFees)) {
            data["extraFees"] = [];
            for (let item of this.extraFees)
                data["extraFees"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditEeventExtraFeesDto {
    eventId: number;
    extraFees: CreateOrEditEventExtraFeeDto[] | undefined;
}

export class CreateOrEditEventCnaScoreDto implements ICreateOrEditEventCnaScoreDto {
    specialty!: string | undefined;
    score!: number;
    eventId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditEventCnaScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specialty = data["specialty"];
            this.score = data["score"];
            this.eventId = data["eventId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventCnaScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventCnaScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialty"] = this.specialty;
        data["score"] = this.score;
        data["eventId"] = this.eventId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventCnaScoreDto {
    specialty: string | undefined;
    score: number;
    eventId: number;
    id: number | undefined;
}

export class CreateOrEditEventCnaScoresDto implements ICreateOrEditEventCnaScoresDto {
    eventId!: number;
    scores!: CreateOrEditEventCnaScoreDto[] | undefined;

    constructor(data?: ICreateOrEditEventCnaScoresDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            if (Array.isArray(data["scores"])) {
                this.scores = [] as any;
                for (let item of data["scores"])
                    this.scores!.push(CreateOrEditEventCnaScoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditEventCnaScoresDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventCnaScoresDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        if (Array.isArray(this.scores)) {
            data["scores"] = [];
            for (let item of this.scores)
                data["scores"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditEventCnaScoresDto {
    eventId: number;
    scores: CreateOrEditEventCnaScoreDto[] | undefined;
}

export class CreateOrEditCertificateConfigsDto implements ICreateOrEditCertificateConfigsDto {
    eventId!: number;
    certificateConfigs!: CreateOrEditCertificateConfigDto[] | undefined;

    constructor(data?: ICreateOrEditCertificateConfigsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            if (Array.isArray(data["certificateConfigs"])) {
                this.certificateConfigs = [] as any;
                for (let item of data["certificateConfigs"])
                    this.certificateConfigs!.push(CreateOrEditCertificateConfigDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditCertificateConfigsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCertificateConfigsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        if (Array.isArray(this.certificateConfigs)) {
            data["certificateConfigs"] = [];
            for (let item of this.certificateConfigs)
                data["certificateConfigs"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditCertificateConfigsDto {
    eventId: number;
    certificateConfigs: CreateOrEditCertificateConfigDto[] | undefined;
}

export class CreateOrEditEventScheduleRoomDayDto implements ICreateOrEditEventScheduleRoomDayDto {
    eventScheduleRoomId!: number;
    eventScheduleDayId!: number | undefined;
    hasActivities!: boolean;
    id!: number;

    constructor(data?: ICreateOrEditEventScheduleRoomDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventScheduleRoomId = data["eventScheduleRoomId"];
            this.eventScheduleDayId = data["eventScheduleDayId"];
            this.hasActivities = data["hasActivities"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventScheduleRoomDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventScheduleRoomDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventScheduleRoomId"] = this.eventScheduleRoomId;
        data["eventScheduleDayId"] = this.eventScheduleDayId;
        data["hasActivities"] = this.hasActivities;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventScheduleRoomDayDto {
    eventScheduleRoomId: number;
    eventScheduleDayId: number | undefined;
    hasActivities: boolean;
    id: number;
}

export class CreateOrEditEventScheduleCalendarDto implements ICreateOrEditEventScheduleCalendarDto {
    roomsDays!: CreateOrEditEventScheduleRoomDayDto[] | undefined;
    id!: number;

    constructor(data?: ICreateOrEditEventScheduleCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["roomsDays"])) {
                this.roomsDays = [] as any;
                for (let item of data["roomsDays"])
                    this.roomsDays!.push(CreateOrEditEventScheduleRoomDayDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditEventScheduleCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditEventScheduleCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roomsDays)) {
            data["roomsDays"] = [];
            for (let item of this.roomsDays)
                data["roomsDays"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditEventScheduleCalendarDto {
    roomsDays: CreateOrEditEventScheduleRoomDayDto[] | undefined;
    id: number;
}

export class EventScheduleDayDto implements IEventScheduleDayDto {
    day!: moment.Moment;
    color!: string | undefined;
    beginHour!: string;
    endHour!: string;
    eventScheduleId!: number;
    hasActivities!: boolean;
    id!: number;

    constructor(data?: IEventScheduleDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? moment(data["day"].toString()) : <any>undefined;
            this.color = data["color"];
            this.beginHour = data["beginHour"];
            this.endHour = data["endHour"];
            this.eventScheduleId = data["eventScheduleId"];
            this.hasActivities = data["hasActivities"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        data["color"] = this.color;
        data["beginHour"] = this.beginHour;
        data["endHour"] = this.endHour;
        data["eventScheduleId"] = this.eventScheduleId;
        data["hasActivities"] = this.hasActivities;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleDayDto {
    day: moment.Moment;
    color: string | undefined;
    beginHour: string;
    endHour: string;
    eventScheduleId: number;
    hasActivities: boolean;
    id: number;
}

export class EventScheduleRoomDto implements IEventScheduleRoomDto {
    description!: string | undefined;
    shortDescription!: string | undefined;
    numberOfVacancies!: number | undefined;
    eventScheduleId!: number;
    hasActivities!: boolean;
    id!: number;

    constructor(data?: IEventScheduleRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.shortDescription = data["shortDescription"];
            this.numberOfVacancies = data["numberOfVacancies"];
            this.eventScheduleId = data["eventScheduleId"];
            this.hasActivities = data["hasActivities"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["shortDescription"] = this.shortDescription;
        data["numberOfVacancies"] = this.numberOfVacancies;
        data["eventScheduleId"] = this.eventScheduleId;
        data["hasActivities"] = this.hasActivities;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleRoomDto {
    description: string | undefined;
    shortDescription: string | undefined;
    numberOfVacancies: number | undefined;
    eventScheduleId: number;
    hasActivities: boolean;
    id: number;
}

export class EventScheduleDto implements IEventScheduleDto {
    description!: string | undefined;
    aboutEvent!: string | undefined;
    eventId!: number | undefined;
    calendarId!: number | undefined;
    event!: EventListDto;
    calendar!: CreateOrEditEventScheduleCalendarDto;
    readonly days!: EventScheduleDayDto[] | undefined;
    readonly rooms!: EventScheduleRoomDto[] | undefined;
    id!: number;

    constructor(data?: IEventScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.aboutEvent = data["aboutEvent"];
            this.eventId = data["eventId"];
            this.calendarId = data["calendarId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.calendar = data["calendar"] ? CreateOrEditEventScheduleCalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (Array.isArray(data["days"])) {
                (<any>this).days = [] as any;
                for (let item of data["days"])
                    (<any>this).days!.push(EventScheduleDayDto.fromJS(item));
            }
            if (Array.isArray(data["rooms"])) {
                (<any>this).rooms = [] as any;
                for (let item of data["rooms"])
                    (<any>this).rooms!.push(EventScheduleRoomDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["aboutEvent"] = this.aboutEvent;
        data["eventId"] = this.eventId;
        data["calendarId"] = this.calendarId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleDto {
    description: string | undefined;
    aboutEvent: string | undefined;
    eventId: number | undefined;
    calendarId: number | undefined;
    event: EventListDto;
    calendar: CreateOrEditEventScheduleCalendarDto;
    days: EventScheduleDayDto[] | undefined;
    rooms: EventScheduleRoomDto[] | undefined;
    id: number;
}

export class GetEventScheduleForViewDto implements IGetEventScheduleForViewDto {
    eventSchedule!: EventScheduleDto;
    eventName!: string | undefined;

    constructor(data?: IGetEventScheduleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSchedule = data["eventSchedule"] ? EventScheduleDto.fromJS(data["eventSchedule"]) : <any>undefined;
            this.eventName = data["eventName"];
        }
    }

    static fromJS(data: any): GetEventScheduleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventScheduleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSchedule"] = this.eventSchedule ? this.eventSchedule.toJSON() : <any>undefined;
        data["eventName"] = this.eventName;
        return data; 
    }
}

export interface IGetEventScheduleForViewDto {
    eventSchedule: EventScheduleDto;
    eventName: string | undefined;
}

export class PagedResultDtoOfGetEventScheduleForViewDto implements IPagedResultDtoOfGetEventScheduleForViewDto {
    totalCount!: number;
    items!: GetEventScheduleForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetEventScheduleForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetEventScheduleForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetEventScheduleForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetEventScheduleForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetEventScheduleForViewDto {
    totalCount: number;
    items: GetEventScheduleForViewDto[] | undefined;
}

export class EventScheduleEventLookupTableDto implements IEventScheduleEventLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IEventScheduleEventLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): EventScheduleEventLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleEventLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IEventScheduleEventLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class GetEventSchedulesInput implements IGetEventSchedulesInput {
    term!: string | undefined;
    eventId!: number | undefined;

    constructor(data?: IGetEventSchedulesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.term = data["term"];
            this.eventId = data["eventId"];
        }
    }

    static fromJS(data: any): GetEventSchedulesInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventSchedulesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["term"] = this.term;
        data["eventId"] = this.eventId;
        return data; 
    }
}

export interface IGetEventSchedulesInput {
    term: string | undefined;
    eventId: number | undefined;
}

export class EventScheduleListDto implements IEventScheduleListDto {
    description!: string | undefined;
    eventName!: string | undefined;
    eventShortName!: string | undefined;
    eventId!: number | undefined;
    id!: number;

    constructor(data?: IEventScheduleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.eventName = data["eventName"];
            this.eventShortName = data["eventShortName"];
            this.eventId = data["eventId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["eventName"] = this.eventName;
        data["eventShortName"] = this.eventShortName;
        data["eventId"] = this.eventId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleListDto {
    description: string | undefined;
    eventName: string | undefined;
    eventShortName: string | undefined;
    eventId: number | undefined;
    id: number;
}

export class UpdateEventScheduleDto implements IUpdateEventScheduleDto {
    description!: string | undefined;
    aboutEvent!: string | undefined;
    eventId!: number | undefined;
    event!: EventListDto;
    calendar!: CreateOrEditEventScheduleCalendarDto;
    days!: EventScheduleDayDto[] | undefined;
    rooms!: EventScheduleRoomDto[] | undefined;
    id!: number;

    constructor(data?: IUpdateEventScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.aboutEvent = data["aboutEvent"];
            this.eventId = data["eventId"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
            this.calendar = data["calendar"] ? CreateOrEditEventScheduleCalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (Array.isArray(data["days"])) {
                this.days = [] as any;
                for (let item of data["days"])
                    this.days!.push(EventScheduleDayDto.fromJS(item));
            }
            if (Array.isArray(data["rooms"])) {
                this.rooms = [] as any;
                for (let item of data["rooms"])
                    this.rooms!.push(EventScheduleRoomDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateEventScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["aboutEvent"] = this.aboutEvent;
        data["eventId"] = this.eventId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateEventScheduleDto {
    description: string | undefined;
    aboutEvent: string | undefined;
    eventId: number | undefined;
    event: EventListDto;
    calendar: CreateOrEditEventScheduleCalendarDto;
    days: EventScheduleDayDto[] | undefined;
    rooms: EventScheduleRoomDto[] | undefined;
    id: number;
}

export class GetEventScheduleForEditOutput implements IGetEventScheduleForEditOutput {
    eventSchedule!: UpdateEventScheduleDto;

    constructor(data?: IGetEventScheduleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventSchedule = data["eventSchedule"] ? UpdateEventScheduleDto.fromJS(data["eventSchedule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEventScheduleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventScheduleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventSchedule"] = this.eventSchedule ? this.eventSchedule.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetEventScheduleForEditOutput {
    eventSchedule: UpdateEventScheduleDto;
}

export class CreateEventScheduleDto implements ICreateEventScheduleDto {
    description!: string | undefined;
    aboutEvent!: string | undefined;
    eventId!: number | undefined;
    days!: EventScheduleDayDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateEventScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.aboutEvent = data["aboutEvent"];
            this.eventId = data["eventId"];
            if (Array.isArray(data["days"])) {
                this.days = [] as any;
                for (let item of data["days"])
                    this.days!.push(EventScheduleDayDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateEventScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["aboutEvent"] = this.aboutEvent;
        data["eventId"] = this.eventId;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateEventScheduleDto {
    description: string | undefined;
    aboutEvent: string | undefined;
    eventId: number | undefined;
    days: EventScheduleDayDto[] | undefined;
    id: number | undefined;
}

export class EventScheduleRoomDayDto implements IEventScheduleRoomDayDto {
    isDeleted!: boolean;
    eventScheduleRoomId!: number;
    eventScheduleRoom!: EventScheduleRoomDto;
    eventScheduleDayId!: number | undefined;
    eventScheduleDay!: EventScheduleDayDto;
    calendarId!: number | undefined;
    activities!: ActivityDto[] | undefined;
    id!: number;

    constructor(data?: IEventScheduleRoomDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDeleted = data["isDeleted"];
            this.eventScheduleRoomId = data["eventScheduleRoomId"];
            this.eventScheduleRoom = data["eventScheduleRoom"] ? EventScheduleRoomDto.fromJS(data["eventScheduleRoom"]) : <any>undefined;
            this.eventScheduleDayId = data["eventScheduleDayId"];
            this.eventScheduleDay = data["eventScheduleDay"] ? EventScheduleDayDto.fromJS(data["eventScheduleDay"]) : <any>undefined;
            this.calendarId = data["calendarId"];
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item of data["activities"])
                    this.activities!.push(ActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EventScheduleRoomDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventScheduleRoomDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDeleted"] = this.isDeleted;
        data["eventScheduleRoomId"] = this.eventScheduleRoomId;
        data["eventScheduleRoom"] = this.eventScheduleRoom ? this.eventScheduleRoom.toJSON() : <any>undefined;
        data["eventScheduleDayId"] = this.eventScheduleDayId;
        data["eventScheduleDay"] = this.eventScheduleDay ? this.eventScheduleDay.toJSON() : <any>undefined;
        data["calendarId"] = this.calendarId;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEventScheduleRoomDayDto {
    isDeleted: boolean;
    eventScheduleRoomId: number;
    eventScheduleRoom: EventScheduleRoomDto;
    eventScheduleDayId: number | undefined;
    eventScheduleDay: EventScheduleDayDto;
    calendarId: number | undefined;
    activities: ActivityDto[] | undefined;
    id: number;
}

export class CalendarDto implements ICalendarDto {
    approved!: boolean;
    publishDate!: moment.Moment | undefined;
    eventScheduleId!: number;
    roomsDays!: EventScheduleRoomDayDto[] | undefined;
    id!: number;

    constructor(data?: ICalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approved = data["approved"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.eventScheduleId = data["eventScheduleId"];
            if (Array.isArray(data["roomsDays"])) {
                this.roomsDays = [] as any;
                for (let item of data["roomsDays"])
                    this.roomsDays!.push(EventScheduleRoomDayDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved"] = this.approved;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["eventScheduleId"] = this.eventScheduleId;
        if (Array.isArray(this.roomsDays)) {
            data["roomsDays"] = [];
            for (let item of this.roomsDays)
                data["roomsDays"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICalendarDto {
    approved: boolean;
    publishDate: moment.Moment | undefined;
    eventScheduleId: number;
    roomsDays: EventScheduleRoomDayDto[] | undefined;
    id: number;
}

export class RoomActivitiesDto implements IRoomActivitiesDto {
    room!: EventScheduleRoomListDto;
    activities!: CreateOrEditActivityDto[] | undefined;
    id!: number;

    constructor(data?: IRoomActivitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.room = data["room"] ? EventScheduleRoomListDto.fromJS(data["room"]) : <any>undefined;
            if (Array.isArray(data["activities"])) {
                this.activities = [] as any;
                for (let item of data["activities"])
                    this.activities!.push(CreateOrEditActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoomActivitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomActivitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["room"] = this.room ? this.room.toJSON() : <any>undefined;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoomActivitiesDto {
    room: EventScheduleRoomListDto;
    activities: CreateOrEditActivityDto[] | undefined;
    id: number;
}

export class CalendarScheduleDto implements ICalendarScheduleDto {
    day!: EventScheduleDayListDto;
    rooms!: RoomActivitiesDto[] | undefined;
    id!: number;

    constructor(data?: ICalendarScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"] ? EventScheduleDayListDto.fromJS(data["day"]) : <any>undefined;
            if (Array.isArray(data["rooms"])) {
                this.rooms = [] as any;
                for (let item of data["rooms"])
                    this.rooms!.push(RoomActivitiesDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CalendarScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toJSON() : <any>undefined;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICalendarScheduleDto {
    day: EventScheduleDayListDto;
    rooms: RoomActivitiesDto[] | undefined;
    id: number;
}

export class GetCalendarForViewDto implements IGetCalendarForViewDto {
    calendar!: CalendarDto;
    roomsDays!: CalendarScheduleDto[] | undefined;

    constructor(data?: IGetCalendarForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendar = data["calendar"] ? CalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (Array.isArray(data["roomsDays"])) {
                this.roomsDays = [] as any;
                for (let item of data["roomsDays"])
                    this.roomsDays!.push(CalendarScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (Array.isArray(this.roomsDays)) {
            data["roomsDays"] = [];
            for (let item of this.roomsDays)
                data["roomsDays"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCalendarForViewDto {
    calendar: CalendarDto;
    roomsDays: CalendarScheduleDto[] | undefined;
}

export class CreateOrEditCalendarDto implements ICreateOrEditCalendarDto {
    approved!: boolean;
    publishDate!: moment.Moment | undefined;
    schedule!: EventScheduleListDto;
    eventScheduleId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.approved = data["approved"];
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.schedule = data["schedule"] ? EventScheduleListDto.fromJS(data["schedule"]) : <any>undefined;
            this.eventScheduleId = data["eventScheduleId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approved"] = this.approved;
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["schedule"] = this.schedule ? this.schedule.toJSON() : <any>undefined;
        data["eventScheduleId"] = this.eventScheduleId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCalendarDto {
    approved: boolean;
    publishDate: moment.Moment | undefined;
    schedule: EventScheduleListDto;
    eventScheduleId: number;
    id: number | undefined;
}

export class GetCalendarForEditOutput implements IGetCalendarForEditOutput {
    calendar!: CreateOrEditCalendarDto;
    schedule!: CalendarScheduleDto[] | undefined;

    constructor(data?: IGetCalendarForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.calendar = data["calendar"] ? CreateOrEditCalendarDto.fromJS(data["calendar"]) : <any>undefined;
            if (Array.isArray(data["schedule"])) {
                this.schedule = [] as any;
                for (let item of data["schedule"])
                    this.schedule!.push(CalendarScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalendarForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalendarForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendar"] = this.calendar ? this.calendar.toJSON() : <any>undefined;
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetCalendarForEditOutput {
    calendar: CreateOrEditCalendarDto;
    schedule: CalendarScheduleDto[] | undefined;
}

export class CreateOrEditCalendarActivityOutput implements ICreateOrEditCalendarActivityOutput {
    blockConflicts!: BlockConfictDto[] | undefined;
    id!: number;

    constructor(data?: ICreateOrEditCalendarActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["blockConflicts"])) {
                this.blockConflicts = [] as any;
                for (let item of data["blockConflicts"])
                    this.blockConflicts!.push(BlockConfictDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCalendarActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCalendarActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blockConflicts)) {
            data["blockConflicts"] = [];
            for (let item of this.blockConflicts)
                data["blockConflicts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCalendarActivityOutput {
    blockConflicts: BlockConfictDto[] | undefined;
    id: number;
}

export class ListResultDtoOfEventScheduleDayListDto implements IListResultDtoOfEventScheduleDayListDto {
    items!: EventScheduleDayListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventScheduleDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventScheduleDayListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventScheduleDayListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventScheduleDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventScheduleDayListDto {
    items: EventScheduleDayListDto[] | undefined;
}

export class ListResultDtoOfEventScheduleRoomListDto implements IListResultDtoOfEventScheduleRoomListDto {
    items!: EventScheduleRoomListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventScheduleRoomListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventScheduleRoomListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventScheduleRoomListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventScheduleRoomListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventScheduleRoomListDto {
    items: EventScheduleRoomListDto[] | undefined;
}

export class ListResultDtoOfEventScheduleRoomDayListDto implements IListResultDtoOfEventScheduleRoomDayListDto {
    items!: EventScheduleRoomDayListDto[] | undefined;

    constructor(data?: IListResultDtoOfEventScheduleRoomDayListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(EventScheduleRoomDayListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEventScheduleRoomDayListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEventScheduleRoomDayListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEventScheduleRoomDayListDto {
    items: EventScheduleRoomDayListDto[] | undefined;
}

export class ExhibitorTypeDto implements IExhibitorTypeDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IExhibitorTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorTypeDto {
    description: string | undefined;
    id: number | undefined;
}

export class UpdateFileInput implements IUpdateFileInput {
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateFileInput {
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export enum ExhibitorFileType {
    Video = 0,
    Document = 1,
}

export class ExhibitorFileDto implements IExhibitorFileDto {
    description!: string | undefined;
    videoUrl!: string | undefined;
    videoThumbImage!: string | undefined;
    videoInput!: UpdateFileInput;
    filePath!: string | undefined;
    fileSize!: number;
    documentInput!: UpdateFileInput;
    fileType!: ExhibitorFileType;
    prescriber!: boolean;
    order!: number;
    exhibitorId!: number;
    id!: number;

    constructor(data?: IExhibitorFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.videoUrl = data["videoUrl"];
            this.videoThumbImage = data["videoThumbImage"];
            this.videoInput = data["videoInput"] ? UpdateFileInput.fromJS(data["videoInput"]) : <any>undefined;
            this.filePath = data["filePath"];
            this.fileSize = data["fileSize"];
            this.documentInput = data["documentInput"] ? UpdateFileInput.fromJS(data["documentInput"]) : <any>undefined;
            this.fileType = data["fileType"];
            this.prescriber = data["prescriber"];
            this.order = data["order"];
            this.exhibitorId = data["exhibitorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["videoUrl"] = this.videoUrl;
        data["videoThumbImage"] = this.videoThumbImage;
        data["videoInput"] = this.videoInput ? this.videoInput.toJSON() : <any>undefined;
        data["filePath"] = this.filePath;
        data["fileSize"] = this.fileSize;
        data["documentInput"] = this.documentInput ? this.documentInput.toJSON() : <any>undefined;
        data["fileType"] = this.fileType;
        data["prescriber"] = this.prescriber;
        data["order"] = this.order;
        data["exhibitorId"] = this.exhibitorId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorFileDto {
    description: string | undefined;
    videoUrl: string | undefined;
    videoThumbImage: string | undefined;
    videoInput: UpdateFileInput;
    filePath: string | undefined;
    fileSize: number;
    documentInput: UpdateFileInput;
    fileType: ExhibitorFileType;
    prescriber: boolean;
    order: number;
    exhibitorId: number;
    id: number;
}

export enum ExhibitorLinkType {
    None = 0,
    InternalLink = 1,
    ExternalLink = 2,
}

export class UpdateBannerInput implements IUpdateBannerInput {
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateBannerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateBannerInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBannerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateBannerInput {
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class ExhibitorBannerDto implements IExhibitorBannerDto {
    description!: string | undefined;
    title!: string | undefined;
    text!: string | undefined;
    linkType!: ExhibitorLinkType;
    internalLink!: string | undefined;
    externalLink!: string | undefined;
    imagePath!: string | undefined;
    order!: number;
    exhibitorId!: number;
    input!: UpdateBannerInput;
    id!: number;

    constructor(data?: IExhibitorBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.title = data["title"];
            this.text = data["text"];
            this.linkType = data["linkType"];
            this.internalLink = data["internalLink"];
            this.externalLink = data["externalLink"];
            this.imagePath = data["imagePath"];
            this.order = data["order"];
            this.exhibitorId = data["exhibitorId"];
            this.input = data["input"] ? UpdateBannerInput.fromJS(data["input"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorBannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorBannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["title"] = this.title;
        data["text"] = this.text;
        data["linkType"] = this.linkType;
        data["internalLink"] = this.internalLink;
        data["externalLink"] = this.externalLink;
        data["imagePath"] = this.imagePath;
        data["order"] = this.order;
        data["exhibitorId"] = this.exhibitorId;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorBannerDto {
    description: string | undefined;
    title: string | undefined;
    text: string | undefined;
    linkType: ExhibitorLinkType;
    internalLink: string | undefined;
    externalLink: string | undefined;
    imagePath: string | undefined;
    order: number;
    exhibitorId: number;
    input: UpdateBannerInput;
    id: number;
}

export class ExhibitorDrawCategoryDto implements IExhibitorDrawCategoryDto {
    categoryId!: number;
    exhibitorId!: number;
    id!: number;

    constructor(data?: IExhibitorDrawCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryId = data["categoryId"];
            this.exhibitorId = data["exhibitorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorDrawCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorDrawCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["exhibitorId"] = this.exhibitorId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorDrawCategoryDto {
    categoryId: number;
    exhibitorId: number;
    id: number;
}

export class ExhibitorSocialNetworkDto implements IExhibitorSocialNetworkDto {
    name!: string | undefined;
    link!: string | undefined;
    exhibitorId!: number;
    id!: number | undefined;

    constructor(data?: IExhibitorSocialNetworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.link = data["link"];
            this.exhibitorId = data["exhibitorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorSocialNetworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorSocialNetworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["link"] = this.link;
        data["exhibitorId"] = this.exhibitorId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorSocialNetworkDto {
    name: string | undefined;
    link: string | undefined;
    exhibitorId: number;
    id: number | undefined;
}

export class ExhibitorDto implements IExhibitorDto {
    isActive!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    order!: number | undefined;
    logoPath!: string | undefined;
    emblemPath!: string | undefined;
    logoListPath!: string | undefined;
    websiteLink!: string | undefined;
    surveyLink!: string | undefined;
    drawLink!: string | undefined;
    contactLink!: string | undefined;
    exhibitorType!: ExhibitorTypeDto;
    eventScheduleId!: number | undefined;
    files!: ExhibitorFileDto[] | undefined;
    banners!: ExhibitorBannerDto[] | undefined;
    drawCategories!: ExhibitorDrawCategoryDto[] | undefined;
    socialNetworks!: ExhibitorSocialNetworkDto[] | undefined;
    id!: number;

    constructor(data?: IExhibitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.description = data["description"];
            this.order = data["order"];
            this.logoPath = data["logoPath"];
            this.emblemPath = data["emblemPath"];
            this.logoListPath = data["logoListPath"];
            this.websiteLink = data["websiteLink"];
            this.surveyLink = data["surveyLink"];
            this.drawLink = data["drawLink"];
            this.contactLink = data["contactLink"];
            this.exhibitorType = data["exhibitorType"] ? ExhibitorTypeDto.fromJS(data["exhibitorType"]) : <any>undefined;
            this.eventScheduleId = data["eventScheduleId"];
            if (Array.isArray(data["files"])) {
                this.files = [] as any;
                for (let item of data["files"])
                    this.files!.push(ExhibitorFileDto.fromJS(item));
            }
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(ExhibitorBannerDto.fromJS(item));
            }
            if (Array.isArray(data["drawCategories"])) {
                this.drawCategories = [] as any;
                for (let item of data["drawCategories"])
                    this.drawCategories!.push(ExhibitorDrawCategoryDto.fromJS(item));
            }
            if (Array.isArray(data["socialNetworks"])) {
                this.socialNetworks = [] as any;
                for (let item of data["socialNetworks"])
                    this.socialNetworks!.push(ExhibitorSocialNetworkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        data["logoPath"] = this.logoPath;
        data["emblemPath"] = this.emblemPath;
        data["logoListPath"] = this.logoListPath;
        data["websiteLink"] = this.websiteLink;
        data["surveyLink"] = this.surveyLink;
        data["drawLink"] = this.drawLink;
        data["contactLink"] = this.contactLink;
        data["exhibitorType"] = this.exhibitorType ? this.exhibitorType.toJSON() : <any>undefined;
        data["eventScheduleId"] = this.eventScheduleId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        if (Array.isArray(this.drawCategories)) {
            data["drawCategories"] = [];
            for (let item of this.drawCategories)
                data["drawCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.socialNetworks)) {
            data["socialNetworks"] = [];
            for (let item of this.socialNetworks)
                data["socialNetworks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorDto {
    isActive: boolean;
    name: string | undefined;
    description: string | undefined;
    order: number | undefined;
    logoPath: string | undefined;
    emblemPath: string | undefined;
    logoListPath: string | undefined;
    websiteLink: string | undefined;
    surveyLink: string | undefined;
    drawLink: string | undefined;
    contactLink: string | undefined;
    exhibitorType: ExhibitorTypeDto;
    eventScheduleId: number | undefined;
    files: ExhibitorFileDto[] | undefined;
    banners: ExhibitorBannerDto[] | undefined;
    drawCategories: ExhibitorDrawCategoryDto[] | undefined;
    socialNetworks: ExhibitorSocialNetworkDto[] | undefined;
    id: number;
}

export class GetExhibitorForViewDto implements IGetExhibitorForViewDto {
    exhibitor!: ExhibitorDto;
    eventScheduleDescription!: string | undefined;
    logo!: string | undefined;
    companyLogoId!: string | undefined;

    constructor(data?: IGetExhibitorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exhibitor = data["exhibitor"] ? ExhibitorDto.fromJS(data["exhibitor"]) : <any>undefined;
            this.eventScheduleDescription = data["eventScheduleDescription"];
            this.logo = data["logo"];
            this.companyLogoId = data["companyLogoId"];
        }
    }

    static fromJS(data: any): GetExhibitorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetExhibitorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exhibitor"] = this.exhibitor ? this.exhibitor.toJSON() : <any>undefined;
        data["eventScheduleDescription"] = this.eventScheduleDescription;
        data["logo"] = this.logo;
        data["companyLogoId"] = this.companyLogoId;
        return data; 
    }
}

export interface IGetExhibitorForViewDto {
    exhibitor: ExhibitorDto;
    eventScheduleDescription: string | undefined;
    logo: string | undefined;
    companyLogoId: string | undefined;
}

export class PagedResultDtoOfGetExhibitorForViewDto implements IPagedResultDtoOfGetExhibitorForViewDto {
    totalCount!: number;
    items!: GetExhibitorForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetExhibitorForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetExhibitorForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetExhibitorForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetExhibitorForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetExhibitorForViewDto {
    totalCount: number;
    items: GetExhibitorForViewDto[] | undefined;
}

export class ExhibitorEventScheduleLookupTableDto implements IExhibitorEventScheduleLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IExhibitorEventScheduleLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): ExhibitorEventScheduleLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorEventScheduleLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IExhibitorEventScheduleLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ListResultDtoOfExhibitorDto implements IListResultDtoOfExhibitorDto {
    items!: ExhibitorDto[] | undefined;

    constructor(data?: IListResultDtoOfExhibitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ExhibitorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfExhibitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfExhibitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfExhibitorDto {
    items: ExhibitorDto[] | undefined;
}

export class CreateOrEditExhibitorDto implements ICreateOrEditExhibitorDto {
    isActive!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    order!: number | undefined;
    logoId!: string | undefined;
    logoPath!: string | undefined;
    emblemPath!: string | undefined;
    logoListPath!: string | undefined;
    websiteLink!: string | undefined;
    surveyLink!: string | undefined;
    surveyImagePath!: string | undefined;
    drawLink!: string | undefined;
    drawImagePath!: string | undefined;
    contactLink!: string | undefined;
    exhibitorType!: ExhibitorTypeDto;
    eventScheduleId!: number | undefined;
    companyId!: number;
    company!: CompanyDto;
    files!: ExhibitorFileDto[] | undefined;
    banners!: ExhibitorBannerDto[] | undefined;
    drawCategories!: ExhibitorDrawCategoryDto[] | undefined;
    socialNetworks!: ExhibitorSocialNetworkDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditExhibitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.description = data["description"];
            this.order = data["order"];
            this.logoId = data["logoId"];
            this.logoPath = data["logoPath"];
            this.emblemPath = data["emblemPath"];
            this.logoListPath = data["logoListPath"];
            this.websiteLink = data["websiteLink"];
            this.surveyLink = data["surveyLink"];
            this.surveyImagePath = data["surveyImagePath"];
            this.drawLink = data["drawLink"];
            this.drawImagePath = data["drawImagePath"];
            this.contactLink = data["contactLink"];
            this.exhibitorType = data["exhibitorType"] ? ExhibitorTypeDto.fromJS(data["exhibitorType"]) : <any>undefined;
            this.eventScheduleId = data["eventScheduleId"];
            this.companyId = data["companyId"];
            this.company = data["company"] ? CompanyDto.fromJS(data["company"]) : <any>undefined;
            if (Array.isArray(data["files"])) {
                this.files = [] as any;
                for (let item of data["files"])
                    this.files!.push(ExhibitorFileDto.fromJS(item));
            }
            if (Array.isArray(data["banners"])) {
                this.banners = [] as any;
                for (let item of data["banners"])
                    this.banners!.push(ExhibitorBannerDto.fromJS(item));
            }
            if (Array.isArray(data["drawCategories"])) {
                this.drawCategories = [] as any;
                for (let item of data["drawCategories"])
                    this.drawCategories!.push(ExhibitorDrawCategoryDto.fromJS(item));
            }
            if (Array.isArray(data["socialNetworks"])) {
                this.socialNetworks = [] as any;
                for (let item of data["socialNetworks"])
                    this.socialNetworks!.push(ExhibitorSocialNetworkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditExhibitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditExhibitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["description"] = this.description;
        data["order"] = this.order;
        data["logoId"] = this.logoId;
        data["logoPath"] = this.logoPath;
        data["emblemPath"] = this.emblemPath;
        data["logoListPath"] = this.logoListPath;
        data["websiteLink"] = this.websiteLink;
        data["surveyLink"] = this.surveyLink;
        data["surveyImagePath"] = this.surveyImagePath;
        data["drawLink"] = this.drawLink;
        data["drawImagePath"] = this.drawImagePath;
        data["contactLink"] = this.contactLink;
        data["exhibitorType"] = this.exhibitorType ? this.exhibitorType.toJSON() : <any>undefined;
        data["eventScheduleId"] = this.eventScheduleId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.banners)) {
            data["banners"] = [];
            for (let item of this.banners)
                data["banners"].push(item.toJSON());
        }
        if (Array.isArray(this.drawCategories)) {
            data["drawCategories"] = [];
            for (let item of this.drawCategories)
                data["drawCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.socialNetworks)) {
            data["socialNetworks"] = [];
            for (let item of this.socialNetworks)
                data["socialNetworks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditExhibitorDto {
    isActive: boolean;
    name: string | undefined;
    description: string | undefined;
    order: number | undefined;
    logoId: string | undefined;
    logoPath: string | undefined;
    emblemPath: string | undefined;
    logoListPath: string | undefined;
    websiteLink: string | undefined;
    surveyLink: string | undefined;
    surveyImagePath: string | undefined;
    drawLink: string | undefined;
    drawImagePath: string | undefined;
    contactLink: string | undefined;
    exhibitorType: ExhibitorTypeDto;
    eventScheduleId: number | undefined;
    companyId: number;
    company: CompanyDto;
    files: ExhibitorFileDto[] | undefined;
    banners: ExhibitorBannerDto[] | undefined;
    drawCategories: ExhibitorDrawCategoryDto[] | undefined;
    socialNetworks: ExhibitorSocialNetworkDto[] | undefined;
    id: number | undefined;
}

export class GetExhibitorForEditOutput implements IGetExhibitorForEditOutput {
    exhibitor!: CreateOrEditExhibitorDto;
    eventScheduleDescription!: string | undefined;

    constructor(data?: IGetExhibitorForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exhibitor = data["exhibitor"] ? CreateOrEditExhibitorDto.fromJS(data["exhibitor"]) : <any>undefined;
            this.eventScheduleDescription = data["eventScheduleDescription"];
        }
    }

    static fromJS(data: any): GetExhibitorForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExhibitorForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exhibitor"] = this.exhibitor ? this.exhibitor.toJSON() : <any>undefined;
        data["eventScheduleDescription"] = this.eventScheduleDescription;
        return data; 
    }
}

export interface IGetExhibitorForEditOutput {
    exhibitor: CreateOrEditExhibitorDto;
    eventScheduleDescription: string | undefined;
}

export class UpdateExhibitorLogoInput implements IUpdateExhibitorLogoInput {
    exhibitoId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateExhibitorLogoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.exhibitoId = data["exhibitoId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateExhibitorLogoInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExhibitorLogoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exhibitoId"] = this.exhibitoId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateExhibitorLogoInput {
    exhibitoId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class UpdateExhibitorOrder implements IUpdateExhibitorOrder {
    order!: number;
    id!: number;

    constructor(data?: IUpdateExhibitorOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateExhibitorOrder {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExhibitorOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateExhibitorOrder {
    order: number;
    id: number;
}

export class UpdateExhibitorOrderInput implements IUpdateExhibitorOrderInput {
    exhibitors!: UpdateExhibitorOrder[] | undefined;

    constructor(data?: IUpdateExhibitorOrderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["exhibitors"])) {
                this.exhibitors = [] as any;
                for (let item of data["exhibitors"])
                    this.exhibitors!.push(UpdateExhibitorOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateExhibitorOrderInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExhibitorOrderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exhibitors)) {
            data["exhibitors"] = [];
            for (let item of this.exhibitors)
                data["exhibitors"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateExhibitorOrderInput {
    exhibitors: UpdateExhibitorOrder[] | undefined;
}

export class ExhibitorTypeListDto implements IExhibitorTypeListDto {
    description!: string | undefined;
    id!: number | undefined;

    constructor(data?: IExhibitorTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExhibitorTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExhibitorTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExhibitorTypeListDto {
    description: string | undefined;
    id: number | undefined;
}

export class ListResultDtoOfExhibitorTypeListDto implements IListResultDtoOfExhibitorTypeListDto {
    items!: ExhibitorTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfExhibitorTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ExhibitorTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfExhibitorTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfExhibitorTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfExhibitorTypeListDto {
    items: ExhibitorTypeListDto[] | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string | undefined;
    userName: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class GetGuestForViewDto implements IGetGuestForViewDto {
    guest!: GuestDto;
    userName!: string | undefined;

    constructor(data?: IGetGuestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guest = data["guest"] ? GuestDto.fromJS(data["guest"]) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetGuestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IGetGuestForViewDto {
    guest: GuestDto;
    userName: string | undefined;
}

export class PagedResultDtoOfGetGuestForViewDto implements IPagedResultDtoOfGetGuestForViewDto {
    totalCount!: number;
    items!: GetGuestForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetGuestForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetGuestForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetGuestForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetGuestForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetGuestForViewDto {
    totalCount: number;
    items: GetGuestForViewDto[] | undefined;
}

export class GuestUserLookupTableDto implements IGuestUserLookupTableDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IGuestUserLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): GuestUserLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestUserLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IGuestUserLookupTableDto {
    id: number;
    displayName: string | undefined;
}

export class ListResultDtoOfGuestDto implements IListResultDtoOfGuestDto {
    items!: GuestDto[] | undefined;

    constructor(data?: IListResultDtoOfGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GuestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGuestDto {
    items: GuestDto[] | undefined;
}

export class GuestListDto implements IGuestListDto {
    cpf!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    userId!: number | undefined;
    picture!: string | undefined;
    numberOfParticipations!: number;
    invitationStatus!: string | undefined;
    user!: UserListDto;
    id!: number;

    constructor(data?: IGuestListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.name = data["name"];
            this.email = data["email"];
            this.userId = data["userId"];
            this.picture = data["picture"];
            this.numberOfParticipations = data["numberOfParticipations"];
            this.invitationStatus = data["invitationStatus"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GuestListDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["name"] = this.name;
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["picture"] = this.picture;
        data["numberOfParticipations"] = this.numberOfParticipations;
        data["invitationStatus"] = this.invitationStatus;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGuestListDto {
    cpf: string | undefined;
    name: string | undefined;
    email: string | undefined;
    userId: number | undefined;
    picture: string | undefined;
    numberOfParticipations: number;
    invitationStatus: string | undefined;
    user: UserListDto;
    id: number;
}

export class ListResultDtoOfGuestListDto implements IListResultDtoOfGuestListDto {
    items!: GuestListDto[] | undefined;

    constructor(data?: IListResultDtoOfGuestListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GuestListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGuestListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGuestListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGuestListDto {
    items: GuestListDto[] | undefined;
}

export class GetGuestForEditOutput implements IGetGuestForEditOutput {
    guest!: CreateOrEditGuestDto;
    userName!: string | undefined;

    constructor(data?: IGetGuestForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guest = data["guest"] ? CreateOrEditGuestDto.fromJS(data["guest"]) : <any>undefined;
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): GetGuestForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuestForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IGetGuestForEditOutput {
    guest: CreateOrEditGuestDto;
    userName: string | undefined;
}

export class GuestScheduleDto implements IGuestScheduleDto {
    guest!: CreateOrEditGuestDto;
    calendarActivities!: GetActivityForViewDto[] | undefined;

    constructor(data?: IGuestScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.guest = data["guest"] ? CreateOrEditGuestDto.fromJS(data["guest"]) : <any>undefined;
            if (Array.isArray(data["calendarActivities"])) {
                this.calendarActivities = [] as any;
                for (let item of data["calendarActivities"])
                    this.calendarActivities!.push(GetActivityForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuestScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guest"] = this.guest ? this.guest.toJSON() : <any>undefined;
        if (Array.isArray(this.calendarActivities)) {
            data["calendarActivities"] = [];
            for (let item of this.calendarActivities)
                data["calendarActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGuestScheduleDto {
    guest: CreateOrEditGuestDto;
    calendarActivities: GetActivityForViewDto[] | undefined;
}

export class SendSchedulesDto implements ISendSchedulesDto {
    ids!: number[] | undefined;

    constructor(data?: ISendSchedulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["ids"])) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): SendSchedulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendSchedulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface ISendSchedulesDto {
    ids: number[] | undefined;
}

export class ListResultDtoOfGuestRoleDto implements IListResultDtoOfGuestRoleDto {
    items!: GuestRoleDto[] | undefined;

    constructor(data?: IListResultDtoOfGuestRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GuestRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGuestRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfGuestRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGuestRoleDto {
    items: GuestRoleDto[] | undefined;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data; 
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: moment.Moment;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenants!: RecentTenant[] | undefined;
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: moment.Moment;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetRecentTenantsOutput {
    recentTenants: RecentTenant[] | undefined;
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: moment.Moment;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data; 
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: moment.Moment;
    subscriptionEndDateEnd!: moment.Moment;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
}

export enum ChartDateInterval {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: moment.Moment;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: moment.Moment;
    amount: number;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.timeOutSecond = data["timeOutSecond"];
            this.showTimeOutNotificationSecond = data["showTimeOutNotificationSecond"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        return data; 
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = data["useCaptchaOnLogin"];
            this.sessionTimeOutSettings = data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;
    footer!: string | undefined;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
            this.footer = data["footer"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        data["footer"] = this.footer;
        return data; 
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
    footer: string | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data; 
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting;
    defaultPasswordComplexity!: PasswordComplexitySetting;
    userLockOut!: UserLockOutSettingsEditDto;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowOneConcurrentLoginPerUser = data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data; 
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto;
    otherSettings!: OtherSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
            this.otherSettings = data["otherSettings"] ? OtherSettingsEditDto.fromJS(data["otherSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
    otherSettings: OtherSettingsEditDto;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string | undefined;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendTestEmailInput {
    emailAddress: string | undefined;
}

export enum BannerType {
    EventInformations = 0,
    File = 1,
}

export class HotsiteEventDto implements IHotsiteEventDto {
    name!: string | undefined;
    shortName!: string | undefined;
    description!: string | undefined;
    terms!: string | undefined;
    receivableByCoupon!: boolean;
    scientificSchedule!: string | undefined;
    numberOfPlaces!: number;
    isPublished!: boolean;
    logoId!: string | undefined;
    logo!: string | undefined;
    tenantId!: number;
    type!: EventTypeDto;
    place!: EventPlaceDto;
    policies!: EventPolicyDto[] | undefined;
    days!: EventDayDto[] | undefined;
    deadlines!: EventDeadlineDto[] | undefined;
    cnaScores!: EventCnaScoreDto[] | undefined;
    extraFees!: EventExtraFeeDto[] | undefined;
    paymentMethods!: PaymentMethodPermissionDto[] | undefined;
    id!: number;

    constructor(data?: IHotsiteEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.shortName = data["shortName"];
            this.description = data["description"];
            this.terms = data["terms"];
            this.receivableByCoupon = data["receivableByCoupon"];
            this.scientificSchedule = data["scientificSchedule"];
            this.numberOfPlaces = data["numberOfPlaces"];
            this.isPublished = data["isPublished"];
            this.logoId = data["logoId"];
            this.logo = data["logo"];
            this.tenantId = data["tenantId"];
            this.type = data["type"] ? EventTypeDto.fromJS(data["type"]) : <any>undefined;
            this.place = data["place"] ? EventPlaceDto.fromJS(data["place"]) : <any>undefined;
            if (Array.isArray(data["policies"])) {
                this.policies = [] as any;
                for (let item of data["policies"])
                    this.policies!.push(EventPolicyDto.fromJS(item));
            }
            if (Array.isArray(data["days"])) {
                this.days = [] as any;
                for (let item of data["days"])
                    this.days!.push(EventDayDto.fromJS(item));
            }
            if (Array.isArray(data["deadlines"])) {
                this.deadlines = [] as any;
                for (let item of data["deadlines"])
                    this.deadlines!.push(EventDeadlineDto.fromJS(item));
            }
            if (Array.isArray(data["cnaScores"])) {
                this.cnaScores = [] as any;
                for (let item of data["cnaScores"])
                    this.cnaScores!.push(EventCnaScoreDto.fromJS(item));
            }
            if (Array.isArray(data["extraFees"])) {
                this.extraFees = [] as any;
                for (let item of data["extraFees"])
                    this.extraFees!.push(EventExtraFeeDto.fromJS(item));
            }
            if (Array.isArray(data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodPermissionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HotsiteEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["terms"] = this.terms;
        data["receivableByCoupon"] = this.receivableByCoupon;
        data["scientificSchedule"] = this.scientificSchedule;
        data["numberOfPlaces"] = this.numberOfPlaces;
        data["isPublished"] = this.isPublished;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        if (Array.isArray(this.policies)) {
            data["policies"] = [];
            for (let item of this.policies)
                data["policies"].push(item.toJSON());
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        if (Array.isArray(this.deadlines)) {
            data["deadlines"] = [];
            for (let item of this.deadlines)
                data["deadlines"].push(item.toJSON());
        }
        if (Array.isArray(this.cnaScores)) {
            data["cnaScores"] = [];
            for (let item of this.cnaScores)
                data["cnaScores"].push(item.toJSON());
        }
        if (Array.isArray(this.extraFees)) {
            data["extraFees"] = [];
            for (let item of this.extraFees)
                data["extraFees"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IHotsiteEventDto {
    name: string | undefined;
    shortName: string | undefined;
    description: string | undefined;
    terms: string | undefined;
    receivableByCoupon: boolean;
    scientificSchedule: string | undefined;
    numberOfPlaces: number;
    isPublished: boolean;
    logoId: string | undefined;
    logo: string | undefined;
    tenantId: number;
    type: EventTypeDto;
    place: EventPlaceDto;
    policies: EventPolicyDto[] | undefined;
    days: EventDayDto[] | undefined;
    deadlines: EventDeadlineDto[] | undefined;
    cnaScores: EventCnaScoreDto[] | undefined;
    extraFees: EventExtraFeeDto[] | undefined;
    paymentMethods: PaymentMethodPermissionDto[] | undefined;
    id: number;
}

export enum TargetType {
    Self = 0,
    Blank = 1,
}

export class UpdatePhotoInput implements IUpdatePhotoInput {
    photoId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdatePhotoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.photoId = data["photoId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdatePhotoInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhotoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoId"] = this.photoId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdatePhotoInput {
    photoId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditPhotoDto implements ICreateOrEditPhotoDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    path!: string | undefined;
    link!: string | undefined;
    targetType!: TargetType;
    photoId!: string | undefined;
    fileName!: string | undefined;
    fileExtension!: string | undefined;
    photo!: string | undefined;
    input!: UpdatePhotoInput;
    order!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.path = data["path"];
            this.link = data["link"];
            this.targetType = data["targetType"];
            this.photoId = data["photoId"];
            this.fileName = data["fileName"];
            this.fileExtension = data["fileExtension"];
            this.photo = data["photo"];
            this.input = data["input"] ? UpdatePhotoInput.fromJS(data["input"]) : <any>undefined;
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["path"] = this.path;
        data["link"] = this.link;
        data["targetType"] = this.targetType;
        data["photoId"] = this.photoId;
        data["fileName"] = this.fileName;
        data["fileExtension"] = this.fileExtension;
        data["photo"] = this.photo;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPhotoDto {
    title: string | undefined;
    subtitle: string | undefined;
    path: string | undefined;
    link: string | undefined;
    targetType: TargetType;
    photoId: string | undefined;
    fileName: string | undefined;
    fileExtension: string | undefined;
    photo: string | undefined;
    input: UpdatePhotoInput;
    order: number;
    id: number | undefined;
}

export class HomeSectionDto implements IHomeSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    externalLink!: string | undefined;
    bannerBgColor!: string | undefined;
    bannerType!: BannerType;
    delayAutoplay!: number | undefined;
    hotsiteId!: number;
    event!: HotsiteEventDto;
    images!: CreateOrEditPhotoDto[] | undefined;
    id!: number;

    constructor(data?: IHomeSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.bannerBgColor = data["bannerBgColor"];
            this.bannerType = data["bannerType"];
            this.delayAutoplay = data["delayAutoplay"];
            this.hotsiteId = data["hotsiteId"];
            this.event = data["event"] ? HotsiteEventDto.fromJS(data["event"]) : <any>undefined;
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(CreateOrEditPhotoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HomeSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new HomeSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["bannerBgColor"] = this.bannerBgColor;
        data["bannerType"] = this.bannerType;
        data["delayAutoplay"] = this.delayAutoplay;
        data["hotsiteId"] = this.hotsiteId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IHomeSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    externalLink: string | undefined;
    bannerBgColor: string | undefined;
    bannerType: BannerType;
    delayAutoplay: number | undefined;
    hotsiteId: number;
    event: HotsiteEventDto;
    images: CreateOrEditPhotoDto[] | undefined;
    id: number;
}

export class PhotoDto implements IPhotoDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    text!: string | undefined;
    photoId!: string | undefined;
    photo!: string | undefined;
    order!: number;
    id!: number;

    constructor(data?: IPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.text = data["text"];
            this.photoId = data["photoId"];
            this.photo = data["photo"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["text"] = this.text;
        data["photoId"] = this.photoId;
        data["photo"] = this.photo;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPhotoDto {
    title: string | undefined;
    subtitle: string | undefined;
    text: string | undefined;
    photoId: string | undefined;
    photo: string | undefined;
    order: number;
    id: number;
}

export class ImageGalleryDto implements IImageGalleryDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    isActive!: boolean;
    order!: number;
    aboutEventId!: number;
    images!: PhotoDto[] | undefined;
    id!: number;

    constructor(data?: IImageGalleryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.isActive = data["isActive"];
            this.order = data["order"];
            this.aboutEventId = data["aboutEventId"];
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(PhotoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ImageGalleryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageGalleryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        data["aboutEventId"] = this.aboutEventId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IImageGalleryDto {
    title: string | undefined;
    subtitle: string | undefined;
    isActive: boolean;
    order: number;
    aboutEventId: number;
    images: PhotoDto[] | undefined;
    id: number;
}

export class AboutEventSectionDto implements IAboutEventSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    gallery!: ImageGalleryDto;
    hotsiteId!: number;
    id!: number;

    constructor(data?: IAboutEventSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.gallery = data["gallery"] ? ImageGalleryDto.fromJS(data["gallery"]) : <any>undefined;
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AboutEventSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutEventSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["gallery"] = this.gallery ? this.gallery.toJSON() : <any>undefined;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAboutEventSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    gallery: ImageGalleryDto;
    hotsiteId: number;
    id: number;
}

export class CertificateSectionDto implements ICertificateSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    externalLink!: string | undefined;
    text!: string | undefined;
    enableCertificate!: boolean;
    hotsiteId!: number;
    id!: number;

    constructor(data?: ICertificateSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.text = data["text"];
            this.enableCertificate = data["enableCertificate"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["text"] = this.text;
        data["enableCertificate"] = this.enableCertificate;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICertificateSectionDto {
    isActive: boolean;
    name: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    externalLink: string | undefined;
    text: string | undefined;
    enableCertificate: boolean;
    hotsiteId: number;
    id: number;
}

export class RegistrationSectionDto implements IRegistrationSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    externalLink!: string | undefined;
    text!: string | undefined;
    showDeadlineTable!: boolean;
    showCnaTable!: boolean;
    hotsiteId!: number;
    event!: HotsiteEventDto;
    categories!: CategoryListDto[] | undefined;
    id!: number;

    constructor(data?: IRegistrationSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.text = data["text"];
            this.showDeadlineTable = data["showDeadlineTable"];
            this.showCnaTable = data["showCnaTable"];
            this.hotsiteId = data["hotsiteId"];
            this.event = data["event"] ? HotsiteEventDto.fromJS(data["event"]) : <any>undefined;
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(CategoryListDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["text"] = this.text;
        data["showDeadlineTable"] = this.showDeadlineTable;
        data["showCnaTable"] = this.showCnaTable;
        data["hotsiteId"] = this.hotsiteId;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegistrationSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    externalLink: string | undefined;
    text: string | undefined;
    showDeadlineTable: boolean;
    showCnaTable: boolean;
    hotsiteId: number;
    event: HotsiteEventDto;
    categories: CategoryListDto[] | undefined;
    id: number;
}

export enum ScientificProgramType {
    Text = 0,
    File = 1,
}

export class ScientificProgramSectionDto implements IScientificProgramSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    externalLink!: string | undefined;
    text!: string | undefined;
    target!: TargetType;
    pageDescription!: string | undefined;
    programFileId!: string | undefined;
    programFileExtension!: string | undefined;
    programFileName!: string | undefined;
    programFile!: string | undefined;
    scientificProgramType!: ScientificProgramType;
    hotsiteId!: number;
    id!: number;

    constructor(data?: IScientificProgramSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.text = data["text"];
            this.target = data["target"];
            this.pageDescription = data["pageDescription"];
            this.programFileId = data["programFileId"];
            this.programFileExtension = data["programFileExtension"];
            this.programFileName = data["programFileName"];
            this.programFile = data["programFile"];
            this.scientificProgramType = data["scientificProgramType"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ScientificProgramSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScientificProgramSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["text"] = this.text;
        data["target"] = this.target;
        data["pageDescription"] = this.pageDescription;
        data["programFileId"] = this.programFileId;
        data["programFileExtension"] = this.programFileExtension;
        data["programFileName"] = this.programFileName;
        data["programFile"] = this.programFile;
        data["scientificProgramType"] = this.scientificProgramType;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IScientificProgramSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    externalLink: string | undefined;
    text: string | undefined;
    target: TargetType;
    pageDescription: string | undefined;
    programFileId: string | undefined;
    programFileExtension: string | undefined;
    programFileName: string | undefined;
    programFile: string | undefined;
    scientificProgramType: ScientificProgramType;
    hotsiteId: number;
    id: number;
}

export class ContactSectionAddressDto implements IContactSectionAddressDto {
    contactSectionId!: number;
    logradour!: string | undefined;
    number!: string | undefined;
    complement!: string | undefined;
    district!: string | undefined;
    zipCode!: string | undefined;
    city!: string | undefined;
    stateAbbreviation!: string | undefined;
    stateName!: string | undefined;
    countryName!: string | undefined;
    isMailing!: boolean;
    type!: AddressType;
    id!: number | undefined;

    constructor(data?: IContactSectionAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactSectionId = data["contactSectionId"];
            this.logradour = data["logradour"];
            this.number = data["number"];
            this.complement = data["complement"];
            this.district = data["district"];
            this.zipCode = data["zipCode"];
            this.city = data["city"];
            this.stateAbbreviation = data["stateAbbreviation"];
            this.stateName = data["stateName"];
            this.countryName = data["countryName"];
            this.isMailing = data["isMailing"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactSectionAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSectionAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactSectionId"] = this.contactSectionId;
        data["logradour"] = this.logradour;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["district"] = this.district;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["stateAbbreviation"] = this.stateAbbreviation;
        data["stateName"] = this.stateName;
        data["countryName"] = this.countryName;
        data["isMailing"] = this.isMailing;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactSectionAddressDto {
    contactSectionId: number;
    logradour: string | undefined;
    number: string | undefined;
    complement: string | undefined;
    district: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    stateAbbreviation: string | undefined;
    stateName: string | undefined;
    countryName: string | undefined;
    isMailing: boolean;
    type: AddressType;
    id: number | undefined;
}

export class ContactSectionEmailDto implements IContactSectionEmailDto {
    support!: boolean;
    showInTheSite!: boolean;
    contactSectionId!: number;
    emailAddress!: string | undefined;
    id!: number | undefined;

    constructor(data?: IContactSectionEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.support = data["support"];
            this.showInTheSite = data["showInTheSite"];
            this.contactSectionId = data["contactSectionId"];
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactSectionEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSectionEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["support"] = this.support;
        data["showInTheSite"] = this.showInTheSite;
        data["contactSectionId"] = this.contactSectionId;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactSectionEmailDto {
    support: boolean;
    showInTheSite: boolean;
    contactSectionId: number;
    emailAddress: string | undefined;
    id: number | undefined;
}

export class ContactSectionPhoneDto implements IContactSectionPhoneDto {
    contactSectionId!: number;
    ddi!: string | undefined;
    ddd!: string | undefined;
    number!: string | undefined;
    type!: PhoneType;
    id!: number | undefined;

    constructor(data?: IContactSectionPhoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactSectionId = data["contactSectionId"];
            this.ddi = data["ddi"];
            this.ddd = data["ddd"];
            this.number = data["number"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactSectionPhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSectionPhoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactSectionId"] = this.contactSectionId;
        data["ddi"] = this.ddi;
        data["ddd"] = this.ddd;
        data["number"] = this.number;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactSectionPhoneDto {
    contactSectionId: number;
    ddi: string | undefined;
    ddd: string | undefined;
    number: string | undefined;
    type: PhoneType;
    id: number | undefined;
}

export enum SocialNetworkName {
    Facebook = 0,
    Twitter = 1,
    YouTube = 2,
    Instagram = 3,
    LinkedIn = 4,
}

export class SocialNetworkDto implements ISocialNetworkDto {
    name!: SocialNetworkName;
    link!: string | undefined;
    contactSectionId!: number;
    id!: number;

    constructor(data?: ISocialNetworkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.link = data["link"];
            this.contactSectionId = data["contactSectionId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SocialNetworkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialNetworkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["link"] = this.link;
        data["contactSectionId"] = this.contactSectionId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISocialNetworkDto {
    name: SocialNetworkName;
    link: string | undefined;
    contactSectionId: number;
    id: number;
}

export class ContactSectionDto implements IContactSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    externalLink!: string | undefined;
    text!: string | undefined;
    hotsiteId!: number;
    address!: ContactSectionAddressDto;
    emails!: ContactSectionEmailDto[] | undefined;
    phones!: ContactSectionPhoneDto[] | undefined;
    socialNetworks!: SocialNetworkDto[] | undefined;
    id!: number;

    constructor(data?: IContactSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.text = data["text"];
            this.hotsiteId = data["hotsiteId"];
            this.address = data["address"] ? ContactSectionAddressDto.fromJS(data["address"]) : <any>undefined;
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(ContactSectionEmailDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(ContactSectionPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["socialNetworks"])) {
                this.socialNetworks = [] as any;
                for (let item of data["socialNetworks"])
                    this.socialNetworks!.push(SocialNetworkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["text"] = this.text;
        data["hotsiteId"] = this.hotsiteId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.socialNetworks)) {
            data["socialNetworks"] = [];
            for (let item of this.socialNetworks)
                data["socialNetworks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    externalLink: string | undefined;
    text: string | undefined;
    hotsiteId: number;
    address: ContactSectionAddressDto;
    emails: ContactSectionEmailDto[] | undefined;
    phones: ContactSectionPhoneDto[] | undefined;
    socialNetworks: SocialNetworkDto[] | undefined;
    id: number;
}

export class LocalizationSectionDto implements ILocalizationSectionDto {
    placeType!: EventPlaceType;
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    regionTipsFileId!: string | undefined;
    regionTipsFileExtension!: string | undefined;
    regionTipsFileName!: string | undefined;
    regionTipsFile!: string | undefined;
    googleMapsConfig!: string | undefined;
    hotsiteId!: number;
    id!: number;

    constructor(data?: ILocalizationSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.placeType = data["placeType"];
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.regionTipsFileId = data["regionTipsFileId"];
            this.regionTipsFileExtension = data["regionTipsFileExtension"];
            this.regionTipsFileName = data["regionTipsFileName"];
            this.regionTipsFile = data["regionTipsFile"];
            this.googleMapsConfig = data["googleMapsConfig"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LocalizationSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizationSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeType"] = this.placeType;
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["regionTipsFileId"] = this.regionTipsFileId;
        data["regionTipsFileExtension"] = this.regionTipsFileExtension;
        data["regionTipsFileName"] = this.regionTipsFileName;
        data["regionTipsFile"] = this.regionTipsFile;
        data["googleMapsConfig"] = this.googleMapsConfig;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILocalizationSectionDto {
    placeType: EventPlaceType;
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    regionTipsFileId: string | undefined;
    regionTipsFileExtension: string | undefined;
    regionTipsFileName: string | undefined;
    regionTipsFile: string | undefined;
    googleMapsConfig: string | undefined;
    hotsiteId: number;
    id: number;
}

export class TravelAgencyDto implements ITravelAgencyDto {
    name!: string | undefined;
    description!: string | undefined;
    link!: string | undefined;
    travelAgencySectionId!: number;
    id!: number;

    constructor(data?: ITravelAgencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.link = data["link"];
            this.travelAgencySectionId = data["travelAgencySectionId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TravelAgencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelAgencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["link"] = this.link;
        data["travelAgencySectionId"] = this.travelAgencySectionId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITravelAgencyDto {
    name: string | undefined;
    description: string | undefined;
    link: string | undefined;
    travelAgencySectionId: number;
    id: number;
}

export class TravelAgencySectionDto implements ITravelAgencySectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    externalLink!: string | undefined;
    hotsiteId!: number;
    agencies!: TravelAgencyDto[] | undefined;
    id!: number;

    constructor(data?: ITravelAgencySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.hotsiteId = data["hotsiteId"];
            if (Array.isArray(data["agencies"])) {
                this.agencies = [] as any;
                for (let item of data["agencies"])
                    this.agencies!.push(TravelAgencyDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TravelAgencySectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TravelAgencySectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["hotsiteId"] = this.hotsiteId;
        if (Array.isArray(this.agencies)) {
            data["agencies"] = [];
            for (let item of this.agencies)
                data["agencies"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITravelAgencySectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    externalLink: string | undefined;
    hotsiteId: number;
    agencies: TravelAgencyDto[] | undefined;
    id: number;
}

export class SponsorDto implements ISponsorDto {
    order!: number;
    sponsorTypeId!: number;
    companyId!: number;
    company!: CompanyDto;
    id!: number;

    constructor(data?: ISponsorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"];
            this.sponsorTypeId = data["sponsorTypeId"];
            this.companyId = data["companyId"];
            this.company = data["company"] ? CompanyDto.fromJS(data["company"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SponsorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["sponsorTypeId"] = this.sponsorTypeId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISponsorDto {
    order: number;
    sponsorTypeId: number;
    companyId: number;
    company: CompanyDto;
    id: number;
}

export class ContactDto implements IContactDto {
    name!: string | undefined;
    phone!: string | undefined;
    emailAddress!: string | undefined;
    message!: string | undefined;
    hotsiteId!: number;
    id!: number;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.message = data["message"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["message"] = this.message;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IContactDto {
    name: string | undefined;
    phone: string | undefined;
    emailAddress: string | undefined;
    message: string | undefined;
    hotsiteId: number;
    id: number;
}

export class HotsiteDto implements IHotsiteDto {
    isDefault!: boolean;
    isPublished!: boolean;
    homeSection!: HomeSectionDto;
    aboutEventSection!: AboutEventSectionDto;
    certificateSection!: CertificateSectionDto;
    registrationSection!: RegistrationSectionDto;
    scientificProgramSection!: ScientificProgramSectionDto;
    contactSection!: ContactSectionDto;
    localizationSection!: LocalizationSectionDto;
    travelAgencySection!: TravelAgencySectionDto;
    friendlyUrl!: string | undefined;
    eventId!: number;
    logoId!: string | undefined;
    logo!: string | undefined;
    event!: HotsiteEventDto;
    sponsors!: SponsorDto[] | undefined;
    contacts!: ContactDto[] | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IHotsiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDefault = data["isDefault"];
            this.isPublished = data["isPublished"];
            this.homeSection = data["homeSection"] ? HomeSectionDto.fromJS(data["homeSection"]) : <any>undefined;
            this.aboutEventSection = data["aboutEventSection"] ? AboutEventSectionDto.fromJS(data["aboutEventSection"]) : <any>undefined;
            this.certificateSection = data["certificateSection"] ? CertificateSectionDto.fromJS(data["certificateSection"]) : <any>undefined;
            this.registrationSection = data["registrationSection"] ? RegistrationSectionDto.fromJS(data["registrationSection"]) : <any>undefined;
            this.scientificProgramSection = data["scientificProgramSection"] ? ScientificProgramSectionDto.fromJS(data["scientificProgramSection"]) : <any>undefined;
            this.contactSection = data["contactSection"] ? ContactSectionDto.fromJS(data["contactSection"]) : <any>undefined;
            this.localizationSection = data["localizationSection"] ? LocalizationSectionDto.fromJS(data["localizationSection"]) : <any>undefined;
            this.travelAgencySection = data["travelAgencySection"] ? TravelAgencySectionDto.fromJS(data["travelAgencySection"]) : <any>undefined;
            this.friendlyUrl = data["friendlyUrl"];
            this.eventId = data["eventId"];
            this.logoId = data["logoId"];
            this.logo = data["logo"];
            this.event = data["event"] ? HotsiteEventDto.fromJS(data["event"]) : <any>undefined;
            if (Array.isArray(data["sponsors"])) {
                this.sponsors = [] as any;
                for (let item of data["sponsors"])
                    this.sponsors!.push(SponsorDto.fromJS(item));
            }
            if (Array.isArray(data["contacts"])) {
                this.contacts = [] as any;
                for (let item of data["contacts"])
                    this.contacts!.push(ContactDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HotsiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDefault"] = this.isDefault;
        data["isPublished"] = this.isPublished;
        data["homeSection"] = this.homeSection ? this.homeSection.toJSON() : <any>undefined;
        data["aboutEventSection"] = this.aboutEventSection ? this.aboutEventSection.toJSON() : <any>undefined;
        data["certificateSection"] = this.certificateSection ? this.certificateSection.toJSON() : <any>undefined;
        data["registrationSection"] = this.registrationSection ? this.registrationSection.toJSON() : <any>undefined;
        data["scientificProgramSection"] = this.scientificProgramSection ? this.scientificProgramSection.toJSON() : <any>undefined;
        data["contactSection"] = this.contactSection ? this.contactSection.toJSON() : <any>undefined;
        data["localizationSection"] = this.localizationSection ? this.localizationSection.toJSON() : <any>undefined;
        data["travelAgencySection"] = this.travelAgencySection ? this.travelAgencySection.toJSON() : <any>undefined;
        data["friendlyUrl"] = this.friendlyUrl;
        data["eventId"] = this.eventId;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        if (Array.isArray(this.sponsors)) {
            data["sponsors"] = [];
            for (let item of this.sponsors)
                data["sponsors"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHotsiteDto {
    isDefault: boolean;
    isPublished: boolean;
    homeSection: HomeSectionDto;
    aboutEventSection: AboutEventSectionDto;
    certificateSection: CertificateSectionDto;
    registrationSection: RegistrationSectionDto;
    scientificProgramSection: ScientificProgramSectionDto;
    contactSection: ContactSectionDto;
    localizationSection: LocalizationSectionDto;
    travelAgencySection: TravelAgencySectionDto;
    friendlyUrl: string | undefined;
    eventId: number;
    logoId: string | undefined;
    logo: string | undefined;
    event: HotsiteEventDto;
    sponsors: SponsorDto[] | undefined;
    contacts: ContactDto[] | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetHotsiteForViewDto implements IGetHotsiteForViewDto {
    hotsite!: HotsiteDto;
    eventLogo!: string | undefined;
    hotsiteRootAddress!: string | undefined;

    constructor(data?: IGetHotsiteForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hotsite = data["hotsite"] ? HotsiteDto.fromJS(data["hotsite"]) : <any>undefined;
            this.eventLogo = data["eventLogo"];
            this.hotsiteRootAddress = data["hotsiteRootAddress"];
        }
    }

    static fromJS(data: any): GetHotsiteForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotsiteForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotsite"] = this.hotsite ? this.hotsite.toJSON() : <any>undefined;
        data["eventLogo"] = this.eventLogo;
        data["hotsiteRootAddress"] = this.hotsiteRootAddress;
        return data; 
    }
}

export interface IGetHotsiteForViewDto {
    hotsite: HotsiteDto;
    eventLogo: string | undefined;
    hotsiteRootAddress: string | undefined;
}

export class PagedResultDtoOfGetHotsiteForViewDto implements IPagedResultDtoOfGetHotsiteForViewDto {
    totalCount!: number;
    items!: GetHotsiteForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetHotsiteForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetHotsiteForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetHotsiteForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetHotsiteForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetHotsiteForViewDto {
    totalCount: number;
    items: GetHotsiteForViewDto[] | undefined;
}

export class GetHotsiteInput implements IGetHotsiteInput {
    tenantId!: number | undefined;
    eventId!: number;
    color1!: string | undefined;
    color2!: string | undefined;
    friendlyUrl!: string | undefined;
    isPublished!: boolean;
    id!: number;

    constructor(data?: IGetHotsiteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.eventId = data["eventId"];
            this.color1 = data["color1"];
            this.color2 = data["color2"];
            this.friendlyUrl = data["friendlyUrl"];
            this.isPublished = data["isPublished"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetHotsiteInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotsiteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["eventId"] = this.eventId;
        data["color1"] = this.color1;
        data["color2"] = this.color2;
        data["friendlyUrl"] = this.friendlyUrl;
        data["isPublished"] = this.isPublished;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetHotsiteInput {
    tenantId: number | undefined;
    eventId: number;
    color1: string | undefined;
    color2: string | undefined;
    friendlyUrl: string | undefined;
    isPublished: boolean;
    id: number;
}

export enum BackgroundBannerType {
    Image = 0,
    Color = 1,
}

export enum BackgroundBannerTextType {
    Hide = 0,
    Text = 1,
}

export class CreateOrEditHomeSectionDto implements ICreateOrEditHomeSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    bannerBgColor!: string | undefined;
    bannerType!: BannerType;
    delayAutoplay!: number | undefined;
    hotsiteId!: number;
    images!: CreateOrEditPhotoDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditHomeSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.bannerBgColor = data["bannerBgColor"];
            this.bannerType = data["bannerType"];
            this.delayAutoplay = data["delayAutoplay"];
            this.hotsiteId = data["hotsiteId"];
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(CreateOrEditPhotoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditHomeSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditHomeSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["bannerBgColor"] = this.bannerBgColor;
        data["bannerType"] = this.bannerType;
        data["delayAutoplay"] = this.delayAutoplay;
        data["hotsiteId"] = this.hotsiteId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditHomeSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    bannerBgColor: string | undefined;
    bannerType: BannerType;
    delayAutoplay: number | undefined;
    hotsiteId: number;
    images: CreateOrEditPhotoDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditImageGallery implements ICreateOrEditImageGallery {
    title!: string | undefined;
    subtitle!: string | undefined;
    isActive!: boolean;
    aboutEventId!: number;
    images!: CreateOrEditPhotoDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditImageGallery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.isActive = data["isActive"];
            this.aboutEventId = data["aboutEventId"];
            if (Array.isArray(data["images"])) {
                this.images = [] as any;
                for (let item of data["images"])
                    this.images!.push(CreateOrEditPhotoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditImageGallery {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditImageGallery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["isActive"] = this.isActive;
        data["aboutEventId"] = this.aboutEventId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditImageGallery {
    title: string | undefined;
    subtitle: string | undefined;
    isActive: boolean;
    aboutEventId: number;
    images: CreateOrEditPhotoDto[] | undefined;
    id: number | undefined;
}

export class CreateOrEditAboutEventSectionDto implements ICreateOrEditAboutEventSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    gallery!: CreateOrEditImageGallery;
    hotsiteId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditAboutEventSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.gallery = data["gallery"] ? CreateOrEditImageGallery.fromJS(data["gallery"]) : <any>undefined;
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditAboutEventSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAboutEventSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["gallery"] = this.gallery ? this.gallery.toJSON() : <any>undefined;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditAboutEventSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    gallery: CreateOrEditImageGallery;
    hotsiteId: number;
    id: number | undefined;
}

export class CreateOrEditCertificateSectionDto implements ICreateOrEditCertificateSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    enableCertificate!: boolean;
    hotsiteId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCertificateSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.enableCertificate = data["enableCertificate"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCertificateSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCertificateSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["enableCertificate"] = this.enableCertificate;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCertificateSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    enableCertificate: boolean;
    hotsiteId: number;
    id: number | undefined;
}

export class CreateOrEditRegistrationSectionDto implements ICreateOrEditRegistrationSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    showDeadlineTable!: boolean;
    showCnaTable!: boolean;
    hotsiteId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRegistrationSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.showDeadlineTable = data["showDeadlineTable"];
            this.showCnaTable = data["showCnaTable"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegistrationSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["showDeadlineTable"] = this.showDeadlineTable;
        data["showCnaTable"] = this.showCnaTable;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRegistrationSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    showDeadlineTable: boolean;
    showCnaTable: boolean;
    hotsiteId: number;
    id: number | undefined;
}

export class UpdateProgramFileInput implements IUpdateProgramFileInput {
    scientificProgramId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateProgramFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.scientificProgramId = data["scientificProgramId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProgramFileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProgramFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scientificProgramId"] = this.scientificProgramId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProgramFileInput {
    scientificProgramId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditScientificProgramSectionDto implements ICreateOrEditScientificProgramSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    programFileId!: string | undefined;
    programFile!: string | undefined;
    programInput!: UpdateProgramFileInput;
    programFileExtension!: string | undefined;
    programFileName!: string | undefined;
    scientificProgramType!: ScientificProgramType;
    hotsiteId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditScientificProgramSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.programFileId = data["programFileId"];
            this.programFile = data["programFile"];
            this.programInput = data["programInput"] ? UpdateProgramFileInput.fromJS(data["programInput"]) : <any>undefined;
            this.programFileExtension = data["programFileExtension"];
            this.programFileName = data["programFileName"];
            this.scientificProgramType = data["scientificProgramType"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditScientificProgramSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditScientificProgramSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["programFileId"] = this.programFileId;
        data["programFile"] = this.programFile;
        data["programInput"] = this.programInput ? this.programInput.toJSON() : <any>undefined;
        data["programFileExtension"] = this.programFileExtension;
        data["programFileName"] = this.programFileName;
        data["scientificProgramType"] = this.scientificProgramType;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditScientificProgramSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    programFileId: string | undefined;
    programFile: string | undefined;
    programInput: UpdateProgramFileInput;
    programFileExtension: string | undefined;
    programFileName: string | undefined;
    scientificProgramType: ScientificProgramType;
    hotsiteId: number;
    id: number | undefined;
}

export class CreateOrEditContactSectionDto implements ICreateOrEditContactSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    hotsiteId!: number;
    address!: ContactSectionAddressDto;
    emails!: ContactSectionEmailDto[] | undefined;
    phones!: ContactSectionPhoneDto[] | undefined;
    socialNetworks!: SocialNetworkDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditContactSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.hotsiteId = data["hotsiteId"];
            this.address = data["address"] ? ContactSectionAddressDto.fromJS(data["address"]) : <any>undefined;
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(ContactSectionEmailDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(ContactSectionPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["socialNetworks"])) {
                this.socialNetworks = [] as any;
                for (let item of data["socialNetworks"])
                    this.socialNetworks!.push(SocialNetworkDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditContactSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditContactSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["hotsiteId"] = this.hotsiteId;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.socialNetworks)) {
            data["socialNetworks"] = [];
            for (let item of this.socialNetworks)
                data["socialNetworks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditContactSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    hotsiteId: number;
    address: ContactSectionAddressDto;
    emails: ContactSectionEmailDto[] | undefined;
    phones: ContactSectionPhoneDto[] | undefined;
    socialNetworks: SocialNetworkDto[] | undefined;
    id: number | undefined;
}

export class UpdateRegionTipsFile implements IUpdateRegionTipsFile {
    localizationId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateRegionTipsFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.localizationId = data["localizationId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateRegionTipsFile {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegionTipsFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localizationId"] = this.localizationId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateRegionTipsFile {
    localizationId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditLocalizationSectionDto implements ICreateOrEditLocalizationSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    text!: string | undefined;
    regionTipsFileId!: string | undefined;
    regionTipsFile!: string | undefined;
    regionTipsFileInput!: UpdateRegionTipsFile;
    regionTipsFileExtension!: string | undefined;
    regionTipsFileName!: string | undefined;
    googleMapsConfig!: string | undefined;
    hotsiteId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditLocalizationSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.text = data["text"];
            this.regionTipsFileId = data["regionTipsFileId"];
            this.regionTipsFile = data["regionTipsFile"];
            this.regionTipsFileInput = data["regionTipsFileInput"] ? UpdateRegionTipsFile.fromJS(data["regionTipsFileInput"]) : <any>undefined;
            this.regionTipsFileExtension = data["regionTipsFileExtension"];
            this.regionTipsFileName = data["regionTipsFileName"];
            this.googleMapsConfig = data["googleMapsConfig"];
            this.hotsiteId = data["hotsiteId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditLocalizationSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditLocalizationSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["text"] = this.text;
        data["regionTipsFileId"] = this.regionTipsFileId;
        data["regionTipsFile"] = this.regionTipsFile;
        data["regionTipsFileInput"] = this.regionTipsFileInput ? this.regionTipsFileInput.toJSON() : <any>undefined;
        data["regionTipsFileExtension"] = this.regionTipsFileExtension;
        data["regionTipsFileName"] = this.regionTipsFileName;
        data["googleMapsConfig"] = this.googleMapsConfig;
        data["hotsiteId"] = this.hotsiteId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditLocalizationSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    text: string | undefined;
    regionTipsFileId: string | undefined;
    regionTipsFile: string | undefined;
    regionTipsFileInput: UpdateRegionTipsFile;
    regionTipsFileExtension: string | undefined;
    regionTipsFileName: string | undefined;
    googleMapsConfig: string | undefined;
    hotsiteId: number;
    id: number | undefined;
}

export class CreateOrEditTravelAgencySectionDto implements ICreateOrEditTravelAgencySectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    hotsiteId!: number;
    agencies!: TravelAgencyDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTravelAgencySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.hotsiteId = data["hotsiteId"];
            if (Array.isArray(data["agencies"])) {
                this.agencies = [] as any;
                for (let item of data["agencies"])
                    this.agencies!.push(TravelAgencyDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTravelAgencySectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTravelAgencySectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["hotsiteId"] = this.hotsiteId;
        if (Array.isArray(this.agencies)) {
            data["agencies"] = [];
            for (let item of this.agencies)
                data["agencies"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTravelAgencySectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    hotsiteId: number;
    agencies: TravelAgencyDto[] | undefined;
    id: number | undefined;
}

export class UpdateHositeVideoImageInput implements IUpdateHositeVideoImageInput {
    hotsiteVideoId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateHositeVideoImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hotsiteVideoId = data["hotsiteVideoId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateHositeVideoImageInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHositeVideoImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotsiteVideoId"] = this.hotsiteVideoId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateHositeVideoImageInput {
    hotsiteVideoId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class HotsiteVideoDto implements IHotsiteVideoDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    url!: string | undefined;
    thumbnail!: string | undefined;
    thumbnailId!: string | undefined;
    order!: number;
    externalLink!: boolean;
    imageInput!: UpdateHositeVideoImageInput;
    id!: number;

    constructor(data?: IHotsiteVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.url = data["url"];
            this.thumbnail = data["thumbnail"];
            this.thumbnailId = data["thumbnailId"];
            this.order = data["order"];
            this.externalLink = data["externalLink"];
            this.imageInput = data["imageInput"] ? UpdateHositeVideoImageInput.fromJS(data["imageInput"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HotsiteVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["url"] = this.url;
        data["thumbnail"] = this.thumbnail;
        data["thumbnailId"] = this.thumbnailId;
        data["order"] = this.order;
        data["externalLink"] = this.externalLink;
        data["imageInput"] = this.imageInput ? this.imageInput.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHotsiteVideoDto {
    title: string | undefined;
    subtitle: string | undefined;
    url: string | undefined;
    thumbnail: string | undefined;
    thumbnailId: string | undefined;
    order: number;
    externalLink: boolean;
    imageInput: UpdateHositeVideoImageInput;
    id: number;
}

export class CreateOrEditVideoSectionDto implements ICreateOrEditVideoSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    hotsiteId!: number;
    text!: string | undefined;
    videos!: HotsiteVideoDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditVideoSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.hotsiteId = data["hotsiteId"];
            this.text = data["text"];
            if (Array.isArray(data["videos"])) {
                this.videos = [] as any;
                for (let item of data["videos"])
                    this.videos!.push(HotsiteVideoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditVideoSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditVideoSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["hotsiteId"] = this.hotsiteId;
        data["text"] = this.text;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditVideoSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    hotsiteId: number;
    text: string | undefined;
    videos: HotsiteVideoDto[] | undefined;
    id: number | undefined;
}

export class UpdateSpeakerImageInput implements IUpdateSpeakerImageInput {
    speakerId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateSpeakerImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.speakerId = data["speakerId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateSpeakerImageInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpeakerImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speakerId"] = this.speakerId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateSpeakerImageInput {
    speakerId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class SpeakerDto implements ISpeakerDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    text!: string | undefined;
    photoId!: string | undefined;
    photo!: string | undefined;
    order!: number;
    imageInput!: UpdateSpeakerImageInput;
    id!: number;

    constructor(data?: ISpeakerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.text = data["text"];
            this.photoId = data["photoId"];
            this.photo = data["photo"];
            this.order = data["order"];
            this.imageInput = data["imageInput"] ? UpdateSpeakerImageInput.fromJS(data["imageInput"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SpeakerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["text"] = this.text;
        data["photoId"] = this.photoId;
        data["photo"] = this.photo;
        data["order"] = this.order;
        data["imageInput"] = this.imageInput ? this.imageInput.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISpeakerDto {
    title: string | undefined;
    subtitle: string | undefined;
    text: string | undefined;
    photoId: string | undefined;
    photo: string | undefined;
    order: number;
    imageInput: UpdateSpeakerImageInput;
    id: number;
}

export class CreateOrEditSpeakerSectionDto implements ICreateOrEditSpeakerSectionDto {
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    hotsiteId!: number;
    speakers!: SpeakerDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSpeakerSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.hotsiteId = data["hotsiteId"];
            if (Array.isArray(data["speakers"])) {
                this.speakers = [] as any;
                for (let item of data["speakers"])
                    this.speakers!.push(SpeakerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSpeakerSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSpeakerSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["hotsiteId"] = this.hotsiteId;
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSpeakerSectionDto {
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    hotsiteId: number;
    speakers: SpeakerDto[] | undefined;
    id: number | undefined;
}

export class UpdateHotsiteDto implements IUpdateHotsiteDto {
    isDefault!: boolean;
    friendlyUrl!: string | undefined;
    color1!: string | undefined;
    color2!: string | undefined;
    copyright!: string | undefined;
    logoId!: string | undefined;
    logo!: string | undefined;
    backgroundImageId!: string | undefined;
    backgroundImage!: string | undefined;
    backgroundBannerType!: BackgroundBannerType;
    backgroundBannerColor!: string | undefined;
    backgroundBannerTextType!: BackgroundBannerTextType;
    backgroundBannerTextColor!: string | undefined;
    homeSection!: CreateOrEditHomeSectionDto;
    aboutEventSection!: CreateOrEditAboutEventSectionDto;
    certificateSection!: CreateOrEditCertificateSectionDto;
    registrationSection!: CreateOrEditRegistrationSectionDto;
    scientificProgramSection!: CreateOrEditScientificProgramSectionDto;
    contactSection!: CreateOrEditContactSectionDto;
    localizationSection!: CreateOrEditLocalizationSectionDto;
    travelAgencySection!: CreateOrEditTravelAgencySectionDto;
    videoSection!: CreateOrEditVideoSectionDto;
    speakerSection!: CreateOrEditSpeakerSectionDto;
    eventId!: number;
    sponsors!: SponsorDto[] | undefined;
    id!: number | undefined;

    constructor(data?: IUpdateHotsiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDefault = data["isDefault"];
            this.friendlyUrl = data["friendlyUrl"];
            this.color1 = data["color1"];
            this.color2 = data["color2"];
            this.copyright = data["copyright"];
            this.logoId = data["logoId"];
            this.logo = data["logo"];
            this.backgroundImageId = data["backgroundImageId"];
            this.backgroundImage = data["backgroundImage"];
            this.backgroundBannerType = data["backgroundBannerType"];
            this.backgroundBannerColor = data["backgroundBannerColor"];
            this.backgroundBannerTextType = data["backgroundBannerTextType"];
            this.backgroundBannerTextColor = data["backgroundBannerTextColor"];
            this.homeSection = data["homeSection"] ? CreateOrEditHomeSectionDto.fromJS(data["homeSection"]) : <any>undefined;
            this.aboutEventSection = data["aboutEventSection"] ? CreateOrEditAboutEventSectionDto.fromJS(data["aboutEventSection"]) : <any>undefined;
            this.certificateSection = data["certificateSection"] ? CreateOrEditCertificateSectionDto.fromJS(data["certificateSection"]) : <any>undefined;
            this.registrationSection = data["registrationSection"] ? CreateOrEditRegistrationSectionDto.fromJS(data["registrationSection"]) : <any>undefined;
            this.scientificProgramSection = data["scientificProgramSection"] ? CreateOrEditScientificProgramSectionDto.fromJS(data["scientificProgramSection"]) : <any>undefined;
            this.contactSection = data["contactSection"] ? CreateOrEditContactSectionDto.fromJS(data["contactSection"]) : <any>undefined;
            this.localizationSection = data["localizationSection"] ? CreateOrEditLocalizationSectionDto.fromJS(data["localizationSection"]) : <any>undefined;
            this.travelAgencySection = data["travelAgencySection"] ? CreateOrEditTravelAgencySectionDto.fromJS(data["travelAgencySection"]) : <any>undefined;
            this.videoSection = data["videoSection"] ? CreateOrEditVideoSectionDto.fromJS(data["videoSection"]) : <any>undefined;
            this.speakerSection = data["speakerSection"] ? CreateOrEditSpeakerSectionDto.fromJS(data["speakerSection"]) : <any>undefined;
            this.eventId = data["eventId"];
            if (Array.isArray(data["sponsors"])) {
                this.sponsors = [] as any;
                for (let item of data["sponsors"])
                    this.sponsors!.push(SponsorDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateHotsiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHotsiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDefault"] = this.isDefault;
        data["friendlyUrl"] = this.friendlyUrl;
        data["color1"] = this.color1;
        data["color2"] = this.color2;
        data["copyright"] = this.copyright;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo;
        data["backgroundImageId"] = this.backgroundImageId;
        data["backgroundImage"] = this.backgroundImage;
        data["backgroundBannerType"] = this.backgroundBannerType;
        data["backgroundBannerColor"] = this.backgroundBannerColor;
        data["backgroundBannerTextType"] = this.backgroundBannerTextType;
        data["backgroundBannerTextColor"] = this.backgroundBannerTextColor;
        data["homeSection"] = this.homeSection ? this.homeSection.toJSON() : <any>undefined;
        data["aboutEventSection"] = this.aboutEventSection ? this.aboutEventSection.toJSON() : <any>undefined;
        data["certificateSection"] = this.certificateSection ? this.certificateSection.toJSON() : <any>undefined;
        data["registrationSection"] = this.registrationSection ? this.registrationSection.toJSON() : <any>undefined;
        data["scientificProgramSection"] = this.scientificProgramSection ? this.scientificProgramSection.toJSON() : <any>undefined;
        data["contactSection"] = this.contactSection ? this.contactSection.toJSON() : <any>undefined;
        data["localizationSection"] = this.localizationSection ? this.localizationSection.toJSON() : <any>undefined;
        data["travelAgencySection"] = this.travelAgencySection ? this.travelAgencySection.toJSON() : <any>undefined;
        data["videoSection"] = this.videoSection ? this.videoSection.toJSON() : <any>undefined;
        data["speakerSection"] = this.speakerSection ? this.speakerSection.toJSON() : <any>undefined;
        data["eventId"] = this.eventId;
        if (Array.isArray(this.sponsors)) {
            data["sponsors"] = [];
            for (let item of this.sponsors)
                data["sponsors"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateHotsiteDto {
    isDefault: boolean;
    friendlyUrl: string | undefined;
    color1: string | undefined;
    color2: string | undefined;
    copyright: string | undefined;
    logoId: string | undefined;
    logo: string | undefined;
    backgroundImageId: string | undefined;
    backgroundImage: string | undefined;
    backgroundBannerType: BackgroundBannerType;
    backgroundBannerColor: string | undefined;
    backgroundBannerTextType: BackgroundBannerTextType;
    backgroundBannerTextColor: string | undefined;
    homeSection: CreateOrEditHomeSectionDto;
    aboutEventSection: CreateOrEditAboutEventSectionDto;
    certificateSection: CreateOrEditCertificateSectionDto;
    registrationSection: CreateOrEditRegistrationSectionDto;
    scientificProgramSection: CreateOrEditScientificProgramSectionDto;
    contactSection: CreateOrEditContactSectionDto;
    localizationSection: CreateOrEditLocalizationSectionDto;
    travelAgencySection: CreateOrEditTravelAgencySectionDto;
    videoSection: CreateOrEditVideoSectionDto;
    speakerSection: CreateOrEditSpeakerSectionDto;
    eventId: number;
    sponsors: SponsorDto[] | undefined;
    id: number | undefined;
}

export class GetHotsiteForEditOutput implements IGetHotsiteForEditOutput {
    hotsite!: UpdateHotsiteDto;
    hotsiteRootAddress!: string | undefined;

    constructor(data?: IGetHotsiteForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hotsite = data["hotsite"] ? UpdateHotsiteDto.fromJS(data["hotsite"]) : <any>undefined;
            this.hotsiteRootAddress = data["hotsiteRootAddress"];
        }
    }

    static fromJS(data: any): GetHotsiteForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotsiteForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotsite"] = this.hotsite ? this.hotsite.toJSON() : <any>undefined;
        data["hotsiteRootAddress"] = this.hotsiteRootAddress;
        return data; 
    }
}

export interface IGetHotsiteForEditOutput {
    hotsite: UpdateHotsiteDto;
    hotsiteRootAddress: string | undefined;
}

export class HotsiteListDto implements IHotsiteListDto {
    id!: number;
    event!: EventListDto;

    constructor(data?: IHotsiteListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.event = data["event"] ? EventListDto.fromJS(data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HotsiteListDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHotsiteListDto {
    id: number;
    event: EventListDto;
}

export class ListResultDtoOfHotsiteListDto implements IListResultDtoOfHotsiteListDto {
    items!: HotsiteListDto[] | undefined;

    constructor(data?: IListResultDtoOfHotsiteListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(HotsiteListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHotsiteListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfHotsiteListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfHotsiteListDto {
    items: HotsiteListDto[] | undefined;
}

export class CreateHotsiteDto implements ICreateHotsiteDto {
    eventId!: number;
    friendlyUrl!: string | undefined;
    copyright!: string | undefined;

    constructor(data?: ICreateHotsiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.eventId = data["eventId"];
            this.friendlyUrl = data["friendlyUrl"];
            this.copyright = data["copyright"];
        }
    }

    static fromJS(data: any): CreateHotsiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHotsiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["friendlyUrl"] = this.friendlyUrl;
        data["copyright"] = this.copyright;
        return data; 
    }
}

export interface ICreateHotsiteDto {
    eventId: number;
    friendlyUrl: string | undefined;
    copyright: string | undefined;
}

export class SectionSettingsDto implements ISectionSettingsDto {
    id!: number;
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;

    constructor(data?: ISectionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
        }
    }

    static fromJS(data: any): SectionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        return data; 
    }
}

export interface ISectionSettingsDto {
    id: number;
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
}

export class HotsiteSectionSettingsDto implements IHotsiteSectionSettingsDto {
    homeSection!: SectionSettingsDto;
    aboutEventSection!: SectionSettingsDto;
    certificateSection!: SectionSettingsDto;
    registrationSection!: SectionSettingsDto;
    scientificProgramSection!: SectionSettingsDto;
    contactSection!: SectionSettingsDto;
    localizationSection!: SectionSettingsDto;
    travelAgencySection!: SectionSettingsDto;
    videoSection!: SectionSettingsDto;
    speakerSection!: SectionSettingsDto;
    id!: number;

    constructor(data?: IHotsiteSectionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.homeSection = data["homeSection"] ? SectionSettingsDto.fromJS(data["homeSection"]) : <any>undefined;
            this.aboutEventSection = data["aboutEventSection"] ? SectionSettingsDto.fromJS(data["aboutEventSection"]) : <any>undefined;
            this.certificateSection = data["certificateSection"] ? SectionSettingsDto.fromJS(data["certificateSection"]) : <any>undefined;
            this.registrationSection = data["registrationSection"] ? SectionSettingsDto.fromJS(data["registrationSection"]) : <any>undefined;
            this.scientificProgramSection = data["scientificProgramSection"] ? SectionSettingsDto.fromJS(data["scientificProgramSection"]) : <any>undefined;
            this.contactSection = data["contactSection"] ? SectionSettingsDto.fromJS(data["contactSection"]) : <any>undefined;
            this.localizationSection = data["localizationSection"] ? SectionSettingsDto.fromJS(data["localizationSection"]) : <any>undefined;
            this.travelAgencySection = data["travelAgencySection"] ? SectionSettingsDto.fromJS(data["travelAgencySection"]) : <any>undefined;
            this.videoSection = data["videoSection"] ? SectionSettingsDto.fromJS(data["videoSection"]) : <any>undefined;
            this.speakerSection = data["speakerSection"] ? SectionSettingsDto.fromJS(data["speakerSection"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HotsiteSectionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteSectionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeSection"] = this.homeSection ? this.homeSection.toJSON() : <any>undefined;
        data["aboutEventSection"] = this.aboutEventSection ? this.aboutEventSection.toJSON() : <any>undefined;
        data["certificateSection"] = this.certificateSection ? this.certificateSection.toJSON() : <any>undefined;
        data["registrationSection"] = this.registrationSection ? this.registrationSection.toJSON() : <any>undefined;
        data["scientificProgramSection"] = this.scientificProgramSection ? this.scientificProgramSection.toJSON() : <any>undefined;
        data["contactSection"] = this.contactSection ? this.contactSection.toJSON() : <any>undefined;
        data["localizationSection"] = this.localizationSection ? this.localizationSection.toJSON() : <any>undefined;
        data["travelAgencySection"] = this.travelAgencySection ? this.travelAgencySection.toJSON() : <any>undefined;
        data["videoSection"] = this.videoSection ? this.videoSection.toJSON() : <any>undefined;
        data["speakerSection"] = this.speakerSection ? this.speakerSection.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHotsiteSectionSettingsDto {
    homeSection: SectionSettingsDto;
    aboutEventSection: SectionSettingsDto;
    certificateSection: SectionSettingsDto;
    registrationSection: SectionSettingsDto;
    scientificProgramSection: SectionSettingsDto;
    contactSection: SectionSettingsDto;
    localizationSection: SectionSettingsDto;
    travelAgencySection: SectionSettingsDto;
    videoSection: SectionSettingsDto;
    speakerSection: SectionSettingsDto;
    id: number;
}

export class HotsiteItemMenuDto implements IHotsiteItemMenuDto {
    isActive!: boolean;
    order!: number | undefined;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    externalLink!: string | undefined;
    target!: TargetType;
    pageDescription!: string | undefined;

    constructor(data?: IHotsiteItemMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.order = data["order"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.externalLink = data["externalLink"];
            this.target = data["target"];
            this.pageDescription = data["pageDescription"];
        }
    }

    static fromJS(data: any): HotsiteItemMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteItemMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["order"] = this.order;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["externalLink"] = this.externalLink;
        data["target"] = this.target;
        data["pageDescription"] = this.pageDescription;
        return data; 
    }
}

export interface IHotsiteItemMenuDto {
    isActive: boolean;
    order: number | undefined;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    externalLink: string | undefined;
    target: TargetType;
    pageDescription: string | undefined;
}

export class HotsiteMenuDto implements IHotsiteMenuDto {
    homeSection!: HotsiteItemMenuDto;
    aboutEventSection!: HotsiteItemMenuDto;
    certificateSection!: HotsiteItemMenuDto;
    registrationSection!: HotsiteItemMenuDto;
    scientificProgramSection!: HotsiteItemMenuDto;
    contactSection!: HotsiteItemMenuDto;
    localizationSection!: HotsiteItemMenuDto;
    travelAgencySection!: HotsiteItemMenuDto;
    videoSection!: HotsiteItemMenuDto;
    speakerSection!: HotsiteItemMenuDto;

    constructor(data?: IHotsiteMenuDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.homeSection = data["homeSection"] ? HotsiteItemMenuDto.fromJS(data["homeSection"]) : <any>undefined;
            this.aboutEventSection = data["aboutEventSection"] ? HotsiteItemMenuDto.fromJS(data["aboutEventSection"]) : <any>undefined;
            this.certificateSection = data["certificateSection"] ? HotsiteItemMenuDto.fromJS(data["certificateSection"]) : <any>undefined;
            this.registrationSection = data["registrationSection"] ? HotsiteItemMenuDto.fromJS(data["registrationSection"]) : <any>undefined;
            this.scientificProgramSection = data["scientificProgramSection"] ? HotsiteItemMenuDto.fromJS(data["scientificProgramSection"]) : <any>undefined;
            this.contactSection = data["contactSection"] ? HotsiteItemMenuDto.fromJS(data["contactSection"]) : <any>undefined;
            this.localizationSection = data["localizationSection"] ? HotsiteItemMenuDto.fromJS(data["localizationSection"]) : <any>undefined;
            this.travelAgencySection = data["travelAgencySection"] ? HotsiteItemMenuDto.fromJS(data["travelAgencySection"]) : <any>undefined;
            this.videoSection = data["videoSection"] ? HotsiteItemMenuDto.fromJS(data["videoSection"]) : <any>undefined;
            this.speakerSection = data["speakerSection"] ? HotsiteItemMenuDto.fromJS(data["speakerSection"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HotsiteMenuDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteMenuDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeSection"] = this.homeSection ? this.homeSection.toJSON() : <any>undefined;
        data["aboutEventSection"] = this.aboutEventSection ? this.aboutEventSection.toJSON() : <any>undefined;
        data["certificateSection"] = this.certificateSection ? this.certificateSection.toJSON() : <any>undefined;
        data["registrationSection"] = this.registrationSection ? this.registrationSection.toJSON() : <any>undefined;
        data["scientificProgramSection"] = this.scientificProgramSection ? this.scientificProgramSection.toJSON() : <any>undefined;
        data["contactSection"] = this.contactSection ? this.contactSection.toJSON() : <any>undefined;
        data["localizationSection"] = this.localizationSection ? this.localizationSection.toJSON() : <any>undefined;
        data["travelAgencySection"] = this.travelAgencySection ? this.travelAgencySection.toJSON() : <any>undefined;
        data["videoSection"] = this.videoSection ? this.videoSection.toJSON() : <any>undefined;
        data["speakerSection"] = this.speakerSection ? this.speakerSection.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHotsiteMenuDto {
    homeSection: HotsiteItemMenuDto;
    aboutEventSection: HotsiteItemMenuDto;
    certificateSection: HotsiteItemMenuDto;
    registrationSection: HotsiteItemMenuDto;
    scientificProgramSection: HotsiteItemMenuDto;
    contactSection: HotsiteItemMenuDto;
    localizationSection: HotsiteItemMenuDto;
    travelAgencySection: HotsiteItemMenuDto;
    videoSection: HotsiteItemMenuDto;
    speakerSection: HotsiteItemMenuDto;
}

export class HotsiteSettingsDto implements IHotsiteSettingsDto {
    placeType!: EventPlaceType;
    logo!: string | undefined;
    backgroundImage!: string | undefined;
    backgroundBannerType!: BackgroundBannerType;
    backgroundBannerColor!: string | undefined;
    backgroundBannerTextType!: BackgroundBannerTextType;
    backgroundBannerTextColor!: string | undefined;
    color1!: string | undefined;
    color2!: string | undefined;
    copyright!: string | undefined;
    tenancyName!: string | undefined;
    friendlyUrl!: string | undefined;
    isPublished!: boolean;
    menu!: HotsiteMenuDto;

    constructor(data?: IHotsiteSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.placeType = data["placeType"];
            this.logo = data["logo"];
            this.backgroundImage = data["backgroundImage"];
            this.backgroundBannerType = data["backgroundBannerType"];
            this.backgroundBannerColor = data["backgroundBannerColor"];
            this.backgroundBannerTextType = data["backgroundBannerTextType"];
            this.backgroundBannerTextColor = data["backgroundBannerTextColor"];
            this.color1 = data["color1"];
            this.color2 = data["color2"];
            this.copyright = data["copyright"];
            this.tenancyName = data["tenancyName"];
            this.friendlyUrl = data["friendlyUrl"];
            this.isPublished = data["isPublished"];
            this.menu = data["menu"] ? HotsiteMenuDto.fromJS(data["menu"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HotsiteSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeType"] = this.placeType;
        data["logo"] = this.logo;
        data["backgroundImage"] = this.backgroundImage;
        data["backgroundBannerType"] = this.backgroundBannerType;
        data["backgroundBannerColor"] = this.backgroundBannerColor;
        data["backgroundBannerTextType"] = this.backgroundBannerTextType;
        data["backgroundBannerTextColor"] = this.backgroundBannerTextColor;
        data["color1"] = this.color1;
        data["color2"] = this.color2;
        data["copyright"] = this.copyright;
        data["tenancyName"] = this.tenancyName;
        data["friendlyUrl"] = this.friendlyUrl;
        data["isPublished"] = this.isPublished;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHotsiteSettingsDto {
    placeType: EventPlaceType;
    logo: string | undefined;
    backgroundImage: string | undefined;
    backgroundBannerType: BackgroundBannerType;
    backgroundBannerColor: string | undefined;
    backgroundBannerTextType: BackgroundBannerTextType;
    backgroundBannerTextColor: string | undefined;
    color1: string | undefined;
    color2: string | undefined;
    copyright: string | undefined;
    tenancyName: string | undefined;
    friendlyUrl: string | undefined;
    isPublished: boolean;
    menu: HotsiteMenuDto;
}

export class SponsorTypeDto implements ISponsorTypeDto {
    hotsiteId!: number;
    description!: string | undefined;
    order!: number | undefined;
    sponsors!: SponsorDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ISponsorTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hotsiteId = data["hotsiteId"];
            this.description = data["description"];
            this.order = data["order"];
            if (Array.isArray(data["sponsors"])) {
                this.sponsors = [] as any;
                for (let item of data["sponsors"])
                    this.sponsors!.push(SponsorDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SponsorTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotsiteId"] = this.hotsiteId;
        data["description"] = this.description;
        data["order"] = this.order;
        if (Array.isArray(this.sponsors)) {
            data["sponsors"] = [];
            for (let item of this.sponsors)
                data["sponsors"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ISponsorTypeDto {
    hotsiteId: number;
    description: string | undefined;
    order: number | undefined;
    sponsors: SponsorDto[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfSponsorTypeDto implements IListResultDtoOfSponsorTypeDto {
    items!: SponsorTypeDto[] | undefined;

    constructor(data?: IListResultDtoOfSponsorTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SponsorTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSponsorTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSponsorTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSponsorTypeDto {
    items: SponsorTypeDto[] | undefined;
}

export class SponsorTypeListDto implements ISponsorTypeListDto {
    description!: string | undefined;
    order!: number;
    id!: number | undefined;

    constructor(data?: ISponsorTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.order = data["order"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SponsorTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SponsorTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["order"] = this.order;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISponsorTypeListDto {
    description: string | undefined;
    order: number;
    id: number | undefined;
}

export class ListResultDtoOfSponsorTypeListDto implements IListResultDtoOfSponsorTypeListDto {
    items!: SponsorTypeListDto[] | undefined;

    constructor(data?: IListResultDtoOfSponsorTypeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SponsorTypeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSponsorTypeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSponsorTypeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSponsorTypeListDto {
    items: SponsorTypeListDto[] | undefined;
}

export class CreateOrEditSponsorTypeDto implements ICreateOrEditSponsorTypeDto {
    description!: string | undefined;
    order!: number | undefined;
    hotsiteId!: number;
    sponsors!: SponsorDto[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditSponsorTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.order = data["order"];
            this.hotsiteId = data["hotsiteId"];
            if (Array.isArray(data["sponsors"])) {
                this.sponsors = [] as any;
                for (let item of data["sponsors"])
                    this.sponsors!.push(SponsorDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditSponsorTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditSponsorTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["order"] = this.order;
        data["hotsiteId"] = this.hotsiteId;
        if (Array.isArray(this.sponsors)) {
            data["sponsors"] = [];
            for (let item of this.sponsors)
                data["sponsors"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditSponsorTypeDto {
    description: string | undefined;
    order: number | undefined;
    hotsiteId: number;
    sponsors: SponsorDto[] | undefined;
    id: number | undefined;
}

export class UpdateHotsiteSettingsDto implements IUpdateHotsiteSettingsDto {
    isDefault!: boolean;
    color1!: string | undefined;
    color2!: string | undefined;
    friendlyUrl!: string | undefined;
    copyright!: string | undefined;
    backgroundBannerType!: BackgroundBannerType;
    backgroundBannerColor!: string | undefined;
    backgroundBannerTextType!: BackgroundBannerTextType;
    backgroundBannerTextColor!: string | undefined;
    hotsiteId!: number;

    constructor(data?: IUpdateHotsiteSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDefault = data["isDefault"];
            this.color1 = data["color1"];
            this.color2 = data["color2"];
            this.friendlyUrl = data["friendlyUrl"];
            this.copyright = data["copyright"];
            this.backgroundBannerType = data["backgroundBannerType"];
            this.backgroundBannerColor = data["backgroundBannerColor"];
            this.backgroundBannerTextType = data["backgroundBannerTextType"];
            this.backgroundBannerTextColor = data["backgroundBannerTextColor"];
            this.hotsiteId = data["hotsiteId"];
        }
    }

    static fromJS(data: any): UpdateHotsiteSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHotsiteSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDefault"] = this.isDefault;
        data["color1"] = this.color1;
        data["color2"] = this.color2;
        data["friendlyUrl"] = this.friendlyUrl;
        data["copyright"] = this.copyright;
        data["backgroundBannerType"] = this.backgroundBannerType;
        data["backgroundBannerColor"] = this.backgroundBannerColor;
        data["backgroundBannerTextType"] = this.backgroundBannerTextType;
        data["backgroundBannerTextColor"] = this.backgroundBannerTextColor;
        data["hotsiteId"] = this.hotsiteId;
        return data; 
    }
}

export interface IUpdateHotsiteSettingsDto {
    isDefault: boolean;
    color1: string | undefined;
    color2: string | undefined;
    friendlyUrl: string | undefined;
    copyright: string | undefined;
    backgroundBannerType: BackgroundBannerType;
    backgroundBannerColor: string | undefined;
    backgroundBannerTextType: BackgroundBannerTextType;
    backgroundBannerTextColor: string | undefined;
    hotsiteId: number;
}

export class UpdateImageInput implements IUpdateImageInput {
    hotsiteId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hotsiteId = data["hotsiteId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateImageInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hotsiteId"] = this.hotsiteId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateImageInput {
    hotsiteId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class SendContactMessageInput implements ISendContactMessageInput {
    name!: string | undefined;
    phone!: string | undefined;
    emailAddress!: string | undefined;
    tenantId!: number | undefined;
    message!: string | undefined;
    hotsiteId!: number;

    constructor(data?: ISendContactMessageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.phone = data["phone"];
            this.emailAddress = data["emailAddress"];
            this.tenantId = data["tenantId"];
            this.message = data["message"];
            this.hotsiteId = data["hotsiteId"];
        }
    }

    static fromJS(data: any): SendContactMessageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendContactMessageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["emailAddress"] = this.emailAddress;
        data["tenantId"] = this.tenantId;
        data["message"] = this.message;
        data["hotsiteId"] = this.hotsiteId;
        return data; 
    }
}

export interface ISendContactMessageInput {
    name: string | undefined;
    phone: string | undefined;
    emailAddress: string | undefined;
    tenantId: number | undefined;
    message: string | undefined;
    hotsiteId: number;
}

export class CertificateSectionDtoForView implements ICertificateSectionDtoForView {
    isPublished!: boolean;
    certificate!: CertificateSectionDto;
    tenantId!: number | undefined;
    eventId!: number;
    certificateConfigId!: number | undefined;

    constructor(data?: ICertificateSectionDtoForView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.certificate = data["certificate"] ? CertificateSectionDto.fromJS(data["certificate"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.eventId = data["eventId"];
            this.certificateConfigId = data["certificateConfigId"];
        }
    }

    static fromJS(data: any): CertificateSectionDtoForView {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateSectionDtoForView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["certificate"] = this.certificate ? this.certificate.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["eventId"] = this.eventId;
        data["certificateConfigId"] = this.certificateConfigId;
        return data; 
    }
}

export interface ICertificateSectionDtoForView {
    isPublished: boolean;
    certificate: CertificateSectionDto;
    tenantId: number | undefined;
    eventId: number;
    certificateConfigId: number | undefined;
}

export enum HotsiteSection {
    Home = 0,
    AboutEvent = 1,
    Localization = 2,
    Registration = 3,
    Certificate = 4,
    ScientificProgram = 5,
    TravelAgency = 6,
    Contact = 7,
    Video = 8,
    Speaker = 9,
}

export class GetHotsitePageDto implements IGetHotsitePageDto {
    section!: HotsiteSection;
    googleAnalytics!: string | undefined;

    constructor(data?: IGetHotsitePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.section = data["section"];
            this.googleAnalytics = data["googleAnalytics"];
        }
    }

    static fromJS(data: any): GetHotsitePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetHotsitePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["section"] = this.section;
        data["googleAnalytics"] = this.googleAnalytics;
        return data; 
    }
}

export interface IGetHotsitePageDto {
    section: HotsiteSection;
    googleAnalytics: string | undefined;
}

export class VideoSectionDto implements IVideoSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    hotsiteId!: number;
    text!: string | undefined;
    eventId!: number;
    videos!: HotsiteVideoDto[] | undefined;
    id!: number;

    constructor(data?: IVideoSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.hotsiteId = data["hotsiteId"];
            this.text = data["text"];
            this.eventId = data["eventId"];
            if (Array.isArray(data["videos"])) {
                this.videos = [] as any;
                for (let item of data["videos"])
                    this.videos!.push(HotsiteVideoDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): VideoSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["hotsiteId"] = this.hotsiteId;
        data["text"] = this.text;
        data["eventId"] = this.eventId;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IVideoSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    hotsiteId: number;
    text: string | undefined;
    eventId: number;
    videos: HotsiteVideoDto[] | undefined;
    id: number;
}

export class SpeakerSectionDto implements ISpeakerSectionDto {
    isPublished!: boolean;
    isActive!: boolean;
    name!: string | undefined;
    menuTitle!: string | undefined;
    friendlyUrl!: string | undefined;
    order!: number;
    target!: TargetType;
    externalLink!: string | undefined;
    pageDescription!: string | undefined;
    hotsiteId!: number;
    speakers!: SpeakerDto[] | undefined;
    id!: number;

    constructor(data?: ISpeakerSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isPublished = data["isPublished"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.menuTitle = data["menuTitle"];
            this.friendlyUrl = data["friendlyUrl"];
            this.order = data["order"];
            this.target = data["target"];
            this.externalLink = data["externalLink"];
            this.pageDescription = data["pageDescription"];
            this.hotsiteId = data["hotsiteId"];
            if (Array.isArray(data["speakers"])) {
                this.speakers = [] as any;
                for (let item of data["speakers"])
                    this.speakers!.push(SpeakerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SpeakerSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpeakerSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPublished"] = this.isPublished;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["menuTitle"] = this.menuTitle;
        data["friendlyUrl"] = this.friendlyUrl;
        data["order"] = this.order;
        data["target"] = this.target;
        data["externalLink"] = this.externalLink;
        data["pageDescription"] = this.pageDescription;
        data["hotsiteId"] = this.hotsiteId;
        if (Array.isArray(this.speakers)) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ISpeakerSectionDto {
    isPublished: boolean;
    isActive: boolean;
    name: string | undefined;
    menuTitle: string | undefined;
    friendlyUrl: string | undefined;
    order: number;
    target: TargetType;
    externalLink: string | undefined;
    pageDescription: string | undefined;
    hotsiteId: number;
    speakers: SpeakerDto[] | undefined;
    id: number;
}

export class InstallDto implements IInstallDto {
    connectionString!: string | undefined;
    adminPassword!: string | undefined;
    webSiteUrl!: string | undefined;
    serverUrl!: string | undefined;
    defaultLanguage!: string | undefined;
    smtpSettings!: EmailSettingsEditDto;
    billInfo!: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInstallDto {
    connectionString: string | undefined;
    adminPassword: string | undefined;
    webSiteUrl: string | undefined;
    serverUrl: string | undefined;
    defaultLanguage: string | undefined;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (Array.isArray(data["languages"])) {
                this.languages = [] as any;
                for (let item of data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data; 
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: moment.Moment;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (Array.isArray(data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (Array.isArray(data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data; 
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data; 
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string | undefined;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string | undefined;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (Array.isArray(data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(data["flags"])) {
                this.flags = [] as any;
                for (let item of data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string | undefined;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ISetDefaultLanguageInput {
    name: string | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string | undefined;
    sourceName!: string | undefined;
    key!: string | undefined;
    value!: string | undefined;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string | undefined;
    sourceName: string | undefined;
    key: string | undefined;
    value: string | undefined;
}

export class MemberSpecialtyDto implements IMemberSpecialtyDto {
    description!: string | undefined;
    isActive!: boolean;
    id!: number;

    constructor(data?: IMemberSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberSpecialtyDto {
    description: string | undefined;
    isActive: boolean;
    id: number;
}

export class MemberDto implements IMemberDto {
    cpf!: string | undefined;
    badgeName!: string | undefined;
    rg!: string | undefined;
    crm!: string | undefined;
    rgEmitter!: string | undefined;
    rgEmitterUf!: string | undefined;
    bornDate!: moment.Moment | undefined;
    deathYear!: number | undefined;
    graduationYear!: number | undefined;
    statusCrm!: StatusCrm;
    situationCrm!: SituationCrm;
    annuitySituation!: MemberAnnuitySituation;
    userId!: number;
    user!: UserListDto;
    specialtyId!: number | undefined;
    specialty!: MemberSpecialtyDto;
    categories!: MemberCategoryDto[] | undefined;
    id!: number;

    constructor(data?: IMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.badgeName = data["badgeName"];
            this.rg = data["rg"];
            this.crm = data["crm"];
            this.rgEmitter = data["rgEmitter"];
            this.rgEmitterUf = data["rgEmitterUf"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.deathYear = data["deathYear"];
            this.graduationYear = data["graduationYear"];
            this.statusCrm = data["statusCrm"];
            this.situationCrm = data["situationCrm"];
            this.annuitySituation = data["annuitySituation"];
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.specialtyId = data["specialtyId"];
            this.specialty = data["specialty"] ? MemberSpecialtyDto.fromJS(data["specialty"]) : <any>undefined;
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(MemberCategoryDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["badgeName"] = this.badgeName;
        data["rg"] = this.rg;
        data["crm"] = this.crm;
        data["rgEmitter"] = this.rgEmitter;
        data["rgEmitterUf"] = this.rgEmitterUf;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["deathYear"] = this.deathYear;
        data["graduationYear"] = this.graduationYear;
        data["statusCrm"] = this.statusCrm;
        data["situationCrm"] = this.situationCrm;
        data["annuitySituation"] = this.annuitySituation;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["specialtyId"] = this.specialtyId;
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IMemberDto {
    cpf: string | undefined;
    badgeName: string | undefined;
    rg: string | undefined;
    crm: string | undefined;
    rgEmitter: string | undefined;
    rgEmitterUf: string | undefined;
    bornDate: moment.Moment | undefined;
    deathYear: number | undefined;
    graduationYear: number | undefined;
    statusCrm: StatusCrm;
    situationCrm: SituationCrm;
    annuitySituation: MemberAnnuitySituation;
    userId: number;
    user: UserListDto;
    specialtyId: number | undefined;
    specialty: MemberSpecialtyDto;
    categories: MemberCategoryDto[] | undefined;
    id: number;
}

export class GetMemberForViewDto implements IGetMemberForViewDto {
    member!: MemberDto;
    categoryName!: string | undefined;
    categoryLevelName!: string | undefined;
    pendingDocumentation!: boolean;
    documentationStatus!: DocumentationStatus;
    guestEventSchedule!: boolean;
    userSituationDescription!: string | undefined;

    constructor(data?: IGetMemberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : <any>undefined;
            this.categoryName = data["categoryName"];
            this.categoryLevelName = data["categoryLevelName"];
            this.pendingDocumentation = data["pendingDocumentation"];
            this.documentationStatus = data["documentationStatus"];
            this.guestEventSchedule = data["guestEventSchedule"];
            this.userSituationDescription = data["userSituationDescription"];
        }
    }

    static fromJS(data: any): GetMemberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["categoryName"] = this.categoryName;
        data["categoryLevelName"] = this.categoryLevelName;
        data["pendingDocumentation"] = this.pendingDocumentation;
        data["documentationStatus"] = this.documentationStatus;
        data["guestEventSchedule"] = this.guestEventSchedule;
        data["userSituationDescription"] = this.userSituationDescription;
        return data; 
    }
}

export interface IGetMemberForViewDto {
    member: MemberDto;
    categoryName: string | undefined;
    categoryLevelName: string | undefined;
    pendingDocumentation: boolean;
    documentationStatus: DocumentationStatus;
    guestEventSchedule: boolean;
    userSituationDescription: string | undefined;
}

export class PagedResultDtoOfGetMemberForViewDto implements IPagedResultDtoOfGetMemberForViewDto {
    totalCount!: number;
    items!: GetMemberForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMemberForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetMemberForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMemberForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMemberForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMemberForViewDto {
    totalCount: number;
    items: GetMemberForViewDto[] | undefined;
}

export class GetMemberForEditOutput implements IGetMemberForEditOutput {
    member!: CreateOrEditMemberDto;
    category!: CategoryDto;
    specialtyName!: string | undefined;
    annuitySituation!: MemberAnnuitySituation;

    constructor(data?: IGetMemberForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.member = data["member"] ? CreateOrEditMemberDto.fromJS(data["member"]) : <any>undefined;
            this.category = data["category"] ? CategoryDto.fromJS(data["category"]) : <any>undefined;
            this.specialtyName = data["specialtyName"];
            this.annuitySituation = data["annuitySituation"];
        }
    }

    static fromJS(data: any): GetMemberForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["specialtyName"] = this.specialtyName;
        data["annuitySituation"] = this.annuitySituation;
        return data; 
    }
}

export interface IGetMemberForEditOutput {
    member: CreateOrEditMemberDto;
    category: CategoryDto;
    specialtyName: string | undefined;
    annuitySituation: MemberAnnuitySituation;
}

export class ValidateCrmDto implements IValidateCrmDto {
    crm!: string | undefined;
    name!: string | undefined;
    tenantId!: number;

    constructor(data?: IValidateCrmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.crm = data["crm"];
            this.name = data["name"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): ValidateCrmDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCrmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crm"] = this.crm;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IValidateCrmDto {
    crm: string | undefined;
    name: string | undefined;
    tenantId: number;
}

export class ResultValidateCrmDto implements IResultValidateCrmDto {
    statusCrm!: StatusCrm;
    situationCrm!: SituationCrm;

    constructor(data?: IResultValidateCrmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCrm = data["statusCrm"];
            this.situationCrm = data["situationCrm"];
        }
    }

    static fromJS(data: any): ResultValidateCrmDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultValidateCrmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCrm"] = this.statusCrm;
        data["situationCrm"] = this.situationCrm;
        return data; 
    }
}

export interface IResultValidateCrmDto {
    statusCrm: StatusCrm;
    situationCrm: SituationCrm;
}

export class MemberCategoryLookupTableDto implements IMemberCategoryLookupTableDto {
    id!: number;
    displayName!: string | undefined;
    requiresCRM!: boolean;
    validateCPF!: boolean;
    validateCRM!: boolean;
    allowNewUserRegister!: boolean;
    levels!: CategoryLevelDto[] | undefined;

    constructor(data?: IMemberCategoryLookupTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.requiresCRM = data["requiresCRM"];
            this.validateCPF = data["validateCPF"];
            this.validateCRM = data["validateCRM"];
            this.allowNewUserRegister = data["allowNewUserRegister"];
            if (Array.isArray(data["levels"])) {
                this.levels = [] as any;
                for (let item of data["levels"])
                    this.levels!.push(CategoryLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MemberCategoryLookupTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MemberCategoryLookupTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["requiresCRM"] = this.requiresCRM;
        data["validateCPF"] = this.validateCPF;
        data["validateCRM"] = this.validateCRM;
        data["allowNewUserRegister"] = this.allowNewUserRegister;
        if (Array.isArray(this.levels)) {
            data["levels"] = [];
            for (let item of this.levels)
                data["levels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMemberCategoryLookupTableDto {
    id: number;
    displayName: string | undefined;
    requiresCRM: boolean;
    validateCPF: boolean;
    validateCRM: boolean;
    allowNewUserRegister: boolean;
    levels: CategoryLevelDto[] | undefined;
}

export class PagedResultDtoOfCreateOrEditMemberCategoryDto implements IPagedResultDtoOfCreateOrEditMemberCategoryDto {
    totalCount!: number;
    items!: CreateOrEditMemberCategoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCreateOrEditMemberCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(CreateOrEditMemberCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCreateOrEditMemberCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCreateOrEditMemberCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfCreateOrEditMemberCategoryDto {
    totalCount: number;
    items: CreateOrEditMemberCategoryDto[] | undefined;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class DisapproveDocDto implements IDisapproveDocDto {
    note!: string | undefined;
    id!: number;

    constructor(data?: IDisapproveDocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DisapproveDocDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisapproveDocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }
}

export interface IDisapproveDocDto {
    note: string | undefined;
    id: number;
}

export class ListResultDtoOfMemberSpecialtyDto implements IListResultDtoOfMemberSpecialtyDto {
    items!: MemberSpecialtyDto[] | undefined;

    constructor(data?: IListResultDtoOfMemberSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(MemberSpecialtyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMemberSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfMemberSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMemberSpecialtyDto {
    items: MemberSpecialtyDto[] | undefined;
}

export class GetMemberSpecialtyForViewDto implements IGetMemberSpecialtyForViewDto {
    specialty!: MemberSpecialtyDto;
    totalMembers!: number;

    constructor(data?: IGetMemberSpecialtyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.specialty = data["specialty"] ? MemberSpecialtyDto.fromJS(data["specialty"]) : <any>undefined;
            this.totalMembers = data["totalMembers"];
        }
    }

    static fromJS(data: any): GetMemberSpecialtyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberSpecialtyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["specialty"] = this.specialty ? this.specialty.toJSON() : <any>undefined;
        data["totalMembers"] = this.totalMembers;
        return data; 
    }
}

export interface IGetMemberSpecialtyForViewDto {
    specialty: MemberSpecialtyDto;
    totalMembers: number;
}

export class PagedResultDtoOfGetMemberSpecialtyForViewDto implements IPagedResultDtoOfGetMemberSpecialtyForViewDto {
    totalCount!: number;
    items!: GetMemberSpecialtyForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetMemberSpecialtyForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetMemberSpecialtyForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetMemberSpecialtyForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetMemberSpecialtyForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetMemberSpecialtyForViewDto {
    totalCount: number;
    items: GetMemberSpecialtyForViewDto[] | undefined;
}

export class CreateOrEditMemberSpecialtyDto implements ICreateOrEditMemberSpecialtyDto {
    description!: string | undefined;
    isActive!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditMemberSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditMemberSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditMemberSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditMemberSpecialtyDto {
    description: string | undefined;
    isActive: boolean;
    id: number | undefined;
}

export enum UserNotificationState {
    Unread = 0,
    Read = 1,
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).type = data["type"];
            if (data["properties"]) {
                this.properties = {} as any;
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties![key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
    Fatal = 4,
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: moment.Moment;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            this.entityId = data["entityId"];
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string | undefined;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string | undefined;
    isSubscribed: boolean;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (Array.isArray(data["notifications"])) {
                this.notifications = [] as any;
                for (let item of data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string | undefined;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string | undefined;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (Array.isArray(data["notifications"])) {
                this.notifications = [] as any;
                for (let item of data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class GetOrderItemProductForViewDto implements IGetOrderItemProductForViewDto {
    orderItemProduct!: OrderItemProductDto;

    constructor(data?: IGetOrderItemProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderItemProduct = data["orderItemProduct"] ? OrderItemProductDto.fromJS(data["orderItemProduct"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderItemProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderItemProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderItemProduct"] = this.orderItemProduct ? this.orderItemProduct.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetOrderItemProductForViewDto {
    orderItemProduct: OrderItemProductDto;
}

export class PagedResultDtoOfGetOrderItemProductForViewDto implements IPagedResultDtoOfGetOrderItemProductForViewDto {
    totalCount!: number;
    items!: GetOrderItemProductForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrderItemProductForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetOrderItemProductForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrderItemProductForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrderItemProductForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetOrderItemProductForViewDto {
    totalCount: number;
    items: GetOrderItemProductForViewDto[] | undefined;
}

export class OrderItemProductLogoInput implements IOrderItemProductLogoInput {
    orderItemProductId!: number;
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IOrderItemProductLogoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderItemProductId = data["orderItemProductId"];
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): OrderItemProductLogoInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemProductLogoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderItemProductId"] = this.orderItemProductId;
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IOrderItemProductLogoInput {
    orderItemProductId: number;
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class CreateOrEditOrderItemProductDto implements ICreateOrEditOrderItemProductDto {
    isActive!: boolean;
    description!: string | undefined;
    amount!: number;
    logoPath!: string | undefined;
    logoInput!: OrderItemProductLogoInput;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrderItemProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.amount = data["amount"];
            this.logoPath = data["logoPath"];
            this.logoInput = data["logoInput"] ? OrderItemProductLogoInput.fromJS(data["logoInput"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrderItemProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrderItemProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["logoPath"] = this.logoPath;
        data["logoInput"] = this.logoInput ? this.logoInput.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditOrderItemProductDto {
    isActive: boolean;
    description: string | undefined;
    amount: number;
    logoPath: string | undefined;
    logoInput: OrderItemProductLogoInput;
    id: number | undefined;
}

export class ListResultDtoOfOrderItemProductDto implements IListResultDtoOfOrderItemProductDto {
    items!: OrderItemProductDto[] | undefined;

    constructor(data?: IListResultDtoOfOrderItemProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrderItemProductDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrderItemProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrderItemProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrderItemProductDto {
    items: OrderItemProductDto[] | undefined;
}

export class GetOrderItemProductForEditOutput implements IGetOrderItemProductForEditOutput {
    orderItemProduct!: CreateOrEditOrderItemProductDto;

    constructor(data?: IGetOrderItemProductForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderItemProduct = data["orderItemProduct"] ? CreateOrEditOrderItemProductDto.fromJS(data["orderItemProduct"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderItemProductForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderItemProductForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderItemProduct"] = this.orderItemProduct ? this.orderItemProduct.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetOrderItemProductForEditOutput {
    orderItemProduct: CreateOrEditOrderItemProductDto;
}

export enum OrderItemType {
    Registration = 0,
    Annuity = 1,
    Free = 2,
}

export class GetOrderForViewDto implements IGetOrderForViewDto {
    order!: OrderDto;
    payment!: PaymentCompleteDto;
    memberId!: number | undefined;
    memberEmailAddress!: string | undefined;
    memberPhone!: string | undefined;
    memberBadgeName!: string | undefined;

    constructor(data?: IGetOrderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"] ? OrderDto.fromJS(data["order"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.memberId = data["memberId"];
            this.memberEmailAddress = data["memberEmailAddress"];
            this.memberPhone = data["memberPhone"];
            this.memberBadgeName = data["memberBadgeName"];
        }
    }

    static fromJS(data: any): GetOrderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["memberId"] = this.memberId;
        data["memberEmailAddress"] = this.memberEmailAddress;
        data["memberPhone"] = this.memberPhone;
        data["memberBadgeName"] = this.memberBadgeName;
        return data; 
    }
}

export interface IGetOrderForViewDto {
    order: OrderDto;
    payment: PaymentCompleteDto;
    memberId: number | undefined;
    memberEmailAddress: string | undefined;
    memberPhone: string | undefined;
    memberBadgeName: string | undefined;
}

export class PagedResultDtoOfGetOrderForViewDto implements IPagedResultDtoOfGetOrderForViewDto {
    totalCount!: number;
    items!: GetOrderForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetOrderForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetOrderForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetOrderForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetOrderForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetOrderForViewDto {
    totalCount: number;
    items: GetOrderForViewDto[] | undefined;
}

export class CreateOrEditPixPaymentDto implements ICreateOrEditPixPaymentDto {
    key!: string | undefined;
    dueDate!: moment.Moment;
    pixCopiaECola!: string | undefined;
    urlQrCodeImage!: string | undefined;
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPixPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.pixCopiaECola = data["pixCopiaECola"];
            this.urlQrCodeImage = data["urlQrCodeImage"];
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPixPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPixPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["pixCopiaECola"] = this.pixCopiaECola;
        data["urlQrCodeImage"] = this.urlQrCodeImage;
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPixPaymentDto {
    key: string | undefined;
    dueDate: moment.Moment;
    pixCopiaECola: string | undefined;
    urlQrCodeImage: string | undefined;
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditCashPaymentDto implements ICreateOrEditCashPaymentDto {
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCashPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCashPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCashPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCashPaymentDto {
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditTicketPaymentDto implements ICreateOrEditTicketPaymentDto {
    barcode!: string | undefined;
    dueDate!: moment.Moment;
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditTicketPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.barcode = data["barcode"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditTicketPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditTicketPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditTicketPaymentDto {
    barcode: string | undefined;
    dueDate: moment.Moment;
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditCreditCardPaymentDto implements ICreateOrEditCreditCardPaymentDto {
    hash!: string | undefined;
    holderCpfCnpj!: string | undefined;
    holderPhone!: string | undefined;
    holderBornDate!: moment.Moment | undefined;
    cardBrand!: string | undefined;
    holderName!: string | undefined;
    cardNumber!: string | undefined;
    cardExpirationDate!: moment.Moment | undefined;
    creditCardToken!: string | undefined;
    installment!: InstallmentDto;
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCreditCardPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hash = data["hash"];
            this.holderCpfCnpj = data["holderCpfCnpj"];
            this.holderPhone = data["holderPhone"];
            this.holderBornDate = data["holderBornDate"] ? moment(data["holderBornDate"].toString()) : <any>undefined;
            this.cardBrand = data["cardBrand"];
            this.holderName = data["holderName"];
            this.cardNumber = data["cardNumber"];
            this.cardExpirationDate = data["cardExpirationDate"] ? moment(data["cardExpirationDate"].toString()) : <any>undefined;
            this.creditCardToken = data["creditCardToken"];
            this.installment = data["installment"] ? InstallmentDto.fromJS(data["installment"]) : <any>undefined;
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCreditCardPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCreditCardPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hash"] = this.hash;
        data["holderCpfCnpj"] = this.holderCpfCnpj;
        data["holderPhone"] = this.holderPhone;
        data["holderBornDate"] = this.holderBornDate ? this.holderBornDate.toISOString() : <any>undefined;
        data["cardBrand"] = this.cardBrand;
        data["holderName"] = this.holderName;
        data["cardNumber"] = this.cardNumber;
        data["cardExpirationDate"] = this.cardExpirationDate ? this.cardExpirationDate.toISOString() : <any>undefined;
        data["creditCardToken"] = this.creditCardToken;
        data["installment"] = this.installment ? this.installment.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCreditCardPaymentDto {
    hash: string | undefined;
    holderCpfCnpj: string | undefined;
    holderPhone: string | undefined;
    holderBornDate: moment.Moment | undefined;
    cardBrand: string | undefined;
    holderName: string | undefined;
    cardNumber: string | undefined;
    cardExpirationDate: moment.Moment | undefined;
    creditCardToken: string | undefined;
    installment: InstallmentDto;
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditOnlineDebitPaymentDto implements ICreateOrEditOnlineDebitPaymentDto {
    hash!: string | undefined;
    bankName!: string | undefined;
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOnlineDebitPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hash = data["hash"];
            this.bankName = data["bankName"];
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOnlineDebitPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOnlineDebitPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hash"] = this.hash;
        data["bankName"] = this.bankName;
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditOnlineDebitPaymentDto {
    hash: string | undefined;
    bankName: string | undefined;
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditCouponPaymentDto implements ICreateOrEditCouponPaymentDto {
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditCouponPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditCouponPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditCouponPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditCouponPaymentDto {
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditPagSeguroPaymentDto implements ICreateOrEditPagSeguroPaymentDto {
    description!: string | undefined;
    phone!: string | undefined;
    name!: string | undefined;
    email!: string | undefined;
    cpf!: string | undefined;
    paymentLink!: string | undefined;
    pagSeguroRefCode!: string | undefined;
    pagSeguroConfigId!: number;
    bornDate!: moment.Moment | undefined;
    paidDate!: moment.Moment | undefined;
    expireDate!: moment.Moment | undefined;
    total!: number;
    discount!: number;
    discountCoupon!: number;
    discountPaymentMethod!: number;
    discountManually!: number;
    totalPaid!: number;
    returnedTotal!: number | undefined;
    returnedDate!: moment.Moment | undefined;
    status!: PaymentStatus;
    type!: PaymentType;
    feeAmount!: number | undefined;
    netAmount!: number | undefined;
    escrowEndDate!: moment.Moment | undefined;
    notes!: string | undefined;
    manuallyEdited!: boolean;
    address!: PaymentAddressDto;
    couponCode!: string | undefined;
    orderId!: number | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditPagSeguroPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.phone = data["phone"];
            this.name = data["name"];
            this.email = data["email"];
            this.cpf = data["cpf"];
            this.paymentLink = data["paymentLink"];
            this.pagSeguroRefCode = data["pagSeguroRefCode"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.paidDate = data["paidDate"] ? moment(data["paidDate"].toString()) : <any>undefined;
            this.expireDate = data["expireDate"] ? moment(data["expireDate"].toString()) : <any>undefined;
            this.total = data["total"];
            this.discount = data["discount"];
            this.discountCoupon = data["discountCoupon"];
            this.discountPaymentMethod = data["discountPaymentMethod"];
            this.discountManually = data["discountManually"];
            this.totalPaid = data["totalPaid"];
            this.returnedTotal = data["returnedTotal"];
            this.returnedDate = data["returnedDate"] ? moment(data["returnedDate"].toString()) : <any>undefined;
            this.status = data["status"];
            this.type = data["type"];
            this.feeAmount = data["feeAmount"];
            this.netAmount = data["netAmount"];
            this.escrowEndDate = data["escrowEndDate"] ? moment(data["escrowEndDate"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.manuallyEdited = data["manuallyEdited"];
            this.address = data["address"] ? PaymentAddressDto.fromJS(data["address"]) : <any>undefined;
            this.couponCode = data["couponCode"];
            this.orderId = data["orderId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditPagSeguroPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditPagSeguroPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["phone"] = this.phone;
        data["name"] = this.name;
        data["email"] = this.email;
        data["cpf"] = this.cpf;
        data["paymentLink"] = this.paymentLink;
        data["pagSeguroRefCode"] = this.pagSeguroRefCode;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["total"] = this.total;
        data["discount"] = this.discount;
        data["discountCoupon"] = this.discountCoupon;
        data["discountPaymentMethod"] = this.discountPaymentMethod;
        data["discountManually"] = this.discountManually;
        data["totalPaid"] = this.totalPaid;
        data["returnedTotal"] = this.returnedTotal;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["feeAmount"] = this.feeAmount;
        data["netAmount"] = this.netAmount;
        data["escrowEndDate"] = this.escrowEndDate ? this.escrowEndDate.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["manuallyEdited"] = this.manuallyEdited;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["couponCode"] = this.couponCode;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditPagSeguroPaymentDto {
    description: string | undefined;
    phone: string | undefined;
    name: string | undefined;
    email: string | undefined;
    cpf: string | undefined;
    paymentLink: string | undefined;
    pagSeguroRefCode: string | undefined;
    pagSeguroConfigId: number;
    bornDate: moment.Moment | undefined;
    paidDate: moment.Moment | undefined;
    expireDate: moment.Moment | undefined;
    total: number;
    discount: number;
    discountCoupon: number;
    discountPaymentMethod: number;
    discountManually: number;
    totalPaid: number;
    returnedTotal: number | undefined;
    returnedDate: moment.Moment | undefined;
    status: PaymentStatus;
    type: PaymentType;
    feeAmount: number | undefined;
    netAmount: number | undefined;
    escrowEndDate: moment.Moment | undefined;
    notes: string | undefined;
    manuallyEdited: boolean;
    address: PaymentAddressDto;
    couponCode: string | undefined;
    orderId: number | undefined;
    id: number | undefined;
}

export class CreateOrEditOrderDto implements ICreateOrEditOrderDto {
    tenantId!: number | undefined;
    description!: string | undefined;
    dueDate!: moment.Moment | undefined;
    userId!: number | undefined;
    user!: UserListDto;
    situation!: OrderSituation;
    items!: OrderItemDto[] | undefined;
    paymentMethods!: PaymentMethodPermissionDto[] | undefined;
    pixPayment!: CreateOrEditPixPaymentDto;
    cashPayment!: CreateOrEditCashPaymentDto;
    ticketPayment!: CreateOrEditTicketPaymentDto;
    creditCardPayment!: CreateOrEditCreditCardPaymentDto;
    onlineDebitPayment!: CreateOrEditOnlineDebitPaymentDto;
    couponPayment!: CreateOrEditCouponPaymentDto;
    pagseguroPayment!: CreateOrEditPagSeguroPaymentDto;
    payment!: PaymentCompleteDto;
    isEdit!: boolean;
    itsFree!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserListDto.fromJS(data["user"]) : <any>undefined;
            this.situation = data["situation"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrderItemDto.fromJS(item));
            }
            if (Array.isArray(data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethodPermissionDto.fromJS(item));
            }
            this.pixPayment = data["pixPayment"] ? CreateOrEditPixPaymentDto.fromJS(data["pixPayment"]) : <any>undefined;
            this.cashPayment = data["cashPayment"] ? CreateOrEditCashPaymentDto.fromJS(data["cashPayment"]) : <any>undefined;
            this.ticketPayment = data["ticketPayment"] ? CreateOrEditTicketPaymentDto.fromJS(data["ticketPayment"]) : <any>undefined;
            this.creditCardPayment = data["creditCardPayment"] ? CreateOrEditCreditCardPaymentDto.fromJS(data["creditCardPayment"]) : <any>undefined;
            this.onlineDebitPayment = data["onlineDebitPayment"] ? CreateOrEditOnlineDebitPaymentDto.fromJS(data["onlineDebitPayment"]) : <any>undefined;
            this.couponPayment = data["couponPayment"] ? CreateOrEditCouponPaymentDto.fromJS(data["couponPayment"]) : <any>undefined;
            this.pagseguroPayment = data["pagseguroPayment"] ? CreateOrEditPagSeguroPaymentDto.fromJS(data["pagseguroPayment"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.isEdit = data["isEdit"];
            this.itsFree = data["itsFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["situation"] = this.situation;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["pixPayment"] = this.pixPayment ? this.pixPayment.toJSON() : <any>undefined;
        data["cashPayment"] = this.cashPayment ? this.cashPayment.toJSON() : <any>undefined;
        data["ticketPayment"] = this.ticketPayment ? this.ticketPayment.toJSON() : <any>undefined;
        data["creditCardPayment"] = this.creditCardPayment ? this.creditCardPayment.toJSON() : <any>undefined;
        data["onlineDebitPayment"] = this.onlineDebitPayment ? this.onlineDebitPayment.toJSON() : <any>undefined;
        data["couponPayment"] = this.couponPayment ? this.couponPayment.toJSON() : <any>undefined;
        data["pagseguroPayment"] = this.pagseguroPayment ? this.pagseguroPayment.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["isEdit"] = this.isEdit;
        data["itsFree"] = this.itsFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditOrderDto {
    tenantId: number | undefined;
    description: string | undefined;
    dueDate: moment.Moment | undefined;
    userId: number | undefined;
    user: UserListDto;
    situation: OrderSituation;
    items: OrderItemDto[] | undefined;
    paymentMethods: PaymentMethodPermissionDto[] | undefined;
    pixPayment: CreateOrEditPixPaymentDto;
    cashPayment: CreateOrEditCashPaymentDto;
    ticketPayment: CreateOrEditTicketPaymentDto;
    creditCardPayment: CreateOrEditCreditCardPaymentDto;
    onlineDebitPayment: CreateOrEditOnlineDebitPaymentDto;
    couponPayment: CreateOrEditCouponPaymentDto;
    pagseguroPayment: CreateOrEditPagSeguroPaymentDto;
    payment: PaymentCompleteDto;
    isEdit: boolean;
    itsFree: boolean;
    id: number | undefined;
}

export class GetOrderForEditOutput implements IGetOrderForEditOutput {
    order!: CreateOrEditOrderDto;

    constructor(data?: IGetOrderForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"] ? CreateOrEditOrderDto.fromJS(data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetOrderForEditOutput {
    order: CreateOrEditOrderDto;
}

export class CreateOrEditOrderOutput implements ICreateOrEditOrderOutput {
    id!: number | undefined;
    success!: boolean;
    message!: string | undefined;
    html!: string | undefined;
    data!: string | undefined;
    url!: string | undefined;
    barcode!: string | undefined;
    pixCopiaECola!: string | undefined;
    itsPaid!: boolean;

    constructor(data?: ICreateOrEditOrderOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.data = data["data"];
            this.url = data["url"];
            this.barcode = data["barcode"];
            this.pixCopiaECola = data["pixCopiaECola"];
            this.itsPaid = data["itsPaid"];
        }
    }

    static fromJS(data: any): CreateOrEditOrderOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditOrderOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["data"] = this.data;
        data["url"] = this.url;
        data["barcode"] = this.barcode;
        data["pixCopiaECola"] = this.pixCopiaECola;
        data["itsPaid"] = this.itsPaid;
        return data; 
    }
}

export interface ICreateOrEditOrderOutput {
    id: number | undefined;
    success: boolean;
    message: string | undefined;
    html: string | undefined;
    data: string | undefined;
    url: string | undefined;
    barcode: string | undefined;
    pixCopiaECola: string | undefined;
    itsPaid: boolean;
}

export class GiveMoneyBackInput implements IGiveMoneyBackInput {
    orderId!: number;
    value!: number;

    constructor(data?: IGiveMoneyBackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): GiveMoneyBackInput {
        data = typeof data === 'object' ? data : {};
        let result = new GiveMoneyBackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["value"] = this.value;
        return data; 
    }
}

export interface IGiveMoneyBackInput {
    orderId: number;
    value: number;
}

export class UpdateReceiptImageInput implements IUpdateReceiptImageInput {
    fileName!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateReceiptImageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateReceiptImageInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReceiptImageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateReceiptImageInput {
    fileName: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class ReceiptSettingsDto implements IReceiptSettingsDto {
    text!: string | undefined;
    pathFile!: string | undefined;
    defaultFile!: boolean;
    input!: UpdateReceiptImageInput;

    constructor(data?: IReceiptSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"];
            this.pathFile = data["pathFile"];
            this.defaultFile = data["defaultFile"];
            this.input = data["input"] ? UpdateReceiptImageInput.fromJS(data["input"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["pathFile"] = this.pathFile;
        data["defaultFile"] = this.defaultFile;
        data["input"] = this.input ? this.input.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IReceiptSettingsDto {
    text: string | undefined;
    pathFile: string | undefined;
    defaultFile: boolean;
    input: UpdateReceiptImageInput;
}

export class GetReceiptDto implements IGetReceiptDto {
    orderId!: number | undefined;
    registrationId!: number | undefined;
    annuityId!: number | undefined;

    constructor(data?: IGetReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.orderId = data["orderId"];
            this.registrationId = data["registrationId"];
            this.annuityId = data["annuityId"];
        }
    }

    static fromJS(data: any): GetReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["registrationId"] = this.registrationId;
        data["annuityId"] = this.annuityId;
        return data; 
    }
}

export interface IGetReceiptDto {
    orderId: number | undefined;
    registrationId: number | undefined;
    annuityId: number | undefined;
}

export class KeyValuePairOfStringStringValues implements IKeyValuePairOfStringStringValues {
    readonly key!: string | undefined;
    readonly value!: string[];

    constructor(data?: IKeyValuePairOfStringStringValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).key = data["key"];
            if (Array.isArray(data["value"])) {
                (<any>this).value = [] as any;
                for (let item of data["value"])
                    (<any>this).value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringStringValues {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringStringValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data; 
    }
}

export interface IKeyValuePairOfStringStringValues {
    key: string | undefined;
    value: string[];
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.roleCount = data["roleCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: moment.Moment;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.name = data["name"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: moment.Moment;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string | undefined;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string | undefined;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data; 
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["userIds"])) {
                this.userIds = [] as any;
                for (let item of data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
}

export class PagSeguroWebhookDto implements IPagSeguroWebhookDto {
    endToEndId!: string | undefined;
    txId!: string | undefined;
    valor!: string | undefined;
    horario!: string | undefined;

    constructor(data?: IPagSeguroWebhookDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endToEndId = data["endToEndId"];
            this.txId = data["txId"];
            this.valor = data["valor"];
            this.horario = data["horario"];
        }
    }

    static fromJS(data: any): PagSeguroWebhookDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagSeguroWebhookDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endToEndId"] = this.endToEndId;
        data["txId"] = this.txId;
        data["valor"] = this.valor;
        data["horario"] = this.horario;
        return data; 
    }
}

export interface IPagSeguroWebhookDto {
    endToEndId: string | undefined;
    txId: string | undefined;
    valor: string | undefined;
    horario: string | undefined;
}

export class PagSeguroInstallmentsResponse implements IPagSeguroInstallmentsResponse {
    success!: boolean;
    response!: string | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IPagSeguroInstallmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.success = data["success"];
            this.response = data["response"];
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): PagSeguroInstallmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagSeguroInstallmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["response"] = this.response;
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IPagSeguroInstallmentsResponse {
    success: boolean;
    response: string | undefined;
    errorMessage: string | undefined;
}

export class PagSeguroPublicKeysResponse implements IPagSeguroPublicKeysResponse {
    public_key!: string | undefined;

    constructor(data?: IPagSeguroPublicKeysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.public_key = data["public_key"];
        }
    }

    static fromJS(data: any): PagSeguroPublicKeysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PagSeguroPublicKeysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["public_key"] = this.public_key;
        return data; 
    }
}

export interface IPagSeguroPublicKeysResponse {
    public_key: string | undefined;
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.dailyPrice = data["dailyPrice"];
            this.weeklyPrice = data["weeklyPrice"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto;
    additionalPrice!: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data; 
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export enum EditionPaymentType {
    NewRegistration = 0,
    BuyNow = 1,
    Upgrade = 2,
    Extend = 3,
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export enum SubscriptionPaymentGatewayType {
    Paypal = 1,
    Stripe = 2,
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number;
    editionPaymentType!: EditionPaymentType;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = data["recurringPaymentEnabled"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data; 
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.gateway = data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data; 
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number;
    editionId!: number;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    externalPaymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.externalPaymentId = data["externalPaymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    externalPaymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gatewayType = data["gatewayType"];
            this.supportsRecurringPayments = data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data; 
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export enum SubscriptionPaymentStatus {
    NotPaid = 1,
    Paid = 2,
    Failed = 3,
    Cancelled = 4,
    Completed = 5,
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    description!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;
    amount!: number;
    editionId!: number;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    editionPaymentType!: EditionPaymentType;
    id!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.tenantId = data["tenantId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.status = data["status"];
            this.isRecurring = data["isRecurring"];
            this.externalPaymentId = data["externalPaymentId"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
            this.editionPaymentType = data["editionPaymentType"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["editionPaymentType"] = this.editionPaymentType;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentDto {
    description: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
    amount: number;
    editionId: number;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    payerId: string | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    editionPaymentType: EditionPaymentType;
    id: number;
}

export class PaymentMethodDto implements IPaymentMethodDto {
    paymentType!: PaymentType;
    pagSeguroConfigId!: number | undefined;
    description!: string | undefined;
    isActive!: boolean;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentType = data["paymentType"];
            this.pagSeguroConfigId = data["pagSeguroConfigId"];
            this.description = data["description"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["pagSeguroConfigId"] = this.pagSeguroConfigId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IPaymentMethodDto {
    paymentType: PaymentType;
    pagSeguroConfigId: number | undefined;
    description: string | undefined;
    isActive: boolean;
}

export class PagedResultDtoOfPaymentMethodDto implements IPagedResultDtoOfPaymentMethodDto {
    totalCount!: number;
    items!: PaymentMethodDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PaymentMethodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPaymentMethodDto {
    totalCount: number;
    items: PaymentMethodDto[] | undefined;
}

export class BrandDto implements IBrandDto {
    code!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    imagePath!: string | undefined;
    isActive!: boolean;
    id!: number;

    constructor(data?: IBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.imagePath = data["imagePath"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["imagePath"] = this.imagePath;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IBrandDto {
    code: number;
    name: string | undefined;
    displayName: string | undefined;
    imagePath: string | undefined;
    isActive: boolean;
    id: number;
}

export class ListResultDtoOfBrandDto implements IListResultDtoOfBrandDto {
    items!: BrandDto[] | undefined;

    constructor(data?: IListResultDtoOfBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(BrandDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfBrandDto {
    items: BrandDto[] | undefined;
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.clientId = data["clientId"];
            this.demoUsername = data["demoUsername"];
            this.demoPassword = data["demoPassword"];
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data; 
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string | undefined;
    newPassword!: string | undefined;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    currentPassword: string | undefined;
    newPassword: string | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileToken = data["fileToken"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string | undefined;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string | undefined;
}

export class CurrentMemberProfileDto implements ICurrentMemberProfileDto {
    cpf!: string | undefined;
    badgeName!: string | undefined;
    crm!: string | undefined;
    statusCrm!: StatusCrm;
    situationCrm!: SituationCrm;
    rg!: string | undefined;
    rgEmitter!: string | undefined;
    rgEmitterUf!: string | undefined;
    bornDate!: moment.Moment | undefined;
    graduationYear!: number | undefined;
    specialtyId!: number | undefined;
    id!: number;

    constructor(data?: ICurrentMemberProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.cpf = data["cpf"];
            this.badgeName = data["badgeName"];
            this.crm = data["crm"];
            this.statusCrm = data["statusCrm"];
            this.situationCrm = data["situationCrm"];
            this.rg = data["rg"];
            this.rgEmitter = data["rgEmitter"];
            this.rgEmitterUf = data["rgEmitterUf"];
            this.bornDate = data["bornDate"] ? moment(data["bornDate"].toString()) : <any>undefined;
            this.graduationYear = data["graduationYear"];
            this.specialtyId = data["specialtyId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrentMemberProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentMemberProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cpf"] = this.cpf;
        data["badgeName"] = this.badgeName;
        data["crm"] = this.crm;
        data["statusCrm"] = this.statusCrm;
        data["situationCrm"] = this.situationCrm;
        data["rg"] = this.rg;
        data["rgEmitter"] = this.rgEmitter;
        data["rgEmitterUf"] = this.rgEmitterUf;
        data["bornDate"] = this.bornDate ? this.bornDate.toISOString() : <any>undefined;
        data["graduationYear"] = this.graduationYear;
        data["specialtyId"] = this.specialtyId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrentMemberProfileDto {
    cpf: string | undefined;
    badgeName: string | undefined;
    crm: string | undefined;
    statusCrm: StatusCrm;
    situationCrm: SituationCrm;
    rg: string | undefined;
    rgEmitter: string | undefined;
    rgEmitterUf: string | undefined;
    bornDate: moment.Moment | undefined;
    graduationYear: number | undefined;
    specialtyId: number | undefined;
    id: number;
}

export class CurrentUserProfileDto implements ICurrentUserProfileDto {
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    member!: CurrentMemberProfileDto;
    emails!: UserEmailDto[] | undefined;
    phones!: UserPhoneDto[] | undefined;
    addresses!: UserAddressDto[] | undefined;
    id!: number;

    constructor(data?: ICurrentUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.member = data["member"] ? CurrentMemberProfileDto.fromJS(data["member"]) : <any>undefined;
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(UserEmailDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(UserPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(UserAddressDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CurrentUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICurrentUserProfileDto {
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    member: CurrentMemberProfileDto;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    id: number;
}

export class CurrentProfileEditDto implements ICurrentProfileEditDto {
    user!: CurrentUserProfileDto;
    mainAddress!: UserAddressDto;
    mainPhone!: UserPhoneDto;
    profilePictureId!: string | undefined;
    annuitySituation!: MemberAnnuitySituation;

    constructor(data?: ICurrentProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? CurrentUserProfileDto.fromJS(data["user"]) : <any>undefined;
            this.mainAddress = data["mainAddress"] ? UserAddressDto.fromJS(data["mainAddress"]) : <any>undefined;
            this.mainPhone = data["mainPhone"] ? UserPhoneDto.fromJS(data["mainPhone"]) : <any>undefined;
            this.profilePictureId = data["profilePictureId"];
            this.annuitySituation = data["annuitySituation"];
        }
    }

    static fromJS(data: any): CurrentProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["mainAddress"] = this.mainAddress ? this.mainAddress.toJSON() : <any>undefined;
        data["mainPhone"] = this.mainPhone ? this.mainPhone.toJSON() : <any>undefined;
        data["profilePictureId"] = this.profilePictureId;
        data["annuitySituation"] = this.annuitySituation;
        return data; 
    }
}

export interface ICurrentProfileEditDto {
    user: CurrentUserProfileDto;
    mainAddress: UserAddressDto;
    mainPhone: UserPhoneDto;
    profilePictureId: string | undefined;
    annuitySituation: MemberAnnuitySituation;
}

export class OutputAnnuityProfileForViewDto implements IOutputAnnuityProfileForViewDto {
    memberCategory!: MemberCategoryDto;

    constructor(data?: IOutputAnnuityProfileForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberCategory = data["memberCategory"] ? MemberCategoryDto.fromJS(data["memberCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OutputAnnuityProfileForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OutputAnnuityProfileForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberCategory"] = this.memberCategory ? this.memberCategory.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IOutputAnnuityProfileForViewDto {
    memberCategory: MemberCategoryDto;
}

export class CreateOrEditRegistrationExtraFee implements ICreateOrEditRegistrationExtraFee {
    extraFeeId!: number;
    registrationId!: number;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRegistrationExtraFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extraFeeId = data["extraFeeId"];
            this.registrationId = data["registrationId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationExtraFee {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegistrationExtraFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraFeeId"] = this.extraFeeId;
        data["registrationId"] = this.registrationId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRegistrationExtraFee {
    extraFeeId: number;
    registrationId: number;
    id: number | undefined;
}

export class CreateOrEditRegistrationDto implements ICreateOrEditRegistrationDto {
    isFree!: boolean;
    presence!: boolean;
    categoryId!: number | undefined;
    eventDeadlineId!: number;
    userId!: number;
    tenantId!: number | undefined;
    payment!: PaymentCompleteDto;
    cashPayment!: CreateOrEditCashPaymentDto;
    pagseguroPayment!: CreateOrEditPagSeguroPaymentDto;
    fees!: CreateOrEditRegistrationExtraFee[] | undefined;
    id!: number | undefined;

    constructor(data?: ICreateOrEditRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.presence = data["presence"];
            this.categoryId = data["categoryId"];
            this.eventDeadlineId = data["eventDeadlineId"];
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.cashPayment = data["cashPayment"] ? CreateOrEditCashPaymentDto.fromJS(data["cashPayment"]) : <any>undefined;
            this.pagseguroPayment = data["pagseguroPayment"] ? CreateOrEditPagSeguroPaymentDto.fromJS(data["pagseguroPayment"]) : <any>undefined;
            if (Array.isArray(data["fees"])) {
                this.fees = [] as any;
                for (let item of data["fees"])
                    this.fees!.push(CreateOrEditRegistrationExtraFee.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["presence"] = this.presence;
        data["categoryId"] = this.categoryId;
        data["eventDeadlineId"] = this.eventDeadlineId;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["cashPayment"] = this.cashPayment ? this.cashPayment.toJSON() : <any>undefined;
        data["pagseguroPayment"] = this.pagseguroPayment ? this.pagseguroPayment.toJSON() : <any>undefined;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditRegistrationDto {
    isFree: boolean;
    presence: boolean;
    categoryId: number | undefined;
    eventDeadlineId: number;
    userId: number;
    tenantId: number | undefined;
    payment: PaymentCompleteDto;
    cashPayment: CreateOrEditCashPaymentDto;
    pagseguroPayment: CreateOrEditPagSeguroPaymentDto;
    fees: CreateOrEditRegistrationExtraFee[] | undefined;
    id: number | undefined;
}

export class CreateOrEditRegistrationOutput implements ICreateOrEditRegistrationOutput {
    id!: number | undefined;
    errorOnSendEmail!: boolean;
    success!: boolean;
    message!: string | undefined;
    html!: string | undefined;
    data!: string | undefined;
    url!: string | undefined;
    barcode!: string | undefined;
    pixCopiaECola!: string | undefined;
    itsPaid!: boolean;

    constructor(data?: ICreateOrEditRegistrationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.errorOnSendEmail = data["errorOnSendEmail"];
            this.success = data["success"];
            this.message = data["message"];
            this.html = data["html"];
            this.data = data["data"];
            this.url = data["url"];
            this.barcode = data["barcode"];
            this.pixCopiaECola = data["pixCopiaECola"];
            this.itsPaid = data["itsPaid"];
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegistrationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["errorOnSendEmail"] = this.errorOnSendEmail;
        data["success"] = this.success;
        data["message"] = this.message;
        data["html"] = this.html;
        data["data"] = this.data;
        data["url"] = this.url;
        data["barcode"] = this.barcode;
        data["pixCopiaECola"] = this.pixCopiaECola;
        data["itsPaid"] = this.itsPaid;
        return data; 
    }
}

export interface ICreateOrEditRegistrationOutput {
    id: number | undefined;
    errorOnSendEmail: boolean;
    success: boolean;
    message: string | undefined;
    html: string | undefined;
    data: string | undefined;
    url: string | undefined;
    barcode: string | undefined;
    pixCopiaECola: string | undefined;
    itsPaid: boolean;
}

export class CreateOrEditListRegistrationDto implements ICreateOrEditListRegistrationDto {
    registrations!: CreateOrEditRegistrationDto[] | undefined;

    constructor(data?: ICreateOrEditListRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["registrations"])) {
                this.registrations = [] as any;
                for (let item of data["registrations"])
                    this.registrations!.push(CreateOrEditRegistrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrEditListRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditListRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrEditListRegistrationDto {
    registrations: CreateOrEditRegistrationDto[] | undefined;
}

export class CreateOrEditUserDto implements ICreateOrEditUserDto {
    userName!: string | undefined;
    name!: string | undefined;
    emailAddress!: string | undefined;
    hasRegistration!: boolean;
    member!: CreateOrEditMemberDto;
    emails!: UserEmailDto[] | undefined;
    phones!: UserPhoneDto[] | undefined;
    address!: UserAddressDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new UserAddressDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.name = data["name"];
            this.emailAddress = data["emailAddress"];
            this.hasRegistration = data["hasRegistration"];
            this.member = data["member"] ? CreateOrEditMemberDto.fromJS(data["member"]) : <any>undefined;
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(UserEmailDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(UserPhoneDto.fromJS(item));
            }
            this.address = data["address"] ? UserAddressDto.fromJS(data["address"]) : new UserAddressDto();
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["hasRegistration"] = this.hasRegistration;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditUserDto {
    userName: string | undefined;
    name: string | undefined;
    emailAddress: string | undefined;
    hasRegistration: boolean;
    member: CreateOrEditMemberDto;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    address: UserAddressDto;
    id: number | undefined;
}

export class CreateOrEditRegistrationUser implements ICreateOrEditRegistrationUser {
    tenantId!: number | undefined;
    isHotsite!: boolean | undefined;
    user!: CreateOrEditUserDto;
    pendingDocumentation!: boolean;
    registrationNotPayied!: boolean;
    registrationId!: number;
    hasRegistration!: boolean;
    approvedRegistration!: boolean;
    order!: OrderDto;
    payment!: PaymentCompleteDto;
    documentation!: CreateOrEditDocumentationDto;

    constructor(data?: ICreateOrEditRegistrationUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isHotsite = data["isHotsite"];
            this.user = data["user"] ? CreateOrEditUserDto.fromJS(data["user"]) : <any>undefined;
            this.pendingDocumentation = data["pendingDocumentation"];
            this.registrationNotPayied = data["registrationNotPayied"];
            this.registrationId = data["registrationId"];
            this.hasRegistration = data["hasRegistration"];
            this.approvedRegistration = data["approvedRegistration"];
            this.order = data["order"] ? OrderDto.fromJS(data["order"]) : <any>undefined;
            this.payment = data["payment"] ? PaymentCompleteDto.fromJS(data["payment"]) : <any>undefined;
            this.documentation = data["documentation"] ? CreateOrEditDocumentationDto.fromJS(data["documentation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditRegistrationUser {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditRegistrationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isHotsite"] = this.isHotsite;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["pendingDocumentation"] = this.pendingDocumentation;
        data["registrationNotPayied"] = this.registrationNotPayied;
        data["registrationId"] = this.registrationId;
        data["hasRegistration"] = this.hasRegistration;
        data["approvedRegistration"] = this.approvedRegistration;
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["payment"] = this.payment ? this.payment.toJSON() : <any>undefined;
        data["documentation"] = this.documentation ? this.documentation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditRegistrationUser {
    tenantId: number | undefined;
    isHotsite: boolean | undefined;
    user: CreateOrEditUserDto;
    pendingDocumentation: boolean;
    registrationNotPayied: boolean;
    registrationId: number;
    hasRegistration: boolean;
    approvedRegistration: boolean;
    order: OrderDto;
    payment: PaymentCompleteDto;
    documentation: CreateOrEditDocumentationDto;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;
    totalUsers!: number;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.totalUsers = data["totalUsers"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["totalUsers"] = this.totalUsers;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    totalUsers: number;
    id: number;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string | undefined;
    isDefault!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string | undefined;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (Array.isArray(data["permissions"])) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[] | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    id: number;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    creationTime!: moment.Moment;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.subscriptionPaymentType = data["subscriptionPaymentType"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            this.currency = data["currency"];
            this.currencySign = data["currencySign"];
            this.allowTenantsToChangeEmailSettings = data["allowTenantsToChangeEmailSettings"];
            if (data["features"]) {
                this.features = {} as any;
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features![key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    features: { [key: string]: boolean; } | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data; 
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;
    headerMenuArrows!: boolean;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.headerSkin = data["headerSkin"];
            this.minimizeDesktopHeaderType = data["minimizeDesktopHeaderType"];
            this.headerMenuArrows = data["headerMenuArrows"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        data["headerMenuArrows"] = this.headerMenuArrows;
        return data; 
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
    headerMenuArrows: boolean;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedSubHeader = data["fixedSubHeader"];
            this.subheaderStyle = data["subheaderStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        return data; 
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.submenuToggle = data["submenuToggle"];
            this.searchActive = data["searchActive"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        return data; 
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.theme = data["theme"];
            this.layout = data["layout"] ? ThemeLayoutSettingsDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? ThemeHeaderSettingsDto.fromJS(data["header"]) : <any>undefined;
            this.subHeader = data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(data["subHeader"]) : <any>undefined;
            this.menu = data["menu"] ? ThemeMenuSettingsDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? ThemeFooterSettingsDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.baseSettings = data["baseSettings"] ? ThemeSettingsDto.fromJS(data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = data["isLeftMenuUsed"];
            this.isTopMenuUsed = data["isTopMenuUsed"];
            this.isTabMenuUsed = data["isTabMenuUsed"];
            this.allowMenuScroll = data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data; 
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
            this.theme = data["theme"] ? UiCustomizationSettingsDto.fromJS(data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publishableKey = data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data; 
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
    paymentId!: number;
    successUrl!: string | undefined;
    cancelUrl!: string | undefined;

    constructor(data?: IStripeCreatePaymentSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.successUrl = data["successUrl"];
            this.cancelUrl = data["cancelUrl"];
        }
    }

    static fromJS(data: any): StripeCreatePaymentSessionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data; 
    }
}

export interface IStripeCreatePaymentSessionInput {
    paymentId: number;
    successUrl: string | undefined;
    cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
    paymentDone!: boolean;

    constructor(data?: IStripePaymentResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentDone = data["paymentDone"];
        }
    }

    static fromJS(data: any): StripePaymentResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        return data; 
    }
}

export interface IStripePaymentResultOutput {
    paymentDone: boolean;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: moment.Moment;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string | undefined;
    name!: string | undefined;
    adminEmailAddress!: string | undefined;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string | undefined;
    name: string | undefined;
    adminEmailAddress: string | undefined;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: moment.Moment | undefined;
    isInTrialPeriod!: boolean;
    baseHotsiteUrl!: string | undefined;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.baseHotsiteUrl = data["baseHotsiteUrl"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["baseHotsiteUrl"] = this.baseHotsiteUrl;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    tenancyName: string | undefined;
    name: string | undefined;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    baseHotsiteUrl: string | undefined;
    id: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(data["features"])) {
                this.features = [] as any;
                for (let item of data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[] | undefined;
}

export class HotsiteTenantDto implements IHotsiteTenantDto {
    id!: number;
    name!: string | undefined;
    logo!: string | undefined;
    friendlyUrl!: string | undefined;
    tenantId!: number | undefined;
    eventId!: number;
    color1!: string | undefined;
    color2!: string | undefined;
    isPublished!: boolean;

    constructor(data?: IHotsiteTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.logo = data["logo"];
            this.friendlyUrl = data["friendlyUrl"];
            this.tenantId = data["tenantId"];
            this.eventId = data["eventId"];
            this.color1 = data["color1"];
            this.color2 = data["color2"];
            this.isPublished = data["isPublished"];
        }
    }

    static fromJS(data: any): HotsiteTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new HotsiteTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["logo"] = this.logo;
        data["friendlyUrl"] = this.friendlyUrl;
        data["tenantId"] = this.tenantId;
        data["eventId"] = this.eventId;
        data["color1"] = this.color1;
        data["color2"] = this.color2;
        data["isPublished"] = this.isPublished;
        return data; 
    }
}

export interface IHotsiteTenantDto {
    id: number;
    name: string | undefined;
    logo: string | undefined;
    friendlyUrl: string | undefined;
    tenantId: number | undefined;
    eventId: number;
    color1: string | undefined;
    color2: string | undefined;
    isPublished: boolean;
}

export enum SalesSummaryDatePeriod {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;
    discount!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
            this.discount = data["discount"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        data["discount"] = this.discount;
        return data; 
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
    discount: number;
}

export class DailyRegistrationData implements IDailyRegistrationData {
    day!: string | undefined;
    count!: number;

    constructor(data?: IDailyRegistrationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.day = data["day"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): DailyRegistrationData {
        data = typeof data === 'object' ? data : {};
        let result = new DailyRegistrationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["count"] = this.count;
        return data; 
    }
}

export interface IDailyRegistrationData {
    day: string | undefined;
    count: number;
}

export class RegistrationCategoryData implements IRegistrationCategoryData {
    category!: string | undefined;
    count!: number;

    constructor(data?: IRegistrationCategoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): RegistrationCategoryData {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationCategoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["count"] = this.count;
        return data; 
    }
}

export interface IRegistrationCategoryData {
    category: string | undefined;
    count: number;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    totalProfitChange!: number;
    totalReceivablesChange!: number;
    newOrdersChange!: number;
    newUsersChange!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: DailyRegistrationData[] | undefined;
    profitShares!: RegistrationCategoryData[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            this.totalProfitChange = data["totalProfitChange"];
            this.totalReceivablesChange = data["totalReceivablesChange"];
            this.newOrdersChange = data["newOrdersChange"];
            this.newUsersChange = data["newUsersChange"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (Array.isArray(data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of data["dailySales"])
                    this.dailySales!.push(DailyRegistrationData.fromJS(item));
            }
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of data["profitShares"])
                    this.profitShares!.push(RegistrationCategoryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        data["totalProfitChange"] = this.totalProfitChange;
        data["totalReceivablesChange"] = this.totalReceivablesChange;
        data["newOrdersChange"] = this.newOrdersChange;
        data["newUsersChange"] = this.newUsersChange;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item.toJSON());
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    totalProfitChange: number;
    totalReceivablesChange: number;
    newOrdersChange: number;
    newUsersChange: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: DailyRegistrationData[] | undefined;
    profitShares: RegistrationCategoryData[] | undefined;
}

export class MemberActivity implements IMemberActivity {
    pic!: string | undefined;
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: number;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pic = data["pic"];
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pic"] = this.pic;
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IMemberActivity {
    pic: string | undefined;
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: number;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    totalReceivables!: number;
    newOrders!: number;
    newUsers!: number;
    totalReceivablesChange!: number;
    totalProfitChange!: number;
    newOrdersChange!: number;
    newUsersChange!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.totalReceivables = data["totalReceivables"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            this.totalReceivablesChange = data["totalReceivablesChange"];
            this.totalProfitChange = data["totalProfitChange"];
            this.newOrdersChange = data["newOrdersChange"];
            this.newUsersChange = data["newUsersChange"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["totalReceivables"] = this.totalReceivables;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        data["totalReceivablesChange"] = this.totalReceivablesChange;
        data["totalProfitChange"] = this.totalProfitChange;
        data["newOrdersChange"] = this.newOrdersChange;
        data["newUsersChange"] = this.newUsersChange;
        return data; 
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    totalReceivables: number;
    newOrders: number;
    newUsers: number;
    totalReceivablesChange: number;
    totalProfitChange: number;
    newOrdersChange: number;
    newUsersChange: number;
}

export class GetTotalOutput implements IGetTotalOutput {
    total!: number;
    totalChange!: number;

    constructor(data?: IGetTotalOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.total = data["total"];
            this.totalChange = data["totalChange"];
        }
    }

    static fromJS(data: any): GetTotalOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTotalOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["totalChange"] = this.totalChange;
        return data; 
    }
}

export interface IGetTotalOutput {
    total: number;
    totalChange: number;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: RegistrationCategoryData[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of data["profitShares"])
                    this.profitShares!.push(RegistrationCategoryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetProfitShareOutput {
    profitShares: RegistrationCategoryData[] | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: DailyRegistrationData[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of data["dailySales"])
                    this.dailySales!.push(DailyRegistrationData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDailySalesOutput {
    dailySales: DailyRegistrationData[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    totalDiscounts!: number;
    paids!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.totalDiscounts = data["totalDiscounts"];
            this.paids = data["paids"];
            this.growth = data["growth"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["totalDiscounts"] = this.totalDiscounts;
        data["paids"] = this.paids;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    totalDiscounts: number;
    paids: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class PaymentStatusData implements IPaymentStatusData {
    statusName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IPaymentStatusData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusName = data["statusName"];
            this.sales = data["sales"];
            if (Array.isArray(data["change"])) {
                this.change = [] as any;
                for (let item of data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = data["averagePrice"];
            this.totalPrice = data["totalPrice"];
        }
    }

    static fromJS(data: any): PaymentStatusData {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStatusData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusName"] = this.statusName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data; 
    }
}

export interface IPaymentStatusData {
    statusName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class GetPaymentStatsOutput implements IGetPaymentStatsOutput {
    stats!: PaymentStatusData[] | undefined;

    constructor(data?: IGetPaymentStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["stats"])) {
                this.stats = [] as any;
                for (let item of data["stats"])
                    this.stats!.push(PaymentStatusData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPaymentStatsOutput {
    stats: PaymentStatusData[] | undefined;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class DocumentApprove implements IDocumentApprove {
    name!: string | undefined;
    userName!: string | undefined;
    memberId!: number;
    categoryName!: string | undefined;
    categoryLevelName!: string | undefined;

    constructor(data?: IDocumentApprove) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.userName = data["userName"];
            this.memberId = data["memberId"];
            this.categoryName = data["categoryName"];
            this.categoryLevelName = data["categoryLevelName"];
        }
    }

    static fromJS(data: any): DocumentApprove {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentApprove();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["memberId"] = this.memberId;
        data["categoryName"] = this.categoryName;
        data["categoryLevelName"] = this.categoryLevelName;
        return data; 
    }
}

export interface IDocumentApprove {
    name: string | undefined;
    userName: string | undefined;
    memberId: number;
    categoryName: string | undefined;
    categoryLevelName: string | undefined;
}

export class GetGeneralDocumentsApproveOutput implements IGetGeneralDocumentsApproveOutput {
    documentsApprove!: DocumentApprove[] | undefined;

    constructor(data?: IGetGeneralDocumentsApproveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["documentsApprove"])) {
                this.documentsApprove = [] as any;
                for (let item of data["documentsApprove"])
                    this.documentsApprove!.push(DocumentApprove.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetGeneralDocumentsApproveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralDocumentsApproveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentsApprove)) {
            data["documentsApprove"] = [];
            for (let item of this.documentsApprove)
                data["documentsApprove"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetGeneralDocumentsApproveOutput {
    documentsApprove: DocumentApprove[] | undefined;
}

export class GetMyDocumentationsOutput implements IGetMyDocumentationsOutput {
    categoryRequiresDocument!: boolean;
    documentationStatus!: DocumentationStatus;

    constructor(data?: IGetMyDocumentationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryRequiresDocument = data["categoryRequiresDocument"];
            this.documentationStatus = data["documentationStatus"];
        }
    }

    static fromJS(data: any): GetMyDocumentationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyDocumentationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryRequiresDocument"] = this.categoryRequiresDocument;
        data["documentationStatus"] = this.documentationStatus;
        return data; 
    }
}

export interface IGetMyDocumentationsOutput {
    categoryRequiresDocument: boolean;
    documentationStatus: DocumentationStatus;
}

export class MyAnnuity implements IMyAnnuity {
    year!: number;
    annuitySituation!: AnnuitySituation;
    categoryRequiresDocument!: boolean;
    documentationStatus!: DocumentationStatus;
    deadline!: number | undefined;
    category!: string | undefined;
    annuityId!: number;

    constructor(data?: IMyAnnuity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.annuitySituation = data["annuitySituation"];
            this.categoryRequiresDocument = data["categoryRequiresDocument"];
            this.documentationStatus = data["documentationStatus"];
            this.deadline = data["deadline"];
            this.category = data["category"];
            this.annuityId = data["annuityId"];
        }
    }

    static fromJS(data: any): MyAnnuity {
        data = typeof data === 'object' ? data : {};
        let result = new MyAnnuity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["annuitySituation"] = this.annuitySituation;
        data["categoryRequiresDocument"] = this.categoryRequiresDocument;
        data["documentationStatus"] = this.documentationStatus;
        data["deadline"] = this.deadline;
        data["category"] = this.category;
        data["annuityId"] = this.annuityId;
        return data; 
    }
}

export interface IMyAnnuity {
    year: number;
    annuitySituation: AnnuitySituation;
    categoryRequiresDocument: boolean;
    documentationStatus: DocumentationStatus;
    deadline: number | undefined;
    category: string | undefined;
    annuityId: number;
}

export class GetMyAnnuitiesOutput implements IGetMyAnnuitiesOutput {
    annuities!: MyAnnuity[] | undefined;

    constructor(data?: IGetMyAnnuitiesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["annuities"])) {
                this.annuities = [] as any;
                for (let item of data["annuities"])
                    this.annuities!.push(MyAnnuity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyAnnuitiesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyAnnuitiesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.annuities)) {
            data["annuities"] = [];
            for (let item of this.annuities)
                data["annuities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMyAnnuitiesOutput {
    annuities: MyAnnuity[] | undefined;
}

export class NextEvent implements INextEvent {
    id!: number;
    eventName!: string | undefined;
    beginDate!: moment.Moment;
    endDate!: moment.Moment;
    deadline!: number | undefined;

    constructor(data?: INextEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.eventName = data["eventName"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.deadline = data["deadline"];
        }
    }

    static fromJS(data: any): NextEvent {
        data = typeof data === 'object' ? data : {};
        let result = new NextEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventName"] = this.eventName;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["deadline"] = this.deadline;
        return data; 
    }
}

export interface INextEvent {
    id: number;
    eventName: string | undefined;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    deadline: number | undefined;
}

export class GetMyNextEventsOutput implements IGetMyNextEventsOutput {
    events!: NextEvent[] | undefined;

    constructor(data?: IGetMyNextEventsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["events"])) {
                this.events = [] as any;
                for (let item of data["events"])
                    this.events!.push(NextEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyNextEventsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyNextEventsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMyNextEventsOutput {
    events: NextEvent[] | undefined;
}

export class MyRegistration implements IMyRegistration {
    userName!: string | undefined;
    eventName!: string | undefined;
    eventId!: number;
    registrationId!: number;
    hasCertificate!: boolean;
    status!: PaymentStatus;
    event!: EventDto;
    beginDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    registrationSituation!: RegistrationSituation;

    constructor(data?: IMyRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.eventName = data["eventName"];
            this.eventId = data["eventId"];
            this.registrationId = data["registrationId"];
            this.hasCertificate = data["hasCertificate"];
            this.status = data["status"];
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : <any>undefined;
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.registrationSituation = data["registrationSituation"];
        }
    }

    static fromJS(data: any): MyRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new MyRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["eventName"] = this.eventName;
        data["eventId"] = this.eventId;
        data["registrationId"] = this.registrationId;
        data["hasCertificate"] = this.hasCertificate;
        data["status"] = this.status;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["registrationSituation"] = this.registrationSituation;
        return data; 
    }
}

export interface IMyRegistration {
    userName: string | undefined;
    eventName: string | undefined;
    eventId: number;
    registrationId: number;
    hasCertificate: boolean;
    status: PaymentStatus;
    event: EventDto;
    beginDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    registrationSituation: RegistrationSituation;
}

export class GetMyRegistrationsOutput implements IGetMyRegistrationsOutput {
    registrations!: MyRegistration[] | undefined;

    constructor(data?: IGetMyRegistrationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["registrations"])) {
                this.registrations = [] as any;
                for (let item of data["registrations"])
                    this.registrations!.push(MyRegistration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyRegistrationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyRegistrationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.registrations)) {
            data["registrations"] = [];
            for (let item of this.registrations)
                data["registrations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMyRegistrationsOutput {
    registrations: MyRegistration[] | undefined;
}

export class MyOrder implements IMyOrder {
    id!: number;
    description!: string | undefined;
    dueDate!: moment.Moment | undefined;
    situation!: OrderSituation;

    constructor(data?: IMyOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.description = data["description"];
            this.dueDate = data["dueDate"] ? moment(data["dueDate"].toString()) : <any>undefined;
            this.situation = data["situation"];
        }
    }

    static fromJS(data: any): MyOrder {
        data = typeof data === 'object' ? data : {};
        let result = new MyOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["situation"] = this.situation;
        return data; 
    }
}

export interface IMyOrder {
    id: number;
    description: string | undefined;
    dueDate: moment.Moment | undefined;
    situation: OrderSituation;
}

export class GetMyOrdersOutput implements IGetMyOrdersOutput {
    orders!: MyOrder[] | undefined;

    constructor(data?: IGetMyOrdersOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["orders"])) {
                this.orders = [] as any;
                for (let item of data["orders"])
                    this.orders!.push(MyOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyOrdersOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyOrdersOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMyOrdersOutput {
    orders: MyOrder[] | undefined;
}

export class GetFinancialSalesSummaryOutput implements IGetFinancialSalesSummaryOutput {
    totalSales!: number;
    totalDiscounts!: number;
    paids!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetFinancialSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.totalDiscounts = data["totalDiscounts"];
            this.paids = data["paids"];
            this.growth = data["growth"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFinancialSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["totalDiscounts"] = this.totalDiscounts;
        data["paids"] = this.paids;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetFinancialSalesSummaryOutput {
    totalSales: number;
    totalDiscounts: number;
    paids: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class CategoryData implements ICategoryData {
    category!: string | undefined;
    count!: number;

    constructor(data?: ICategoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.category = data["category"];
            this.count = data["count"];
        }
    }

    static fromJS(data: any): CategoryData {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["count"] = this.count;
        return data; 
    }
}

export interface ICategoryData {
    category: string | undefined;
    count: number;
}

export class GetFinancialProfitShareOutput implements IGetFinancialProfitShareOutput {
    profitShares!: CategoryData[] | undefined;

    constructor(data?: IGetFinancialProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of data["profitShares"])
                    this.profitShares!.push(CategoryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFinancialProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetFinancialProfitShareOutput {
    profitShares: CategoryData[] | undefined;
}

export class GetFinancialGeneralStatsOutput implements IGetFinancialGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetFinancialGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetFinancialGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetFinancialGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetAnnuitySalesSummaryOutput implements IGetAnnuitySalesSummaryOutput {
    totalSales!: number;
    totalDiscounts!: number;
    paids!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetAnnuitySalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalSales = data["totalSales"];
            this.totalDiscounts = data["totalDiscounts"];
            this.paids = data["paids"];
            this.growth = data["growth"];
            if (Array.isArray(data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAnnuitySalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuitySalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["totalDiscounts"] = this.totalDiscounts;
        data["paids"] = this.paids;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAnnuitySalesSummaryOutput {
    totalSales: number;
    totalDiscounts: number;
    paids: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetAnnuityProfitShareOutput implements IGetAnnuityProfitShareOutput {
    profitShares!: CategoryData[] | undefined;

    constructor(data?: IGetAnnuityProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of data["profitShares"])
                    this.profitShares!.push(CategoryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAnnuityProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuityProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetAnnuityProfitShareOutput {
    profitShares: CategoryData[] | undefined;
}

export class GetAnnuityGeneralStatsOutput implements IGetAnnuityGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetAnnuityGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetAnnuityGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAnnuityGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetAnnuityGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export enum SubscriptionStartType {
    Free = 1,
    Trial = 2,
    Paid = 3,
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string | undefined;
    name!: string | undefined;
    adminEmailAddress!: string | undefined;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.editionId = data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data; 
    }
}

export interface IRegisterTenantInput {
    tenancyName: string | undefined;
    name: string | undefined;
    adminEmailAddress: string | undefined;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data; 
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).name = data["name"];
            if (data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        (<any>this).attributes![key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data; 
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (Array.isArray(data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
            this.sessionTimeOutSettings = data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;
    footer!: string | undefined;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useHostDefaultEmailSettings = data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
            this.footer = data["footer"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        data["footer"] = this.footer;
        return data; 
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
    footer: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isQuickThemeSelectEnabled = data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data; 
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export enum ApplicationEmailType {
    OrderCreated = 0,
    OrderPaid = 1,
    RegistrationApproved = 2,
    RegistrationCanceled = 3,
    DocumentationApproved = 4,
    DocumentationDisapproved = 5,
    SendPixPaymentCode = 6,
    OrderCanceled = 7,
    PixPaymentCanceled = 8,
    PaymentReturned = 9,
}

export class CreateOrEditApplicationEmailDto implements ICreateOrEditApplicationEmailDto {
    text!: string | undefined;
    type!: ApplicationEmailType;
    id!: number | undefined;

    constructor(data?: ICreateOrEditApplicationEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.text = data["text"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditApplicationEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditApplicationEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditApplicationEmailDto {
    text: string | undefined;
    type: ApplicationEmailType;
    id: number | undefined;
}

export class TenantTermOfResponsibilityDto implements ITenantTermOfResponsibilityDto {
    newUser!: string | undefined;

    constructor(data?: ITenantTermOfResponsibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newUser = data["newUser"];
        }
    }

    static fromJS(data: any): TenantTermOfResponsibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantTermOfResponsibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUser"] = this.newUser;
        return data; 
    }
}

export interface ITenantTermOfResponsibilityDto {
    newUser: string | undefined;
}

export class TenantSerproDto implements ITenantSerproDto {
    isEnabled!: boolean;
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;
    description!: string | undefined;
    urlRequestCpf!: string | undefined;
    urlToken!: string | undefined;
    isAutomaticValidation!: boolean;

    constructor(data?: ITenantSerproDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.consumerKey = data["consumerKey"];
            this.consumerSecret = data["consumerSecret"];
            this.description = data["description"];
            this.urlRequestCpf = data["urlRequestCpf"];
            this.urlToken = data["urlToken"];
            this.isAutomaticValidation = data["isAutomaticValidation"];
        }
    }

    static fromJS(data: any): TenantSerproDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSerproDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        data["description"] = this.description;
        data["urlRequestCpf"] = this.urlRequestCpf;
        data["urlToken"] = this.urlToken;
        data["isAutomaticValidation"] = this.isAutomaticValidation;
        return data; 
    }
}

export interface ITenantSerproDto {
    isEnabled: boolean;
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
    description: string | undefined;
    urlRequestCpf: string | undefined;
    urlToken: string | undefined;
    isAutomaticValidation: boolean;
}

export class TenantCfmDto implements ITenantCfmDto {
    isEnabled!: boolean;
    description!: string | undefined;
    consumerKey!: string | undefined;
    urlRequestCrm!: string | undefined;

    constructor(data?: ITenantCfmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.description = data["description"];
            this.consumerKey = data["consumerKey"];
            this.urlRequestCrm = data["urlRequestCrm"];
        }
    }

    static fromJS(data: any): TenantCfmDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantCfmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["description"] = this.description;
        data["consumerKey"] = this.consumerKey;
        data["urlRequestCrm"] = this.urlRequestCrm;
        return data; 
    }
}

export interface ITenantCfmDto {
    isEnabled: boolean;
    description: string | undefined;
    consumerKey: string | undefined;
    urlRequestCrm: string | undefined;
}

export class TenantHotsiteDto implements ITenantHotsiteDto {
    googleAnalytics!: string | undefined;

    constructor(data?: ITenantHotsiteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.googleAnalytics = data["googleAnalytics"];
        }
    }

    static fromJS(data: any): TenantHotsiteDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantHotsiteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["googleAnalytics"] = this.googleAnalytics;
        return data; 
    }
}

export interface ITenantHotsiteDto {
    googleAnalytics: string | undefined;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto;
    ldap!: LdapSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto;
    otherSettings!: TenantOtherSettingsEditDto;
    applicationEmails!: CreateOrEditApplicationEmailDto[] | undefined;
    termsOfResponsibility!: TenantTermOfResponsibilityDto;
    serpro!: TenantSerproDto;
    cfm!: TenantCfmDto;
    hotsite!: TenantHotsiteDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? TenantEmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
            this.otherSettings = data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(data["otherSettings"]) : <any>undefined;
            if (Array.isArray(data["applicationEmails"])) {
                this.applicationEmails = [] as any;
                for (let item of data["applicationEmails"])
                    this.applicationEmails!.push(CreateOrEditApplicationEmailDto.fromJS(item));
            }
            this.termsOfResponsibility = data["termsOfResponsibility"] ? TenantTermOfResponsibilityDto.fromJS(data["termsOfResponsibility"]) : <any>undefined;
            this.serpro = data["serpro"] ? TenantSerproDto.fromJS(data["serpro"]) : <any>undefined;
            this.cfm = data["cfm"] ? TenantCfmDto.fromJS(data["cfm"]) : <any>undefined;
            this.hotsite = data["hotsite"] ? TenantHotsiteDto.fromJS(data["hotsite"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationEmails)) {
            data["applicationEmails"] = [];
            for (let item of this.applicationEmails)
                data["applicationEmails"].push(item.toJSON());
        }
        data["termsOfResponsibility"] = this.termsOfResponsibility ? this.termsOfResponsibility.toJSON() : <any>undefined;
        data["serpro"] = this.serpro ? this.serpro.toJSON() : <any>undefined;
        data["cfm"] = this.cfm ? this.cfm.toJSON() : <any>undefined;
        data["hotsite"] = this.hotsite ? this.hotsite.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    otherSettings: TenantOtherSettingsEditDto;
    applicationEmails: CreateOrEditApplicationEmailDto[] | undefined;
    termsOfResponsibility: TenantTermOfResponsibilityDto;
    serpro: TenantSerproDto;
    cfm: TenantCfmDto;
    hotsite: TenantHotsiteDto;
}

export class GetThematicAreaForViewDto implements IGetThematicAreaForViewDto {
    thematicArea!: ThematicAreaDto;

    constructor(data?: IGetThematicAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.thematicArea = data["thematicArea"] ? ThematicAreaDto.fromJS(data["thematicArea"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThematicAreaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetThematicAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetThematicAreaForViewDto {
    thematicArea: ThematicAreaDto;
}

export class PagedResultDtoOfGetThematicAreaForViewDto implements IPagedResultDtoOfGetThematicAreaForViewDto {
    totalCount!: number;
    items!: GetThematicAreaForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetThematicAreaForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetThematicAreaForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetThematicAreaForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetThematicAreaForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetThematicAreaForViewDto {
    totalCount: number;
    items: GetThematicAreaForViewDto[] | undefined;
}

export class CreateOrEditThematicAreaDto implements ICreateOrEditThematicAreaDto {
    isActive!: boolean;
    description!: string | undefined;
    eventScheduleId!: number;
    responsibleId!: number | undefined;
    responsible!: UserListDto;
    coverageAreaId!: number;
    coverageArea!: CoverageAreaDto;
    id!: number | undefined;

    constructor(data?: ICreateOrEditThematicAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.description = data["description"];
            this.eventScheduleId = data["eventScheduleId"];
            this.responsibleId = data["responsibleId"];
            this.responsible = data["responsible"] ? UserListDto.fromJS(data["responsible"]) : <any>undefined;
            this.coverageAreaId = data["coverageAreaId"];
            this.coverageArea = data["coverageArea"] ? CoverageAreaDto.fromJS(data["coverageArea"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditThematicAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditThematicAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["eventScheduleId"] = this.eventScheduleId;
        data["responsibleId"] = this.responsibleId;
        data["responsible"] = this.responsible ? this.responsible.toJSON() : <any>undefined;
        data["coverageAreaId"] = this.coverageAreaId;
        data["coverageArea"] = this.coverageArea ? this.coverageArea.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditThematicAreaDto {
    isActive: boolean;
    description: string | undefined;
    eventScheduleId: number;
    responsibleId: number | undefined;
    responsible: UserListDto;
    coverageAreaId: number;
    coverageArea: CoverageAreaDto;
    id: number | undefined;
}

export class GetThematicAreaForEditOutput implements IGetThematicAreaForEditOutput {
    thematicArea!: CreateOrEditThematicAreaDto;

    constructor(data?: IGetThematicAreaForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.thematicArea = data["thematicArea"] ? CreateOrEditThematicAreaDto.fromJS(data["thematicArea"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetThematicAreaForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetThematicAreaForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thematicArea"] = this.thematicArea ? this.thematicArea.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetThematicAreaForEditOutput {
    thematicArea: CreateOrEditThematicAreaDto;
}

export class ListResultDtoOfThematicAreaDto implements IListResultDtoOfThematicAreaDto {
    items!: ThematicAreaDto[] | undefined;

    constructor(data?: IListResultDtoOfThematicAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ThematicAreaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfThematicAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfThematicAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfThematicAreaDto {
    items: ThematicAreaDto[] | undefined;
}

export enum SettingScopes {
    Application = 1,
    Tenant = 2,
    User = 4,
    All = 7,
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string | undefined;
    password!: string | undefined;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string | undefined;
    password: string | undefined;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (Array.isArray(data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
            this.refreshToken = data["refreshToken"];
            this.refreshTokenExpireInSeconds = data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string | undefined;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
            if (data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in data["additionalParams"]) {
                    if (data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams![key] = data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string | undefined;
    providerKey!: string | undefined;
    providerAccessCode!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string | undefined;
    providerKey: string | undefined;
    providerAccessCode: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
            this.refreshToken = data["refreshToken"];
            this.refreshTokenExpireInSeconds = data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    emails!: UserEmailDto[] | undefined;
    phones!: UserPhoneDto[] | undefined;
    addresses!: UserAddressDto[] | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;
    nameValidSerpro!: string | undefined;
    confirmedName!: boolean | undefined;
    statusCpf!: StatusCpf;
    situationCpf!: SituationCpf;
    member!: CreateOrEditMemberDto;
    userSituationId!: number | undefined;
    userSituation!: UserSituationDto;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            if (Array.isArray(data["emails"])) {
                this.emails = [] as any;
                for (let item of data["emails"])
                    this.emails!.push(UserEmailDto.fromJS(item));
            }
            if (Array.isArray(data["phones"])) {
                this.phones = [] as any;
                for (let item of data["phones"])
                    this.phones!.push(UserPhoneDto.fromJS(item));
            }
            if (Array.isArray(data["addresses"])) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses!.push(UserAddressDto.fromJS(item));
            }
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.nameValidSerpro = data["nameValidSerpro"];
            this.confirmedName = data["confirmedName"];
            this.statusCpf = data["statusCpf"];
            this.situationCpf = data["situationCpf"];
            this.member = data["member"] ? CreateOrEditMemberDto.fromJS(data["member"]) : <any>undefined;
            this.userSituationId = data["userSituationId"];
            this.userSituation = data["userSituation"] ? UserSituationDto.fromJS(data["userSituation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.phones)) {
            data["phones"] = [];
            for (let item of this.phones)
                data["phones"].push(item.toJSON());
        }
        if (Array.isArray(this.addresses)) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["nameValidSerpro"] = this.nameValidSerpro;
        data["confirmedName"] = this.confirmedName;
        data["statusCpf"] = this.statusCpf;
        data["situationCpf"] = this.situationCpf;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["userSituationId"] = this.userSituationId;
        data["userSituation"] = this.userSituation ? this.userSituation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    emails: UserEmailDto[] | undefined;
    phones: UserPhoneDto[] | undefined;
    addresses: UserAddressDto[] | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    nameValidSerpro: string | undefined;
    confirmedName: boolean | undefined;
    statusCpf: StatusCpf;
    situationCpf: SituationCpf;
    member: CreateOrEditMemberDto;
    userSituationId: number | undefined;
    userSituation: UserSituationDto;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
            this.inheritedFromOrganizationUnit = data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;
    validateCPF!: boolean;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (Array.isArray(data["roles"])) {
                this.roles = [] as any;
                for (let item of data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
            this.validateCPF = data["validateCPF"];
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        data["validateCPF"] = this.validateCPF;
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
    validateCPF: boolean;
}

export class ListResultDtoOfUserListDto implements IListResultDtoOfUserListDto {
    items!: UserListDto[] | undefined;

    constructor(data?: IListResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserListDto {
    items: UserListDto[] | undefined;
}

export class CheckUserInput implements ICheckUserInput {
    userName!: string | undefined;
    emailAddress!: string | undefined;
    sorting!: string | undefined;
    maxResultCount!: number;
    skipCount!: number;

    constructor(data?: ICheckUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.sorting = data["sorting"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
        }
    }

    static fromJS(data: any): CheckUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["sorting"] = this.sorting;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        return data; 
    }
}

export interface ICheckUserInput {
    userName: string | undefined;
    emailAddress: string | undefined;
    sorting: string | undefined;
    maxResultCount: number;
    skipCount: number;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["permissions"])) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (Array.isArray(data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[] | undefined;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[] | undefined;
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (Array.isArray(data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (Array.isArray(data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[] | undefined;
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class UpdateUserMainDataDto implements IUpdateUserMainDataDto {
    id!: number;
    name!: string | undefined;
    emailAddress!: string | undefined;
    mainPhone!: UserPhoneDto;
    mainAddress!: UserAddressDto;

    constructor(data?: IUpdateUserMainDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.emailAddress = data["emailAddress"];
            this.mainPhone = data["mainPhone"] ? UserPhoneDto.fromJS(data["mainPhone"]) : <any>undefined;
            this.mainAddress = data["mainAddress"] ? UserAddressDto.fromJS(data["mainAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserMainDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserMainDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["emailAddress"] = this.emailAddress;
        data["mainPhone"] = this.mainPhone ? this.mainPhone.toJSON() : <any>undefined;
        data["mainAddress"] = this.mainAddress ? this.mainAddress.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateUserMainDataDto {
    id: number;
    name: string | undefined;
    emailAddress: string | undefined;
    mainPhone: UserPhoneDto;
    mainAddress: UserAddressDto;
}

export class ValidateCpfUserInput implements IValidateCpfUserInput {
    userId!: number;
    userName!: string | undefined;

    constructor(data?: IValidateCpfUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ValidateCpfUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateCpfUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IValidateCpfUserInput {
    userId: number;
    userName: string | undefined;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string | undefined;
    password: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class GetUserSituationForViewDto implements IGetUserSituationForViewDto {
    userSituation!: UserSituationDto;
    totalUsers!: number;

    constructor(data?: IGetUserSituationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userSituation = data["userSituation"] ? UserSituationDto.fromJS(data["userSituation"]) : <any>undefined;
            this.totalUsers = data["totalUsers"];
        }
    }

    static fromJS(data: any): GetUserSituationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSituationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSituation"] = this.userSituation ? this.userSituation.toJSON() : <any>undefined;
        data["totalUsers"] = this.totalUsers;
        return data; 
    }
}

export interface IGetUserSituationForViewDto {
    userSituation: UserSituationDto;
    totalUsers: number;
}

export class PagedResultDtoOfGetUserSituationForViewDto implements IPagedResultDtoOfGetUserSituationForViewDto {
    totalCount!: number;
    items!: GetUserSituationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetUserSituationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetUserSituationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetUserSituationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetUserSituationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfGetUserSituationForViewDto {
    totalCount: number;
    items: GetUserSituationForViewDto[] | undefined;
}

export class CreateOrEditUserSituationDto implements ICreateOrEditUserSituationDto {
    description!: string | undefined;
    isActive!: boolean;
    generateAnnuity!: boolean;
    id!: number | undefined;

    constructor(data?: ICreateOrEditUserSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.generateAnnuity = data["generateAnnuity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrEditUserSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditUserSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["generateAnnuity"] = this.generateAnnuity;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrEditUserSituationDto {
    description: string | undefined;
    isActive: boolean;
    generateAnnuity: boolean;
    id: number | undefined;
}

export class GetUserSituationForEditOutput implements IGetUserSituationForEditOutput {
    userSituation!: CreateOrEditUserSituationDto;

    constructor(data?: IGetUserSituationForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userSituation = data["userSituation"] ? CreateOrEditUserSituationDto.fromJS(data["userSituation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetUserSituationForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserSituationForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSituation"] = this.userSituation ? this.userSituation.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetUserSituationForEditOutput {
    userSituation: CreateOrEditUserSituationDto;
}

export class ListResultDtoOfUserSituationDto implements IListResultDtoOfUserSituationDto {
    items!: UserSituationDto[] | undefined;

    constructor(data?: IListResultDtoOfUserSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(UserSituationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserSituationDto {
    items: UserSituationDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data; 
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal![key] = data["Paypal"][key];
                }
            }
            if (data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in data["Stripe"]) {
                    if (data["Stripe"].hasOwnProperty(key))
                        this.stripe![key] = data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    data["Stripe"][key] = this.stripe[key];
            }
        }
        return data; 
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}